
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jFtVs", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $e5190f4e823bb222$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $e5190f4e823bb222$export$bb5ca5fba6fb4f1f);

var $eUqFw = parcelRequire("eUqFw");

var $417zz = parcelRequire("417zz");
var $e5190f4e823bb222$var$generateUID = function(context) {
    var quartz = context || (0, $417zz.counter);
    var prefix = (0, $417zz.getPrefix)(quartz);
    var id = (0, $417zz.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $e5190f4e823bb222$var$useUIDState = function() {
    // @ts-ignore
    return $eUqFw.useState($e5190f4e823bb222$var$generateUID($eUqFw.useContext((0, $417zz.source))));
};
var $e5190f4e823bb222$export$87d05f07e65211f1 = function() {
    var uid = $e5190f4e823bb222$var$useUIDState()[0].uid;
    return uid;
};
var $e5190f4e823bb222$export$bb5ca5fba6fb4f1f = function() {
    var gen = $e5190f4e823bb222$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("417zz", function(module, exports) {

$parcel$export(module.exports, "counter", () => $2ecd2139c1e458e2$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $2ecd2139c1e458e2$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $2ecd2139c1e458e2$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $2ecd2139c1e458e2$export$36e24695f02d4503);

var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");
var $2ecd2139c1e458e2$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $tkrFt.generateUID)()
    };
};
var $2ecd2139c1e458e2$export$e575061ef2a070eb = $2ecd2139c1e458e2$export$1921362e86c73c88();
var $2ecd2139c1e458e2$export$b4d5da5f34fb77ad = $eUqFw.createContext($2ecd2139c1e458e2$export$1921362e86c73c88());
var $2ecd2139c1e458e2$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $2ecd2139c1e458e2$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("tkrFt", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $0582918cf26ae626$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $0582918cf26ae626$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $0582918cf26ae626$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $0582918cf26ae626$export$e2a22331486dcca0 = $0582918cf26ae626$export$bdbb4cbb3078e58d();

});



parcelRegister("7JEyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1c31c46c14c563$export$2e2bcd8739ae039);
const $5a1c31c46c14c563$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5a1c31c46c14c563$var$ATOMIC_GROUP_LENGTH = 5;
function $5a1c31c46c14c563$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $5a1c31c46c14c563$var$UNDERSCORE_UNICODE ? $5a1c31c46c14c563$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("asu8X", function(module, exports) {

$parcel$export(module.exports, "di", () => $79d3e6c28edd13b3$export$479d1ccc5f2ab701);

var $2P2t0 = parcelRequire("2P2t0");

var $dpjms = parcelRequire("dpjms");
function $79d3e6c28edd13b3$export$479d1ccc5f2ab701(deps, target) {
    // check if babel plugin has been added othrewise this is a noop
    if (Array.isArray(deps)) {
        // Read context and grab all the dependencies override Providers in the tree
        const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
        (0, $2P2t0.Context)._currentRenderer2 && (0, $2P2t0.Context)._currentValue2 || // grab value from default renderer
        (0, $2P2t0.Context)._currentValue || (0, $dpjms.globalDi);
        return getDependencies(deps, target);
    }
}

});
parcelRegister("2P2t0", function(module, exports) {

$parcel$export(module.exports, "Context", () => $20e242117d64e3db$export$841858b892ce1f4c);

var $eUqFw = parcelRequire("eUqFw");

var $dpjms = parcelRequire("dpjms");
const $20e242117d64e3db$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    getDependencies: (0, $dpjms.globalDi).getDependencies
});

});
parcelRegister("dpjms", function(module, exports) {

$parcel$export(module.exports, "globalDi", () => $9c2ca0eaed757b5d$export$a775919ebd7dd28a);

var $iF8Fq = parcelRequire("iF8Fq");

var $3d3oh = parcelRequire("3d3oh");
const $9c2ca0eaed757b5d$var$replacementMap = new Map();
const $9c2ca0eaed757b5d$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        return realDeps.map((dep)=>{
            const replacedInj = (0, $3d3oh.findInjectable)($9c2ca0eaed757b5d$var$replacementMap, dep, targetChild);
            return replacedInj ? replacedInj.value : dep;
        });
    },
    use (injs) {
        if ($9c2ca0eaed757b5d$var$replacementMap.size) throw new Error(`${(0, $iF8Fq.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $3d3oh.addInjectableToMap)($9c2ca0eaed757b5d$var$replacementMap, inj));
    },
    clear () {
        $9c2ca0eaed757b5d$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $iF8Fq.diRegistry).get(inj).global) (0, $3d3oh.addInjectableToMap)($9c2ca0eaed757b5d$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $3d3oh.removeInjectableFromMap)($9c2ca0eaed757b5d$var$replacementMap, inj));
    }
};
function $9c2ca0eaed757b5d$export$b887ce09d70113f9(thunk, deps) {
    $9c2ca0eaed757b5d$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($9c2ca0eaed757b5d$export$a775919ebd7dd28a.clear);
        else $9c2ca0eaed757b5d$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("iF8Fq", function(module, exports) {

$parcel$export(module.exports, "diRegistry", () => $d962c7745f008d23$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $d962c7745f008d23$export$b8b9d90f9e5bd72b);
const $d962c7745f008d23$export$4203fb010fad9bf0 = new WeakMap();
const $d962c7745f008d23$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("3d3oh", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $2565374a4f5459fd$export$5b28268982f175ba);
$parcel$export(module.exports, "addInjectableToMap", () => $2565374a4f5459fd$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $2565374a4f5459fd$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $2565374a4f5459fd$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $2565374a4f5459fd$export$7c436e151c3ee289);

var $iF8Fq = parcelRequire("iF8Fq");

var $1dtzH = parcelRequire("1dtzH");
let $2565374a4f5459fd$var$hasWarned = false;
function $2565374a4f5459fd$export$5b28268982f175ba(message) {
    if (!$2565374a4f5459fd$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $2565374a4f5459fd$var$hasWarned = true;
    }
}
function $2565374a4f5459fd$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $iF8Fq.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $1dtzH.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $2565374a4f5459fd$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $iF8Fq.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $2565374a4f5459fd$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $2565374a4f5459fd$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\[([^\]]+)/) || [];
    return args;
}
function $2565374a4f5459fd$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep) || new Set();
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.includes(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $1dtzH.stats).track(candidate);
    return candidate;
}

});
parcelRegister("1dtzH", function(module, exports) {

$parcel$export(module.exports, "stats", () => $0e2df24683a7a964$export$7804429c45dff272);
const $0e2df24683a7a964$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $0e2df24683a7a964$export$7804429c45dff272 = {
    state: $0e2df24683a7a964$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $0e2df24683a7a964$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("hUYqC", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $973b69ca88cb1fbb$export$12b6b072930fd68f);

var $9qfuq = parcelRequire("9qfuq");
class $973b69ca88cb1fbb$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $9qfuq.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("9qfuq", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $d3ac8439edce1196$export$c90b54e658fc4d7c);

var $1HAY5 = parcelRequire("1HAY5");
function $d3ac8439edce1196$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $d3ac8439edce1196$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $1HAY5.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("1HAY5", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $45f9a111887618d9$export$d27a2b6293f7631c);
class $45f9a111887618d9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("1xrmr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $8deb5691e7b7ca56$export$a7b0697657ed8bd0);

var $eUqFw = parcelRequire("eUqFw");
const $8deb5691e7b7ca56$export$a7b0697657ed8bd0 = (0, $eUqFw.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("cmqZo", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $1ad7d743431753a6$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $1ad7d743431753a6$export$55bce18df99af758);
const $1ad7d743431753a6$var$aggPathname = `/gateway/api/graphql${''}`;
const $1ad7d743431753a6$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $1ad7d743431753a6$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $1ad7d743431753a6$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("2n6bs", function(module, exports) {

$parcel$export(module.exports, "startCapturingExtensions", () => $0172e6b67b1321d7$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $0172e6b67b1321d7$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $0172e6b67b1321d7$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $0172e6b67b1321d7$export$7c6ea4184129ef74);
const $0172e6b67b1321d7$var$OperationExtensionsMap = {};
const $0172e6b67b1321d7$export$8656ba3981c6f6c1 = (operationName)=>{
    $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] = $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] || [];
};
const $0172e6b67b1321d7$export$f16fa6040161f056 = (operationName)=>{
    $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] = undefined;
};
const $0172e6b67b1321d7$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $0172e6b67b1321d7$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $0172e6b67b1321d7$export$7c6ea4184129ef74 = (operationName)=>$0172e6b67b1321d7$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("5udmX", function(module, exports) {

$parcel$export(module.exports, "startCapturingTraceIds", () => $d0155ee58038d577$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $d0155ee58038d577$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $d0155ee58038d577$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $d0155ee58038d577$export$5113e470f5c95670);
const $d0155ee58038d577$var$OperationTraceIdMap = {};
const $d0155ee58038d577$export$a2bcb2fac360646c = (operationName)=>{
    $d0155ee58038d577$var$OperationTraceIdMap[operationName] = $d0155ee58038d577$var$OperationTraceIdMap[operationName] || [];
};
const $d0155ee58038d577$export$559128bdc4352001 = (operationName)=>{
    $d0155ee58038d577$var$OperationTraceIdMap[operationName] = undefined;
};
const $d0155ee58038d577$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $d0155ee58038d577$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $d0155ee58038d577$export$5113e470f5c95670 = (operationName)=>$d0155ee58038d577$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("MYW4e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $0933c058066b723b$var$batchActions;
module.exports.enableBatching = $0933c058066b723b$var$enableBatching;
module.exports.batchDispatchMiddleware = $0933c058066b723b$var$batchDispatchMiddleware;
var $0933c058066b723b$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $0933c058066b723b$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0933c058066b723b$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $0933c058066b723b$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $0933c058066b723b$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("iFajX", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("bwbFz", function(module, exports) {

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $862bbc2a33c81882$var$partition = $f2sQe(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $862bbc2a33c81882$var$partition;

});
parcelRegister("f2sQe", function(module, exports) {

var $7MBST = parcelRequire("7MBST");

var $4rMll = parcelRequire("4rMll");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $af2d6a413362b8c6$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1c8hB(collection) ? $7MBST : $4rMll, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $7qARj(iteratee, 2), accumulator);
    };
}
module.exports = $af2d6a413362b8c6$var$createAggregator;

});
parcelRegister("7MBST", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $5aaa672b52d26956$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $5aaa672b52d26956$var$arrayAggregator;

});

parcelRegister("4rMll", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $33cf2f00574fe6b3$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $awetI(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $33cf2f00574fe6b3$var$baseAggregator;

});
parcelRegister("awetI", function(module, exports) {

var $piimr = parcelRequire("piimr");

var $72U1W = parcelRequire("72U1W");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7a881f9e470b1c13$var$baseEach = $72U1W($piimr);
module.exports = $7a881f9e470b1c13$var$baseEach;

});
parcelRegister("72U1W", function(module, exports) {

var $jxg5X = parcelRequire("jxg5X");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $52142ec7e7327faf$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$jxg5X(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $52142ec7e7327faf$var$createBaseEach;

});





parcelRegister("9RGox", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $f875ca936a00e523$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $3BsIJ = parcelRequire("3BsIJ");

var $3rAsQ = parcelRequire("3rAsQ");
var $f875ca936a00e523$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f875ca936a00e523$var$__await ? (this.v = v, this) : new $f875ca936a00e523$var$__await(v);
};
var $f875ca936a00e523$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f875ca936a00e523$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f875ca936a00e523$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $f875ca936a00e523$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$f875ca936a00e523$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $3BsIJ.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $3BsIJ.stringifyMessage)({
                                    type: (0, $3BsIJ.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($f875ca936a00e523$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $3BsIJ.stringifyMessage)(payload ? {
                            type: (0, $3BsIJ.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $3BsIJ.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $3BsIJ.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $3BsIJ.CloseCode).InternalClientError, (0, $3rAsQ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $3BsIJ.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $3BsIJ.stringifyMessage)(message.payload ? {
                                    type: (0, $3BsIJ.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $3BsIJ.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $3BsIJ.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $3BsIJ.CloseCode).BadResponse, (0, $3rAsQ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($f875ca936a00e523$var$isLikeCloseEvent(errOrCloseEvent) && ($f875ca936a00e523$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $3BsIJ.CloseCode).InternalServerError,
            (0, $3BsIJ.CloseCode).InternalClientError,
            (0, $3BsIJ.CloseCode).BadRequest,
            (0, $3BsIJ.CloseCode).BadResponse,
            (0, $3BsIJ.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $3BsIJ.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $3BsIJ.CloseCode).SubscriberAlreadyExists,
            (0, $3BsIJ.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($f875ca936a00e523$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $3BsIJ.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $3BsIJ.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $3BsIJ.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $3BsIJ.stringifyMessage)({
                        id: id,
                        type: (0, $3BsIJ.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $3BsIJ.stringifyMessage)({
                            id: id,
                            type: (0, $3BsIJ.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $f875ca936a00e523$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $f875ca936a00e523$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $f875ca936a00e523$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $f875ca936a00e523$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $f875ca936a00e523$var$isLikeCloseEvent(val) {
    return (0, $3rAsQ.isObject)(val) && 'code' in val && 'reason' in val;
}
function $f875ca936a00e523$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $f875ca936a00e523$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("3BsIJ", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $fd0053e519e3c093$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $fd0053e519e3c093$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $fd0053e519e3c093$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $fd0053e519e3c093$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $fd0053e519e3c093$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $3rAsQ = parcelRequire("3rAsQ");
const $fd0053e519e3c093$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $fd0053e519e3c093$export$ec743af8bb66f3be = 'graphql-ws';
var $fd0053e519e3c093$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($fd0053e519e3c093$export$777128f41f6616ec || ($fd0053e519e3c093$export$777128f41f6616ec = {}));
var $fd0053e519e3c093$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($fd0053e519e3c093$export$80edbf15fa61a4db || ($fd0053e519e3c093$export$80edbf15fa61a4db = {}));
function $fd0053e519e3c093$export$c17861b159b1b673(val) {
    if (!(0, $3rAsQ.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $fd0053e519e3c093$export$80edbf15fa61a4db.ConnectionInit:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.ConnectionAck:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Ping:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $3rAsQ.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $3rAsQ.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $3rAsQ.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val.payload)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $fd0053e519e3c093$export$9e0e49e75fa7d548(val) {
    try {
        $fd0053e519e3c093$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $fd0053e519e3c093$export$f2f615077a189f21(data, reviver) {
    return $fd0053e519e3c093$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $fd0053e519e3c093$export$77896e5b47bfd50b(msg, replacer) {
    $fd0053e519e3c093$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("3rAsQ", function(module, exports) {

$parcel$export(module.exports, "extendedTypeof", () => $32f1a4ab48fd0f7d$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $32f1a4ab48fd0f7d$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $32f1a4ab48fd0f7d$export$2937fa0c8dddae54);
/** @private */ function $32f1a4ab48fd0f7d$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a(val) {
    return $32f1a4ab48fd0f7d$export$573326049e1b1c6b(val) === 'object';
}
function $32f1a4ab48fd0f7d$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $32f1a4ab48fd0f7d$export$92bd080471bc30f1(val) {
    return $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $32f1a4ab48fd0f7d$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $32f1a4ab48fd0f7d$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("isMPK", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $e3fae251ef2ef0f5$export$6c790f07f4ef6a59);

var $cNy9K = parcelRequire("cNy9K");

var $4Tdfn = parcelRequire("4Tdfn");

var $15269 = parcelRequire("15269");

var $hF3cH = parcelRequire("hF3cH");

var $iBFHQ = parcelRequire("iBFHQ");
const $e3fae251ef2ef0f5$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $hF3cH.network),
        store: new (0, $cNy9K.Store)(new (0, $cNy9K.RecordSource)(), {
            log: // @ts-expect-error - TS2345 - Argument of type '{ log: (event: LogEvent) => void; getDataID: (fieldValue: { [key: string]: unknown; }, typeName: string) => string | undefined; }' is not assignable to parameter of type '{ gcScheduler?: Scheduler | null | undefined; operationLoader?: OperationLoader | null | undefined; gcReleaseBufferSize?: number | null | undefined; queryCacheExpirationTime?: number | ... 1 more ... | undefined; }'.
            log,
            getDataID: (0, $4Tdfn.default)
        }),
        log: log,
        requiredFieldLogger: requiredFieldLogger,
        // Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
        // @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $4Tdfn.default),
        scheduler: (0, $iBFHQ.default),
        missingFieldHandlers: (0, $15269.default)
    });

});
parcelRegister("4Tdfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b836f7d9d390f8cd$export$2e2bcd8739ae039);
function $b836f7d9d390f8cd$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("15269", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6e48922c56e0c4$export$2e2bcd8739ae039);

var $dCoVL = parcelRequire("dCoVL");

var $4Tdfn = parcelRequire("4Tdfn");
const $9e6e48922c56e0c4$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $9e6e48922c56e0c4$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $9e6e48922c56e0c4$var$JiraQueryFilterMissingFieldHandler = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $dCoVL.AnyAri).parse(id).resourceId;
            if ($9e6e48922c56e0c4$var$isCustomFilter(filterId)) return (0, $4Tdfn.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($9e6e48922c56e0c4$var$isSystemFilter(filterId)) return (0, $4Tdfn.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $9e6e48922c56e0c4$var$MissingFieldHandlers = [
    $9e6e48922c56e0c4$var$JiraQueryFilterMissingFieldHandler
];
var $9e6e48922c56e0c4$export$2e2bcd8739ae039 = $9e6e48922c56e0c4$var$MissingFieldHandlers;

});
parcelRegister("dCoVL", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $baf269e1b4d6f11c$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $baf269e1b4d6f11c$export$44a7af7122933d6b);

var $hkoEN = parcelRequire("hkoEN");
// src/core/ari.ts
var $baf269e1b4d6f11c$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $hkoEN.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $baf269e1b4d6f11c$export$44a7af7122933d6b = class _AnyAri extends $baf269e1b4d6f11c$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $hkoEN.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $hkoEN.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("hkoEN", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $e3044e82ed7f104f$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $e3044e82ed7f104f$export$ab4b293d0121b8ee);

var $gZt4y = parcelRequire("gZt4y");

var $lpE9K = parcelRequire("lpE9K");
// src/core/rules/cloud-id.ts
function $e3044e82ed7f104f$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9\\-]*$")) {
    if (!cloudId.match(format)) throw new (0, $lpE9K.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $e3044e82ed7f104f$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $lpE9K.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $e3044e82ed7f104f$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $e3044e82ed7f104f$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $e3044e82ed7f104f$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $lpE9K.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $e3044e82ed7f104f$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $lpE9K.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $e3044e82ed7f104f$var$NUMBER_OF_ARI_SEGMENTS = 5, $e3044e82ed7f104f$export$4c3a8cde7a55740b = class extends (0, $gZt4y.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $e3044e82ed7f104f$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $gZt4y.validateAriQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $e3044e82ed7f104f$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $lpE9K.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $lpE9K.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $e3044e82ed7f104f$var$NUMBER_OF_ATI_SEGMENTS = 4, $e3044e82ed7f104f$var$AtiParser = class extends (0, $gZt4y.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $e3044e82ed7f104f$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $gZt4y.validateAtiQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $gZt4y.validateAtiQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $e3044e82ed7f104f$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $e3044e82ed7f104f$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("gZt4y", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $f849c92f95d9da05$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $f849c92f95d9da05$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $f849c92f95d9da05$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $f849c92f95d9da05$export$3d09a5c28ff3e040);

var $lpE9K = parcelRequire("lpE9K");
// src/core/rules/platform-qualifier.ts
function $f849c92f95d9da05$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $lpE9K.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $f849c92f95d9da05$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $lpE9K.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $f849c92f95d9da05$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $lpE9K.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $f849c92f95d9da05$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $lpE9K.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS = 5, $f849c92f95d9da05$var$SEGMENT_SEPARATOR = ":", $f849c92f95d9da05$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($f849c92f95d9da05$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $lpE9K.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($f849c92f95d9da05$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("lpE9K", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $74d7e98cfa4df308$export$2191b9da168c6cf0);
// src/errors.ts
var $74d7e98cfa4df308$export$2191b9da168c6cf0 = class extends Error {
};

});





parcelRegister("hF3cH", function(module, exports) {

$parcel$export(module.exports, "network", () => $2663841f55898ac1$export$21fcfd9d5c6ebbd4);

var $cNy9K = parcelRequire("cNy9K");

var $cmqZo = parcelRequire("cmqZo");
function $2663841f55898ac1$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $cmqZo.getAggEndpoint)(request, cacheConfig);
    const body = (0, $cmqZo.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json'
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $2663841f55898ac1$export$21fcfd9d5c6ebbd4 = (0, $cNy9K.Network).create($2663841f55898ac1$var$fetchQuery);

});

parcelRegister("iBFHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $035a85083c70fbef$export$2e2bcd8739ae039);

var $lEfVV = parcelRequire("lEfVV");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$035a85083c70fbef$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // Enable batch updates for state changes scheduled by Relay. In React 18 this will be
        // superseded by `React.startTransition` or removed entirely if Relay enable batch updates by
        // default.
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
            fn();
        });
        return '';
    }
};

});


parcelRegister("4nnPJ", function(module, exports) {

$parcel$export(module.exports, "GlobalPageLoadExperience", () => $f2a0338addd29e74$export$bf7c1e56255f1467);

var $6coAu = parcelRequire("6coAu");

var $e8Y19 = parcelRequire("e8Y19");

var $12kyE = parcelRequire("12kyE");

var $2Khqb = parcelRequire("2Khqb");
class $f2a0338addd29e74$var$UFOGlobalPageLoadExperience extends (0, $e8Y19.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $e8Y19.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args);
        this.loadingPageLoadId = 'UNKNOWN';
        this.type = (0, $12kyE.ExperienceTypes).Load;
        this.performanceType = (0, $12kyE.ExperiencePerformanceTypes).PageLoad;
        this.initial = true;
    }
}
const $f2a0338addd29e74$export$bf7c1e56255f1467 = new $f2a0338addd29e74$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $6coAu.untilAll)([
        {
            category: (0, $2Khqb.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("6coAu", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $a05a5dd59924faf3$export$44695628831598be);

var $L0eva = parcelRequire("L0eva");

var $liN9S = parcelRequire("liN9S");
const $a05a5dd59924faf3$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $a05a5dd59924faf3$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $a05a5dd59924faf3$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($a05a5dd59924faf3$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($a05a5dd59924faf3$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $liN9S.UFOExperienceState).ABORTED || data.state === (0, $liN9S.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $L0eva.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $liN9S.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("liN9S", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $55ae6648ca41fb22$export$81b70111112841a0);
const $55ae6648ca41fb22$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("e8Y19", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $a4269200cbf0c97b$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $a4269200cbf0c97b$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $1vxVh = parcelRequire("1vxVh");

var $2OtXX = parcelRequire("2OtXX");

var $L0eva = parcelRequire("L0eva");

var $1zivP = parcelRequire("1zivP");

var $2mh9F = parcelRequire("2mh9F");

var $9rqMH = parcelRequire("9rqMH");

var $liN9S = parcelRequire("liN9S");

var $5l5pG = parcelRequire("5l5pG");

var $12kyE = parcelRequire("12kyE");
const $a4269200cbf0c97b$var$getPageVisibleState = ()=>{
    return !(0, $1vxVh.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $2mh9F.PageVisibleState).VISIBLE : (0, $2mh9F.PageVisibleState).HIDDEN;
};
const $a4269200cbf0c97b$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9rqMH.roundPerfNow)();
};
class $a4269200cbf0c97b$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $liN9S.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $2mh9F.PageVisibleState).MIXED;
            (0, $1zivP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $a4269200cbf0c97b$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $L0eva.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $5l5pG.canTransition)(this.state, newState)) {
            (0, $L0eva.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $liN9S.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.unsubscribeEvent)((0, $2mh9F.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $L0eva.ufolog)('this.parent', this.parent);
                (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $L0eva.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $L0eva.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $liN9S.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $a4269200cbf0c97b$var$getPageVisibleState();
            (0, $1zivP.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $L0eva.ufolog)('subscribed', this.id);
                (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.subscribeEvent)((0, $2mh9F.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $2mh9F.FMP_MARK) && name !== (0, $2mh9F.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $L0eva.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $liN9S.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $2mh9F.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $2mh9F.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $L0eva.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1zivP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $L0eva.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $6ddab31b75c80c2b$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $6ddab31b75c80c2b$export$2295b861f318254a = '0.1.5';

parcelRegister("9rqMH", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $0de24159cdedfae7$export$5f490af6b2b115cf);
const $0de24159cdedfae7$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("5l5pG", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $63afb23507bea36e$export$178881f329fdb81f);

var $liN9S = parcelRequire("liN9S");
const $63afb23507bea36e$var$UFOStateAvailableTransitions = {
    [(0, $liN9S.UFOExperienceState).NOT_STARTED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).STARTED.id]: [
        (0, $liN9S.UFOExperienceState).IN_PROGRESS.id,
        (0, $liN9S.UFOExperienceState).BLOCKED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $liN9S.UFOExperienceState).BLOCKED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).BLOCKED.id]: [
        (0, $liN9S.UFOExperienceState).RECOVERED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).RECOVERED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).SUCCEEDED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).FAILED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).ABORTED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ]
};
const $63afb23507bea36e$export$178881f329fdb81f = (state1, state2)=>{
    return $63afb23507bea36e$var$UFOStateAvailableTransitions[state1.id] && $63afb23507bea36e$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("2Khqb", function(module, exports) {

$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $c52c445b33fd5379$export$17d97452062ccf73);
const $c52c445b33fd5379$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("ULuRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e5dd9fa284eb0a0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useUFOTransitionCompleter", () => $2e5dd9fa284eb0a0$export$369f0ded13ce6c50);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $1qnta = parcelRequire("1qnta");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");

var $5mUK8 = parcelRequire("5mUK8");
function $2e5dd9fa284eb0a0$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $4vWWq.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $fVaJL.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $fVaJL.abortAll)('transition', ufoName ?? undefined);
    // if (ff('uip.vc')) {
    //     startTTVC();
    // }
    if (ufoName) {
        (0, $7sbhX.default).current = ufoName;
        const rate = (0, $4vWWq.getInteractionRate)(ufoName, 'transition');
        if ((0, $dZdw5.default)(rate)) {
            const newId = (0, $hompL.v4)();
            (0, $5mUK8.setInteractionActiveTrace)(newId);
            (0, $gnIbC.DefaultInteractionID).current = newId;
            (0, $fVaJL.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $1qnta.getActiveTrace)());
        }
    }
}
function $2e5dd9fa284eb0a0$export$369f0ded13ce6c50() {
    const interactionId = (0, $eUqFw.useContext)((0, $gnIbC.default));
    const capturedInteractionId = interactionId.current;
    (0, $eUqFw.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $fVaJL.tryComplete)(capturedInteractionId);
                });
            });
            (0, $fVaJL.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}

});
parcelRegister("7sbhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9af190a9fc98ce7e$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $9af190a9fc98ce7e$var$UFORouteName = {
    current: null
};
var $9af190a9fc98ce7e$export$2e2bcd8739ae039 = $9af190a9fc98ce7e$var$UFORouteName;

});

parcelRegister("5mUK8", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $24c3b7a29ca91e88$export$f2e521e495a88544);

var $1qnta = parcelRequire("1qnta");

var $8DZUI = parcelRequire("8DZUI");
const $24c3b7a29ca91e88$export$f2e521e495a88544 = (newId)=>{
    (0, $1qnta.setActiveTrace)(newId.replace(/-/g, ''), (0, $8DZUI.generateSpanId)(), 'transition');
};

});
parcelRegister("8DZUI", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $aa261924b323c8fb$export$295213bc4d0c54ad);
const $aa261924b323c8fb$export$295213bc4d0c54ad = ()=>Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');

});



parcelRegister("lEpcX", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $fc30e329ed70ed77$export$b0c5c2fac8144e54);

var $e8lvv = parcelRequire("e8lvv");

var $c1Zqr = parcelRequire("c1Zqr");
const $fc30e329ed70ed77$export$b0c5c2fac8144e54 = {
    pageLoad: $c1Zqr.pageLoad,
    pageSegmentLoad: $c1Zqr.pageSegmentLoad,
    interaction: $c1Zqr.interaction,
    custom: $c1Zqr.custom,
    concurrent: $e8lvv.concurrent
};

});
parcelRegister("e8lvv", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $a4a27eeb37e1a88c$export$370df09ecc3de059);

var $8KzZJ = parcelRequire("8KzZJ");

var $c1Zqr = parcelRequire("c1Zqr");
const $a4a27eeb37e1a88c$var$concurrentMetrics = {};
const $a4a27eeb37e1a88c$var$getKey = (config, type)=>`${type}--${config.key}`;
const $a4a27eeb37e1a88c$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $a4a27eeb37e1a88c$var$ensurePath = (config, type)=>{
    const key = $a4a27eeb37e1a88c$var$getKey(config, type);
    if (!(key in $a4a27eeb37e1a88c$var$concurrentMetrics)) $a4a27eeb37e1a88c$var$concurrentMetrics[key] = {};
};
const $a4a27eeb37e1a88c$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $a4a27eeb37e1a88c$var$getKey(config, type);
    if (concurrentKey in $a4a27eeb37e1a88c$var$concurrentMetrics && $a4a27eeb37e1a88c$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $a4a27eeb37e1a88c$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $a4a27eeb37e1a88c$var$concurrentMetrics)) $a4a27eeb37e1a88c$var$concurrentMetrics[concurrentKey] = {};
};
const $a4a27eeb37e1a88c$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $a4a27eeb37e1a88c$var$validateConfig(config);
    $a4a27eeb37e1a88c$var$ensurePath(config, type);
    const metricFromCache = $a4a27eeb37e1a88c$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $8KzZJ.BMEventsType).INLINE_RESULT ? (0, $c1Zqr.interaction) : (0, $c1Zqr.custom);
    const metric = metricFactory(config);
    $a4a27eeb37e1a88c$var$concurrentMetrics[$a4a27eeb37e1a88c$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $a4a27eeb37e1a88c$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$a4a27eeb37e1a88c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $8KzZJ.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$a4a27eeb37e1a88c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $8KzZJ.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$a4a27eeb37e1a88c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $8KzZJ.BMEventsType).CUSTOM)
};

});
parcelRegister("c1Zqr", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $8c2539da17af5fc6$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $8c2539da17af5fc6$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $8c2539da17af5fc6$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $8c2539da17af5fc6$export$4c00f665f0d4b443);

var $kXLyf = parcelRequire("kXLyf");

var $l0D5F = parcelRequire("l0D5F");

var $946ir = parcelRequire("946ir");

var $8KzZJ = parcelRequire("8KzZJ");
const $8c2539da17af5fc6$export$791d520f7e8058a5 = (config)=>{
    return new (0, $l0D5F.PageLoadMetric)({
        ...config,
        type: (0, $8KzZJ.BMEventsType).PAGE_LOAD
    });
};
const $8c2539da17af5fc6$export$94114666844d5f66 = (config)=>{
    return new (0, $946ir.PageSegmentLoadMetric)({
        ...config,
        type: (0, $8KzZJ.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $8c2539da17af5fc6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $kXLyf.Metric)({
        ...config,
        type: (0, $8KzZJ.BMEventsType).INLINE_RESULT
    });
};
const $8c2539da17af5fc6$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $kXLyf.Metric)({
        ...config,
        type: (0, $8KzZJ.BMEventsType).CUSTOM
    });
};

});
parcelRegister("kXLyf", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $f42e3410de032399$export$efdd3e096bc27746);

var $ijOHt = parcelRequire("ijOHt");

var $23TA2 = parcelRequire("23TA2");

var $dKprl = parcelRequire("dKprl");
class $f42e3410de032399$export$efdd3e096bc27746 extends (0, $dKprl.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $ijOHt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $23TA2.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("l0D5F", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $f4b7eb94d44ccecc$export$3c51073271a9eac3);

var $jOeKw = parcelRequire("jOeKw");

var $gjwQd = parcelRequire("gjwQd");

var $ijOHt = parcelRequire("ijOHt");

var $23TA2 = parcelRequire("23TA2");

var $8KzZJ = parcelRequire("8KzZJ");

var $fLUaq = parcelRequire("fLUaq");

var $gCKcK = parcelRequire("gCKcK");

var $dN18c = parcelRequire("dN18c");
class $f4b7eb94d44ccecc$export$3c51073271a9eac3 extends (0, $fLUaq.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $gCKcK.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        var _this$config$ssr;
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $gCKcK.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $gCKcK.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[(0, $fLUaq.BasePageLoadMetric).FMP]) {
                const mark = (0, $jOeKw.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $gCKcK.pageLoadMetaMetric).markFMP(mark);
            } else (0, $gCKcK.pageLoadMetaMetric).markFMP(this.marks[(0, $fLUaq.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $ijOHt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $23TA2.submitter).queue(data);
        (0, $gjwQd.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $gCKcK.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $gCKcK.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $gCKcK.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        var _configChunk$BMEvents;
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $23TA2.submitter).config.configChunk;
        if (!(configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $8KzZJ.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled)) return false;
        const webVitalMetric = new (0, $dN18c.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $23TA2.submitter).queue(webVitalMetric.getData());
        (0, $gjwQd.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("dN18c", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $a0a0baa1c63287bb$export$dc0d85d4d6503cd7);

var $8KzZJ = parcelRequire("8KzZJ");

var $dKprl = parcelRequire("dKprl");
class $a0a0baa1c63287bb$export$dc0d85d4d6503cd7 extends (0, $dKprl.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $8KzZJ.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $dKprl.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("946ir", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $69995f1bfb8843dc$export$24c8bfcd77494cc1);

var $5zQU9 = parcelRequire("5zQU9");

var $8KzZJ = parcelRequire("8KzZJ");

var $dKprl = parcelRequire("dKprl");

var $kXLyf = parcelRequire("kXLyf");

var $gCKcK = parcelRequire("gCKcK");
class $69995f1bfb8843dc$export$24c8bfcd77494cc1 extends (0, $kXLyf.Metric) {
    constructor(config){
        super(config);
        (0, $5zQU9.default)(this, "isInitial", true);
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $gCKcK.pageLoadMetaMetric).getData();
        this.startTime = pageLoadMetaData.start;
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
        this.state = (0, $dKprl.MetricState).STARTED;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $69995f1bfb8843dc$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($69995f1bfb8843dc$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $gCKcK.pageLoadMetaMetric).getData();
        if (this.config.includePageLoadTimings !== (0, $8KzZJ.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $dKprl.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $dKprl.MetricState).STARTED) (0, $gCKcK.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}
(0, $5zQU9.default)($69995f1bfb8843dc$export$24c8bfcd77494cc1, "FMP", 'fmp');

});




parcelRegister("df4Sl", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $9a40753b2274e68f$export$1e511d4a378977f5, (v) => $9a40753b2274e68f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "defaultMemoize", () => $9a40753b2274e68f$export$281bff7f05488aa2, (v) => $9a40753b2274e68f$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $9a40753b2274e68f$export$5943f4447f6ef248, (v) => $9a40753b2274e68f$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $9a40753b2274e68f$export$75979cfcd91bf38f, (v) => $9a40753b2274e68f$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $9a40753b2274e68f$export$595d22ed68ca2841, (v) => $9a40753b2274e68f$export$595d22ed68ca2841 = v);
var $9a40753b2274e68f$export$1e511d4a378977f5;
var $9a40753b2274e68f$export$281bff7f05488aa2;
var $9a40753b2274e68f$export$5943f4447f6ef248;
var $9a40753b2274e68f$export$75979cfcd91bf38f;
var $9a40753b2274e68f$export$595d22ed68ca2841;
'use strict';
$9a40753b2274e68f$export$1e511d4a378977f5 = true;
$9a40753b2274e68f$export$281bff7f05488aa2 = $9a40753b2274e68f$var$defaultMemoize;
$9a40753b2274e68f$export$5943f4447f6ef248 = $9a40753b2274e68f$var$createSelectorCreator;
$9a40753b2274e68f$export$75979cfcd91bf38f = $9a40753b2274e68f$var$createStructuredSelector;
function $9a40753b2274e68f$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9a40753b2274e68f$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9a40753b2274e68f$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9a40753b2274e68f$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9a40753b2274e68f$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9a40753b2274e68f$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9a40753b2274e68f$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9a40753b2274e68f$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $9a40753b2274e68f$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9a40753b2274e68f$var$createSelector = $9a40753b2274e68f$export$595d22ed68ca2841 = $9a40753b2274e68f$var$createSelectorCreator($9a40753b2274e68f$var$defaultMemoize);
function $9a40753b2274e68f$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9a40753b2274e68f$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("iPaeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

$fKE23.__exportStar((parcelRequire("B4QHA")), module.exports);

});
parcelRegister("B4QHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesMeetConditions = void 0;

var $4VRD8 = parcelRequire("4VRD8");
var $06f737bb8ca63e5e$var$AND_OPERATION = 'and';
var $06f737bb8ca63e5e$var$OR_OPERATION = 'or';
var $06f737bb8ca63e5e$var$NOT_OPERATION = 'not';
var $06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS = [
    $06f737bb8ca63e5e$var$AND_OPERATION,
    $06f737bb8ca63e5e$var$OR_OPERATION,
    $06f737bb8ca63e5e$var$NOT_OPERATION
];
var $06f737bb8ca63e5e$var$SKIP_INSTRUCTION = 'skip';
var $06f737bb8ca63e5e$var$isObject = function(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
};
var $06f737bb8ca63e5e$var$unhandledOperation = function(operation) {
    throw new Error($4VRD8.errors.unhandledOperation(operation));
};
var $06f737bb8ca63e5e$var$checkOperation = function(conditionsInput, staticContextInput, operation, nesting) {
    if (nesting === void 0) nesting = 0;
    if (nesting >= 10) throw Error($4VRD8.errors.nestingOvercomplicated());
    var conditions = $06f737bb8ca63e5e$var$isObject(conditionsInput) ? conditionsInput : {};
    var staticContext = $06f737bb8ca63e5e$var$isObject(staticContextInput) ? staticContextInput : {};
    var staticKeys = Object.keys(conditions).filter(function(key) {
        return !$06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS.includes(key);
    });
    var operationEntries = Object.entries(conditions).filter(function(_a) {
        var key = _a[0];
        return $06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS.includes(key);
    });
    var staticKeysLength = staticKeys.length;
    var operationsLength = operationEntries.length;
    var staticEqualityComparator = function(key) {
        return (Array.isArray(conditions[key]) ? conditions[key] : [
            conditions[key]
        ]).includes(staticContext[key]);
    };
    if (staticKeysLength === 0 && operationsLength === 0) return $06f737bb8ca63e5e$var$SKIP_INSTRUCTION;
    if (staticKeysLength !== 0) switch(operation){
        case $06f737bb8ca63e5e$var$AND_OPERATION:
            if (!staticKeys.every(staticEqualityComparator)) return false;
            break;
        case $06f737bb8ca63e5e$var$OR_OPERATION:
            if (staticKeys.some(staticEqualityComparator)) return true;
            break;
        case $06f737bb8ca63e5e$var$NOT_OPERATION:
            if (staticKeys.some(function(key) {
                return !staticEqualityComparator(key);
            })) return true;
            break;
        default:
            return $06f737bb8ca63e5e$var$unhandledOperation(operation);
    }
    for(var index = 0; index < operationEntries.length; index += 1){
        var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
        var nextOperationResult = $06f737bb8ca63e5e$var$checkOperation(nextConditions, staticContext, nextOperation, nesting + 1);
        switch(operation){
            case $06f737bb8ca63e5e$var$AND_OPERATION:
                if (nextOperationResult === false) return false;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : true;
                break;
            case $06f737bb8ca63e5e$var$OR_OPERATION:
                if (nextOperationResult === true) return true;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : false;
                break;
            case $06f737bb8ca63e5e$var$NOT_OPERATION:
                if (nextOperationResult === false) return true;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : false;
                break;
            default:
                return $06f737bb8ca63e5e$var$unhandledOperation(operation);
        }
    }
    switch(operation){
        case $06f737bb8ca63e5e$var$AND_OPERATION:
            return true;
        case $06f737bb8ca63e5e$var$OR_OPERATION:
            return false;
        case $06f737bb8ca63e5e$var$NOT_OPERATION:
            return false;
        default:
            return $06f737bb8ca63e5e$var$unhandledOperation(operation);
    }
};
module.exports.doesMeetConditions = function(conditions, staticContext) {
    try {
        var result = $06f737bb8ca63e5e$var$checkOperation(conditions, staticContext, $06f737bb8ca63e5e$var$AND_OPERATION);
        return result === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION ? true : result;
    } catch (_a) {
        return false;
    }
};

});
parcelRegister("4VRD8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errors = void 0;
module.exports.errors = {
    nestingOvercomplicated: function() {
        return 'Nesting of display conditions exceeds 10 levels';
    },
    unhandledOperation: function(operation) {
        return "Unhandled operation: " + operation;
    }
};

});



parcelRegister("2y3XF", function(module, exports) {
module.exports = $1db1d460693008df$var$defaultsPlugin;
function $1db1d460693008df$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("gleLd", function(module, exports) {
var $be5a0ea507855c2a$var$namespace = 'expire_mixin';
module.exports = $be5a0ea507855c2a$var$expirePlugin;
function $be5a0ea507855c2a$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $be5a0ea507855c2a$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("ZGlKn", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $0b968c6645c3089e$var$slice = $7jNqu.slice;
var $0b968c6645c3089e$var$pluck = $7jNqu.pluck;
var $0b968c6645c3089e$var$each = $7jNqu.each;
var $0b968c6645c3089e$var$bind = $7jNqu.bind;
var $0b968c6645c3089e$var$create = $7jNqu.create;
var $0b968c6645c3089e$var$isList = $7jNqu.isList;
var $0b968c6645c3089e$var$isFunction = $7jNqu.isFunction;
var $0b968c6645c3089e$var$isObject = $7jNqu.isObject;
module.exports = {
    createStore: $0b968c6645c3089e$var$createStore
};
var $0b968c6645c3089e$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $0b968c6645c3089e$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $0b968c6645c3089e$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $0b968c6645c3089e$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $0b968c6645c3089e$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$0b968c6645c3089e$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$0b968c6645c3089e$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $0b968c6645c3089e$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $0b968c6645c3089e$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($0b968c6645c3089e$var$isList(plugin)) {
                $0b968c6645c3089e$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $0b968c6645c3089e$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$0b968c6645c3089e$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$0b968c6645c3089e$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $0b968c6645c3089e$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$0b968c6645c3089e$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $0b968c6645c3089e$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $0b968c6645c3089e$var$create(_privateStoreProps, $0b968c6645c3089e$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $0b968c6645c3089e$var$each(store, function(prop, propName) {
        if ($0b968c6645c3089e$var$isFunction(prop)) store.raw[propName] = $0b968c6645c3089e$var$bind(store, prop);
    });
    $0b968c6645c3089e$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $0b968c6645c3089e$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("7jNqu", function(module, exports) {
var $5540a5c51161c92f$var$assign = $5540a5c51161c92f$var$make_assign();
var $5540a5c51161c92f$var$create = $5540a5c51161c92f$var$make_create();
var $5540a5c51161c92f$var$trim = $5540a5c51161c92f$var$make_trim();
var $5540a5c51161c92f$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $5540a5c51161c92f$var$assign,
    create: $5540a5c51161c92f$var$create,
    trim: $5540a5c51161c92f$var$trim,
    bind: $5540a5c51161c92f$var$bind,
    slice: $5540a5c51161c92f$var$slice,
    each: $5540a5c51161c92f$var$each,
    map: $5540a5c51161c92f$var$map,
    pluck: $5540a5c51161c92f$var$pluck,
    isList: $5540a5c51161c92f$var$isList,
    isFunction: $5540a5c51161c92f$var$isFunction,
    isObject: $5540a5c51161c92f$var$isObject,
    Global: $5540a5c51161c92f$var$Global
};
function $5540a5c51161c92f$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$5540a5c51161c92f$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $5540a5c51161c92f$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $5540a5c51161c92f$var$slice(arguments, 1);
        return $5540a5c51161c92f$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $5540a5c51161c92f$var$slice(arguments, 1);
            F.prototype = obj;
            return $5540a5c51161c92f$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $5540a5c51161c92f$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $5540a5c51161c92f$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $5540a5c51161c92f$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $5540a5c51161c92f$var$each(obj, fn) {
    $5540a5c51161c92f$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $5540a5c51161c92f$var$map(obj, fn) {
    var res = $5540a5c51161c92f$var$isList(obj) ? [] : {};
    $5540a5c51161c92f$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $5540a5c51161c92f$var$pluck(obj, fn) {
    if ($5540a5c51161c92f$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $5540a5c51161c92f$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $5540a5c51161c92f$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $5540a5c51161c92f$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("5rWiD", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $3f7cb275f8e060aa$var$Global = $7jNqu.Global;
module.exports = {
    name: 'localStorage',
    read: $3f7cb275f8e060aa$var$read,
    write: $3f7cb275f8e060aa$var$write,
    each: $3f7cb275f8e060aa$var$each,
    remove: $3f7cb275f8e060aa$var$remove,
    clearAll: $3f7cb275f8e060aa$var$clearAll
};
function $3f7cb275f8e060aa$var$localStorage() {
    return $3f7cb275f8e060aa$var$Global.localStorage;
}
function $3f7cb275f8e060aa$var$read(key) {
    return $3f7cb275f8e060aa$var$localStorage().getItem(key);
}
function $3f7cb275f8e060aa$var$write(key, data) {
    return $3f7cb275f8e060aa$var$localStorage().setItem(key, data);
}
function $3f7cb275f8e060aa$var$each(fn) {
    for(var i = $3f7cb275f8e060aa$var$localStorage().length - 1; i >= 0; i--){
        var key = $3f7cb275f8e060aa$var$localStorage().key(i);
        fn($3f7cb275f8e060aa$var$read(key), key);
    }
}
function $3f7cb275f8e060aa$var$remove(key) {
    return $3f7cb275f8e060aa$var$localStorage().removeItem(key);
}
function $3f7cb275f8e060aa$var$clearAll() {
    return $3f7cb275f8e060aa$var$localStorage().clear();
}

});

parcelRegister("gpWeB", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $bf3c274d25fc0e14$var$read,
    write: $bf3c274d25fc0e14$var$write,
    each: $bf3c274d25fc0e14$var$each,
    remove: $bf3c274d25fc0e14$var$remove,
    clearAll: $bf3c274d25fc0e14$var$clearAll
};
var $bf3c274d25fc0e14$var$memoryStorage = {};
function $bf3c274d25fc0e14$var$read(key) {
    return $bf3c274d25fc0e14$var$memoryStorage[key];
}
function $bf3c274d25fc0e14$var$write(key, data) {
    $bf3c274d25fc0e14$var$memoryStorage[key] = data;
}
function $bf3c274d25fc0e14$var$each(callback) {
    for(var key in $bf3c274d25fc0e14$var$memoryStorage)if ($bf3c274d25fc0e14$var$memoryStorage.hasOwnProperty(key)) callback($bf3c274d25fc0e14$var$memoryStorage[key], key);
}
function $bf3c274d25fc0e14$var$remove(key) {
    delete $bf3c274d25fc0e14$var$memoryStorage[key];
}
function $bf3c274d25fc0e14$var$clearAll(key) {
    $bf3c274d25fc0e14$var$memoryStorage = {};
}

});

parcelRegister("224h2", function(module, exports) {

var $6ZDS2 = parcelRequire("6ZDS2");

var $6aRM9 = parcelRequire("6aRM9");

var $ly0Gc = parcelRequire("ly0Gc");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $17af155c4b8942b9$var$flatRest(func) {
    return $ly0Gc($6aRM9(func, undefined, $6ZDS2), func + '');
}
module.exports = $17af155c4b8942b9$var$flatRest;

});

parcelRegister("kDfSL", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $a22cc5f9db02daee$export$c00d22927c60484a);

var $e8Y19 = parcelRequire("e8Y19");
class $a22cc5f9db02daee$export$c00d22927c60484a extends (0, $e8Y19.UFOAbstractExperience) {
}

});

parcelRegister("7PHyj", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $5b3f14712986d9ef$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5b3f14712986d9ef$var$isBoolean(value) {
    return value === true || value === false || $hYEMs(value) && $2OY5s(value) == $5b3f14712986d9ef$var$boolTag;
}
module.exports = $5b3f14712986d9ef$var$isBoolean;

});

parcelRegister("hvbu2", function(module, exports) {

var $8ua71 = parcelRequire("8ua71");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $cbde3d4cc86967f1$var$values(object) {
    return object == null ? [] : $8ua71(object, $8nrDO(object));
}
module.exports = $cbde3d4cc86967f1$var$values;

});
parcelRegister("8ua71", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $62d8f82e40088c8a$var$baseValues(object, props) {
    return $kJvGp(props, function(key) {
        return object[key];
    });
}
module.exports = $62d8f82e40088c8a$var$baseValues;

});


parcelRegister("53ciZ", function(module, exports) {

$parcel$export(module.exports, "extract", () => $3ad6c71f9180779f$export$f9380c9a627682d3, (v) => $3ad6c71f9180779f$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $3ad6c71f9180779f$export$98e6a39c04603d36, (v) => $3ad6c71f9180779f$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $3ad6c71f9180779f$export$fac44ee5b035f737, (v) => $3ad6c71f9180779f$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $3ad6c71f9180779f$export$7a5253c0f62e0150, (v) => $3ad6c71f9180779f$export$7a5253c0f62e0150 = v);
var $3ad6c71f9180779f$export$f9380c9a627682d3;
var $3ad6c71f9180779f$export$98e6a39c04603d36;
var $3ad6c71f9180779f$export$fac44ee5b035f737;
var $3ad6c71f9180779f$export$7a5253c0f62e0150;
'use strict';

var $bEWE2 = parcelRequire("bEWE2");

var $8aUjw = parcelRequire("8aUjw");

var $bJEvY = parcelRequire("bJEvY");
function $3ad6c71f9180779f$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[',
                    $3ad6c71f9180779f$var$encode(index, opts),
                    ']=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $3ad6c71f9180779f$var$encode(key, opts) : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[]=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $3ad6c71f9180779f$var$encode(key, opts) : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
    }
}
function $3ad6c71f9180779f$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ad6c71f9180779f$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $bEWE2(value) : encodeURIComponent(value);
    return value;
}
function $3ad6c71f9180779f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $3ad6c71f9180779f$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $3ad6c71f9180779f$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $3ad6c71f9180779f$var$parse(str, opts) {
    opts = $8aUjw({
        arrayFormat: 'none'
    }, opts);
    var formatter = $3ad6c71f9180779f$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $bJEvY(val);
        formatter($bJEvY(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $3ad6c71f9180779f$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$3ad6c71f9180779f$export$f9380c9a627682d3 = $3ad6c71f9180779f$var$extract;
$3ad6c71f9180779f$export$98e6a39c04603d36 = $3ad6c71f9180779f$var$parse;
$3ad6c71f9180779f$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $8aUjw(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $3ad6c71f9180779f$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $3ad6c71f9180779f$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $3ad6c71f9180779f$var$encode(key, opts) + '=' + $3ad6c71f9180779f$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$3ad6c71f9180779f$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $3ad6c71f9180779f$var$parse($3ad6c71f9180779f$var$extract(str), opts)
    };
};

});
parcelRegister("bEWE2", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("8aUjw", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f3af0aacb50ec3b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f3af0aacb50ec3b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f3af0aacb50ec3b$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f3af0aacb50ec3b$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f3af0aacb50ec3b$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f3af0aacb50ec3b$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f3af0aacb50ec3b$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f3af0aacb50ec3b$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f3af0aacb50ec3b$var$getOwnPropertySymbols) {
            symbols = $5f3af0aacb50ec3b$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f3af0aacb50ec3b$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("9t7rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c99d1e49d5bdb$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $6e4c99d1e49d5bdb$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("232mI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e388bd48350b23$export$2e2bcd8739ae039);

var $9OjEv = parcelRequire("9OjEv");
var $f1e388bd48350b23$export$2e2bcd8739ae039 = (0, $9OjEv.default);

});
parcelRegister("9OjEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7c5fd9af476ef0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9oL1R = parcelRequire("9oL1R");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");

var $hsSud = parcelRequire("hsSud");
let $dc7c5fd9af476ef0$var$tryCompleteHandle;
function $dc7c5fd9af476ef0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    const parentContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const segmentId = (0, $eUqFw.useMemo)(()=>(0, $hsSud.default)(), []);
    const labelStack = (0, $eUqFw.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ], [
        parentContext,
        segmentName,
        segmentId
    ]);
    const interactionId = (0, $eUqFw.useContext)((0, $gnIbC.default));
    const interactionContext = (0, $eUqFw.useMemo)(()=>{
        (0, $fVaJL.addSegment)(labelStack);
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($dc7c5fd9af476ef0$var$tryCompleteHandle) cancelAnimationFrame?.($dc7c5fd9af476ef0$var$tryCompleteHandle);
                    (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_NormalPriority), ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            const enableCompleteUsingDoubleRAF = (0, $4vWWq.getConfig)()?.enableCompleteUsingDoubleRAF ?? false;
                            if (enableCompleteUsingDoubleRAF && isPageVisible && canDoRAF) $dc7c5fd9af476ef0$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $dc7c5fd9af476ef0$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $fVaJL.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $fVaJL.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    });
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $fVaJL.addHold)(interactionId.current, labelStack, name);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $fVaJL.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $fVaJL.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                if (interactionId.current != null) (0, $fVaJL.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $4vWWq.getInteractionRate)(name, 'press');
                if ((0, $dZdw5.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    const newId = (0, $hsSud.default)();
                    interactionId.current = newId;
                    (0, $fVaJL.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $7sbhX.default).current);
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $fVaJL.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $fVaJL.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $fVaJL.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $fVaJL.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $fVaJL.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $fVaJL.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $fVaJL.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $fVaJL.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        interactionId
    ]);
    const onRender = (0, $eUqFw.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            (0, $fVaJL.removeSegment)(labelStack);
        }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $eUqFw.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iuyH.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
}

});
parcelRegister("hsSud", function(module, exports) {

$parcel$export(module.exports, "default", () => $da942cb1057ef541$export$2e2bcd8739ae039);
function $da942cb1057ef541$export$2e2bcd8739ae039(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}

});



parcelRegister("c8Guq", function(module, exports) {

var $fpEqY = parcelRequire("fpEqY");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $8d6730f25ee9d2fa$var$flow = $fpEqY();
module.exports = $8d6730f25ee9d2fa$var$flow;

});
parcelRegister("fpEqY", function(module, exports) {

var $9xdpl = parcelRequire("9xdpl");

var $224h2 = parcelRequire("224h2");

var $6bTTb = parcelRequire("6bTTb");

var $hNaPv = parcelRequire("hNaPv");

var $1c8hB = parcelRequire("1c8hB");

var $cp9gS = parcelRequire("cp9gS");
/** Error message constants. */ var $b3888e314dbeb79d$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $b3888e314dbeb79d$var$WRAP_CURRY_FLAG = 8, $b3888e314dbeb79d$var$WRAP_PARTIAL_FLAG = 32, $b3888e314dbeb79d$var$WRAP_ARY_FLAG = 128, $b3888e314dbeb79d$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $b3888e314dbeb79d$var$createFlow(fromRight) {
    return $224h2(function(funcs) {
        var length = funcs.length, index = length, prereq = $9xdpl.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($b3888e314dbeb79d$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $hNaPv(func) == 'wrapper') var wrapper = new $9xdpl([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $hNaPv(func), data = funcName == 'wrapper' ? $6bTTb(func) : undefined;
            if (data && $cp9gS(data[0]) && data[1] == ($b3888e314dbeb79d$var$WRAP_ARY_FLAG | $b3888e314dbeb79d$var$WRAP_CURRY_FLAG | $b3888e314dbeb79d$var$WRAP_PARTIAL_FLAG | $b3888e314dbeb79d$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$hNaPv(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $cp9gS(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $1c8hB(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $b3888e314dbeb79d$var$createFlow;

});
parcelRegister("9xdpl", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $2YyaX = parcelRequire("2YyaX");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $6f1198a73916bb8b$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$6f1198a73916bb8b$var$LodashWrapper.prototype = $9F9XB($2YyaX.prototype);
$6f1198a73916bb8b$var$LodashWrapper.prototype.constructor = $6f1198a73916bb8b$var$LodashWrapper;
module.exports = $6f1198a73916bb8b$var$LodashWrapper;

});
parcelRegister("2YyaX", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $22abb1f8c23ed823$var$baseLodash() {
// No operation performed.
}
module.exports = $22abb1f8c23ed823$var$baseLodash;

});


parcelRegister("6bTTb", function(module, exports) {

var $beYtW = parcelRequire("beYtW");

var $jG2Eu = parcelRequire("jG2Eu");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $481f1f8dc967c82b$var$getData = !$beYtW ? $jG2Eu : function(func) {
    return $beYtW.get(func);
};
module.exports = $481f1f8dc967c82b$var$getData;

});
parcelRegister("beYtW", function(module, exports) {

var $dFXwz = parcelRequire("dFXwz");
/** Used to store function metadata. */ var $82efeaf6ac20d822$var$metaMap = $dFXwz && new $dFXwz;
module.exports = $82efeaf6ac20d822$var$metaMap;

});


parcelRegister("hNaPv", function(module, exports) {

var $g25CO = parcelRequire("g25CO");
/** Used for built-in method references. */ var $cf3f69db4573ada3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cf3f69db4573ada3$var$hasOwnProperty = $cf3f69db4573ada3$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $cf3f69db4573ada3$var$getFuncName(func) {
    var result = func.name + '', array = $g25CO[result], length = $cf3f69db4573ada3$var$hasOwnProperty.call($g25CO, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $cf3f69db4573ada3$var$getFuncName;

});
parcelRegister("g25CO", function(module, exports) {
/** Used to lookup unminified function names. */ var $bac1323da4446d2f$var$realNames = {};
module.exports = $bac1323da4446d2f$var$realNames;

});


parcelRegister("cp9gS", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $6bTTb = parcelRequire("6bTTb");

var $hNaPv = parcelRequire("hNaPv");

var $bqBQL = parcelRequire("bqBQL");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $907f02e660ccd17b$var$isLaziable(func) {
    var funcName = $hNaPv(func), other = $bqBQL[funcName];
    if (typeof other != 'function' || !(funcName in $jZYVT.prototype)) return false;
    if (func === other) return true;
    var data = $6bTTb(other);
    return !!data && func === data[0];
}
module.exports = $907f02e660ccd17b$var$isLaziable;

});
parcelRegister("jZYVT", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $2YyaX = parcelRequire("2YyaX");
/** Used as references for the maximum length and index of an array. */ var $e8f2face14749367$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $e8f2face14749367$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $e8f2face14749367$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$e8f2face14749367$var$LazyWrapper.prototype = $9F9XB($2YyaX.prototype);
$e8f2face14749367$var$LazyWrapper.prototype.constructor = $e8f2face14749367$var$LazyWrapper;
module.exports = $e8f2face14749367$var$LazyWrapper;

});

parcelRegister("bqBQL", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $9xdpl = parcelRequire("9xdpl");

var $2YyaX = parcelRequire("2YyaX");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");

var $edDMs = parcelRequire("edDMs");
/** Used for built-in method references. */ var $851f7b9fbf6fdb93$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $851f7b9fbf6fdb93$var$hasOwnProperty = $851f7b9fbf6fdb93$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $851f7b9fbf6fdb93$var$lodash(value) {
    if ($hYEMs(value) && !$1c8hB(value) && !(value instanceof $jZYVT)) {
        if (value instanceof $9xdpl) return value;
        if ($851f7b9fbf6fdb93$var$hasOwnProperty.call(value, '__wrapped__')) return $edDMs(value);
    }
    return new $9xdpl(value);
}
// Ensure wrappers are instances of `baseLodash`.
$851f7b9fbf6fdb93$var$lodash.prototype = $2YyaX.prototype;
$851f7b9fbf6fdb93$var$lodash.prototype.constructor = $851f7b9fbf6fdb93$var$lodash;
module.exports = $851f7b9fbf6fdb93$var$lodash;

});
parcelRegister("edDMs", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $9xdpl = parcelRequire("9xdpl");

var $b69Sx = parcelRequire("b69Sx");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $a5a1232fcca67a49$var$wrapperClone(wrapper) {
    if (wrapper instanceof $jZYVT) return wrapper.clone();
    var result = new $9xdpl(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $b69Sx(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $a5a1232fcca67a49$var$wrapperClone;

});





parcelRegister("lnRnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91527533b5c2cff$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
var $f91527533b5c2cff$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $eUqFw.Component) {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "fireClickEvent", (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            });
        }
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerComponent, (0, $kU09D.default)({}, this.props, {
                fireClickEvent: this.fireClickEvent
            }));
        }
    }
    return (0, $2jDha.default)()(EngagementEventsWrapper);
};

});

parcelRegister("5eM40", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d038af813b9e1df$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $3d038af813b9e1df$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $eUqFw.Component) {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "state", {
                message: null
            });
            (0, $5zQU9.default)(this, "onStoreChange", (state)=>{
                this.setState(computeNewState(state));
            });
        }
        UNSAFE_componentWillMount() {
            if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
        }
        componentWillUnmount() {
            if (this.unsubscribe) this.unsubscribe();
        }
        canSubscribe() {
            return this.context && this.context.subscribeEngagementState;
        }
        subscribeToStore() {
            return this.context.subscribeEngagementState(this.onStoreChange);
        }
        render() {
            const { children: children, engagementId: engagementId } = this.props;
            const { message: message } = this.state;
            if (!message) {
                if (componentType === 'inlineDialog') return children || null;
                return null;
            }
            if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
            const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
            // Key is useful here to make sure that when the currently active
            // messages changes, the old component is unmounted (therefore
            // firing an analytic event for hiding the component) and mounting
            // a new component for the new message (firing a shown event for
            // the new message). Not using key would allow React to apply an
            // optimization that would reuse the current component for a new
            // message which would not call the normal mount and unmount
            // lifecycle methods.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerComponent, (0, $kU09D.default)({
                key: messageKey
            }, this.props, message));
        }
    }
    (0, $5zQU9.default)(StoreWrapper, "contextTypes", {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    });
    return StoreWrapper;
};

});

parcelRegister("cIV0x", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", () => $9435d0a02624d87b$export$e7d79186651244da);
const $9435d0a02624d87b$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("lEGwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3e51134e27163a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $fc3e51134e27163a$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("6Pq2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8bb4caacfcbc85$export$2e2bcd8739ae039);

var $id9el = parcelRequire("id9el");

var $4f8bb4caacfcbc85$export$2e2bcd8739ae039 = (0, $id9el.default);

});
parcelRegister("id9el", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42099d57401c4cc$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $c16hR = parcelRequire("c16hR");

var $lzXvi = parcelRequire("lzXvi");
var $d42099d57401c4cc$var$FocusLockCombination = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $eUqFw.createElement((0, $c16hR.default), (0, $kU09D.default)({
        sideCar: (0, $lzXvi.default),
        ref: ref
    }, props));
});
var $d42099d57401c4cc$var$_ref = (0, $c16hR.default).propTypes || {}, $d42099d57401c4cc$var$sideCar = $d42099d57401c4cc$var$_ref.sideCar, $d42099d57401c4cc$var$propTypes = (0, $6XgOP.default)($d42099d57401c4cc$var$_ref, [
    "sideCar"
]);
$d42099d57401c4cc$var$FocusLockCombination.propTypes = {};
var $d42099d57401c4cc$export$2e2bcd8739ae039 = $d42099d57401c4cc$var$FocusLockCombination;

});
parcelRegister("c16hR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bfa747e7d11be41$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $9liOh = parcelRequire("9liOh");

var $kkWA2 = parcelRequire("kkWA2");

var $d2TZh = parcelRequire("d2TZh");

var $829XA = parcelRequire("829XA");

var $9Marc = parcelRequire("9Marc");
var $8bfa747e7d11be41$var$emptyArray = [];
var $8bfa747e7d11be41$var$FocusLock = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $eUqFw.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $eUqFw.useRef();
    var isActive = $eUqFw.useRef(false);
    var originalFocusedElement = $eUqFw.useRef(null);
    var _React$useState2 = $eUqFw.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $8bfa747e7d11be41$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $eUqFw.useState({}), id = _React$useState3[0];
    var onActivation = $eUqFw.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $eUqFw.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $eUqFw.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $eUqFw.useCallback(function(event) {
        if (isActive.current) (0, $829XA.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $829XA.mediumBlur).useMedium;
    var setObserveNode = $eUqFw.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $kU09D.default)((_extends2 = {}, _extends2[$9liOh.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$9liOh.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $kkWA2.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $eUqFw.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $d2TZh.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $d2TZh.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $eUqFw.createElement(SideCar, {
        id: id,
        sideCar: (0, $829XA.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $eUqFw.createElement(Container, (0, $kU09D.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $eUqFw.createElement((0, $9Marc.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $eUqFw.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $d2TZh.hiddenGuard)
    }));
});
$8bfa747e7d11be41$var$FocusLock.propTypes = {};
var $8bfa747e7d11be41$export$2e2bcd8739ae039 = $8bfa747e7d11be41$var$FocusLock;

});
parcelRegister("9liOh", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $6cd4aa7cfb25592a$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $6cd4aa7cfb25592a$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $6cd4aa7cfb25592a$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $6cd4aa7cfb25592a$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $6cd4aa7cfb25592a$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $6cd4aa7cfb25592a$export$4f9a06cb7441a087 = 'data-focus-lock';
var $6cd4aa7cfb25592a$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $6cd4aa7cfb25592a$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $6cd4aa7cfb25592a$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $6cd4aa7cfb25592a$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("kkWA2", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $ece31db3286b5afe$export$74665b213cb5c4cf);

var $iYh9J = parcelRequire("iYh9J");

var $kKhG5 = parcelRequire("kKhG5");
function $ece31db3286b5afe$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $kKhG5.useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("iYh9J", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $dcfb2365fcfb0cfb$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $dcfb2365fcfb0cfb$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("kKhG5", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $f1a5d0fa6fcab9e0$export$25bec8c6f54ee79a);

var $eUqFw = parcelRequire("eUqFw");
function $f1a5d0fa6fcab9e0$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $eUqFw.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("d2TZh", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $97f6e436e4415bf7$export$b8c7b07253306600);

var $eUqFw = parcelRequire("eUqFw");

var $97f6e436e4415bf7$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $97f6e436e4415bf7$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $97f6e436e4415bf7$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $97f6e436e4415bf7$export$b8c7b07253306600
    }));
};
$97f6e436e4415bf7$var$InFocusGuard.propTypes = {};
var $97f6e436e4415bf7$export$2e2bcd8739ae039 = $97f6e436e4415bf7$var$InFocusGuard;

});

parcelRegister("829XA", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $5d963c84baeb8294$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $5d963c84baeb8294$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $5d963c84baeb8294$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $5d963c84baeb8294$export$892cbf28e5518020);

var $j5xtV = parcelRequire("j5xtV");
var $5d963c84baeb8294$export$5733e022b1d538cb = (0, $j5xtV.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $5d963c84baeb8294$export$b3e9a9312f73723c = (0, $j5xtV.createMedium)();
var $5d963c84baeb8294$export$3a1d52767cbc07b8 = (0, $j5xtV.createMedium)();
var $5d963c84baeb8294$export$892cbf28e5518020 = (0, $j5xtV.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("j5xtV", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $de5874b68bebaf87$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $de5874b68bebaf87$export$e13ec7dd7a14088d);
function $de5874b68bebaf87$var$ItoI(a) {
    return a;
}
function $de5874b68bebaf87$var$innerCreateMedium(defaults, middleware = $de5874b68bebaf87$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $de5874b68bebaf87$export$9ffbfcaf067b02c6(defaults, middleware = $de5874b68bebaf87$var$ItoI) {
    return $de5874b68bebaf87$var$innerCreateMedium(defaults, middleware);
}
function $de5874b68bebaf87$export$e13ec7dd7a14088d(options = {}) {
    const medium = $de5874b68bebaf87$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}

});


parcelRegister("9Marc", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $71e0b17131af802f$export$f5272e9b1168239c);

var $eUqFw = parcelRequire("eUqFw");
var $71e0b17131af802f$export$f5272e9b1168239c = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("lzXvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb5b06146dfae6bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $hN291 = parcelRequire("hN291");

var $1S1Me = parcelRequire("1S1Me");
var $7VkAc = parcelRequire("7VkAc");
var $evhrg = parcelRequire("evhrg");
var $4Z1pG = parcelRequire("4Z1pG");
var $iQnjT = parcelRequire("iQnjT");parcelRequire("58RUg");
var $9NCWw = parcelRequire("9NCWw");

var $dhc7V = parcelRequire("dhc7V");

var $829XA = parcelRequire("829XA");
var $fb5b06146dfae6bc$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $fb5b06146dfae6bc$var$isFreeFocus = function isFreeFocus() {
    return $fb5b06146dfae6bc$var$focusOnBody() || (0, $iQnjT.focusIsHidden)();
};
var $fb5b06146dfae6bc$var$lastActiveTrap = null;
var $fb5b06146dfae6bc$var$lastActiveFocus = null;
var $fb5b06146dfae6bc$var$lastPortaledElement = null;
var $fb5b06146dfae6bc$var$focusWasOutsideWindow = false;
var $fb5b06146dfae6bc$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $fb5b06146dfae6bc$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($fb5b06146dfae6bc$var$lastActiveTrap.whiteList || $fb5b06146dfae6bc$var$defaultWhitelist)(activeElement);
};
var $fb5b06146dfae6bc$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $fb5b06146dfae6bc$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $fb5b06146dfae6bc$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $fb5b06146dfae6bc$var$lastPortaledElement && $fb5b06146dfae6bc$var$lastPortaledElement.portaledElement === element;
};
function $fb5b06146dfae6bc$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $fb5b06146dfae6bc$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($fb5b06146dfae6bc$var$focusWasOutsideWindow);
    return $fb5b06146dfae6bc$var$focusWasOutsideWindow === 'meanwhile';
};
var $fb5b06146dfae6bc$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $fb5b06146dfae6bc$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $fb5b06146dfae6bc$var$checkInHost(activeElement, area, area);
    });
};
var $fb5b06146dfae6bc$var$activateTrap = function activateTrap() {
    var result = false;
    if ($fb5b06146dfae6bc$var$lastActiveTrap) {
        var _lastActiveTrap = $fb5b06146dfae6bc$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $fb5b06146dfae6bc$var$lastPortaledElement && $fb5b06146dfae6bc$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $dhc7V.extractRef)).filter(Boolean));
            if (!activeElement || $fb5b06146dfae6bc$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $fb5b06146dfae6bc$var$focusWasOutside(crossFrame) || !$fb5b06146dfae6bc$var$isFreeFocus() || !$fb5b06146dfae6bc$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $4Z1pG.focusInside)(workingArea) || activeElement && $fb5b06146dfae6bc$var$withinHost(activeElement, workingArea) || $fb5b06146dfae6bc$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$fb5b06146dfae6bc$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9NCWw.moveFocusInside)(workingArea, $fb5b06146dfae6bc$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $fb5b06146dfae6bc$var$lastPortaledElement = {};
                        }
                    }
                    $fb5b06146dfae6bc$var$focusWasOutsideWindow = false;
                    $fb5b06146dfae6bc$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $7VkAc.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $fb5b06146dfae6bc$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $fb5b06146dfae6bc$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $fb5b06146dfae6bc$var$onTrap = function onTrap(event) {
    if ($fb5b06146dfae6bc$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $fb5b06146dfae6bc$var$onBlur = function onBlur() {
    return (0, $dhc7V.deferAction)($fb5b06146dfae6bc$var$activateTrap);
};
var $fb5b06146dfae6bc$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $fb5b06146dfae6bc$var$recordPortal(currentNode, source);
};
var $fb5b06146dfae6bc$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $fb5b06146dfae6bc$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        onBlur: $fb5b06146dfae6bc$var$onBlur,
        onFocus: $fb5b06146dfae6bc$var$onFocus
    }, children);
};
$fb5b06146dfae6bc$var$FocusTrap.propTypes = {};
var $fb5b06146dfae6bc$var$onWindowBlur = function onWindowBlur() {
    $fb5b06146dfae6bc$var$focusWasOutsideWindow = 'just';
    (0, $dhc7V.deferAction)(function() {
        $fb5b06146dfae6bc$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $fb5b06146dfae6bc$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $fb5b06146dfae6bc$var$onTrap);
    document.addEventListener('focusout', $fb5b06146dfae6bc$var$onBlur);
    window.addEventListener('blur', $fb5b06146dfae6bc$var$onWindowBlur);
};
var $fb5b06146dfae6bc$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $fb5b06146dfae6bc$var$onTrap);
    document.removeEventListener('focusout', $fb5b06146dfae6bc$var$onBlur);
    window.removeEventListener('blur', $fb5b06146dfae6bc$var$onWindowBlur);
};
function $fb5b06146dfae6bc$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $fb5b06146dfae6bc$var$focusLockAPI = {
    moveFocusInside: (0, $9NCWw.moveFocusInside),
    focusInside: (0, $4Z1pG.focusInside),
    focusNextElement: (0, $evhrg.focusNextElement),
    focusPrevElement: (0, $evhrg.focusPrevElement),
    focusFirstElement: (0, $evhrg.focusFirstElement),
    focusLastElement: (0, $evhrg.focusLastElement),
    captureFocusRestore: (0, $1S1Me.captureFocusRestore)
};
function $fb5b06146dfae6bc$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$fb5b06146dfae6bc$var$lastActiveTrap) $fb5b06146dfae6bc$var$attachHandler();
    var lastTrap = $fb5b06146dfae6bc$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $fb5b06146dfae6bc$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $fb5b06146dfae6bc$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($fb5b06146dfae6bc$var$focusLockAPI);
        $fb5b06146dfae6bc$var$activateTrap(true);
        (0, $dhc7V.deferAction)($fb5b06146dfae6bc$var$activateTrap);
    } else {
        $fb5b06146dfae6bc$var$detachHandler();
        $fb5b06146dfae6bc$var$lastActiveFocus = null;
    }
}
(0, $829XA.mediumFocus).assignSyncMedium($fb5b06146dfae6bc$var$onFocus);
(0, $829XA.mediumBlur).assignMedium($fb5b06146dfae6bc$var$onBlur);
(0, $829XA.mediumEffect).assignMedium(function(cb) {
    return cb($fb5b06146dfae6bc$var$focusLockAPI);
});
var $fb5b06146dfae6bc$export$2e2bcd8739ae039 = (0, $hN291.default)($fb5b06146dfae6bc$var$reducePropsToState, $fb5b06146dfae6bc$var$handleStateChangeOnClient)($fb5b06146dfae6bc$var$FocusWatcher);

});
parcelRegister("hN291", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf38ad1d35f9c2ff$export$2e2bcd8739ae039);

var $6MEf7 = parcelRequire("6MEf7");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $cf38ad1d35f9c2ff$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $6MEf7.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $eUqFw.PureComponent));
        (0, $5zQU9.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $cf38ad1d35f9c2ff$export$2e2bcd8739ae039 = $cf38ad1d35f9c2ff$var$withSideEffect;

});

parcelRegister("1S1Me", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $15cc367201b8b9de$export$d357db6e554ff59a);

var $86n2c = parcelRequire("86n2c");
function $15cc367201b8b9de$var$weakRef(value) {
    if (!value) return null;
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $15cc367201b8b9de$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $15cc367201b8b9de$var$weakRef(currentElement),
            parent: $15cc367201b8b9de$var$weakRef(currentElement.parentElement),
            left: $15cc367201b8b9de$var$weakRef(currentElement.previousElementSibling),
            right: $15cc367201b8b9de$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $15cc367201b8b9de$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $15cc367201b8b9de$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $86n2c.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $15cc367201b8b9de$export$d357db6e554ff59a = function(targetElement) {
    var location = $15cc367201b8b9de$export$5061a7725be48ff9(targetElement);
    return function() {
        return $15cc367201b8b9de$var$restoreFocusTo(location);
    };
};

});
parcelRegister("86n2c", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $5e60c06bcf81da64$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $5e60c06bcf81da64$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $5e60c06bcf81da64$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $5e60c06bcf81da64$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $5e60c06bcf81da64$export$2344b14b097df817);

var $6iFou = parcelRequire("6iFou");

var $6KELS = parcelRequire("6KELS");

var $ioW3j = parcelRequire("ioW3j");

var $6Wn3C = parcelRequire("6Wn3C");
var $5e60c06bcf81da64$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $6iFou.toArray)(nodes).filter(function(node) {
        return (0, $6KELS.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $6KELS.notHiddenInput)(node);
    });
};
var $5e60c06bcf81da64$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $6iFou.toArray)(nodes).filter(function(node) {
        return (0, $6KELS.isAutoFocusAllowedCached)(cache, node);
    });
};
var $5e60c06bcf81da64$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $ioW3j.orderByTabIndex)($5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $5e60c06bcf81da64$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $ioW3j.orderByTabIndex)($5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getFocusables)(topNodes), visibilityCache), false);
};
var $5e60c06bcf81da64$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getParentAutofocusables)(topNode), visibilityCache);
};
var $5e60c06bcf81da64$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $5e60c06bcf81da64$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $6iFou.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $5e60c06bcf81da64$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $5e60c06bcf81da64$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("6iFou", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $4964888380044e00$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $4964888380044e00$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $4964888380044e00$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $4964888380044e00$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $4964888380044e00$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $4964888380044e00$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("6KELS", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $4ea6aa497637ba8a$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $4ea6aa497637ba8a$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $4ea6aa497637ba8a$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $4ea6aa497637ba8a$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $4ea6aa497637ba8a$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $4ea6aa497637ba8a$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $4ea6aa497637ba8a$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $4ea6aa497637ba8a$export$4e62c701997796c1);

var $9liOh = parcelRequire("9liOh");
var $4ea6aa497637ba8a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $4ea6aa497637ba8a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $4ea6aa497637ba8a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $4ea6aa497637ba8a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $4ea6aa497637ba8a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $4ea6aa497637ba8a$var$isTopNode(node) || !$4ea6aa497637ba8a$var$isElementHidden(node) && !$4ea6aa497637ba8a$var$isInert(node) && checkParent($4ea6aa497637ba8a$var$getParentNode(node));
};
var $4ea6aa497637ba8a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $4ea6aa497637ba8a$var$isVisibleUncached(node, $4ea6aa497637ba8a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $4ea6aa497637ba8a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$4ea6aa497637ba8a$var$isTopNode(node) ? $4ea6aa497637ba8a$export$b8550e27de209d85(node) ? checkParent($4ea6aa497637ba8a$var$getParentNode(node)) : false : true;
};
var $4ea6aa497637ba8a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $4ea6aa497637ba8a$var$isAutoFocusAllowedUncached(node, $4ea6aa497637ba8a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $4ea6aa497637ba8a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $4ea6aa497637ba8a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $4ea6aa497637ba8a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $4ea6aa497637ba8a$export$9d74f6fbc6f469d0 = function(node) {
    return $4ea6aa497637ba8a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $4ea6aa497637ba8a$export$8197b0ea56b3b055 = function(node) {
    return !(($4ea6aa497637ba8a$export$88a6ceeed5737ba3(node) || $4ea6aa497637ba8a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $4ea6aa497637ba8a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $9liOh.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $4ea6aa497637ba8a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $4ea6aa497637ba8a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $4ea6aa497637ba8a$export$602e5a0d338d7750 = function(node) {
    return !$4ea6aa497637ba8a$export$d94b8b58ec2f30eb(node);
};
var $4ea6aa497637ba8a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("ioW3j", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $d6577fdd3d3f79b9$export$cb40ee071f0d5226);

var $6iFou = parcelRequire("6iFou");
var $d6577fdd3d3f79b9$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $d6577fdd3d3f79b9$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $d6577fdd3d3f79b9$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $6iFou.toArray)(nodes).map(function(node, index) {
        var tabIndex = $d6577fdd3d3f79b9$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($d6577fdd3d3f79b9$export$350ee6c095d98996);
};

});

parcelRegister("6Wn3C", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $50da0b8c8573a7aa$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $50da0b8c8573a7aa$export$853fa94d922e78b9);

var $9liOh = parcelRequire("9liOh");

var $6iFou = parcelRequire("6iFou");

var $2EctD = parcelRequire("2EctD");
var $50da0b8c8573a7aa$var$queryTabbables = (0, $2EctD.tabbables).join(',');
var $50da0b8c8573a7aa$var$queryGuardTabbables = "".concat($50da0b8c8573a7aa$var$queryTabbables, ", [data-focus-guard]");
var $50da0b8c8573a7aa$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $6iFou.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $50da0b8c8573a7aa$var$queryGuardTabbables : $50da0b8c8573a7aa$var$queryTabbables) ? [
            child
        ] : [], $50da0b8c8573a7aa$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $50da0b8c8573a7aa$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $50da0b8c8573a7aa$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $50da0b8c8573a7aa$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $50da0b8c8573a7aa$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $50da0b8c8573a7aa$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $6iFou.toArray)(parent.parentNode.querySelectorAll($50da0b8c8573a7aa$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $50da0b8c8573a7aa$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $9liOh.FOCUS_AUTO), "]"));
    return (0, $6iFou.toArray)(parentFocus).map(function(node) {
        return $50da0b8c8573a7aa$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("2EctD", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $1ed8fed9706ed342$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $1ed8fed9706ed342$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("7VkAc", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $5c4dd299f915357d$export$f89ac71e91767111);

var $InSZn = parcelRequire("InSZn");

var $6KELS = parcelRequire("6KELS");

var $4YYah = parcelRequire("4YYah");

var $ioW3j = parcelRequire("ioW3j");

var $6Wn3C = parcelRequire("6Wn3C");
var $5c4dd299f915357d$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $InSZn.getAllAffectedNodes)(topNode).filter((0, $6KELS.isNotAGuard));
    var commonParent = (0, $4YYah.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $ioW3j.orderByTabIndex)((0, $6Wn3C.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $6Wn3C.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $6KELS.isGuard)(node)
        };
    });
};

});
parcelRegister("InSZn", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $0856a36bcd3b2082$export$7e87c4720b9b279b);

var $9liOh = parcelRequire("9liOh");

var $6iFou = parcelRequire("6iFou");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $0856a36bcd3b2082$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $0856a36bcd3b2082$var$getTopParent = function(node) {
    return node.parentNode ? $0856a36bcd3b2082$var$getTopParent(node.parentNode) : node;
};
var $0856a36bcd3b2082$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $6iFou.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $9liOh.FOCUS_GROUP));
        acc.push.apply(acc, group ? $0856a36bcd3b2082$var$filterNested((0, $6iFou.toArray)($0856a36bcd3b2082$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $9liOh.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $9liOh.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("4YYah", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $3a0b6f8558d1c7f8$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $3a0b6f8558d1c7f8$export$8f99714c70a37db1);

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");
var $3a0b6f8558d1c7f8$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $3a0b6f8558d1c7f8$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $3a0b6f8558d1c7f8$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $3a0b6f8558d1c7f8$var$getParents(nodeA);
    var parentsB = $3a0b6f8558d1c7f8$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $3a0b6f8558d1c7f8$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $6iFou.asArray)(baseActiveElement);
    var leftEntries = (0, $6iFou.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $86n2c.contains)(common, topCommon)) topCommon = common;
                else topCommon = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $3a0b6f8558d1c7f8$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $86n2c.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("evhrg", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $a8f17ce5843b9ccd$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $a8f17ce5843b9ccd$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $a8f17ce5843b9ccd$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $a8f17ce5843b9ccd$export$6a79073ddabfd6c3);

var $5wzXm = parcelRequire("5wzXm");

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");
var $a8f17ce5843b9ccd$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $6iFou.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $86n2c.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $86n2c.getTabbableNodes)(shards, new Map()) : (0, $86n2c.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $a8f17ce5843b9ccd$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $86n2c.getTabbableNodes)((0, $6iFou.asArray)(shards), new Map()) : (0, $86n2c.getFocusableNodes)((0, $6iFou.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $a8f17ce5843b9ccd$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $a8f17ce5843b9ccd$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $a8f17ce5843b9ccd$var$defaultOptions(options);
    var solution = $a8f17ce5843b9ccd$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $5wzXm.focusOn)(target.node, newOptions.focusOptions);
};
var $a8f17ce5843b9ccd$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $a8f17ce5843b9ccd$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $a8f17ce5843b9ccd$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $a8f17ce5843b9ccd$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $5wzXm.focusOn)(node.node, options.focusOptions);
};
var $a8f17ce5843b9ccd$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$pickBoundary(scope, options, 'first');
};
var $a8f17ce5843b9ccd$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("5wzXm", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $405bd51e6199886f$export$c12b3da842c43a8);
var $405bd51e6199886f$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("4Z1pG", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $3a0df49206e81afa$export$20115f8da7baa6fa);

var $86n2c = parcelRequire("86n2c");

var $InSZn = parcelRequire("InSZn");

var $6iFou = parcelRequire("6iFou");

var $29N1l = parcelRequire("29N1l");
var $3a0df49206e81afa$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $3a0df49206e81afa$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $6iFou.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $3a0df49206e81afa$var$focusInFrame(node, activeElement);
    }));
};
var $3a0df49206e81afa$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $29N1l.getActiveElement)((0, $6iFou.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $InSZn.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $86n2c.contains)(node, activeElement) || $3a0df49206e81afa$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("29N1l", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $192272877e661b38$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $8Ypvn = parcelRequire("8Ypvn");
var $192272877e661b38$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $192272877e661b38$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $8Ypvn.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $192272877e661b38$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("8Ypvn", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $6887b6167779247b$export$78d20aae35adef88);
var $6887b6167779247b$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("iQnjT", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $db7f2c22dedf6fb3$export$be6b21806d3fd485);

var $9liOh = parcelRequire("9liOh");

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");

var $29N1l = parcelRequire("29N1l");
var $db7f2c22dedf6fb3$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $29N1l.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $6iFou.toArray)(inDocument.querySelectorAll("[".concat((0, $9liOh.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $86n2c.contains)(node, activeElement);
    });
};

});

parcelRegister("58RUg", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9NCWw")).moveFocusInside);

var $9liOh = parcelRequire("9liOh");

var $4Z1pG = parcelRequire("4Z1pG");

var $iQnjT = parcelRequire("iQnjT");


var $7VkAc = parcelRequire("7VkAc");

var $9NCWw = parcelRequire("9NCWw");

var $1S1Me = parcelRequire("1S1Me");

var $evhrg = parcelRequire("evhrg");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $3be783d54e0ec6a9$export$1a988e7317c65621 = $9liOh;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $3be783d54e0ec6a9$var$deprecated_default_moveFocusInside = (0, $9NCWw.moveFocusInside);
var $3be783d54e0ec6a9$export$2e2bcd8739ae039 //
 = $3be783d54e0ec6a9$var$deprecated_default_moveFocusInside;

});
parcelRegister("9NCWw", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $7226e5eb175f5d23$export$cd599851e879a025);

var $5wzXm = parcelRequire("5wzXm");

var $bIplp = parcelRequire("bIplp");
var $7226e5eb175f5d23$var$guardCount = 0;
var $7226e5eb175f5d23$var$lockDisabled = false;
var $7226e5eb175f5d23$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $bIplp.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7226e5eb175f5d23$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7226e5eb175f5d23$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7226e5eb175f5d23$var$lockDisabled = true;
            setTimeout(function() {
                $7226e5eb175f5d23$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7226e5eb175f5d23$var$guardCount++;
        (0, $5wzXm.focusOn)(focusable.node, options.focusOptions);
        $7226e5eb175f5d23$var$guardCount--;
    }
};

});
parcelRegister("bIplp", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $887776a219b68cf0$export$305758c744b57f6f);

var $2v7o2 = parcelRequire("2v7o2");

var $86n2c = parcelRequire("86n2c");

var $InSZn = parcelRequire("InSZn");

var $6iFou = parcelRequire("6iFou");

var $3OLvr = parcelRequire("3OLvr");

var $29N1l = parcelRequire("29N1l");

var $6KELS = parcelRequire("6KELS");

var $4YYah = parcelRequire("4YYah");
var $887776a219b68cf0$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $6KELS.isDefined));
};
var $887776a219b68cf0$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $29N1l.getActiveElement)((0, $6iFou.asArray)(topNode).length > 0 ? document : (0, $6iFou.getFirst)(topNode).ownerDocument);
    var entries = (0, $InSZn.getAllAffectedNodes)(topNode).filter((0, $6KELS.isNotAGuard));
    var commonParent = (0, $4YYah.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $86n2c.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $6KELS.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $86n2c.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $887776a219b68cf0$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $2v7o2.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $2v7o2.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $3OLvr.pickAutofocus)(anyFocusable, innerTabbable, (0, $4YYah.allParentAutofocusables)(entries, visibilityCache)) || (0, $3OLvr.pickAutofocus)(anyFocusable, innerFocusables, (0, $4YYah.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("2v7o2", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $1d2434e0b90a992a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $1d2434e0b90a992a$export$65842178e9bb4205);

var $hxIhW = parcelRequire("hxIhW");

var $cbr4O = parcelRequire("cbr4O");

var $6KELS = parcelRequire("6KELS");
var $1d2434e0b90a992a$export$85710b12cf912438 = 'NEW_FOCUS';
var $1d2434e0b90a992a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $6KELS.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $1d2434e0b90a992a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $1d2434e0b90a992a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $hxIhW.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $cbr4O.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $cbr4O.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("hxIhW", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $cc57df7a0531e2f3$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $cc57df7a0531e2f3$export$4a5a72a7124e45f9);

var $6KELS = parcelRequire("6KELS");
var $cc57df7a0531e2f3$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $6KELS.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $cc57df7a0531e2f3$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $6KELS.isRadioElement)(node) && node.name) return $cc57df7a0531e2f3$var$findSelectedRadio(node, nodes);
    return node;
};
var $cc57df7a0531e2f3$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($cc57df7a0531e2f3$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("cbr4O", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $8deb83fb03cfe8f2$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $8deb83fb03cfe8f2$export$e06728ee87c96122);

var $hxIhW = parcelRequire("hxIhW");
var $8deb83fb03cfe8f2$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $hxIhW.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $8deb83fb03cfe8f2$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $hxIhW.correctNode)(node, nodes));
};

});


parcelRegister("3OLvr", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $2c7ae450a5f11ee7$export$cfb742983e257555);

var $86n2c = parcelRequire("86n2c");

var $cbr4O = parcelRequire("cbr4O");

var $6KELS = parcelRequire("6KELS");
var $2c7ae450a5f11ee7$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $6KELS.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $2c7ae450a5f11ee7$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $86n2c.filterAutoFocusable)(nodes.filter($2c7ae450a5f11ee7$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $cbr4O.pickFirstFocus)(autoFocusable);
    return (0, $cbr4O.pickFirstFocus)((0, $86n2c.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("dhc7V", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $9aa6450933a076b0$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $9aa6450933a076b0$export$c613fed06e332533);
function $9aa6450933a076b0$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $9aa6450933a076b0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $9aa6450933a076b0$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("96Gx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a15aa6e88393318$export$2e2bcd8739ae039);

var $c16hR = parcelRequire("c16hR");






var $6a15aa6e88393318$export$2e2bcd8739ae039 = (0, $c16hR.default);

});

parcelRegister("8MHxr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4WeBZ = parcelRequire("4WeBZ");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $6654943a7fe9051b$var$_interopRequireDefault($4WeBZ).default;
    }
});

var $bJ1LD = parcelRequire("bJ1LD");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $bJ1LD.TouchScrollable;
    }
});
function $6654943a7fe9051b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4WeBZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3987e9cf0414f409$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $3987e9cf0414f409$var$_react2 = $3987e9cf0414f409$var$_interopRequireDefault($eUqFw);

var $kQ44K = parcelRequire("kQ44K");

var $bJ1LD = parcelRequire("bJ1LD");

var $hLKOl = parcelRequire("hLKOl");
var $3987e9cf0414f409$var$_withLockSheet2 = $3987e9cf0414f409$var$_interopRequireDefault($hLKOl);

var $6sZKb = parcelRequire("6sZKb");
var $3987e9cf0414f409$var$_withTouchListeners2 = $3987e9cf0414f409$var$_interopRequireDefault($6sZKb);

var $bUSBK = parcelRequire("bUSBK");
function $3987e9cf0414f409$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3987e9cf0414f409$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3987e9cf0414f409$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3987e9cf0414f409$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3987e9cf0414f409$var$ScrollLock = function(_PureComponent) {
    $3987e9cf0414f409$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $3987e9cf0414f409$var$_classCallCheck(this, ScrollLock);
        return $3987e9cf0414f409$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $3987e9cf0414f409$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kQ44K.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $3987e9cf0414f409$var$_react2.default.createElement($bJ1LD.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($eUqFw.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $3987e9cf0414f409$var$compose = (0, $bUSBK.pipe)($3987e9cf0414f409$var$_withTouchListeners2.default, $3987e9cf0414f409$var$_withLockSheet2.default);
var $3987e9cf0414f409$var$SheetLock = $3987e9cf0414f409$var$compose($3987e9cf0414f409$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $3987e9cf0414f409$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $3987e9cf0414f409$var$_react2.default.createElement($3987e9cf0414f409$var$SheetLock, props) : props.children;
};
$3987e9cf0414f409$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $3987e9cf0414f409$var$LockToggle;

});
parcelRegister("kQ44K", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("bJ1LD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $889544a197fa4954$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $889544a197fa4954$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $bUSBK = parcelRequire("bUSBK");
function $889544a197fa4954$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $889544a197fa4954$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $889544a197fa4954$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $889544a197fa4954$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $889544a197fa4954$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $889544a197fa4954$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $889544a197fa4954$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $889544a197fa4954$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $889544a197fa4954$var$_possibleConstructorReturn(_this, _ret);
    }
    $889544a197fa4954$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kQ44K.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $bUSBK.preventInertiaScroll, $bUSBK.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $bUSBK.allowTouchMove, $bUSBK.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$kQ44K.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $bUSBK.preventInertiaScroll, $bUSBK.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $bUSBK.allowTouchMove, $bUSBK.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $889544a197fa4954$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $eUqFw.cloneElement)(children, $889544a197fa4954$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($eUqFw.PureComponent);

});
parcelRegister("bUSBK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $8acf48ac1a508f0a$var$preventTouchMove;
module.exports.allowTouchMove = $8acf48ac1a508f0a$var$allowTouchMove;
module.exports.preventInertiaScroll = $8acf48ac1a508f0a$var$preventInertiaScroll;
module.exports.isTouchDevice = $8acf48ac1a508f0a$var$isTouchDevice;
module.exports.camelToKebab = $8acf48ac1a508f0a$var$camelToKebab;
module.exports.parse = $8acf48ac1a508f0a$var$parse;
module.exports.getPadding = $8acf48ac1a508f0a$var$getPadding;
module.exports.getWindowHeight = $8acf48ac1a508f0a$var$getWindowHeight;
module.exports.getDocumentHeight = $8acf48ac1a508f0a$var$getDocumentHeight;
module.exports.makeStyleTag = $8acf48ac1a508f0a$var$makeStyleTag;
module.exports.injectStyles = $8acf48ac1a508f0a$var$injectStyles;
module.exports.insertStyleTag = $8acf48ac1a508f0a$var$insertStyleTag;

var $kQ44K = parcelRequire("kQ44K");
var $8acf48ac1a508f0a$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $8acf48ac1a508f0a$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $8acf48ac1a508f0a$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $8acf48ac1a508f0a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8acf48ac1a508f0a$var$isTouchDevice() {
    if (!$kQ44K.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $8acf48ac1a508f0a$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $8acf48ac1a508f0a$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $8acf48ac1a508f0a$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $8acf48ac1a508f0a$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($8acf48ac1a508f0a$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $8acf48ac1a508f0a$var$getPadding() {
    if (!$kQ44K.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $8acf48ac1a508f0a$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($kQ44K.canUseDOM) return window.innerHeight * multiplier;
}
function $8acf48ac1a508f0a$var$getDocumentHeight() {
    if ($kQ44K.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $8acf48ac1a508f0a$var$makeStyleTag() {
    if (!$kQ44K.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $8acf48ac1a508f0a$var$injectStyles(tag, css) {
    if (!$kQ44K.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $8acf48ac1a508f0a$var$insertStyleTag(tag) {
    if (!$kQ44K.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("hLKOl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cefb231f4a7a20a5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $cefb231f4a7a20a5$var$withLockSheet;

var $eUqFw = parcelRequire("eUqFw");
var $cefb231f4a7a20a5$var$_react2 = $cefb231f4a7a20a5$var$_interopRequireDefault($eUqFw);

var $bUSBK = parcelRequire("bUSBK");
function $cefb231f4a7a20a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cefb231f4a7a20a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cefb231f4a7a20a5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cefb231f4a7a20a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $cefb231f4a7a20a5$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $cefb231f4a7a20a5$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $cefb231f4a7a20a5$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $cefb231f4a7a20a5$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $bUSBK.makeStyleTag)();
                if (!sheet) return;
                (0, $bUSBK.injectStyles)(sheet, styles);
                (0, $bUSBK.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $bUSBK.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $bUSBK.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $cefb231f4a7a20a5$var$_possibleConstructorReturn(_this, _ret);
        }
        $cefb231f4a7a20a5$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $cefb231f4a7a20a5$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($eUqFw.PureComponent);
}

});

parcelRegister("6sZKb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4b5540a16c16631f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $4b5540a16c16631f$var$withTouchListeners;

var $eUqFw = parcelRequire("eUqFw");
var $4b5540a16c16631f$var$_react2 = $4b5540a16c16631f$var$_interopRequireDefault($eUqFw);

var $kQ44K = parcelRequire("kQ44K");

var $bUSBK = parcelRequire("bUSBK");
function $4b5540a16c16631f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b5540a16c16631f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4b5540a16c16631f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4b5540a16c16631f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $4b5540a16c16631f$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $4b5540a16c16631f$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $4b5540a16c16631f$var$_classCallCheck(this, TouchProvider);
            return $4b5540a16c16631f$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $4b5540a16c16631f$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$kQ44K.canUseDOM || !(0, $bUSBK.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $bUSBK.preventTouchMove, $bUSBK.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$kQ44K.canUseDOM || !(0, $bUSBK.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $bUSBK.preventTouchMove, $bUSBK.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $4b5540a16c16631f$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($eUqFw.PureComponent);
}

});



parcelRegister("8yx6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ab2e75f41b36d7$export$2e2bcd8739ae039);
var $63ab2e75f41b36d7$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $63ab2e75f41b36d7$export$2e2bcd8739ae039 = $63ab2e75f41b36d7$var$rafSchd;

});

parcelRegister("a2Ury", function(module, exports) {

var $k7fXr = parcelRequire("k7fXr");
var $7505dfc8e879aec6$var$listeningFocusTrap = null;
function $7505dfc8e879aec6$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $7505dfc8e879aec6$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($7505dfc8e879aec6$var$listeningFocusTrap) $7505dfc8e879aec6$var$listeningFocusTrap.pause();
        $7505dfc8e879aec6$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $7505dfc8e879aec6$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $7505dfc8e879aec6$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $7505dfc8e879aec6$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $7505dfc8e879aec6$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $7505dfc8e879aec6$var$tryFocus(lastTabbableNode);
            return $7505dfc8e879aec6$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $7505dfc8e879aec6$var$tryFocus(firstTabbableNode);
        $7505dfc8e879aec6$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $k7fXr(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $7505dfc8e879aec6$var$tryFocus(lastTabbableNode);
        $7505dfc8e879aec6$var$tryFocus(firstTabbableNode);
    }
}
function $7505dfc8e879aec6$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $7505dfc8e879aec6$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $7505dfc8e879aec6$var$focusTrap;

});
parcelRegister("k7fXr", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ea50d6f71335097e$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ea50d6f71335097e$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("joBf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ed25e38ff42c85$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kXwvz = parcelRequire("kXwvz");

var $byn9U = parcelRequire("byn9U");

var $lDjMI = parcelRequire("lDjMI");

var $b9Xoy = parcelRequire("b9Xoy");

var $T3JCe = parcelRequire("T3JCe");
var $e1ed25e38ff42c85$var$testOmitPropsOnStringTag = (0, $kXwvz.default);
var $e1ed25e38ff42c85$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $e1ed25e38ff42c85$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $e1ed25e38ff42c85$var$testOmitPropsOnStringTag : $e1ed25e38ff42c85$var$testOmitPropsOnComponent;
};
var $e1ed25e38ff42c85$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $e1ed25e38ff42c85$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $e1ed25e38ff42c85$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lDjMI.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $T3JCe.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lDjMI.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e1ed25e38ff42c85$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $e1ed25e38ff42c85$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $e1ed25e38ff42c85$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $byn9U.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $eUqFw.useContext)((0, $byn9U.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lDjMI.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $b9Xoy.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $e1ed25e38ff42c85$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $eUqFw.createElement)($e1ed25e38ff42c85$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $eUqFw.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kU09D.default)({}, options, nextOptions, {
                shouldForwardProp: $e1ed25e38ff42c85$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $e1ed25e38ff42c85$export$2e2bcd8739ae039 = $e1ed25e38ff42c85$var$createStyled;

});
parcelRegister("kXwvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42288cd8c23180b$export$2e2bcd8739ae039);

var $bRPu3 = parcelRequire("bRPu3");
var $f42288cd8c23180b$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f42288cd8c23180b$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $bRPu3.default)(function(prop) {
    return $f42288cd8c23180b$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("lDjMI", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $fbfc9659b588f826$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $fbfc9659b588f826$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $fbfc9659b588f826$export$6f077d94b33a01aa);
var $fbfc9659b588f826$var$isBrowser = true;
function $fbfc9659b588f826$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $fbfc9659b588f826$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $fbfc9659b588f826$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $fbfc9659b588f826$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $fbfc9659b588f826$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRegister("bW292", function(module, exports) {

$parcel$export(module.exports, "getATLContextDomain", () => $bbea85c236a72978$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $bbea85c236a72978$export$45d6512913ef41b4);


var $1LnKS = parcelRequire("1LnKS");

var $dHMKP = parcelRequire("dHMKP");
function $bbea85c236a72978$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $bbea85c236a72978$var$isValidDomainKey(domainKey) {
    if (!(0, $dHMKP.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $bbea85c236a72978$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$bbea85c236a72978$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $dHMKP.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $bbea85c236a72978$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $1LnKS.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? // Fallback to mandatory commercial production
    override[0, $80f8efc879637eec$export$f005e2e9f707cb5f][0, $80f8efc879637eec$export$42dd0cdd351a4a9]);
    // Third priority, join the subdomain
    const tld = (0, $1LnKS.domainMap)[perimeter]?.[env] ?? (0, $1LnKS.domainMap)[0, $80f8efc879637eec$export$f005e2e9f707cb5f][0, $80f8efc879637eec$export$42dd0cdd351a4a9];
    const subdomain = (0, $1LnKS.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $bbea85c236a72978$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$bbea85c236a72978$export$b5ce351acdc48c2a(domain)}`;
}
function $bbea85c236a72978$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
}

});
const $80f8efc879637eec$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $80f8efc879637eec$export$f005e2e9f707cb5f = 'commercial';
const $80f8efc879637eec$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $80f8efc879637eec$export$a739cd5aac835909 = 'stg';
const $80f8efc879637eec$export$42dd0cdd351a4a9 = 'prod';
const $80f8efc879637eec$export$404582bc18fe4d9e = 'dev';

parcelRegister("1LnKS", function(module, exports) {

$parcel$export(module.exports, "domainMap", () => $1d7404ea220cca8f$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $1d7404ea220cca8f$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $1d7404ea220cca8f$export$4723232b625f823e);

const $1d7404ea220cca8f$export$6836b090dbaa813a = {
    [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $80f8efc879637eec$export$bd6b5a7802d76127)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $1d7404ea220cca8f$export$c6ab20d0ac4d06b2 = {};
const $1d7404ea220cca8f$export$4723232b625f823e = {
    analytics: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $80f8efc879637eec$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("dHMKP", function(module, exports) {

$parcel$export(module.exports, "AllowedDomains", () => $cf431f961efd814d$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $cf431f961efd814d$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid'
];

});


parcelRegister("fcWBJ", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/** Used for built-in method references. */ var $b12570436e43257d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b12570436e43257d$var$hasOwnProperty = $b12570436e43257d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b12570436e43257d$var$groupBy = $f2sQe(function(result, value, key) {
    if ($b12570436e43257d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3pSMu(result, key, [
        value
    ]);
});
module.exports = $b12570436e43257d$var$groupBy;

});

parcelRegister("cnRoI", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $90410db367a60352$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $90410db367a60352$var$mapKeys;

});

parcelRegister("fUTZC", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $awetI = parcelRequire("awetI");

var $cOXK6 = parcelRequire("cOXK6");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $b96784f98aa1ce5f$var$forEach(collection, iteratee) {
    var func = $1c8hB(collection) ? $9Kzih : $awetI;
    return func(collection, $cOXK6(iteratee));
}
module.exports = $b96784f98aa1ce5f$var$forEach;

});
parcelRegister("cOXK6", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $95587f286d00dd83$var$castFunction(value) {
    return typeof value == 'function' ? value : $3QMTK;
}
module.exports = $95587f286d00dd83$var$castFunction;

});


parcelRegister("lyOYo", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $42tFs = parcelRequire("42tFs");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $fb245023a1ed37bc$var$uniqBy(array, iteratee) {
    return array && array.length ? $42tFs(array, $7qARj(iteratee, 2)) : [];
}
module.exports = $fb245023a1ed37bc$var$uniqBy;

});

parcelRegister("aeTOI", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $i31gq = parcelRequire("i31gq");

var $3Bqj8 = parcelRequire("3Bqj8");

var $jxg5X = parcelRequire("jxg5X");

var $fdip7 = parcelRequire("fdip7");

var $8nrDO = parcelRequire("8nrDO");
/** Used for built-in method references. */ var $7746824ad0b9147c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7746824ad0b9147c$var$hasOwnProperty = $7746824ad0b9147c$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $7746824ad0b9147c$var$assign = $3Bqj8(function(object, source) {
    if ($fdip7(source) || $jxg5X(source)) {
        $i31gq(source, $8nrDO(source), object);
        return;
    }
    for(var key in source)if ($7746824ad0b9147c$var$hasOwnProperty.call(source, key)) $jDLwO(object, key, source[key]);
});
module.exports = $7746824ad0b9147c$var$assign;

});

parcelRegister("84CBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $650931fd002453ca$export$2e2bcd8739ae039);

var $3maQ0 = parcelRequire("3maQ0");
var $650931fd002453ca$export$2e2bcd8739ae039 = (0, $3maQ0.default);

});
parcelRegister("3maQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ca762c93e82ce0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $lDuRz = parcelRequire("lDuRz");
function $98ca762c93e82ce0$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // react-18: useId instead
    const context = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $lDuRz.default)(()=>{
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : null;
}

});
parcelRegister("lDuRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $824a72923f5632a9$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $eUqFw = parcelRequire("eUqFw");
var $824a72923f5632a9$export$2e2bcd8739ae039 = (0, $eUqFw.useLayoutEffect);

});



parcelRegister("4vTMF", function(module, exports) {

var $lrLC2 = parcelRequire("lrLC2");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $34955437dbccaff0$var$kebabCase = $lrLC2(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $34955437dbccaff0$var$kebabCase;

});

parcelRegister("lyUHD", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $fb28c1ebd36ca859$var$Global = $7jNqu.Global;
module.exports = {
    name: 'sessionStorage',
    read: $fb28c1ebd36ca859$var$read,
    write: $fb28c1ebd36ca859$var$write,
    each: $fb28c1ebd36ca859$var$each,
    remove: $fb28c1ebd36ca859$var$remove,
    clearAll: $fb28c1ebd36ca859$var$clearAll
};
function $fb28c1ebd36ca859$var$sessionStorage() {
    return $fb28c1ebd36ca859$var$Global.sessionStorage;
}
function $fb28c1ebd36ca859$var$read(key) {
    return $fb28c1ebd36ca859$var$sessionStorage().getItem(key);
}
function $fb28c1ebd36ca859$var$write(key, data) {
    return $fb28c1ebd36ca859$var$sessionStorage().setItem(key, data);
}
function $fb28c1ebd36ca859$var$each(fn) {
    for(var i = $fb28c1ebd36ca859$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $fb28c1ebd36ca859$var$sessionStorage().key(i);
        fn($fb28c1ebd36ca859$var$read(key), key);
    }
}
function $fb28c1ebd36ca859$var$remove(key) {
    return $fb28c1ebd36ca859$var$sessionStorage().removeItem(key);
}
function $fb28c1ebd36ca859$var$clearAll() {
    return $fb28c1ebd36ca859$var$sessionStorage().clear();
}

});

parcelRegister("9lcOH", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $1b369f3afafe87a4$export$5b689ca7b019e89f);

var $fVaJL = parcelRequire("fVaJL");
function $1b369f3afafe87a4$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $fVaJL.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName || interaction.type === 'page_load' || interaction.type === 'transition') return;
    (0, $fVaJL.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("duQ8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $93be20e309370cc7$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");
function $93be20e309370cc7$export$2e2bcd8739ae039(name, timestamp) {
    const rate = (0, $4vWWq.getInteractionRate)(name, 'press');
    const pressInteractionsList = (0, $4vWWq.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $fVaJL.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $dZdw5.default)(rate)) {
        (0, $fVaJL.abortAll)('new_interaction', name);
        const startTimestamp = timestamp ?? performance.now();
        const newId = (0, $hompL.v4)();
        (0, $gnIbC.DefaultInteractionID).current = newId;
        (0, $fVaJL.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $7sbhX.default).current);
    }
}

});

parcelRegister("lbDTY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j4VTi = parcelRequire("j4VTi");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f6c993b5d14dfd2e$var$_interopRequireDefault($j4VTi).default;
    }
});
function $f6c993b5d14dfd2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("j4VTi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $de3b4bf63375b073$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $de3b4bf63375b073$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $de3b4bf63375b073$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $de3b4bf63375b073$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $de3b4bf63375b073$var$NodeResolver = function(_Component) {
    $de3b4bf63375b073$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $de3b4bf63375b073$var$_classCallCheck(this, NodeResolver);
        return $de3b4bf63375b073$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $de3b4bf63375b073$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $lEfVV.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($eUqFw.Component);
module.exports.default = $de3b4bf63375b073$var$NodeResolver;

});


parcelRegister("fa2D3", function(module, exports) {

$parcel$export(module.exports, "default", () => $28600248698669fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");
function $28600248698669fc$export$2e2bcd8739ae039(name) {
    const context = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const handleClick = (0, $eUqFw.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("k7cZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4e8918d9e7eef9$export$2e2bcd8739ae039);

var $luZsm = parcelRequire("luZsm");
function $ea4e8918d9e7eef9$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $ea4e8918d9e7eef9$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $ea4e8918d9e7eef9$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($ea4e8918d9e7eef9$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $ea4e8918d9e7eef9$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($ea4e8918d9e7eef9$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $luZsm.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $ea4e8918d9e7eef9$var$getOptions(options);
    return $ea4e8918d9e7eef9$var$defaultBehavior((0, $luZsm.default)(target, computeOptions), computeOptions.behavior);
}
var $ea4e8918d9e7eef9$export$2e2bcd8739ae039 = $ea4e8918d9e7eef9$var$scrollIntoView;

});
parcelRegister("luZsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6c124618acde79$export$2e2bcd8739ae039);
function $fa6c124618acde79$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $fa6c124618acde79$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $fa6c124618acde79$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $fa6c124618acde79$var$isHiddenByFrame(el) {
    var frame = $fa6c124618acde79$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $fa6c124618acde79$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $fa6c124618acde79$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $fa6c124618acde79$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $fa6c124618acde79$var$isHiddenByFrame(el);
    }
    return false;
}
function $fa6c124618acde79$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $fa6c124618acde79$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$fa6c124618acde79$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($fa6c124618acde79$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $fa6c124618acde79$var$isScrollable(cursor) && !$fa6c124618acde79$var$isScrollable(document.documentElement)) continue;
        if ($fa6c124618acde79$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $fa6c124618acde79$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $fa6c124618acde79$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $fa6c124618acde79$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $fa6c124618acde79$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("1K77P", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $144f9d3f3cfe8997$export$e83743682263315a);

var $49WjJ = parcelRequire("49WjJ");

var $gNjcN = parcelRequire("gNjcN");

var $cFcvW = parcelRequire("cFcvW");
const $144f9d3f3cfe8997$var$cache = (0, $49WjJ.createCache)(new Map());
function $144f9d3f3cfe8997$export$e83743682263315a(loader, opts) {
    return $144f9d3f3cfe8997$var$cache.get(opts.moduleId, ()=>(0, $gNjcN.PreloadableJSResource)(()=>(0, $cFcvW.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("49WjJ", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $30753d47ae63a22e$export$cf6fa0bbcc94b912);
function $30753d47ae63a22e$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("gNjcN", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $c3a01ec29139504d$export$4fe5fba5bb1d3c09);

var $lzHCi = parcelRequire("lzHCi");
function $c3a01ec29139504d$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $lzHCi.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("lzHCi", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $fb4eb33adb738382$export$148e45a6d4b4d65);

var $7R2i3 = parcelRequire("7R2i3");

var $37bBT = parcelRequire("37bBT");

var $2hYGo = parcelRequire("2hYGo");
function $fb4eb33adb738382$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $37bBT.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $37bBT.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners){
                var _listener$onError;
                (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
            }
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $7R2i3.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $37bBT.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $2hYGo.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError === null || onError === void 0 || onError(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("7R2i3", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $5b7f426f3034cd2f$export$567fc7097e064344);
let $5b7f426f3034cd2f$var$id = 100000;
function $5b7f426f3034cd2f$export$567fc7097e064344() {
    $5b7f426f3034cd2f$var$id += 1;
    return $5b7f426f3034cd2f$var$id.toString();
}

});

parcelRegister("37bBT", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $244b081a58d92306$export$10dc3edfc20c8ff);
function $244b081a58d92306$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers !== null && subscribers !== void 0 ? subscribers : [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $244b081a58d92306$export$10dc3edfc20c8ff = $244b081a58d92306$var$createEventEmitter();

});

parcelRegister("2hYGo", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $1aac3da52b9c6880$export$3b514faac3ba993c);
function $1aac3da52b9c6880$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("cFcvW", function(module, exports) {

$parcel$export(module.exports, "postTask", () => $93830570d80fdb1b$export$13c9d02ca54955a3);
async function $93830570d80fdb1b$var$toPromise(callback) {
    return callback();
}

function $93830570d80fdb1b$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    if (typeof globalThis.scheduler === 'undefined') {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        return (parcelRequire("5q3zd")).then(()=>scheduler.postTask(callback, options));
        return $93830570d80fdb1b$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("5q3zd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cT2it');
        const value = parcelRequire('7wK8q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cT2it").then(()=>parcelRequire('7wK8q'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});
parcelRegister("bjqNS", function(module, exports) {

$parcel$export(module.exports, "register", () => $83c642ad29ddccba$export$6503ec6e8aabbaf, (v) => $83c642ad29ddccba$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $83c642ad29ddccba$export$f7ad0328861e2f03, (v) => $83c642ad29ddccba$export$f7ad0328861e2f03 = v);
var $83c642ad29ddccba$export$6503ec6e8aabbaf;
var $83c642ad29ddccba$export$f7ad0328861e2f03;
"use strict";
var $83c642ad29ddccba$var$mapping = new Map();
function $83c642ad29ddccba$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$83c642ad29ddccba$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $83c642ad29ddccba$var$resolve(id) {
    var resolved = $83c642ad29ddccba$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$83c642ad29ddccba$export$6503ec6e8aabbaf = $83c642ad29ddccba$var$register;
$83c642ad29ddccba$export$f7ad0328861e2f03 = $83c642ad29ddccba$var$resolve;

});





parcelRegister("7QhYz", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $5b5b555d6465a049$export$fa00dd5c1a75592f);
function $5b5b555d6465a049$export$fa00dd5c1a75592f(// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("9WJJx", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $11208f5b95d47870$export$eebbda33f5d4d735);

var $eUqFw = parcelRequire("eUqFw");

var $6078G = parcelRequire("6078G");

var $gmZvv = parcelRequire("gmZvv");

var $i6BC8 = parcelRequire("i6BC8");

var $74BVL = parcelRequire("74BVL");

var $4VsvK = parcelRequire("4VsvK");

var $4ItDq = parcelRequire("4ItDq");

var $6Pq2D = parcelRequire("6Pq2D");
const $11208f5b95d47870$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $11208f5b95d47870$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4VsvK.default), nudge: Nudge = (0, $6078G.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $eUqFw.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $eUqFw.useRef)(null);
    const spotlightCardRef = (0, $eUqFw.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $eUqFw.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $eUqFw.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $eUqFw.useState)(false);
    const stopBlink = (0, $eUqFw.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $eUqFw.useRef)({
        fn: ()=>{}
    });
    (0, $eUqFw.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $eUqFw.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $eUqFw.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $eUqFw.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $eUqFw.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $eUqFw.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $eUqFw.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $eUqFw.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $74BVL.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $11208f5b95d47870$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $eUqFw.useMemo)(()=>Spotlight === (0, $4VsvK.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Nudge, {
        ref: nudgeRef,
        hasPulse: showNudge,
        onClickCapture: onTargetClick,
        onMouseEnter: markReadyToShow,
        pulseColor: pulseColor,
        pulseShadowColor: pulseShadowColor,
        pulseBorderRadius: pulseBorderRadius,
        nudgeTestId: nudgeTestId,
        tag: nudgeTag
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: position,
        referenceElement: nudgeRef.current || undefined,
        offset: offset
    }, ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ItDq.SpotlightContainer), {
            showSpotlight: showSpotlight,
            shouldBlink: shouldBlink,
            stopBlink: stopBlink,
            zIndex: zIndex,
            ref: ref,
            containerStyles: {
                ...popperStyles,
                ...concealSpotlightOnScrollStyles(isReferenceHidden)
            },
            role: "dialog",
            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, (forceUpdateFnRef.current.fn = forceUpdate) && null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Spotlight, {
            ...cardConfig,
            ref: spotlightCardRef
        }))))));
});
var $11208f5b95d47870$export$2e2bcd8739ae039 = $11208f5b95d47870$export$eebbda33f5d4d735;

});
parcelRegister("6078G", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $f5456a86e5d0b314$export$b7d614104f4a4a7c);

var $eUqFw = parcelRequire("eUqFw");

var $VDAtw = parcelRequire("VDAtw");
const $f5456a86e5d0b314$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $VDAtw.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));

});
parcelRegister("VDAtw", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $a9486f7afde85855$export$2d11151259bb3b10);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
var $PdmhA = parcelRequire("PdmhA");
function $a9486f7afde85855$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9486f7afde85855$var$baseShadow = '0 0 0 3px';
const $a9486f7afde85855$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $PdmhA).P75})`;
const $a9486f7afde85855$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $a9486f7afde85855$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $a9486f7afde85855$var$pulseAnimation = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animation: `pulseKeyframes 3000ms ${$a9486f7afde85855$var$easing} infinite`
});
const $a9486f7afde85855$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $a9486f7afde85855$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $byn9U.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $a9486f7afde85855$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$a9486f7afde85855$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $a9486f7afde85855$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$a9486f7afde85855$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $a9486f7afde85855$var$pulseAnimation
            ]
        }
    });
const $a9486f7afde85855$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $lcnyw.borderRadius)(), pulseColor: pulseColor = $a9486f7afde85855$var$basePulseColor, pulseShadowColor: pulseShadowColor = $a9486f7afde85855$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $byn9U.jsx)(CastTargetContainer, {
        css: $a9486f7afde85855$export$814d9bf8c56ac913({
            hasPulse: hasPulse,
            pulseBorderRadius: pulseBorderRadius,
            pulseColor: pulseColor,
            pulseShadowColor: pulseShadowColor
        }),
        ref: ref,
        ...rest
    });
});

});


parcelRegister("4VsvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0324b41a659f77e2$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $byn9U = parcelRequire("byn9U");
function $0324b41a659f77e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0324b41a659f77e2$var$borderRadius = 3;
const $0324b41a659f77e2$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $PdmhA.P300)})`,
    borderRadius: `${$0324b41a659f77e2$var$borderRadius}px`,
    overflow: 'auto'
};
const $0324b41a659f77e2$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $0324b41a659f77e2$var$headingStyles = {
    name: "1j2r6qm",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:500;letter-spacing:-0.008em;margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $0324b41a659f77e2$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $0324b41a659f77e2$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $0324b41a659f77e2$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $byn9U.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        fontFamily: 'inherit',
        fontWeight: 500,
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $PdmhA.P300})` : `var(--ds-background-inverse-subtle, ${0, $PdmhA.P400})`,
        height: '2.28571em',
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $PdmhA.P200)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $PdmhA.P200)})`
        }
    });
const $0324b41a659f77e2$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        css: $0324b41a659f77e2$var$actionItemStyles(index),
        ...rest
    });
const $0324b41a659f77e2$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $0324b41a659f77e2$export$b3ae98194e057550 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $eUqFw.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $byn9U.jsx)($0324b41a659f77e2$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$0324b41a659f77e2$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$headerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $0324b41a659f77e2$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $byn9U.jsx)("span", null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$actionItemContainerStyles
    }, renderedActions))));
});
var $0324b41a659f77e2$export$2e2bcd8739ae039 = $0324b41a659f77e2$export$b3ae98194e057550;

});

parcelRegister("4ItDq", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $28cfb52a1cf9708a$export$d0f55839b708c0a0);

var $eUqFw = parcelRequire("eUqFw");

var $247XK = parcelRequire("247XK");

var $gmZvv = parcelRequire("gmZvv");
const $28cfb52a1cf9708a$export$474e8ee88cc7cd8f = 200;
const $28cfb52a1cf9708a$export$3d6f334bf7dc4597 = 120;
const $28cfb52a1cf9708a$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$28cfb52a1cf9708a$export$474e8ee88cc7cd8f}ms`
};
const $28cfb52a1cf9708a$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$28cfb52a1cf9708a$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $28cfb52a1cf9708a$var$timeoutDurations = {
    enter: 0,
    exit: $28cfb52a1cf9708a$export$3d6f334bf7dc4597
};
const $28cfb52a1cf9708a$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $28cfb52a1cf9708a$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink
    }, (state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
            zIndex: zIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...containerStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$28cfb52a1cf9708a$var$defaultTransitionStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$28cfb52a1cf9708a$var$statefulTransitionStyles[state]
            },
            ref: ref,
            "aria-labelledby": ariaLabelledBy,
            ...rest
        }))));

});


parcelRegister("dxIU5", function(module, exports) {

var $feGjZ = parcelRequire("feGjZ");

var $5rnZD = parcelRequire("5rnZD");

var $7kP6w = parcelRequire("7kP6w");
/** Error message constants. */ var $9dc1305df9bb0863$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9dc1305df9bb0863$var$nativeMax = Math.max, $9dc1305df9bb0863$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $9dc1305df9bb0863$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($9dc1305df9bb0863$var$FUNC_ERROR_TEXT);
    wait = $7kP6w(wait) || 0;
    if ($feGjZ(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $9dc1305df9bb0863$var$nativeMax($7kP6w(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $9dc1305df9bb0863$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $5rnZD();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($5rnZD());
    }
    function debounced() {
        var time = $5rnZD(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $9dc1305df9bb0863$var$debounce;

});
parcelRegister("5rnZD", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $3f6215e80c296c0d$var$now = function() {
    return $c1MCs.Date.now();
};
module.exports = $3f6215e80c296c0d$var$now;

});


parcelRegister("3IRl5", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("aBT3I", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $7b9811a9b68a0a8a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7zpSo = parcelRequire("7zpSo");

var $g695f = parcelRequire("g695f");

var $lnRnG = parcelRequire("lnRnG");

var $5eM40 = parcelRequire("5eM40");

var $Y85k6 = parcelRequire("Y85k6");
const $7b9811a9b68a0a8a$var$SpotlightWithVariables = (0, $g695f.default)((0, $Y85k6.default));
const $7b9811a9b68a0a8a$export$f57123e11f24bec9 = (0, $lnRnG.default)($7b9811a9b68a0a8a$var$SpotlightWithVariables);
const $7b9811a9b68a0a8a$var$SpotlightWithMessage = (0, $5eM40.default)($7b9811a9b68a0a8a$export$f57123e11f24bec9, 'spotlight');
function $7b9811a9b68a0a8a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b9811a9b68a0a8a$var$SpotlightWithMessage, props));
}

});
parcelRegister("g695f", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8440b735a8dd0a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $ki4KB = parcelRequire("ki4KB");
function $bb8440b735a8dd0a$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $eUqFw.Component) {
        render() {
            const props = $bb8440b735a8dd0a$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TargetComponent, props);
        }
    }
    (0, $5zQU9.default)(WithVariables, "displayName", `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`);
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $bb8440b735a8dd0a$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $ki4KB.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $ki4KB.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $ki4KB.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("ki4KB", function(module, exports) {

$parcel$export(module.exports, "rebuildButtonAction", () => $ec592c778f7e37c1$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $ec592c778f7e37c1$export$d808999430a3f186);

var $8jFem = parcelRequire("8jFem");
function $ec592c778f7e37c1$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $ec592c778f7e37c1$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $8jFem.runTemplateForUrl)(input, variables) : (0, $8jFem.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $c2bf5dbfd9f552ad$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $c2bf5dbfd9f552ad$export$e26f00bd90899835 = 'success';
const $c2bf5dbfd9f552ad$export$edb46161045fece7 = 'error';

parcelRegister("8jFem", function(module, exports) {

$parcel$export(module.exports, "runTemplateForUrl", () => $60e0149e9467c78a$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $60e0149e9467c78a$export$5681b97796b74884);

var $6dftS = parcelRequire("6dftS");

var $gqOTQ = parcelRequire("gqOTQ");


var $cPjUH = parcelRequire("cPjUH");
function $60e0149e9467c78a$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $6dftS.default)(template);
    return (0, $cPjUH.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $60e0149e9467c78a$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $6dftS.default)(template);
    return (0, $gqOTQ.replaceForUrl)(epTemplate, variables);
}
function $60e0149e9467c78a$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $6dftS.default)(template);
    return (0, $gqOTQ.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("6dftS", function(module, exports) {

$parcel$export(module.exports, "default", () => $485ff722d03a2581$export$2e2bcd8739ae039);

var $70YeU = parcelRequire("70YeU");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $485ff722d03a2581$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $485ff722d03a2581$var$UNESCAPED_MATCH = 1;
const $485ff722d03a2581$var$UNESCAPED_GROUP_CONTENTS = 2;
const $485ff722d03a2581$var$ESCAPED_GROUP_CONTENTS = 5;
function $485ff722d03a2581$export$2e2bcd8739ae039(template) {
    const parts = (0, $70YeU.regexpParts)(template, $485ff722d03a2581$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$485ff722d03a2581$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$485ff722d03a2581$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$485ff722d03a2581$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("70YeU", function(module, exports) {

$parcel$export(module.exports, "regexpParts", () => $51b742d0c3320d1b$export$b16d411b3b6d6dff);
/**
 * Execs the RegExp on the input string collecting all it's matches, then return
 * an Array of either text or match objects.
 *
 * @param {String} input
 * @param {RegExp} regexp
 * @return {Array<RegExpPart>} Text or match objects
 */ function $51b742d0c3320d1b$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $51b742d0c3320d1b$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $51b742d0c3320d1b$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $51b742d0c3320d1b$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $51b742d0c3320d1b$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("gqOTQ", function(module, exports) {

$parcel$export(module.exports, "replaceForUrl", () => $bf668ea89aeae22b$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $bf668ea89aeae22b$export$ca536300dbd6350);

var $cPjUH = parcelRequire("cPjUH");

var $a1RUM = parcelRequire("a1RUM");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $bf668ea89aeae22b$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cPjUH.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $bf668ea89aeae22b$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $bf668ea89aeae22b$var$rawReplaceVariablesForUrl(template, variables) {
    return $bf668ea89aeae22b$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $bf668ea89aeae22b$var$rawReplaceVariablesForHtml(template, variables) {
    return $bf668ea89aeae22b$var$rawReplaceVariables(template, variables, (0, $a1RUM.default));
}
function $bf668ea89aeae22b$export$d10ae881b12b8ef2(template, variables) {
    return $bf668ea89aeae22b$var$withVariableValidation(template, variables, $bf668ea89aeae22b$var$rawReplaceVariablesForUrl);
}
function $bf668ea89aeae22b$export$ca536300dbd6350(template, variables) {
    return $bf668ea89aeae22b$var$withVariableValidation(template, variables, $bf668ea89aeae22b$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("cPjUH", function(module, exports) {

$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $0268ee394d4d4e8b$export$4a33186abb06007b);

var $aSlpb = parcelRequire("aSlpb");
function $0268ee394d4d4e8b$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $0268ee394d4d4e8b$export$4a33186abb06007b(template) {
    const variableParts = $0268ee394d4d4e8b$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $aSlpb.uniqStrings)(variableNames);
}

});
parcelRegister("aSlpb", function(module, exports) {

$parcel$export(module.exports, "uniqStrings", () => $7eaf8d27071155d0$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $7eaf8d27071155d0$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("a1RUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d3d1b8aba6866c$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $74d3d1b8aba6866c$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("Y85k6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b4be0322f28fd53$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hJJD2 = parcelRequire("hJJD2");

var $cIV0x = parcelRequire("cIV0x");

var $lEGwk = parcelRequire("lEGwk");
class $0b4be0322f28fd53$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $cIV0x.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEGwk.default), {
            html: body
        }));
    }
}
(0, $5zQU9.default)($0b4be0322f28fd53$export$2e2bcd8739ae039, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});

});


parcelRegister("hpAuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad114aaae16ee7b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
class $cad114aaae16ee7b$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            shouldRenderChildren: false
        });
        (0, $5zQU9.default)(this, "stop", async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        });
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
}
(0, $5zQU9.default)($cad114aaae16ee7b$export$2e2bcd8739ae039, "defaultProps", {
    fallback: null
});

});

parcelRegister("8Voen", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f671575e700988$export$2e2bcd8739ae039);

var $eMQs7 = parcelRequire("eMQs7");

var $3DGOA = parcelRequire("3DGOA");
class $67f671575e700988$export$2e2bcd8739ae039 {
    /**
   * Legacy constructor for creating a CoordinationClient. Assumes
   * that the client is being used in a non-FedRAMP environment.
   *
   * This constructor has been deprecated, please use the
   * CoordinationClientConfig constructor instead.
   *
   * @param cloudId The CloudID of the site
   * @param stargateUrl The URL to use for sending requests to Stargate
   * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-3359 Internal documentation for deprecation (no external access)}
   */ /**
   * Creates a new client for coordinating messages using Engagement
   * Platform.
   *
   * The only required options for the configuration are `cloudId` and
   * `stargateUrl`.
   *
   * @param configOrCloudId Configuration for how the CoordinationClient should be created
   * @param stargateUrl The URL to use for sending requests to Stargate
   */ constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $3DGOA.isMessagingEnabled)()) return false;
        return (0, $eMQs7.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $3DGOA.isMessagingEnabled)()) return false;
        return (0, $eMQs7.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("aRS7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e98d550d03be7fb$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $7ueqz = parcelRequire("7ueqz");

var $5W2Uo = parcelRequire("5W2Uo");
var $7e98d550d03be7fb$var$isValid = (0, $5W2Uo.default)((0, $7ueqz.default), 1);
var $7e98d550d03be7fb$export$2e2bcd8739ae039 = $7e98d550d03be7fb$var$isValid;

});
parcelRegister("5W2Uo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4524a0196fe23b4f$export$2e2bcd8739ae039);
function $4524a0196fe23b4f$export$2e2bcd8739ae039(fn, arity, a) {
    a = a || [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return $4524a0196fe23b4f$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});


parcelRegister("9pRhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dafc8522cb390e5$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $kWEgJ = parcelRequire("kWEgJ");

var $5W2Uo = parcelRequire("5W2Uo");
var $6dafc8522cb390e5$var$isWithinInterval = (0, $5W2Uo.default)((0, $kWEgJ.default), 2);
var $6dafc8522cb390e5$export$2e2bcd8739ae039 = $6dafc8522cb390e5$var$isWithinInterval;

});

parcelRegister("9myoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d10d8d515bab2af$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $fiOXn = parcelRequire("fiOXn");

var $5W2Uo = parcelRequire("5W2Uo");
var $6d10d8d515bab2af$var$sub = (0, $5W2Uo.default)((0, $fiOXn.default), 2);
var $6d10d8d515bab2af$export$2e2bcd8739ae039 = $6d10d8d515bab2af$var$sub;

});

parcelRegister("a576Y", function(module, exports) {

var $dxIU5 = parcelRequire("dxIU5");

var $feGjZ = parcelRequire("feGjZ");
/** Error message constants. */ var $756fe338e6f9fa23$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $756fe338e6f9fa23$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($756fe338e6f9fa23$var$FUNC_ERROR_TEXT);
    if ($feGjZ(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $dxIU5(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $756fe338e6f9fa23$var$throttle;

});

parcelRegister("3G3gn", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $943C2 = parcelRequire("943C2");

var $9eFtX = parcelRequire("9eFtX");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $2ad7d356c61a8e97$var$sortBy = $9eFtX(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $3P7i5(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $3P7i5(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $943C2(collection, $hKE3p(iteratees, 1), []);
});
module.exports = $2ad7d356c61a8e97$var$sortBy;

});
parcelRegister("943C2", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $dS3e6 = parcelRequire("dS3e6");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $hVWSV = parcelRequire("hVWSV");

var $74vSq = parcelRequire("74vSq");

var $2UGl0 = parcelRequire("2UGl0");

var $3QMTK = parcelRequire("3QMTK");

var $1c8hB = parcelRequire("1c8hB");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $69974a25804cb8c6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $kJvGp(iteratees, function(iteratee) {
        if ($1c8hB(iteratee)) return function(value) {
            return $dS3e6(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $3QMTK
    ];
    var index = -1;
    iteratees = $kJvGp(iteratees, $74vSq($7qARj));
    var result = $iA1h1(collection, function(value, key, collection) {
        var criteria = $kJvGp(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $hVWSV(result, function(object, other) {
        return $2UGl0(object, other, orders);
    });
}
module.exports = $69974a25804cb8c6$var$baseOrderBy;

});
parcelRegister("iA1h1", function(module, exports) {

var $awetI = parcelRequire("awetI");

var $jxg5X = parcelRequire("jxg5X");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d86c93b23723e939$var$baseMap(collection, iteratee) {
    var index = -1, result = $jxg5X(collection) ? Array(collection.length) : [];
    $awetI(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $d86c93b23723e939$var$baseMap;

});

parcelRegister("hVWSV", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $d0e56fd712f7edce$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $d0e56fd712f7edce$var$baseSortBy;

});

parcelRegister("2UGl0", function(module, exports) {

var $3Sx56 = parcelRequire("3Sx56");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $21f1a725ef116621$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $3Sx56(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $21f1a725ef116621$var$compareMultiple;

});
parcelRegister("3Sx56", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $2d301382a375e0f6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8aco7(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8aco7(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $2d301382a375e0f6$var$compareAscending;

});




parcelRegister("6Qy8u", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $72a4b41762a7cddc$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");
const $72a4b41762a7cddc$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("bYKiA", function(module, exports) {
"use strict";
var $8b893642f4a42c8a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $8b893642f4a42c8a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b893642f4a42c8a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8b893642f4a42c8a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $8b893642f4a42c8a$var$ALL_INITIALIZERS = [];
var $8b893642f4a42c8a$var$READY_INITIALIZERS = [];
function $8b893642f4a42c8a$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $8b893642f4a42c8a$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $8b893642f4a42c8a$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $8b893642f4a42c8a$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $8b893642f4a42c8a$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $8b893642f4a42c8a$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $8b893642f4a42c8a$var$render(loaded, props) {
    return $eUqFw.createElement($8b893642f4a42c8a$var$resolve(loaded), props);
}
function $8b893642f4a42c8a$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $8b893642f4a42c8a$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $8b893642f4a42c8a$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $8b893642f4a42c8a$var$READY_INITIALIZERS.push(function() {
        if ($8b893642f4a42c8a$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $8b893642f4a42c8a$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $8b893642f4a42c8a$var$_classCallCheck(this, LoadableComponent);
            var _this = $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $eUqFw.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($eUqFw.Component), _class.contextTypes = {
        loadable: $1Qivz.shape({
            report: $1Qivz.func.isRequired
        })
    }, _temp;
}
function $8b893642f4a42c8a$var$Loadable(opts) {
    return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$load, opts);
}
function $8b893642f4a42c8a$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$loadMap, opts);
}
$8b893642f4a42c8a$var$Loadable.Map = $8b893642f4a42c8a$var$LoadableMap;
var $8b893642f4a42c8a$var$Capture = function(_React$Component2) {
    $8b893642f4a42c8a$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $8b893642f4a42c8a$var$_classCallCheck(this, Capture);
        return $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $eUqFw.Children.only(this.props.children);
    };
    return Capture;
}($eUqFw.Component);
$8b893642f4a42c8a$var$Capture.propTypes = {
    report: $1Qivz.func.isRequired
};
$8b893642f4a42c8a$var$Capture.childContextTypes = {
    loadable: $1Qivz.shape({
        report: $1Qivz.func.isRequired
    }).isRequired
};
$8b893642f4a42c8a$var$Loadable.Capture = $8b893642f4a42c8a$var$Capture;
function $8b893642f4a42c8a$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $8b893642f4a42c8a$var$flushInitializers(initializers);
    });
}
$8b893642f4a42c8a$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$8b893642f4a42c8a$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $8b893642f4a42c8a$var$Loadable;

});

parcelRegister("6BD9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5bd3b2b1c3a4ae$export$2e2bcd8739ae039);

var $h4jeE = parcelRequire("h4jeE");
const $ef5bd3b2b1c3a4ae$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $ef5bd3b2b1c3a4ae$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $ef5bd3b2b1c3a4ae$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $h4jeE.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("h4jeE", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $d13c58bdee1481e4$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $d13c58bdee1481e4$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $d13c58bdee1481e4$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$d13c58bdee1481e4$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("byYfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7d202e8a0eafca$export$2e2bcd8739ae039);
const $4c7d202e8a0eafca$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $4c7d202e8a0eafca$export$2e2bcd8739ae039 = $4c7d202e8a0eafca$var$convertToError;

});

parcelRegister("taXj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $057b35180044d2aa$export$2e2bcd8739ae039);
function $057b35180044d2aa$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $057b35180044d2aa$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $057b35180044d2aa$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $057b35180044d2aa$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $057b35180044d2aa$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $057b35180044d2aa$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $057b35180044d2aa$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $057b35180044d2aa$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $057b35180044d2aa$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $057b35180044d2aa$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $057b35180044d2aa$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $057b35180044d2aa$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $057b35180044d2aa$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $057b35180044d2aa$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $057b35180044d2aa$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $057b35180044d2aa$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $057b35180044d2aa$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $057b35180044d2aa$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $057b35180044d2aa$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $057b35180044d2aa$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $057b35180044d2aa$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $057b35180044d2aa$var$fromHex_1 = $057b35180044d2aa$var$fromHex, $057b35180044d2aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $057b35180044d2aa$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $057b35180044d2aa$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $057b35180044d2aa$var$fromRgb_1 = $057b35180044d2aa$var$fromRgb, $057b35180044d2aa$var$fromCssRgb_1 = $057b35180044d2aa$var$fromCssRgb, $057b35180044d2aa$var$fromHsl_1 = $057b35180044d2aa$var$fromHsl, $057b35180044d2aa$var$fromCssHsl_1 = $057b35180044d2aa$var$fromCssHsl, $057b35180044d2aa$var$fromHsv_1 = $057b35180044d2aa$var$fromHsv, $057b35180044d2aa$var$fromCmyk_1 = $057b35180044d2aa$var$fromCmyk, $057b35180044d2aa$var$fromYiq_1 = $057b35180044d2aa$var$fromYiq, $057b35180044d2aa$var$fromXYZ_1 = $057b35180044d2aa$var$fromXYZ, $057b35180044d2aa$var$fromxyY_1 = $057b35180044d2aa$var$fromxyY, $057b35180044d2aa$var$fromLms_1 = $057b35180044d2aa$var$fromLms, $057b35180044d2aa$var$fromCieLab_1 = $057b35180044d2aa$var$fromCieLab, $057b35180044d2aa$var$fromCieLuv_1 = $057b35180044d2aa$var$fromCieLuv, $057b35180044d2aa$var$fromCieLch_1 = $057b35180044d2aa$var$fromCieLch, $057b35180044d2aa$var$fromHsluv = $057b35180044d2aa$var$fromCieLch$1, $057b35180044d2aa$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $057b35180044d2aa$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $057b35180044d2aa$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $057b35180044d2aa$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $057b35180044d2aa$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $057b35180044d2aa$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $057b35180044d2aa$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $057b35180044d2aa$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $057b35180044d2aa$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsluv
    }
}, $057b35180044d2aa$var$adapt_1 = $057b35180044d2aa$var$adapt, $057b35180044d2aa$var$adjacent_1 = $057b35180044d2aa$var$adjacent, $057b35180044d2aa$var$brightness_1 = $057b35180044d2aa$var$brightness, $057b35180044d2aa$var$complementary_1 = $057b35180044d2aa$var$complementary, $057b35180044d2aa$var$contrast_1 = $057b35180044d2aa$var$contrast, $057b35180044d2aa$var$contrastRatio_1 = $057b35180044d2aa$var$contrastRatio, $057b35180044d2aa$var$convert_1 = $057b35180044d2aa$var$convert, $057b35180044d2aa$var$difference_1 = $057b35180044d2aa$var$difference, $057b35180044d2aa$var$fade_1 = $057b35180044d2aa$var$fade, $057b35180044d2aa$var$greyscale_1 = $057b35180044d2aa$var$greyscale, $057b35180044d2aa$var$hue_1 = $057b35180044d2aa$var$hue, $057b35180044d2aa$var$invert_1 = $057b35180044d2aa$var$invert, $057b35180044d2aa$var$invertLightness_1 = $057b35180044d2aa$var$invertLightness, $057b35180044d2aa$var$mid_1 = $057b35180044d2aa$var$mid, $057b35180044d2aa$var$multiply_1 = $057b35180044d2aa$var$multiply, $057b35180044d2aa$var$saturation_1 = $057b35180044d2aa$var$saturation, $057b35180044d2aa$var$sepia_1 = $057b35180044d2aa$var$sepia, $057b35180044d2aa$var$shade_1 = $057b35180044d2aa$var$shade, $057b35180044d2aa$var$temperature_1 = $057b35180044d2aa$var$temperature, $057b35180044d2aa$var$tetrad_1 = $057b35180044d2aa$var$tetrad, $057b35180044d2aa$var$triad_1 = $057b35180044d2aa$var$triad, $057b35180044d2aa$var$index$2 = {
    adapt: $057b35180044d2aa$var$adapt_1,
    adjacent: $057b35180044d2aa$var$adjacent_1,
    brightness: $057b35180044d2aa$var$brightness_1,
    complementary: $057b35180044d2aa$var$complementary_1,
    contrast: $057b35180044d2aa$var$contrast_1,
    contrastRatio: $057b35180044d2aa$var$contrastRatio_1,
    convert: $057b35180044d2aa$var$convert_1,
    difference: $057b35180044d2aa$var$difference_1,
    fade: $057b35180044d2aa$var$fade_1,
    greyscale: $057b35180044d2aa$var$greyscale_1,
    hue: $057b35180044d2aa$var$hue_1,
    invert: $057b35180044d2aa$var$invert_1,
    invertLightness: $057b35180044d2aa$var$invertLightness_1,
    mid: $057b35180044d2aa$var$mid_1,
    multiply: $057b35180044d2aa$var$multiply_1,
    saturation: $057b35180044d2aa$var$saturation_1,
    sepia: $057b35180044d2aa$var$sepia_1,
    shade: $057b35180044d2aa$var$shade_1,
    temperature: $057b35180044d2aa$var$temperature_1,
    tetrad: $057b35180044d2aa$var$tetrad_1,
    triad: $057b35180044d2aa$var$triad_1
}, $057b35180044d2aa$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $057b35180044d2aa$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $057b35180044d2aa$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($057b35180044d2aa$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $057b35180044d2aa$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($057b35180044d2aa$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $057b35180044d2aa$var$api_1 = $057b35180044d2aa$var$api, $057b35180044d2aa$var$helpers = {
    getIlluminant: function(r) {
        return $057b35180044d2aa$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $057b35180044d2aa$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $057b35180044d2aa$var$index)if ($057b35180044d2aa$var$index.hasOwnProperty(e) && $057b35180044d2aa$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $057b35180044d2aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $057b35180044d2aa$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $057b35180044d2aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $057b35180044d2aa$var$constants, s));
            default:
                return null;
        }
    }
}, $057b35180044d2aa$var$helpers_1 = $057b35180044d2aa$var$helpers, $057b35180044d2aa$var$dependencies = {
    conversions: $057b35180044d2aa$var$index,
    operations: $057b35180044d2aa$var$index$2,
    helpers: $057b35180044d2aa$var$helpers_1
}, $057b35180044d2aa$var$entry = $057b35180044d2aa$var$api_1($057b35180044d2aa$var$dependencies, $057b35180044d2aa$var$constants);
var $057b35180044d2aa$export$2e2bcd8739ae039 = $057b35180044d2aa$var$entry;

});

parcelRegister("exJuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9676f90260fc6cf$export$2e2bcd8739ae039);
parcelRequire("kU09D");
parcelRequire("eUqFw");
parcelRequire("kXwvz");

var $joBf7 = parcelRequire("joBf7");

parcelRequire("lDjMI");
parcelRequire("b9Xoy");
parcelRequire("T3JCe");
var $a9676f90260fc6cf$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $a9676f90260fc6cf$var$newStyled = (0, $joBf7.default).bind();
$a9676f90260fc6cf$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $a9676f90260fc6cf$var$newStyled[tagName] = $a9676f90260fc6cf$var$newStyled(tagName);
});
var $a9676f90260fc6cf$export$2e2bcd8739ae039 = $a9676f90260fc6cf$var$newStyled;

});

parcelRegister("hgFNe", function(module, exports) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $c92459879273b4b9$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = $c92459879273b4b9$var$fromPairs;

});

parcelRegister("1WBrr", function(module, exports) {

$parcel$export(module.exports, "slackServiceFactory", () => $16a8405a64ac1f47$export$b2ac8baa522556a7);

var $9zh1D = parcelRequire("9zh1D");

var $aq3qS = parcelRequire("aq3qS");

var $9760g = parcelRequire("9760g");
function $16a8405a64ac1f47$export$b2ac8baa522556a7(cloudId, product, createAnalyticsEvent) {
    switch(product){
        case 'platform':
            return new (0, $9760g.default)(cloudId, createAnalyticsEvent);
        case 'confluence':
            return new (0, $9zh1D.default)(cloudId, createAnalyticsEvent);
        default:
            return new (0, $aq3qS.default)(cloudId, createAnalyticsEvent);
    }
}

});
parcelRegister("9zh1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7496ce70979888$export$2e2bcd8739ae039);

var $35UNK = parcelRequire("35UNK");

var $dbkcG = parcelRequire("dbkcG");

var $5K6vN = parcelRequire("5K6vN");
class $6f7496ce70979888$export$2e2bcd8739ae039 extends (0, $35UNK.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $dbkcG.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'confluence', analytics);
        this.confluenceAnalytics = (0, $dbkcG.getConfluenceSlackServiceAnalytics)(createUIAnalyticsEvent);
    }
    async primeConsentUrl() {
        if (this.consentUrl) return;
        const location = typeof window === 'undefined' ? undefined : window.location;
        if (location) {
            var _this$abortController;
            const urlResult = await (0, $5K6vN.default)(location, this.confluenceAnalytics, (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.signal);
            if (urlResult.ok) this.consentUrl = urlResult.result;
            else throw new Error('Failed priming consent URL');
        }
    }
}

});
parcelRegister("35UNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $240de6496103b03d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $jkH4Q = parcelRequire("jkH4Q");

var $3G3gn = parcelRequire("3G3gn");

var $hompL = parcelRequire("hompL");


var $cnL02 = parcelRequire("cnL02");

var $872ua = parcelRequire("872ua");

var $i71b0 = parcelRequire("i71b0");

var $4kLQ3 = parcelRequire("4kLQ3");
const $240de6496103b03d$var$POPUP_WIDTH = 500;
const $240de6496103b03d$var$POPUP_HEIGHT = 900;
const $240de6496103b03d$var$USER_FETCH_LIMIT = 1000;
const $240de6496103b03d$var$retryOptions = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $240de6496103b03d$export$2e2bcd8739ae039 {
    constructor(cloudId, product, analytics){
        (0, $5zQU9.default)(this, "windowName", (0, $hompL.v4)());
        (0, $5zQU9.default)(this, "abortController", typeof AbortController !== 'undefined' ? new AbortController() : null);
        (0, $5zQU9.default)(this, "userStream", {
            count: 0,
            pages: 0,
            finishedLoading: false
        });
        (0, $5zQU9.default)(this, "channelStream", {
            count: 0,
            pages: 0,
            finishedLoading: false
        });
        // Handle Slack authorization success message from popup window
        (0, $5zQU9.default)(this, "onMessage", ({ data: data, target: target, source: source })=>{
            var _this$onSuccess;
            if (!source || target !== window || data !== 'success') return;
            window.removeEventListener('message', this.onMessage);
            const popupWindow = source;
            if (!this.popupWindow) return;
            popupWindow.close();
            this.popupWindow = undefined;
            (_this$onSuccess = this.onSuccess) === null || _this$onSuccess === void 0 || _this$onSuccess.call(this);
        });
        this.cloudId = cloudId;
        this.product = product;
        this.analytics = analytics;
        this.baseUrl = `${0, $202cf7601b72b7d1$export$68362b925a39303e}/${product}`;
    }
    abort() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        }
    }
    async getConsent(onSuccess) {
        await this.primeConsentUrl();
        this.onSuccess = onSuccess;
        window.addEventListener('message', this.onMessage);
        const popupWindow = window.open(this.consentUrl, this.windowName, (0, $cnL02.default)($240de6496103b03d$var$POPUP_WIDTH, $240de6496103b03d$var$POPUP_HEIGHT));
        if (popupWindow) this.popupWindow = popupWindow;
    }
    async isSlackEnabled() {
        const result = await (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController;
                return fetch(`${this.baseUrl}/enabled?cloudId=${this.cloudId}`, {
                    signal: (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.signal
                });
            },
            mapResult: (response)=>response.json().then(({ enabled: enabled })=>enabled),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code !== null && code !== void 0 ? code : '',
                        message: message !== null && message !== void 0 ? message : ''
                    };
                })
        });
        if (result.ok) this.analytics.onGetEnabledSucceeded();
        else if (!result.aborted && !(0, $872ua.isAcceptableFailure)(result.status)) this.analytics.onGetEnabledFailed({
            status: result.status,
            errorMessage: result.message
        });
        return result;
    }
    async getTeams() {
        var _this$abortController2;
        const response = await (0, $4kLQ3.fetchItemsWithCursor)({
            url: `${this.baseUrl}/teams`,
            queryParams: {
                cloudId: this.cloudId
            },
            signal: (_this$abortController2 = this.abortController) === null || _this$abortController2 === void 0 ? void 0 : _this$abortController2.signal,
            getItems: (response)=>response.teams,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($240de6496103b03d$var$retryOptions)
        });
        if (response.ok) {
            this.analytics.onFetchTeamsSucceeded({
                teams: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(response.items, [
                    ({ name: name })=>name.toLowerCase()
                ])
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchTeamsFailed({
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    streamUsers(teamId, onResponse, cursor) {
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController3;
                return fetch(`${this.baseUrl}/recipients${(0, $4kLQ3.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor,
                    limit: $240de6496103b03d$var$USER_FETCH_LIMIT
                })}`, {
                    signal: (_this$abortController3 = this.abortController) === null || _this$abortController3 === void 0 ? void 0 : _this$abortController3.signal
                });
            },
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($240de6496103b03d$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchUsersFailed({
                    teamId: teamId,
                    page: this.userStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.recipients.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.recipients,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    streamChannels(teamId, onResponse, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController4;
                return fetch(`${this.baseUrl}/channels${(0, $4kLQ3.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor
                })}`, {
                    signal: (_this$abortController4 = this.abortController) === null || _this$abortController4 === void 0 ? void 0 : _this$abortController4.signal
                });
            },
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($240de6496103b03d$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchChannelsFailed({
                    teamId: teamId,
                    page: this.channelStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannels(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchChannelsSucceeded({
                teamId: teamId,
                channels: this.channelStream.count,
                pages: this.channelStream.pages
            });
        });
    }
    async fetchSlackUsers(teamId) {
        var _this$abortController5;
        const response = await (0, $4kLQ3.fetchItemsWithCursor)({
            url: `${this.baseUrl}/recipients`,
            queryParams: {
                cloudId: this.cloudId,
                teamId: teamId
            },
            signal: (_this$abortController5 = this.abortController) === null || _this$abortController5 === void 0 ? void 0 : _this$abortController5.signal,
            getItems: (response)=>response.recipients,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($240de6496103b03d$var$retryOptions)
        });
        if (response.ok) {
            const users = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(response.items, [
                ({ name: name })=>name.toLowerCase()
            ]);
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: users
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchUsersFailed({
                teamId: teamId,
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    async share({ teamId: teamId, conversationId: conversationId, conversationType: conversationType, link: link, message: message }) {
        var _this$abortController7;
        (0, $i71b0.startUfoExperience)((0, $i71b0.UfoExperiences).SLACK_REQUEST_SENT);
        const origin = new (0, $jkH4Q.default)({
            product: this.product
        });
        const response = await (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController6;
                return fetch(`${this.baseUrl}/share`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        conversation: {
                            id: conversationId,
                            type: conversationType
                        },
                        link: origin.addToUrl(link),
                        message: message
                    }),
                    signal: (_this$abortController6 = this.abortController) === null || _this$abortController6 === void 0 ? void 0 : _this$abortController6.signal
                });
            },
            mapResult: ()=>Promise.resolve(),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code !== null && code !== void 0 ? code : '',
                        message: message !== null && message !== void 0 ? message : ''
                    };
                }),
            signal: (_this$abortController7 = this.abortController) === null || _this$abortController7 === void 0 ? void 0 : _this$abortController7.signal
        });
        if (response.ok) {
            const successAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: message.length || 0,
                userCount: this.userStream.count
            };
            this.analytics.onShareSucceeded(successAttributes);
            (0, $i71b0.succeedUfoExperience)((0, $i71b0.UfoExperiences).SLACK_REQUEST_SENT, successAttributes);
        } else if (!response.aborted && !(0, $872ua.isAcceptableFailure)(response.status)) {
            const failedAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: response.status,
                errorMessage: response.message
            };
            this.analytics.onShareFailed(failedAttributes);
            (0, $i71b0.failUfoExperience)((0, $i71b0.UfoExperiences).SLACK_REQUEST_SENT, failedAttributes);
        }
        return response.ok ? {
            ok: true,
            result: origin
        } : response;
    }
}

});
const $202cf7601b72b7d1$export$68362b925a39303e = '/gateway/api/slack';
const $202cf7601b72b7d1$export$83c8d7110915321e = 'invite-people';
const $202cf7601b72b7d1$export$2c32b0fe4533d89e = 0;
const $202cf7601b72b7d1$export$9267d266a5449137 = 'NETWORK_ERROR';
const $202cf7601b72b7d1$export$33789febc109c023 = 'Network error';
const $202cf7601b72b7d1$export$4804b650706e0b62 = 'CONFLUENCE_METADATA_ERROR';
const $202cf7601b72b7d1$export$85183a312807388d = 'peopleTeams';
const $202cf7601b72b7d1$export$d67bd32411617d53 = 480;
const $202cf7601b72b7d1$export$cce5ee914c2ec5d9 = 924;
const $202cf7601b72b7d1$export$ab2f49a861856bab = '/gateway/api';
const $202cf7601b72b7d1$export$127769e597bc5ee5 = '/external-users/third-party';
const $202cf7601b72b7d1$export$8bad17bb0225d989 = '/external-users/orgs';
const $202cf7601b72b7d1$export$e468596ea25b5295 = 'integrations';
const $202cf7601b72b7d1$export$458ba67f45a7f353 = 'Third Party Search';
const $202cf7601b72b7d1$export$bc2c06c4779f47f2 = 'Organisation Settings';
const $202cf7601b72b7d1$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $202cf7601b72b7d1$export$3f9855fcc7fa383e = '/slack-channels';
const $202cf7601b72b7d1$export$2d4bcc939d0de9de = 'google-invites';
const $202cf7601b72b7d1$export$baca96d2908c1d98 = 'microsoft-invites';
const $202cf7601b72b7d1$export$89aa938ff9a6aec2 = 3;

parcelRegister("cnL02", function(module, exports) {

$parcel$export(module.exports, "default", () => $903c172c4a16be5e$export$2e2bcd8739ae039);
function $903c172c4a16be5e$export$2e2bcd8739ae039(preferredWidth, preferredHeight) {
    const width = Math.min(preferredWidth, window.screen.availWidth);
    const height = Math.min(preferredHeight, window.screen.availHeight);
    return Object.entries({
        toolbar: 0,
        menubar: 0,
        location: 0,
        status: 0,
        scrollbars: 1,
        resizable: 0,
        chrome: 'yes',
        width: width,
        height: height,
        left: Math.round((window.innerWidth - width) / 2 + window.screenX),
        top: Math.round((window.innerHeight - height) / 3 + window.screenY)
    }).map(([key, value])=>`${key}=${value}`).join(',');
}

});

parcelRegister("872ua", function(module, exports) {

$parcel$export(module.exports, "isAcceptableFailure", () => $5e80e7c512ad0811$export$678d91a98f79a24d);
const $5e80e7c512ad0811$export$678d91a98f79a24d = (statusCode)=>!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;

});

parcelRegister("i71b0", function(module, exports) {

$parcel$export(module.exports, "UfoExperiences", () => $d2f9cb10cdfc9bf6$export$72df3c76208340b5);
$parcel$export(module.exports, "ufoExperiences", () => $d2f9cb10cdfc9bf6$export$615f888019c45765);
$parcel$export(module.exports, "startUfoExperience", () => $d2f9cb10cdfc9bf6$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $d2f9cb10cdfc9bf6$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $d2f9cb10cdfc9bf6$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $d2f9cb10cdfc9bf6$export$b1021040eb94cdca);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $d2f9cb10cdfc9bf6$export$72df3c76208340b5 = /*#__PURE__*/ function(UfoExperiences) {
    UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
    UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
    UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
    UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
    return UfoExperiences;
}({});
var $d2f9cb10cdfc9bf6$var$PlatformComponent = /*#__PURE__*/ function(PlatformComponent) {
    PlatformComponent["ShareToSlack"] = "share-to-slack";
    PlatformComponent["CoreInvites"] = "core-invites";
    return PlatformComponent;
}($d2f9cb10cdfc9bf6$var$PlatformComponent || {});
const $d2f9cb10cdfc9bf6$export$615f888019c45765 = {
    [$d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_REQUEST_SENT]: new (0, $kDfSL.UFOExperience)($d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_REQUEST_SENT, {
        type: (0, $12kyE.ExperienceTypes).Experience,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: $d2f9cb10cdfc9bf6$var$PlatformComponent.ShareToSlack
        }
    }),
    [$d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_SEGMENT_RENDERED]: new (0, $kDfSL.UFOExperience)($d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_SEGMENT_RENDERED, {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: $d2f9cb10cdfc9bf6$var$PlatformComponent.ShareToSlack
        }
    }),
    [$d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_FORM_ENABLED]: new (0, $kDfSL.UFOExperience)($d2f9cb10cdfc9bf6$export$72df3c76208340b5.SLACK_FORM_ENABLED, {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: $d2f9cb10cdfc9bf6$var$PlatformComponent.ShareToSlack
        }
    }),
    [$d2f9cb10cdfc9bf6$export$72df3c76208340b5.PLATFORM_SLACK_USERS_PAGE_FETCHED]: new (0, $kDfSL.UFOExperience)($d2f9cb10cdfc9bf6$export$72df3c76208340b5.PLATFORM_SLACK_USERS_PAGE_FETCHED, {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: $d2f9cb10cdfc9bf6$var$PlatformComponent.CoreInvites
        }
    })
};
const $d2f9cb10cdfc9bf6$export$5e9287b6a10f8075 = (experienceName, properties)=>{
    const experience = $d2f9cb10cdfc9bf6$export$615f888019c45765[experienceName];
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $d2f9cb10cdfc9bf6$export$c5a5cf072c836c0e = (experienceName, properties)=>{
    const experience = $d2f9cb10cdfc9bf6$export$615f888019c45765[experienceName];
    experience.success({
        metadata: properties
    });
};
const $d2f9cb10cdfc9bf6$export$8dda83bafca11b77 = (experienceName, properties)=>{
    const experience = $d2f9cb10cdfc9bf6$export$615f888019c45765[experienceName];
    experience.failure({
        metadata: properties
    });
};
const $d2f9cb10cdfc9bf6$export$b1021040eb94cdca = (experienceName, properties)=>{
    const experience = $d2f9cb10cdfc9bf6$export$615f888019c45765[experienceName];
    experience.abort({
        metadata: properties
    });
};

});

parcelRegister("4kLQ3", function(module, exports) {

$parcel$export(module.exports, "fetchItemsWithCursor", () => $327e236b43ff73dd$export$1d3435507f486e79);
$parcel$export(module.exports, "retryFetch", () => $327e236b43ff73dd$export$635968db05579875);
$parcel$export(module.exports, "httpRetryPolicy", () => $327e236b43ff73dd$export$bd28f8bf945907aa);
$parcel$export(module.exports, "FetchError", () => $327e236b43ff73dd$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $327e236b43ff73dd$export$6d71b655afe1638d);
$parcel$export(module.exports, "buildQueryString", () => $327e236b43ff73dd$export$6b17a39e52c8ee53);
$parcel$export(module.exports, "sortByName", () => $327e236b43ff73dd$export$7932064324870761);

var $3G3gn = parcelRequire("3G3gn");


var $dzbDS = parcelRequire("dzbDS");
function $327e236b43ff73dd$var$defaultErrorMapper(response) {
    return Promise.resolve({
        code: response.status.toString(),
        message: response.statusText
    });
}
function $327e236b43ff73dd$var$defaultResultMapper(response) {
    return response.json();
}
async function $327e236b43ff73dd$export$1d3435507f486e79({ url: url, queryParams: queryParams = {}, signal: signal, getItems: getItems, getCursor: getCursor, canRetryCheck: canRetryCheck, mapError: mapError = $327e236b43ff73dd$var$defaultErrorMapper }) {
    const items = [];
    let response;
    let page = 0;
    do {
        var _response, _response2;
        // Bail out here in case the abort signal is fired between requests.
        if (signal !== null && signal !== void 0 && signal.aborted) return {
            ok: false,
            aborted: true
        };
        const cursor = (_response2 = response) !== null && _response2 !== void 0 && _response2.ok ? getCursor(response.result) : undefined;
        const queryParamsWithCursor = cursor ? {
            ...queryParams,
            cursor: cursor
        } : queryParams;
        const search = Object.entries(queryParamsWithCursor !== null && queryParamsWithCursor !== void 0 ? queryParamsWithCursor : {}).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        const urlWithParams = [
            url,
            search
        ].filter(Boolean).join('?');
        // Get the next page and retry in case of intermittent errors
        response = await $327e236b43ff73dd$export$635968db05579875({
            request: ()=>fetch(urlWithParams, {
                    signal: signal
                }),
            mapError: mapError,
            signal: signal,
            canRetryCheck: canRetryCheck
        });
        if (!response.ok) return response.aborted ? response : {
            ...response,
            page: page
        };
        items.push.apply(items, getItems(response.result));
        ++page;
    }while ((_response = response) !== null && _response !== void 0 && _response.ok && getCursor(response.result));
    return {
        ok: true,
        items: items,
        pages: page
    };
}
async function $327e236b43ff73dd$export$9369b12211e1fce4({ request: request, canRetryCheck: canRetryCheck, attempt: attempt = 0, signal: signal }) {
    const result = await request(signal);
    if (result.ok || result.aborted || signal !== null && signal !== void 0 && signal.aborted) return result;
    else {
        const [canRetry, timeToWait] = canRetryCheck(result.status, ++attempt, signal);
        if (canRetry) {
            if (timeToWait) await (0, $dzbDS.wait)(timeToWait);
            return $327e236b43ff73dd$export$9369b12211e1fce4({
                request: request,
                canRetryCheck: canRetryCheck,
                attempt: attempt,
                signal: signal
            });
        }
    }
    return result;
}
const $327e236b43ff73dd$var$DEFAULT_MAX_ATTEMPTS = 3;
const $327e236b43ff73dd$var$DEFAULT_BACKOFF_TIME_MS = 200;
const $327e236b43ff73dd$var$DEFAULT_BACKOFF_TIME_429_MS = 1000;
function $327e236b43ff73dd$export$bd28f8bf945907aa({ maxAttempts: maxAttempts = $327e236b43ff73dd$var$DEFAULT_MAX_ATTEMPTS, backoffTimeMs: backoffTimeMs = $327e236b43ff73dd$var$DEFAULT_BACKOFF_TIME_MS, rateLimitBackoffTimeMs: rateLimitBackoffTimeMs = $327e236b43ff73dd$var$DEFAULT_BACKOFF_TIME_429_MS } = {}) {
    return (status, attempts)=>{
        // Stop if attempts are exhausted
        if (attempts >= maxAttempts) return [
            false,
            0
        ];
        switch(status){
            // Unlikely to recover from these
            case 401:
            case 403:
            case 404:
                return [
                    false,
                    0
                ];
            // Probably rate limiting. Back off and try again.
            case 429:
                return [
                    true,
                    rateLimitBackoffTimeMs
                ];
            // Unknown error. Back off and try again.
            default:
                return [
                    true,
                    backoffTimeMs
                ];
        }
    };
}
function $327e236b43ff73dd$export$635968db05579875({ request: request, mapResult: mapResult = $327e236b43ff73dd$var$defaultResultMapper, mapError: mapError = $327e236b43ff73dd$var$defaultErrorMapper, canRetryCheck: canRetryCheck = $327e236b43ff73dd$export$bd28f8bf945907aa(), signal: signal }) {
    return $327e236b43ff73dd$export$9369b12211e1fce4({
        request: async ()=>{
            let response;
            try {
                response = await request();
                if (response.ok) return {
                    ok: true,
                    result: await mapResult(response)
                };
                const { code: code, message: message } = await mapError(response);
                // Error status
                return {
                    ok: false,
                    aborted: false,
                    status: response.status,
                    code: code,
                    message: message
                };
            } catch (error) {
                if (error instanceof Error) {
                    // Request aborted client-side
                    if (error.name === 'AbortError') return {
                        ok: false,
                        aborted: true
                    };
                    // Client-side networking error
                    return {
                        ok: false,
                        aborted: false,
                        status: (0, $202cf7601b72b7d1$export$2c32b0fe4533d89e),
                        code: error.name,
                        message: error.message
                    };
                }
                return {
                    ok: false,
                    aborted: false,
                    status: (0, $202cf7601b72b7d1$export$2c32b0fe4533d89e),
                    code: (0, $202cf7601b72b7d1$export$9267d266a5449137),
                    message: (0, $202cf7601b72b7d1$export$33789febc109c023)
                };
            }
        },
        canRetryCheck: canRetryCheck,
        signal: signal
    });
}
class $327e236b43ff73dd$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, errorType){
        super(message);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.errorType = errorType;
    }
}
const $327e236b43ff73dd$export$6d71b655afe1638d = (url, action, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new $327e236b43ff73dd$export$26e841bcf1aeb894(`Unable to fetch ${action} ${response.statusText}`, response.status);
    });
const $327e236b43ff73dd$var$isNil = (value)=>value === undefined || value === null;
function $327e236b43ff73dd$export$6b17a39e52c8ee53(obj) {
    const query = Object.keys(obj).filter((key)=>!$327e236b43ff73dd$var$isNil(obj[key])).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    return query ? '?' + query : query;
}
function $327e236b43ff73dd$export$7932064324870761(values) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(values, ({ name: name })=>name.toLowerCase());
}

});
parcelRegister("dzbDS", function(module, exports) {

$parcel$export(module.exports, "wait", () => $9e07932807d30379$export$5c069c93d2b7493f);
async function $9e07932807d30379$export$5c069c93d2b7493f(delayMs) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, delayMs);
    });
}

});



parcelRegister("dbkcG", function(module, exports) {

$parcel$export(module.exports, "getSlackServiceAnalytics", () => $998bf979acf4f423$export$2b9ff26dd710d5d7);
$parcel$export(module.exports, "getConfluenceSlackServiceAnalytics", () => $998bf979acf4f423$export$2cc68fa43a97a8c);


var $hM7RE = parcelRequire("hM7RE");

const $998bf979acf4f423$var$createAndFireEventOnPeopleTeams = (0, $hM7RE.default)((0, $202cf7601b72b7d1$export$85183a312807388d));
var $998bf979acf4f423$var$AnalyticsActionSubject = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["INTEGRATION_SUCCEEDED"] = "integrationEnabled";
    AnalyticsActionSubject["INTEGRATION_TEAMS"] = "integrationTeams";
    AnalyticsActionSubject["INTEGRATION_CONVERSATIONS"] = "integrationConversations";
    AnalyticsActionSubject["INTEGRATION_METADATA"] = "integrationMetadata";
    AnalyticsActionSubject["INTEGRATION_TOKEN"] = "integrationCsrfToken";
    AnalyticsActionSubject["SHARE"] = "share";
    return AnalyticsActionSubject;
}($998bf979acf4f423$var$AnalyticsActionSubject || {});
var $998bf979acf4f423$var$AnalyticsAction = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    return AnalyticsAction;
}($998bf979acf4f423$var$AnalyticsAction || {});
const $998bf979acf4f423$export$e0925453bd625a62 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_SUCCEEDED,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$d533ef9287e29338 = (createAnalyticsEvent, { status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_SUCCEEDED,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        attributes: {
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$10723e48240e4b6a = (createAnalyticsEvent, { teams: teams, pages: pages })=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_TEAMS,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED,
        attributes: {
            teams: teams,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$77d7c2557ef0cb5b = (createAnalyticsEvent, { page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_TEAMS,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        attributes: {
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$1fb50f4a006f5510 = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages })=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_CONVERSATIONS,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$121a5feec5d3a18f = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_CONVERSATIONS,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$503ff4642f649174 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_METADATA,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$68485a36cbb1a06f = (createAnalyticsEvent, params)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_METADATA,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        attributes: {
            ...params
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$5cc3ad7b898341e7 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_METADATA,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$757b1ed45dd16a84 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.INTEGRATION_TOKEN,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$var$productActionSubjectId = {
    jira: 'issue',
    confluence: 'page',
    // default to issue at the moment but should
    // be something else depending on what is actually shared
    // once we implement sharing with the platform slack app
    platform: 'issue'
};
const $998bf979acf4f423$export$24b0574fd3374a47 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.SHARE,
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED,
        actionSubjectId: $998bf979acf4f423$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            messageLength: messageLength,
            workspaceSize: userCount
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$867fe86603399772 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $998bf979acf4f423$var$AnalyticsActionSubject.SHARE,
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        actionSubjectId: $998bf979acf4f423$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$5a5d58e4161f41aa = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: $998bf979acf4f423$var$AnalyticsAction.SUCCEEDED,
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$1286eed6ab074bde = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $998bf979acf4f423$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: $998bf979acf4f423$var$AnalyticsAction.FAILED,
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $998bf979acf4f423$export$2b9ff26dd710d5d7 = (createAnalyticsEvent)=>({
        onGetEnabledSucceeded: ()=>$998bf979acf4f423$export$e0925453bd625a62(createAnalyticsEvent),
        onGetEnabledFailed: (params)=>$998bf979acf4f423$export$d533ef9287e29338(createAnalyticsEvent, params),
        onFetchTeamsSucceeded: (params)=>$998bf979acf4f423$export$10723e48240e4b6a(createAnalyticsEvent, params),
        onFetchTeamsFailed: (params)=>$998bf979acf4f423$export$77d7c2557ef0cb5b(createAnalyticsEvent, params),
        onFetchUsersSucceeded: ({ teamId: teamId, users: users, pages: pages })=>$998bf979acf4f423$export$1fb50f4a006f5510(createAnalyticsEvent, {
                slackTeamId: teamId || '',
                conversationTypes: [
                    'directMessage'
                ],
                conversations: users || 0,
                pages: pages
            }),
        onFetchUsersFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>$998bf979acf4f423$export$121a5feec5d3a18f(createAnalyticsEvent, {
                slackTeamId: teamId,
                conversationTypes: [
                    'directMessage'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage
            }),
        onShareSucceeded: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount })=>{
            $998bf979acf4f423$export$24b0574fd3374a47({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: messageLength,
                userCount: userCount
            }, createAnalyticsEvent);
        },
        onShareFailed: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage })=>{
            $998bf979acf4f423$export$867fe86603399772({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: status,
                errorMessage: errorMessage
            }, createAnalyticsEvent);
        },
        onFetchChannelsSucceeded: ({ teamId: teamId, channels: channels, pages: pages })=>{
            $998bf979acf4f423$export$5a5d58e4161f41aa({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                conversations: channels,
                pages: pages,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        },
        onFetchChannelsFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>{
            $998bf979acf4f423$export$1286eed6ab074bde({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        }
    });
const $998bf979acf4f423$export$2cc68fa43a97a8c = (createAnalyticsEvent)=>({
        onFetchConnectMetadataSucceeded: ()=>$998bf979acf4f423$export$503ff4642f649174(createAnalyticsEvent),
        onFetchConnectMetadataFailed: (params)=>$998bf979acf4f423$export$68485a36cbb1a06f(createAnalyticsEvent, params),
        onRefreshIntegrationCsrfTokenSucceeded: ()=>$998bf979acf4f423$export$5cc3ad7b898341e7(createAnalyticsEvent),
        onRefreshIntegrationCsrfTokenFailed: ()=>$998bf979acf4f423$export$757b1ed45dd16a84(createAnalyticsEvent)
    });

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';


parcelRegister("5K6vN", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e64cc08948135f$export$2e2bcd8739ae039);


var $j6H3y = parcelRequire("j6H3y");

var $huQA1 = parcelRequire("huQA1");
const $42e64cc08948135f$var$consentUrl = {
    prod: `https://confluence-chats-integr.services.atlassian.com/api/slack/teams/login?source=${(0, $202cf7601b72b7d1$export$83c8d7110915321e)}`,
    staging: `https://confluence-chats-integr.stg.services.atlassian.com/api/slack/teams/login?source=${(0, $202cf7601b72b7d1$export$83c8d7110915321e)}`
};
const $42e64cc08948135f$var$connectKey = {
    prod: 'confluence-chats-integration',
    staging: 'confluence-chats-integration-stg-east'
};
const $42e64cc08948135f$var$ACQUIRE_CSRF_TIMEOUT_MS = 2000;
async function $42e64cc08948135f$export$2e2bcd8739ae039(location, analytics, signal) {
    const environment = (0, $j6H3y.default)(location.hostname);
    const response = await $42e64cc08948135f$var$getConfluenceSlackIntegrationDialogParams(location, signal);
    if (!response.ok) {
        if (!response.aborted) analytics.onFetchConnectMetadataFailed({
            status: response.status,
            errorMessage: response.message
        });
        return response;
    }
    analytics.onFetchConnectMetadataSucceeded();
    const { contextJwt: contextJwt, url: url } = response.result;
    // Prime the consent URL’s origin with any cookies it needs (namely, the CSRF
    // token) which would ordinarily be set by integration’s dialog.
    //
    // Explanation: This ensures a cookie containing a valid CSRF token is set on
    // the Slack consent popup window’s origin. This is a necessary step because
    // the Slack integration requires a valid CSRF token in the consent page
    // request when its URL contains a jwt query parameter. Failure to provide a
    // CSRF token cookie results in an invalid CSRF token error.
    try {
        await (0, $huQA1.default)(url, $42e64cc08948135f$var$ACQUIRE_CSRF_TIMEOUT_MS);
        analytics.onRefreshIntegrationCsrfTokenSucceeded();
    } catch (error) {
        analytics.onRefreshIntegrationCsrfTokenFailed();
    // Ignore and hope there’s already a valid CSRF token.
    }
    return {
        ok: true,
        result: `${$42e64cc08948135f$var$consentUrl[environment]}&jwt=${encodeURIComponent(contextJwt)}`
    };
}
async function $42e64cc08948135f$var$getConfluenceSlackIntegrationDialogParams(location, signal) {
    const connectPath = $42e64cc08948135f$var$getConnectPath(location);
    try {
        const response = await fetch(connectPath, {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            signal: signal,
            body: Object.entries({
                'plugin-key': 'confluence-chats-integration',
                key: 'dialog',
                productContext: '{}',
                classifier: 'json'
            }).map((kvp)=>kvp.map(encodeURIComponent).join('=')).join('&')
        });
        if (response.ok) return {
            ok: true,
            result: await response.json()
        };
        return {
            ok: false,
            aborted: false,
            status: response.status,
            code: `${response.status}`,
            message: await response.text()
        };
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === 'AbortError') return {
                ok: false,
                aborted: true
            };
            return {
                ok: false,
                aborted: false,
                status: (0, $202cf7601b72b7d1$export$2c32b0fe4533d89e),
                code: (0, $202cf7601b72b7d1$export$9267d266a5449137),
                message: error.message || (0, $202cf7601b72b7d1$export$33789febc109c023)
            };
        }
        return {
            ok: false,
            aborted: false,
            status: (0, $202cf7601b72b7d1$export$2c32b0fe4533d89e),
            code: (0, $202cf7601b72b7d1$export$9267d266a5449137),
            message: (0, $202cf7601b72b7d1$export$33789febc109c023)
        };
    }
}
function $42e64cc08948135f$var$getConnectPath(location) {
    const environment = (0, $j6H3y.default)(location.hostname);
    return `/wiki/plugins/servlet/ac/${$42e64cc08948135f$var$connectKey[environment]}/dialog`;
}

});
parcelRegister("j6H3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8ff9f3c220b682$export$2e2bcd8739ae039);
function $de8ff9f3c220b682$export$2e2bcd8739ae039(hostname) {
    return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
}

});

parcelRegister("huQA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbce0650f6c3c130$export$2e2bcd8739ae039);
/**
 * Fetch the specified URL, which is expected to set one or more cookies on its
 * origin.
 *
 * In order for this to work, a same-origin request is made by temporarily
 * creating an iframe.
 *
 * @param url       - the URL to fetch
 * @param timeoutMs - milliseconds to wait before timing out
 */ function $cbce0650f6c3c130$export$2e2bcd8739ae039(url, timeoutMs) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.position = 'absolute';
    iframe.style.visibility = 'hidden';
    iframe.style.borderWidth = '0';
    document.body.appendChild(iframe);
    return new Promise((resolve, reject)=>{
        let completed = false;
        const timeout = setTimeout(()=>{
            completed = true;
            document.body.removeChild(iframe);
            reject();
        }, timeoutMs);
        iframe.onload = ()=>{
            if (!completed) {
                clearTimeout(timeout);
                completed = true;
                document.body.removeChild(iframe);
                resolve();
            }
        };
    });
}

});



parcelRegister("aq3qS", function(module, exports) {

$parcel$export(module.exports, "default", () => $795efeb66cfe5079$export$2e2bcd8739ae039);

var $35UNK = parcelRequire("35UNK");

var $dbkcG = parcelRequire("dbkcG");

var $eWHFO = parcelRequire("eWHFO");
class $795efeb66cfe5079$export$2e2bcd8739ae039 extends (0, $35UNK.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $dbkcG.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'jira', analytics);
    }
    async primeConsentUrl() {
        if (!this.consentUrl) this.consentUrl = (0, $eWHFO.default)(location);
    }
}

});
parcelRegister("eWHFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae185c1c27d9d018$export$2e2bcd8739ae039);


var $j6H3y = parcelRequire("j6H3y");
const $ae185c1c27d9d018$var$consentUrl = {
    prod: `https://atlassian-slack-integration.services.atlassian.com/api/slack/login?source=${(0, $202cf7601b72b7d1$export$83c8d7110915321e)}`,
    staging: `https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login?source=${(0, $202cf7601b72b7d1$export$83c8d7110915321e)}`
};
function $ae185c1c27d9d018$export$2e2bcd8739ae039(location) {
    const environment = (0, $j6H3y.default)(location.hostname);
    return $ae185c1c27d9d018$var$consentUrl[environment];
}

});


parcelRegister("9760g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a296c9e566988e4$export$2e2bcd8739ae039);

var $35UNK = parcelRequire("35UNK");

var $dbkcG = parcelRequire("dbkcG");


var $i71b0 = parcelRequire("i71b0");

var $4kLQ3 = parcelRequire("4kLQ3");
const $6a296c9e566988e4$var$USER_FETCH_LIMIT = 500;
const $6a296c9e566988e4$var$RETRY_OPTIONS = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $6a296c9e566988e4$export$2e2bcd8739ae039 extends (0, $35UNK.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $dbkcG.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'platform', analytics);
    }
    streamUsers(teamId, onResponse, cursor) {
        (0, $i71b0.startUfoExperience)((0, $i71b0.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
            limit: $6a296c9e566988e4$var$USER_FETCH_LIMIT
        });
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            teamId: teamId,
            cloudId: this.cloudId,
            limit: $6a296c9e566988e4$var$USER_FETCH_LIMIT.toString(),
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController;
                return fetch(`${(0, $202cf7601b72b7d1$export$ab2f49a861856bab)}${(0, $202cf7601b72b7d1$export$127769e597bc5ee5)}/slack/users?${queryString}`, {
                    signal: (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.signal
                });
            },
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($6a296c9e566988e4$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) {
                    this.analytics.onFetchUsersFailed({
                        teamId: teamId,
                        page: this.userStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    (0, $i71b0.failUfoExperience)((0, $i71b0.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                } else (0, $i71b0.abortUfoExperience)((0, $i71b0.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.users.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.users.map(({ id: id, email: email, displayName: displayName, realName: name, avatar: avatarUrl })=>({
                        id: id,
                        name: name,
                        displayName: displayName,
                        avatarUrl: avatarUrl,
                        email: email,
                        type: 'directMessage'
                    })),
                nextCursor: resp.result.nextCursor
            });
            (0, $i71b0.succeedUfoExperience)((0, $i71b0.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                numResults: resp.result.users.length
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    /*
   * Temporary experiment endpoint for Invite 3rd Party Team (ITPT)
   */ streamChannelsExperiment(workspaceId, onResponse, onError, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            workspaceId: workspaceId,
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $4kLQ3.retryFetch)({
            request: ()=>{
                var _this$abortController2;
                return fetch(`${(0, $202cf7601b72b7d1$export$ab2f49a861856bab)}${(0, $202cf7601b72b7d1$export$20875166a8676880)}${(0, $202cf7601b72b7d1$export$3f9855fcc7fa383e)}?${queryString}`, {
                    signal: (_this$abortController2 = this.abortController) === null || _this$abortController2 === void 0 ? void 0 : _this$abortController2.signal
                });
            },
            canRetryCheck: (0, $4kLQ3.httpRetryPolicy)($6a296c9e566988e4$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannelsExperiment(workspaceId, onResponse, onError, resp.result.nextCursor);
        }).catch((error)=>{
            onError(error);
        });
    }
    // This was necessary since it was abstract in the base class
    // but is not used in this slack service
    async primeConsentUrl() {}
}

});


parcelRegister("hXPzA", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("6wYjl")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("6wYjl")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("6wYjl")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("6waSD")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("6waSD")).Reasons);

var $6wYjl = parcelRequire("6wYjl");

var $6waSD = parcelRequire("6waSD");

});
parcelRegister("6wYjl", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $606dd72bb06c61b6$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $606dd72bb06c61b6$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $606dd72bb06c61b6$export$655b6c19a0daddb8);

var $eUqFw = parcelRequire("eUqFw");

var $kms3n = parcelRequire("kms3n");

var $6waSD = parcelRequire("6waSD");
const $606dd72bb06c61b6$var$LATEST_VERSION = (0, $kms3n.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $606dd72bb06c61b6$var$CrossFlowContext = /*#__PURE__*/ (0, $eUqFw.createContext)(()=>({
        isEnabled: false,
        reason: (0, $6waSD.Reasons).NO_PROVIDER
    }));
const $606dd72bb06c61b6$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $kms3n.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $kms3n.createAPIv0)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $6waSD.Reasons).NO_API_SUPPORT
                };
        }
    };
const $606dd72bb06c61b6$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $eUqFw.useMemo)(()=>$606dd72bb06c61b6$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($606dd72bb06c61b6$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $606dd72bb06c61b6$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $eUqFw.useContext)($606dd72bb06c61b6$var$CrossFlowContext);
    return (0, $eUqFw.useMemo)(()=>negotiateApi($606dd72bb06c61b6$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $606dd72bb06c61b6$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $606dd72bb06c61b6$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("kms3n", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $0a8c1b627b4c08ea$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv0", () => $0a8c1b627b4c08ea$export$9ff7368ac93fcf2d);
const $0a8c1b627b4c08ea$export$a4ad2735b021c132 = 0;
const $0a8c1b627b4c08ea$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("6waSD", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $d119a1389c5a1fdc$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $d119a1389c5a1fdc$export$da2d4f2f250d6f84);
const $d119a1389c5a1fdc$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $d119a1389c5a1fdc$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("8a0ZO", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("kxJAm")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("bPFq3")).Targets);

var $kxJAm = parcelRequire("kxJAm");

var $bPFq3 = parcelRequire("bPFq3");

});
parcelRegister("kxJAm", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $694aea767013a371$export$a5e53d1dcbd6eb61);
class $694aea767013a371$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("bPFq3", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $ff4315d85018519c$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $ff4315d85018519c$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass'
};

});


parcelRegister("NYVfB", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("6wYjl")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("6wYjl")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("6waSD")).Journeys);
$parcel$export(module.exports, "Targets", () => (parcelRequire("bPFq3")).Targets);
parcelRequire("hXPzA");
var $6waSD = parcelRequire("6waSD");
var $6wYjl = parcelRequire("6wYjl");
parcelRequire("8a0ZO");
var $bPFq3 = parcelRequire("bPFq3");

var $dSjY7 = parcelRequire("dSjY7");

});
parcelRegister("dSjY7", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("hXPzA");
var $6wYjl = parcelRequire("6wYjl");
const $a19fcee06dd42255$export$bb23a1e8e036feea = (props)=>{
    // Using useRef here to ensure that only the initial props are used
    // and it ensures that the useEffect handler below is only run once.
    // Any subsequent changes to props have no effect.
    const propsRef = (0, $eUqFw.useRef)(props);
    const crossFlowRef = (0, $eUqFw.useRef)((0, $6wYjl.useCrossFlow)());
    (0, $eUqFw.useEffect)(()=>{
        const crossFlow = crossFlowRef.current;
        (async ()=>{
            const { onComplete: onComplete, onError: onError, ...options } = propsRef.current;
            if (crossFlow.isEnabled) try {
                const status = await crossFlow.api.open(options);
                onComplete === null || onComplete === void 0 || onComplete(status);
            } catch (err) {
                onError === null || onError === void 0 || onError(err);
            }
        })();
    }, []);
    return null;
};

});


parcelRegister("jbNLw", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $df85a5ccfb188eb5$export$224367b01f71f2aa);

var $dVYxA = parcelRequire("dVYxA");

var $4ujFn = parcelRequire("4ujFn");
let $df85a5ccfb188eb5$var$previousClientVersion;
const $df85a5ccfb188eb5$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($df85a5ccfb188eb5$var$previousClientVersion && $df85a5ccfb188eb5$var$previousClientVersion !== version && logger !== null && logger !== void 0 && logger.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $df85a5ccfb188eb5$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $dVYxA.ActivityClientV2)(product, baseUrl);
    return new (0, $4ujFn.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("dVYxA", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $a24f8f567b87cf8f$export$330ab0047f2fb745);

var $5zQU9 = parcelRequire("5zQU9");

var $aOhoS = parcelRequire("aOhoS");

var $aMXE8 = parcelRequire("aMXE8");

var $kfmJM = parcelRequire("kfmJM");
class $a24f8f567b87cf8f$export$330ab0047f2fb745 extends (0, $aMXE8.ActivityClient) {
    constructor(_product, baseUrl){
        super('v2', _product, undefined, baseUrl);
        (0, $5zQU9.default)(this, "fetchActivities", async (retryMS, filters, activityQueries)=>{
            return (0, $aOhoS.fetchActivitiesWithExperience)((experience)=>(0, $kfmJM.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        });
        (0, $5zQU9.default)(this, "setProduct", (product)=>{
            this.product = product;
        });
    }
}

});
parcelRegister("aOhoS", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $7dec1233f6d92eab$export$4a906f16800734f3);

var $3rDA6 = parcelRequire("3rDA6");

var $4BV8g = parcelRequire("4BV8g");

var $3fr3j = parcelRequire("3fr3j");
async function $7dec1233f6d92eab$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $3fr3j.recentWorkClientExperienceV2)() : (0, $3fr3j.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $4BV8g.packageName,
            packageVersion: $4BV8g.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $7dec1233f6d92eab$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $7dec1233f6d92eab$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $3rDA6.default)) {
        var _e$xRequestId;
        return {
            ...e,
            xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
            cause: undefined
        };
    }
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("3rDA6", function(module, exports) {

$parcel$export(module.exports, "default", () => $282298b7a2c55b99$export$2e2bcd8739ae039);
class $282298b7a2c55b99$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $282298b7a2c55b99$export$97b788730ba59845 = (e)=>e instanceof $282298b7a2c55b99$export$2e2bcd8739ae039;

});

parcelRegister("4BV8g", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $35b6ef6e0fa86c8e$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $35b6ef6e0fa86c8e$export$91546b032799aa40);
const $35b6ef6e0fa86c8e$export$9345d7360ffe0722 = "@atlassian/recent-work-client";
const $35b6ef6e0fa86c8e$export$91546b032799aa40 = "1.8.7";

});

parcelRegister("3fr3j", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $25d7c1df24a97dec$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $25d7c1df24a97dec$export$9e32a4ed888f4717);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $25d7c1df24a97dec$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $25d7c1df24a97dec$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($25d7c1df24a97dec$var$keyToTiming);
const $25d7c1df24a97dec$export$d7769758f5eaa63b = ()=>{
    return new (0, $kDfSL.UFOExperience)('client', {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $25d7c1df24a97dec$var$timings
    });
};
const $25d7c1df24a97dec$export$9e32a4ed888f4717 = ()=>new (0, $kDfSL.UFOExperience)('client-v3', {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $25d7c1df24a97dec$var$timings
    });

});


parcelRegister("aMXE8", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $7daca793bdcc983b$export$157740f5433f3dbe);

var $5zQU9 = parcelRequire("5zQU9");

var $lwzE0 = parcelRequire("lwzE0");
class $7daca793bdcc983b$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        (0, $5zQU9.default)(this, "product", 'unknown');
        (0, $5zQU9.default)(this, "baseUrl", (0, $lwzE0.GRAPHQL_GATEWAY_PATH));
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers !== null && headers !== void 0 ? headers : {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("lwzE0", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $fab83c5b03ac894c$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $fab83c5b03ac894c$export$eb4e9f525aef1cc3);
const $fab83c5b03ac894c$export$851c5df667ca24c8 = '/gateway/api/graphql';
let $fab83c5b03ac894c$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
let $fab83c5b03ac894c$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
let $fab83c5b03ac894c$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("kfmJM", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $ebd6d88ca21bcbdc$export$750ec7816fdd2f9e);

var $7EIv8 = parcelRequire("7EIv8");

var $65pfv = parcelRequire("65pfv");

var $6S4m0 = parcelRequire("6S4m0");

var $b37KP = parcelRequire("b37KP");
const $ebd6d88ca21bcbdc$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $ebd6d88ca21bcbdc$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $ebd6d88ca21bcbdc$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $ebd6d88ca21bcbdc$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    var _response$data;
    const { limit: // we want to default limit if not applied
    limit = $ebd6d88ca21bcbdc$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $6S4m0.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $ebd6d88ca21bcbdc$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $65pfv.postResource)(baseUrl, {
            operationName: (0, $7EIv8.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activities)) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($ebd6d88ca21bcbdc$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $b37KP.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $b37KP.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $b37KP.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $b37KP.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $b37KP.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("7EIv8", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $592ec9d5cf882468$export$41bca9dc6871dd4e);

var $jh2R9 = parcelRequire("jh2R9");
const $592ec9d5cf882468$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(product);
};
const $592ec9d5cf882468$export$41bca9dc6871dd4e = (product)=>{
    return `${$592ec9d5cf882468$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("65pfv", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $46e6cbaa34d8c701$export$2ff3e1f219ccfad6);
parcelRequire("45owE");
var $7qhNL = parcelRequire("7qhNL");
var $45owE = parcelRequire("45owE");

var $3KPCE = parcelRequire("3KPCE");

var $3rDA6 = parcelRequire("3rDA6");
const $46e6cbaa34d8c701$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $3KPCE.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $7qhNL.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $46e6cbaa34d8c701$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $3rDA6.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $46e6cbaa34d8c701$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $46e6cbaa34d8c701$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $46e6cbaa34d8c701$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $45owE.retryOnException)(()=>$46e6cbaa34d8c701$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS !== null && retryMS !== void 0 ? retryMS : []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $46e6cbaa34d8c701$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("45owE", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $e157174ff0ba4a41$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("7qhNL")).default);

var $byYfF = parcelRequire("byYfF");

var $2ZoHW = parcelRequire("2ZoHW");

var $7qhNL = parcelRequire("7qhNL");
const $e157174ff0ba4a41$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $e157174ff0ba4a41$var$NO_CALLS_ERROR = 'No calls made';
const $e157174ff0ba4a41$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $2ZoHW.NO_RETRIES), retryOn: retryOn = [
    (0, $7qhNL.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($e157174ff0ba4a41$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $e157174ff0ba4a41$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $e157174ff0ba4a41$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $byYfF.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("2ZoHW", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $e20c214c1fd5c843$export$a0a1c8f90becc136);
const $e20c214c1fd5c843$export$a0a1c8f90becc136 = [];
const $e20c214c1fd5c843$export$972171517b12aa4 = [
    0,
    0
];
const $e20c214c1fd5c843$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $e20c214c1fd5c843$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("7qhNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9efe841de14d49e$export$2e2bcd8739ae039);
class $d9efe841de14d49e$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("3KPCE", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $2bbdb6219b03f095$export$2414511207262909);
const $2bbdb6219b03f095$var$urlRegex = new RegExp(/^https?:\/\//);
function $2bbdb6219b03f095$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($2bbdb6219b03f095$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("6S4m0", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $500b29cc7d71e406$export$855cd08371c65b8c);

var $7EIv8 = parcelRequire("7EIv8");

var $16Dvi = parcelRequire("16Dvi");
const $500b29cc7d71e406$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $500b29cc7d71e406$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$500b29cc7d71e406$var$ACTIVITIES}
   }
`;
const $500b29cc7d71e406$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$500b29cc7d71e406$var$ACTIVITIES}
   }
`;
const $500b29cc7d71e406$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$500b29cc7d71e406$var$ACTIVITIES}
    }
`;
const $500b29cc7d71e406$var$activityQueryMap = new Map([
    [
        'workedOn',
        $500b29cc7d71e406$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $500b29cc7d71e406$var$VIEWED__QUERY
    ],
    [
        'all',
        $500b29cc7d71e406$var$ALL__QUERY
    ]
]);
const $500b29cc7d71e406$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $500b29cc7d71e406$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $7EIv8.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $500b29cc7d71e406$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $500b29cc7d71e406$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$500b29cc7d71e406$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $16Dvi.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $500b29cc7d71e406$var$getActivitiesQuery(product, $500b29cc7d71e406$var$getMyActivitiesQuery(activityQueries.map((query)=>$500b29cc7d71e406$var$activityQueryMap.get(query)))),
        queryFilters: (0, $16Dvi.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("16Dvi", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $0ce4fe9e8bbdfd3a$export$5201d39848130041);

var $azRHx = parcelRequire("azRHx");

var $kf2pT = parcelRequire("kf2pT");
const $0ce4fe9e8bbdfd3a$export$5201d39848130041 = {
    v2: (0, $azRHx.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $kf2pT.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("azRHx", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $7b36d431b6335c41$export$1dca7bc1ec360897);

var $8Y6Qe = parcelRequire("8Y6Qe");

var $efQx3 = parcelRequire("efQx3");
const $7b36d431b6335c41$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $efQx3.default)
    ],
    [
        'activities',
        (0, $8Y6Qe.default)
    ]
]);

});
parcelRegister("8Y6Qe", function(module, exports) {

$parcel$export(module.exports, "default", () => $68793be9c5dca0f5$export$2e2bcd8739ae039);

var $eBFS2 = parcelRequire("eBFS2");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $68793be9c5dca0f5$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $eBFS2.generateActivityFiltersV2)(restFilters);
};
var $68793be9c5dca0f5$export$2e2bcd8739ae039 = $68793be9c5dca0f5$var$generateV2ActivitiesFilters;

});
parcelRegister("eBFS2", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $aa25000469708b63$export$ebef9c1f1e15c057);

var $9qnav = parcelRequire("9qnav");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $aa25000469708b63$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $aa25000469708b63$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $aa25000469708b63$export$ebef9c1f1e15c057 = (filters = {})=>(0, $9qnav.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $aa25000469708b63$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $aa25000469708b63$var$KEYS_TO_TRANSFROM.has(originalkey) ? $aa25000469708b63$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("9qnav", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $6dc8838b7f68ffa8$export$23c75313f46dd54e);
const $6dc8838b7f68ffa8$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("efQx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a60b372ee2274866$export$2e2bcd8739ae039);

var $eBFS2 = parcelRequire("eBFS2");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $a60b372ee2274866$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $eBFS2.generateActivityFiltersV2)(restFilters);
};
var $a60b372ee2274866$export$2e2bcd8739ae039 = $a60b372ee2274866$var$generateV2MyActivityFilters;

});


parcelRegister("kf2pT", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $ebc7154516bbaa0d$export$9a1782843b6e99d2);

var $1lrlw = parcelRequire("1lrlw");

var $hgCp2 = parcelRequire("hgCp2");
const $ebc7154516bbaa0d$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $hgCp2.default)
    ],
    [
        'activities',
        (0, $1lrlw.default)
    ]
]);

});
parcelRegister("1lrlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0facf6fb9bd36146$export$2e2bcd8739ae039);

var $4v1yD = parcelRequire("4v1yD");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $0facf6fb9bd36146$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $4v1yD.generateActivityFiltersV3)(restFilters);
};
var $0facf6fb9bd36146$export$2e2bcd8739ae039 = $0facf6fb9bd36146$var$generateV3ActivityFilters;

});
parcelRegister("4v1yD", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $346b4402a272504a$export$e73fe7ded3fe2664);

var $9qnav = parcelRequire("9qnav");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $346b4402a272504a$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $346b4402a272504a$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $346b4402a272504a$export$e73fe7ded3fe2664 = (filters = {})=>(0, $9qnav.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $346b4402a272504a$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $346b4402a272504a$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("hgCp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c921b84e70134ac4$export$2e2bcd8739ae039);

var $4v1yD = parcelRequire("4v1yD");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $c921b84e70134ac4$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $4v1yD.generateActivityFiltersV3)(restFilters);
};
var $c921b84e70134ac4$export$2e2bcd8739ae039 = $c921b84e70134ac4$var$generateV3MyActivityFilters;

});




parcelRegister("b37KP", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $80b5fd598dac3cc2$export$306a8b649360ca6f);
const $80b5fd598dac3cc2$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $80b5fd598dac3cc2$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$80b5fd598dac3cc2$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("4ujFn", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $3449381b1198b4d3$export$3c3c237c92ca1fb9);

var $5zQU9 = parcelRequire("5zQU9");

var $45owE = parcelRequire("45owE");

var $lwzE0 = parcelRequire("lwzE0");

var $4BV8g = parcelRequire("4BV8g");

var $aOhoS = parcelRequire("aOhoS");

var $65pfv = parcelRequire("65pfv");

var $iISJX = parcelRequire("iISJX");

var $kflOV = parcelRequire("kflOV");

var $aJgP0 = parcelRequire("aJgP0");

var $gomn4 = parcelRequire("gomn4");

var $6Zv6i = parcelRequire("6Zv6i");

var $epLgd = parcelRequire("epLgd");

var $aMXE8 = parcelRequire("aMXE8");

var $k5xve = parcelRequire("k5xve");

var $4hsbm = parcelRequire("4hsbm");

var $arLWL = parcelRequire("arLWL");
const $3449381b1198b4d3$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $3449381b1198b4d3$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $3449381b1198b4d3$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $3449381b1198b4d3$var$DEFAULT_TAGS = {
    source: (0, $4BV8g.packageName),
    sourcePackageVersion: (0, $4BV8g.packageVersion)
};
class $3449381b1198b4d3$export$3c3c237c92ca1fb9 extends (0, $aMXE8.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl);
        (0, $5zQU9.default)(this, "setProduct", (product)=>{
            this.product = product;
        });
        (0, $5zQU9.default)(this, "captureException", (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$3449381b1198b4d3$var$DEFAULT_TAGS,
                ...tags
            });
        });
        (0, $5zQU9.default)(this, "captureWarning", (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$3449381b1198b4d3$var$DEFAULT_TAGS,
                ...tags
            });
        });
        (0, $5zQU9.default)(this, "fetchHydratorConfig", async ()=>await this.hydratorConfigClient.fetchConfig());
        (0, $5zQU9.default)(this, "handleGraphQLErrors", (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $kflOV.GraphQLJSError)(err));
                    const invalidFragment = (0, $k5xve.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        });
        (0, $5zQU9.default)(this, "fetchActivitiesV3", async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            var _response$data, _activityRoot, _activityRoot$workedO, _response$data$activi, _response$data$activi2, _response$data$activi3, _activityRoot2, _activityRoot2$all;
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $45owE.retryOnException)(async ()=>{
                    const request = (0, $4hsbm.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $arLWL.filtersToMetadata)(filters)
                    });
                    const res = await (0, $65pfv.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res === null || res === void 0 ? void 0 : res.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $arLWL.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $iISJX.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $iISJX.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                var _IGNORED_HTTP_ERRORS$;
                if (!error || !((_IGNORED_HTTP_ERRORS$ = $3449381b1198b4d3$var$IGNORED_HTTP_ERRORS.get(error.statusCode)) !== null && _IGNORED_HTTP_ERRORS$ !== void 0 && _IGNORED_HTTP_ERRORS$.some((regExp)=>regExp.test(error.message))) && !$3449381b1198b4d3$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $arLWL.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $aJgP0.GraphQLNoResultsError)(response.errors);
            if (!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activity)) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $3449381b1198b4d3$var$transformActivityItem('workedOn', ((_activityRoot = (0, $arLWL.activityRoot)(response.data.activity)) === null || _activityRoot === void 0 ? void 0 : (_activityRoot$workedO = _activityRoot.workedOn) === null || _activityRoot$workedO === void 0 ? void 0 : _activityRoot$workedO.edges) || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $3449381b1198b4d3$var$transformActivityItem('viewed', ((_response$data$activi = response.data.activity) === null || _response$data$activi === void 0 ? void 0 : (_response$data$activi2 = _response$data$activi.myActivity) === null || _response$data$activi2 === void 0 ? void 0 : (_response$data$activi3 = _response$data$activi2.viewed) === null || _response$data$activi3 === void 0 ? void 0 : _response$data$activi3.edges) || [], hydrators, this.captureException);
            const all = $3449381b1198b4d3$var$transformActivityItem('all', ((_activityRoot2 = (0, $arLWL.activityRoot)(response.data.activity)) === null || _activityRoot2 === void 0 ? void 0 : (_activityRoot2$all = _activityRoot2.all) === null || _activityRoot2$all === void 0 ? void 0 : _activityRoot2$all.edges) || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $arLWL.rollupActivitiesData)(activities) : activities;
        });
        (0, $5zQU9.default)(this, "fetchActivities", async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $aOhoS.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        });
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $epLgd.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
function $3449381b1198b4d3$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $gomn4.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                var _object$data, _object$data$containe;
                if (hydratedData.key) containers.push({
                    name: (0, $6Zv6i.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $6Zv6i.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $lwzE0.WORKED_EVENT).CREATED ? (0, $lwzE0.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $arLWL.parseRootContainerARI)(object.rootContainerId),
                        icon: $3449381b1198b4d3$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $6Zv6i.hydrateConfluenceIcon)((_object$data = object.data) === null || _object$data === void 0 ? void 0 : (_object$data$containe = _object$data.container) === null || _object$data$containe === void 0 ? void 0 : _object$data$containe.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $6Zv6i.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                        id: object.id,
                        deduplicateId: (0, $6Zv6i.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $6Zv6i.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $6Zv6i.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        url: (0, $6Zv6i.hydratedValueToString)(hydratedData.url)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("iISJX", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $da16cc592a8dafc8$export$2d1b192199788179);
class $da16cc592a8dafc8$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("kflOV", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $ebd62272d3c3e2fa$export$8d4af49ee2a0fbe2);
class $ebd62272d3c3e2fa$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("aJgP0", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $7cfb27cfeb4df1cb$export$3f19ff30d409b70);
class $7cfb27cfeb4df1cb$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("gomn4", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $bef03da792b15237$export$d658049bf1a63492);

var $illlw = parcelRequire("illlw");

var $kE58e = parcelRequire("kE58e");
const $bef03da792b15237$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $bef03da792b15237$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $kE58e.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $kE58e.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $kE58e.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $bef03da792b15237$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $bef03da792b15237$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(object, path);
}
function $bef03da792b15237$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $bef03da792b15237$var$getOrSearch(current, split);
    return current;
}
function $bef03da792b15237$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(edge, fieldId) === searchValue);
}
function $bef03da792b15237$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$bef03da792b15237$var$resolvePath(object, path));
}
const $bef03da792b15237$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $bef03da792b15237$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("kE58e", function(module, exports) {

$parcel$export(module.exports, "default", () => $f07b861cc0a6e4ce$export$2e2bcd8739ae039);
class $f07b861cc0a6e4ce$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("6Zv6i", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $01504465455577eb$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $01504465455577eb$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $01504465455577eb$export$a328b2bb0d21d984);
const $01504465455577eb$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $01504465455577eb$var$isURL(icon) {
    return typeof icon === 'string';
}
function $01504465455577eb$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $01504465455577eb$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $01504465455577eb$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $01504465455577eb$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $01504465455577eb$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $01504465455577eb$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $01504465455577eb$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $01504465455577eb$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($01504465455577eb$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
        };
        const urlIcons = icons.filter($01504465455577eb$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $01504465455577eb$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("epLgd", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $a7e80f6d8cd2bc74$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $a7e80f6d8cd2bc74$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $5PgJs = parcelRequire("5PgJs");

var $fozPc = parcelRequire("fozPc");
const $a7e80f6d8cd2bc74$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $a7e80f6d8cd2bc74$var$FD_ENVIRONMENT = 'prod';
const $a7e80f6d8cd2bc74$export$c270c412a04ff3e6 = {
    name: $a7e80f6d8cd2bc74$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $a7e80f6d8cd2bc74$var$FD_ENVIRONMENT
    }
};
class $a7e80f6d8cd2bc74$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        (0, $5zQU9.default)(this, "fetchConfig", async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        });
        this.flightDeck = new (0, $5PgJs.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $a7e80f6d8cd2bc74$var$FD_ENVIRONMENT
                },
                value: (0, $fozPc.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($a7e80f6d8cd2bc74$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("5PgJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $43deb1d1d793aea4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $45owE = parcelRequire("45owE");

var $6BD9J = parcelRequire("6BD9J");

var $fRLSZ = parcelRequire("fRLSZ");

var $R6vVg = parcelRequire("R6vVg");

var $dyjVx = parcelRequire("dyjVx");

var $l525T = parcelRequire("l525T");
function $43deb1d1d793aea4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43deb1d1d793aea4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43deb1d1d793aea4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43deb1d1d793aea4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $43deb1d1d793aea4$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $43deb1d1d793aea4$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $43deb1d1d793aea4$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $5zQU9.default)(this, "fallbackArtifactMap", new Map());
        (0, $5zQU9.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $6BD9J.default)($43deb1d1d793aea4$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $dyjVx.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $45owE.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fRLSZ.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $R6vVg.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$43deb1d1d793aea4$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $l525T.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $43deb1d1d793aea4$var$_objectSpread($43deb1d1d793aea4$var$_objectSpread({}, artifact), {}, {
                key: (0, $dyjVx.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $l525T.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("fRLSZ", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b8d0f360ecd40095$export$6026918e023c9101);

var $ao10V = parcelRequire("ao10V");

var $dHnOe = parcelRequire("dHnOe");

var $ireIJ = parcelRequire("ireIJ");

var $3znRC = parcelRequire("3znRC");

var $6KucS = parcelRequire("6KucS");

var $c6GqO = parcelRequire("c6GqO");

var $79X2t = parcelRequire("79X2t");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b8d0f360ecd40095$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b8d0f360ecd40095$var$defaultPerimeter = "commercial";
async function $b8d0f360ecd40095$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b8d0f360ecd40095$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b8d0f360ecd40095$var$defaultPerimeter;
    const environment = $b8d0f360ecd40095$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $ao10V.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b8d0f360ecd40095$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b8d0f360ecd40095$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b8d0f360ecd40095$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b8d0f360ecd40095$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b8d0f360ecd40095$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b8d0f360ecd40095$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $c6GqO.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $c6GqO.getVersionMetadataFetchExperience)();
    return new (0, $6KucS.ConfigClient)(new (0, $ireIJ.BifrostDataSource)(new (0, $3znRC.BifrostHttpClientImpl)(env, perimeter), (0, $dHnOe.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b8d0f360ecd40095$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("ao10V", function(module, exports) {

$parcel$export(module.exports, "default", () => $43aa36fdb0196a46$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products;
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $43aa36fdb0196a46$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $43aa36fdb0196a46$export$2e2bcd8739ae039 = $43aa36fdb0196a46$export$852ff24d0930c62f;

});

parcelRegister("dHnOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $2HKgG = parcelRequire("2HKgG");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $2HKgG.Either;
    }
});

var $2n3xt = parcelRequire("2n3xt");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2n3xt.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2n3xt.tryGetArtifactData;
    }
});

var $8BS3z = parcelRequire("8BS3z");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8BS3z.parseArtifactManifest;
    }
});

var $bK1Zf = parcelRequire("bK1Zf");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $bK1Zf.parseVersionMetadata;
    }
});

var $k0bKY = parcelRequire("k0bKY");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $k0bKY.checkManifest;
    }
});

var $9I5dh = parcelRequire("9I5dh");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $9I5dh.ConfigRegistryDataSource;
    }
});

var $f3GMw = parcelRequire("f3GMw");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $f3GMw.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $f3GMw.Versions;
    }
});

});
parcelRegister("2HKgG", function(module, exports) {
"use strict";
var $1f837cd1c4517ada$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $1f837cd1c4517ada$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $1f837cd1c4517ada$var$Right(value);
    };
    Either.left = function(error) {
        return new $1f837cd1c4517ada$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $1f837cd1c4517ada$var$Either;
var $1f837cd1c4517ada$var$Right = /** @class */ function(_super) {
    $1f837cd1c4517ada$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $1f837cd1c4517ada$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $1f837cd1c4517ada$var$Either.right(this.right);
    };
    return Right;
}($1f837cd1c4517ada$var$Either);
var $1f837cd1c4517ada$var$Left = /** @class */ function(_super) {
    $1f837cd1c4517ada$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $1f837cd1c4517ada$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $1f837cd1c4517ada$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $1f837cd1c4517ada$var$Either.left(f(this.left));
    };
    return Left;
}($1f837cd1c4517ada$var$Either);

});

parcelRegister("2n3xt", function(module, exports) {
"use strict";
var $1ba0797e33c02ae7$var$__assign = module.exports && module.exports.__assign || function() {
    $1ba0797e33c02ae7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1ba0797e33c02ae7$var$__assign.apply(this, arguments);
};
var $1ba0797e33c02ae7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1ba0797e33c02ae7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $lpRxL = parcelRequire("lpRxL");

var $dHnOe = parcelRequire("dHnOe");

var $1W6dg = parcelRequire("1W6dg");

var $ifW8h = parcelRequire("ifW8h");

var $dMICC = parcelRequire("dMICC");
function $1ba0797e33c02ae7$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1ba0797e33c02ae7$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1ba0797e33c02ae7$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $dHnOe.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $1W6dg.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1ba0797e33c02ae7$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $ifW8h.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1ba0797e33c02ae7$var$getArtifactFromSource;
function $1ba0797e33c02ae7$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1ba0797e33c02ae7$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $lpRxL.interpolateTagScheme)(manifest.tagScheme, $1ba0797e33c02ae7$var$__assign($1ba0797e33c02ae7$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1ba0797e33c02ae7$var$__awaiter(_this, void 0, void 0, function() {
                                return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1ba0797e33c02ae7$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $dMICC.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $dMICC.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $ifW8h.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1ba0797e33c02ae7$var$tryGetArtifactData;

});
parcelRegister("lpRxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $f975776b9718f145$var$TAG_SCHEME_VERSION = 2;
function $f975776b9718f145$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($f975776b9718f145$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $f975776b9718f145$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $f975776b9718f145$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $f975776b9718f145$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $f975776b9718f145$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $f975776b9718f145$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $f975776b9718f145$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $f975776b9718f145$var$getDimensionsFromTagScheme;
function $f975776b9718f145$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $f975776b9718f145$var$getDataTagForManifest;
function $f975776b9718f145$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $f975776b9718f145$var$getVersionMetadataTag;
function $f975776b9718f145$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("1W6dg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $169006f8d69b336a$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $169006f8d69b336a$var$getDimensionContext;

});

parcelRegister("ifW8h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $d4a6b89938522709$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $d4a6b89938522709$var$assertUnreachable;

});

parcelRegister("dMICC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $a0925f05dd8f3b3a$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $a0925f05dd8f3b3a$var$toJson;
function $a0925f05dd8f3b3a$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $a0925f05dd8f3b3a$var$toPrettyJson;

});


parcelRegister("8BS3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $60rra = parcelRequire("60rra");
function $644bb5f5dadb27d9$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $60rra.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $60rra.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $644bb5f5dadb27d9$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $60rra.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $644bb5f5dadb27d9$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $644bb5f5dadb27d9$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $60rra.parseUnknownObject)(dimensions);
    var supported = (0, $60rra.parseArray)(unparsedDimensions.supported).map($60rra.parseString);
    var fallback = (0, $60rra.parseUndefinedOr)($60rra.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $644bb5f5dadb27d9$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $60rra.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $644bb5f5dadb27d9$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $644bb5f5dadb27d9$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $60rra.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $60rra.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $60rra.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $60rra.parseUndefinedOr)($60rra.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $644bb5f5dadb27d9$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $644bb5f5dadb27d9$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $644bb5f5dadb27d9$var$parseArtifactManifest;

});
parcelRegister("60rra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $45f806a1ce3c9fdf$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $45f806a1ce3c9fdf$var$parseString;
function $45f806a1ce3c9fdf$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $45f806a1ce3c9fdf$var$parseArray;
function $45f806a1ce3c9fdf$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $45f806a1ce3c9fdf$var$parseBoolean;
function $45f806a1ce3c9fdf$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $45f806a1ce3c9fdf$var$parseUnknownObject;
function $45f806a1ce3c9fdf$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $45f806a1ce3c9fdf$var$parseUndefinedOr;

});


parcelRegister("bK1Zf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $60rra = parcelRequire("60rra");
function $88c5882811c7e79d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $60rra.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $60rra.parseString)(unknownObject.version);
    var publishTime = new Date((0, $60rra.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $60rra.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $88c5882811c7e79d$var$parseVersionMetadata;

});

parcelRegister("k0bKY", function(module, exports) {
"use strict";
var $e8fced57781eaa38$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $e8fced57781eaa38$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $e8fced57781eaa38$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $e8fced57781eaa38$var$checkManifest;

});

parcelRegister("9I5dh", function(module, exports) {
"use strict";
var $711c445488059f65$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $711c445488059f65$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $lpRxL = parcelRequire("lpRxL");

var $2HKgG = parcelRequire("2HKgG");

var $8BS3z = parcelRequire("8BS3z");

var $bK1Zf = parcelRequire("bK1Zf");
var $711c445488059f65$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $lpRxL.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8BS3z.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2HKgG.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $lpRxL.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $bK1Zf.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $711c445488059f65$var$ConfigRegistryDataSource;

});

parcelRegister("f3GMw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $af685263f5b966f2$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $af685263f5b966f2$var$BaseUrls;
var $af685263f5b966f2$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $af685263f5b966f2$var$Versions;

});


parcelRegister("ireIJ", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $d6c62ace4660398e$export$2cb8d79200775058);

var $dHnOe = parcelRequire("dHnOe");

var $lpRxL = parcelRequire("lpRxL");
class $d6c62ace4660398e$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $lpRxL.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $dHnOe.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $dHnOe.parseVersionMetadata)(response);
                return (0, $dHnOe.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $dHnOe.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $lpRxL.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $dHnOe.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $dHnOe.parseArtifactManifest)(response);
                return (0, $dHnOe.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $dHnOe.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3znRC", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $299726d14403a47c$export$45c6d12ca9c14f83);

var $dHnOe = parcelRequire("dHnOe");
function $299726d14403a47c$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $299726d14403a47c$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $299726d14403a47c$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $dHnOe.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $dHnOe.Either).right(json)));
            }).catch((error)=>resolve((0, $dHnOe.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("6KucS", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $4e9e7864c43d3946$export$8489e2f039bfcc4c);

var $5zQU9 = parcelRequire("5zQU9");

var $dHnOe = parcelRequire("dHnOe");

var $8usMG = parcelRequire("8usMG");
function $4e9e7864c43d3946$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e9e7864c43d3946$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e9e7864c43d3946$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e9e7864c43d3946$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4e9e7864c43d3946$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $8usMG.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $4e9e7864c43d3946$var$_objectSpread($4e9e7864c43d3946$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $dHnOe.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $dHnOe.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("8usMG", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $62e77403356b9f6a$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $62e77403356b9f6a$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("c6GqO", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $8d06f594ac1cbfc0$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $8d06f594ac1cbfc0$export$c3ac7702bfd47c1b);
const $8d06f594ac1cbfc0$var$SAMPLING_RATE = 10;
class $8d06f594ac1cbfc0$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $8d06f594ac1cbfc0$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $8d06f594ac1cbfc0$var$SAMPLING_RATE) return new $8d06f594ac1cbfc0$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("bFU0T"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $8d06f594ac1cbfc0$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $8d06f594ac1cbfc0$export$5e7536cf7bc56fee();
    }
}
const $8d06f594ac1cbfc0$export$a3006f8f221c0a3b = ()=>$8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $8d06f594ac1cbfc0$export$c3ac7702bfd47c1b = ()=>$8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("bFU0T", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iHz4i');
        const value = parcelRequire('lnTas');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iHz4i").then(()=>parcelRequire('lnTas'));
}

});


parcelRegister("79X2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $04oes = parcelRequire("04oes");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $04oes.parseConfigWithTargeting;
    }
});

var $rIcfx = parcelRequire("rIcfx");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $rIcfx.TargetedConfig;
    }
});

});
parcelRegister("04oes", function(module, exports) {
"use strict";
var $00d32bdcf6bd19e4$var$__assign = module.exports && module.exports.__assign || function() {
    $00d32bdcf6bd19e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00d32bdcf6bd19e4$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $rIcfx = parcelRequire("rIcfx");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $00d32bdcf6bd19e4$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $00d32bdcf6bd19e4$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $rIcfx.TargetedConfig({
                defaultConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $00d32bdcf6bd19e4$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $rIcfx.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $00d32bdcf6bd19e4$var$__assign($00d32bdcf6bd19e4$var$__assign({}, accObject), (_a = {}, _a[key] = $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $00d32bdcf6bd19e4$var$parseConfigWithTargeting;
function $00d32bdcf6bd19e4$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $00d32bdcf6bd19e4$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $00d32bdcf6bd19e4$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.orgIds),
            siteIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.siteIds),
            userIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $00d32bdcf6bd19e4$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("rIcfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $0534ce4013dfa5ab$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $0534ce4013dfa5ab$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $0534ce4013dfa5ab$var$TargetedConfig;
function $0534ce4013dfa5ab$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("R6vVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fa00df7248ff0a$export$2e2bcd8739ae039);
class $09fa00df7248ff0a$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $09fa00df7248ff0a$export$1d76d155060824c9 = (e)=>e instanceof $09fa00df7248ff0a$export$2e2bcd8739ae039;

});

parcelRegister("dyjVx", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $9ddde86f16eefbf7$export$e3553dc63541d477);
const $9ddde86f16eefbf7$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("l525T", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $f58bb07408e7b310$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $f58bb07408e7b310$export$f33622abb5224195);

var $5zQU9 = parcelRequire("5zQU9");

var $eMQq6 = parcelRequire("eMQq6");
var $8lqPI = parcelRequire("8lqPI");
function $f58bb07408e7b310$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f58bb07408e7b310$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f58bb07408e7b310$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f58bb07408e7b310$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f58bb07408e7b310$export$6061a1a9a61f2e21 = ()=>new (0, $8lqPI.UFOExperience)("fetch", {
        type: (0, $eMQq6.ExperienceTypes).Operation,
        performanceType: (0, $eMQq6.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f58bb07408e7b310$export$1e3a41a51f6457c5 = ()=>new (0, $8lqPI.UFOExperience)("retrieve-artifact", {
        type: (0, $eMQq6.ExperienceTypes).Operation,
        performanceType: (0, $eMQq6.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f58bb07408e7b310$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $f58bb07408e7b310$var$_objectSpread($f58bb07408e7b310$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("eMQq6", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $ac3e35e5186860e0$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $ac3e35e5186860e0$export$cc26007c03242fff);
let $ac3e35e5186860e0$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($ac3e35e5186860e0$export$994164cf3ae1cc9a || ($ac3e35e5186860e0$export$994164cf3ae1cc9a = {}));
let $ac3e35e5186860e0$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($ac3e35e5186860e0$export$cc26007c03242fff || ($ac3e35e5186860e0$export$cc26007c03242fff = {}));

});

parcelRegister("8lqPI", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $6135196a2196f5ba$export$c00d22927c60484a);

var $b1xGg = parcelRequire("b1xGg");
class $6135196a2196f5ba$export$c00d22927c60484a extends (0, $b1xGg.UFOAbstractExperience) {
}

});
parcelRegister("b1xGg", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $8069e9f691bf0fab$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $8069e9f691bf0fab$export$d31c89db257648c);

var $5zQU9 = parcelRequire("5zQU9");

var $aGpn7 = parcelRequire("aGpn7");


var $e0Xd9 = parcelRequire("e0Xd9");

var $8f1o9 = parcelRequire("8f1o9");

var $jjoOz = parcelRequire("jjoOz");

var $eakUS = parcelRequire("eakUS");

var $kFq2M = parcelRequire("kFq2M");

var $e06tK = parcelRequire("e06tK");

var $dXlhF = parcelRequire("dXlhF");

var $dbQMi = parcelRequire("dbQMi");

var $eMQq6 = parcelRequire("eMQq6");
const $8069e9f691bf0fab$var$getPageVisibleState = ()=>{
    return !(0, $e0Xd9.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $kFq2M.PageVisibleState).VISIBLE : (0, $kFq2M.PageVisibleState).HIDDEN;
};
const $8069e9f691bf0fab$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $e06tK.roundPerfNow)();
};
class $8069e9f691bf0fab$export$d31c89db257648c {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    constructor(id, config, instanceId = null){
        (0, $5zQU9.default)(this, "state", (0, $dXlhF.UFOExperienceState).NOT_STARTED);
        (0, $5zQU9.default)(this, "instanceId", null);
        (0, $5zQU9.default)(this, "parent", null);
        (0, $5zQU9.default)(this, "category", null);
        (0, $5zQU9.default)(this, "metadata", {});
        (0, $5zQU9.default)(this, "onDoneCallbacks", []);
        (0, $5zQU9.default)(this, "childExperiences", []);
        (0, $5zQU9.default)(this, "explicitTimings", {});
        (0, $5zQU9.default)(this, "isSSROutputAsFMP", false);
        (0, $5zQU9.default)(this, "uuid", null);
        (0, $5zQU9.default)(this, "_until", null);
        (0, $5zQU9.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $5zQU9.default)(this, "performanceConfig", {});
        (0, $5zQU9.default)(this, "setPageVisibleStateToMixed", ()=>{
            this.pageVisibleState = (0, $kFq2M.PageVisibleState).MIXED;
            (0, $eakUS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $8069e9f691bf0fab$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $eMQq6.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $eMQq6.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jjoOz.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $dbQMi.canTransition)(this.state, newState)) {
            (0, $jjoOz.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $dXlhF.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $8069e9f691bf0fab$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aGpn7.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $8069e9f691bf0fab$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $8f1o9.getGlobalEventStream)().push((0, $8f1o9.unsubscribeEvent)((0, $kFq2M.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jjoOz.ufolog)('this.parent', this.parent);
                (0, $8f1o9.getGlobalEventStream)().push((0, $8f1o9.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jjoOz.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jjoOz.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $dXlhF.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $8069e9f691bf0fab$var$getPageVisibleState();
            (0, $eakUS.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jjoOz.ufolog)('subscribed', this.id);
                (0, $8f1o9.getGlobalEventStream)().push((0, $8f1o9.subscribeEvent)((0, $kFq2M.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $kFq2M.FMP_MARK) && name !== (0, $kFq2M.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jjoOz.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $8069e9f691bf0fab$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $dXlhF.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $kFq2M.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $kFq2M.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jjoOz.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $eakUS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $dXlhF.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $dXlhF.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $dXlhF.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jjoOz.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $5012f565702c7a21$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("aGpn7", function(module, exports) {

var $5rx9z = parcelRequire("5rx9z");

var $eP0kz = parcelRequire("eP0kz");
var $7c7181eef85e42cf$var$uuid = $eP0kz;
$7c7181eef85e42cf$var$uuid.v1 = $5rx9z;
$7c7181eef85e42cf$var$uuid.v4 = $eP0kz;
module.exports = $7c7181eef85e42cf$var$uuid;

});
parcelRegister("5rx9z", function(module, exports) {

var $1X1sf = parcelRequire("1X1sf");

var $2e9BU = parcelRequire("2e9BU");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $3f6930f223912ee3$var$_nodeId;
var $3f6930f223912ee3$var$_clockseq;
// Previous uuid creation time
var $3f6930f223912ee3$var$_lastMSecs = 0;
var $3f6930f223912ee3$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $3f6930f223912ee3$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $3f6930f223912ee3$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $3f6930f223912ee3$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $1X1sf();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $3f6930f223912ee3$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $3f6930f223912ee3$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $3f6930f223912ee3$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $3f6930f223912ee3$var$_lastMSecs + (nsecs - $3f6930f223912ee3$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $3f6930f223912ee3$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $3f6930f223912ee3$var$_lastMSecs = msecs;
    $3f6930f223912ee3$var$_lastNSecs = nsecs;
    $3f6930f223912ee3$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $2e9BU(b);
}
module.exports = $3f6930f223912ee3$var$v1;

});
parcelRegister("1X1sf", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $16bc6dfefc5e4401$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($16bc6dfefc5e4401$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $16bc6dfefc5e4401$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $16bc6dfefc5e4401$var$getRandomValues($16bc6dfefc5e4401$var$rnds8);
        return $16bc6dfefc5e4401$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $16bc6dfefc5e4401$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $16bc6dfefc5e4401$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $16bc6dfefc5e4401$var$rnds;
    };
}

});

parcelRegister("2e9BU", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $19f457fe209bc7ea$var$byteToHex = [];
for(var $19f457fe209bc7ea$var$i = 0; $19f457fe209bc7ea$var$i < 256; ++$19f457fe209bc7ea$var$i)$19f457fe209bc7ea$var$byteToHex[$19f457fe209bc7ea$var$i] = ($19f457fe209bc7ea$var$i + 0x100).toString(16).substr(1);
function $19f457fe209bc7ea$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $19f457fe209bc7ea$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $19f457fe209bc7ea$var$bytesToUuid;

});


parcelRegister("eP0kz", function(module, exports) {

var $1X1sf = parcelRequire("1X1sf");

var $2e9BU = parcelRequire("2e9BU");
function $aca615c852e788cc$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1X1sf)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $2e9BU(rnds);
}
module.exports = $aca615c852e788cc$var$v4;

});


// temp solution until we can get it automated
const $5012f565702c7a21$export$2295b861f318254a = '0.1.5';

parcelRegister("e0Xd9", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $a33efee259383d4a$export$15e172712955e18f);
const $a33efee259383d4a$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("8f1o9", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $6000cd2783103a3a$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $6000cd2783103a3a$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $6000cd2783103a3a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $6000cd2783103a3a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $6000cd2783103a3a$export$7c957416596ca127);

var $jjoOz = parcelRequire("jjoOz");

var $kFq2M = parcelRequire("kFq2M");
const $6000cd2783103a3a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $6000cd2783103a3a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $6000cd2783103a3a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $6000cd2783103a3a$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $jjoOz.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $6000cd2783103a3a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $kFq2M.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $6000cd2783103a3a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $kFq2M.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $6000cd2783103a3a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $kFq2M.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("jjoOz", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $e0f30a5b73f3b49a$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $e0f30a5b73f3b49a$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $e0f30a5b73f3b49a$export$d53d07b6034c4560);

var $5zQU9 = parcelRequire("5zQU9");
class $e0f30a5b73f3b49a$var$UFOLogger {
    constructor(){
        (0, $5zQU9.default)(this, "enabled", false);
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($e0f30a5b73f3b49a$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($e0f30a5b73f3b49a$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
(0, $5zQU9.default)($e0f30a5b73f3b49a$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
const $e0f30a5b73f3b49a$export$4ab84f6f04f6566d = new $e0f30a5b73f3b49a$var$UFOLogger();
const $e0f30a5b73f3b49a$export$b4958caff08a0960 = (...args)=>{
    $e0f30a5b73f3b49a$export$4ab84f6f04f6566d.log(...args);
};
const $e0f30a5b73f3b49a$export$d53d07b6034c4560 = (...args)=>{
    $e0f30a5b73f3b49a$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("kFq2M", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $f0bbd6bf9c5790f7$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $f0bbd6bf9c5790f7$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $f0bbd6bf9c5790f7$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $f0bbd6bf9c5790f7$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $f0bbd6bf9c5790f7$export$837e0f79a8056912);

let $f0bbd6bf9c5790f7$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($f0bbd6bf9c5790f7$export$96253c35c37cf96b || ($f0bbd6bf9c5790f7$export$96253c35c37cf96b = {}));
let $f0bbd6bf9c5790f7$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($f0bbd6bf9c5790f7$export$a12c67b37a306b13 || ($f0bbd6bf9c5790f7$export$a12c67b37a306b13 = {}));
let $f0bbd6bf9c5790f7$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($f0bbd6bf9c5790f7$export$66b33c055cbb625e || ($f0bbd6bf9c5790f7$export$66b33c055cbb625e = {}));
let $f0bbd6bf9c5790f7$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($f0bbd6bf9c5790f7$export$3ce489cbe02dc21b || ($f0bbd6bf9c5790f7$export$3ce489cbe02dc21b = {}));
let $f0bbd6bf9c5790f7$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($f0bbd6bf9c5790f7$export$341b330828bd3906 || ($f0bbd6bf9c5790f7$export$341b330828bd3906 = {}));
let $f0bbd6bf9c5790f7$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($f0bbd6bf9c5790f7$export$b9b20160f581e4f8 || ($f0bbd6bf9c5790f7$export$b9b20160f581e4f8 = {}));
const $f0bbd6bf9c5790f7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $f0bbd6bf9c5790f7$export$9f2bf58999404c75 = 'fmp';
const $f0bbd6bf9c5790f7$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("eakUS", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $a502396f32e4722d$export$13e680397ec8f3eb);

var $5zQU9 = parcelRequire("5zQU9");

var $e0Xd9 = parcelRequire("e0Xd9");
class $a502396f32e4722d$var$VisibilityChangeObserver {
    constructor(){
        (0, $5zQU9.default)(this, "started", false);
        (0, $5zQU9.default)(this, "observers", []);
        (0, $5zQU9.default)(this, "broadcast", ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        });
    }
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e0Xd9.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
}
const $a502396f32e4722d$export$13e680397ec8f3eb = new $a502396f32e4722d$var$VisibilityChangeObserver();

});

parcelRegister("e06tK", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $a31617569b9f8ab5$export$5f490af6b2b115cf);
const $a31617569b9f8ab5$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("dXlhF", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $a2914b95e03c5121$export$81b70111112841a0);
const $a2914b95e03c5121$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("dbQMi", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $99a53e0e298198ed$export$178881f329fdb81f);

var $dXlhF = parcelRequire("dXlhF");
const $99a53e0e298198ed$var$UFOStateAvailableTransitions = {
    [(0, $dXlhF.UFOExperienceState).NOT_STARTED.id]: [
        (0, $dXlhF.UFOExperienceState).STARTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).STARTED.id]: [
        (0, $dXlhF.UFOExperienceState).IN_PROGRESS.id,
        (0, $dXlhF.UFOExperienceState).BLOCKED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $dXlhF.UFOExperienceState).FAILED.id,
        (0, $dXlhF.UFOExperienceState).ABORTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $dXlhF.UFOExperienceState).BLOCKED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $dXlhF.UFOExperienceState).FAILED.id,
        (0, $dXlhF.UFOExperienceState).ABORTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).BLOCKED.id]: [
        (0, $dXlhF.UFOExperienceState).RECOVERED.id,
        (0, $dXlhF.UFOExperienceState).ABORTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).RECOVERED.id]: [
        (0, $dXlhF.UFOExperienceState).STARTED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED.id,
        (0, $dXlhF.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $dXlhF.UFOExperienceState).FAILED.id,
        (0, $dXlhF.UFOExperienceState).ABORTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).SUCCEEDED.id]: [
        (0, $dXlhF.UFOExperienceState).STARTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $dXlhF.UFOExperienceState).SUCCEEDED.id,
        (0, $dXlhF.UFOExperienceState).FAILED.id,
        (0, $dXlhF.UFOExperienceState).ABORTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).FAILED.id]: [
        (0, $dXlhF.UFOExperienceState).STARTED.id
    ],
    [(0, $dXlhF.UFOExperienceState).ABORTED.id]: [
        (0, $dXlhF.UFOExperienceState).STARTED.id
    ]
};
const $99a53e0e298198ed$export$178881f329fdb81f = (state1, state2)=>{
    return $99a53e0e298198ed$var$UFOStateAvailableTransitions[state1.id] && $99a53e0e298198ed$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("fozPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b354e2f218eb1257$export$2e2bcd8739ae039);
var $b354e2f218eb1257$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("k5xve", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9fe433481cd8d1d$export$2e2bcd8739ae039);

var $dCD82 = parcelRequire("dCD82");
const $e9fe433481cd8d1d$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $dCD82.default)
    ]
]);
const $e9fe433481cd8d1d$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $e9fe433481cd8d1d$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $e9fe433481cd8d1d$export$2e2bcd8739ae039 = $e9fe433481cd8d1d$var$graphQLErrorHandler;

});
parcelRegister("dCD82", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ead2d1e57acc920$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $9ead2d1e57acc920$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $9ead2d1e57acc920$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $9ead2d1e57acc920$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $9ead2d1e57acc920$export$2e2bcd8739ae039 = $9ead2d1e57acc920$var$validationErrorHandler;

});


parcelRegister("4hsbm", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $31de9c62fd3945fe$export$7489a6ef09862e48);

var $7EIv8 = parcelRequire("7EIv8");

var $16Dvi = parcelRequire("16Dvi");
const $31de9c62fd3945fe$var$ACTIVITIES_LIMIT = 50;
const $31de9c62fd3945fe$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $31de9c62fd3945fe$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $31de9c62fd3945fe$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $31de9c62fd3945fe$var$activityQueryMap = new Map([
    [
        'workedOn',
        $31de9c62fd3945fe$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $31de9c62fd3945fe$var$VIEWED__QUERY
    ],
    [
        'all',
        $31de9c62fd3945fe$var$ALL__QUERY
    ]
]);
const $31de9c62fd3945fe$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $31de9c62fd3945fe$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $7EIv8.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $31de9c62fd3945fe$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $31de9c62fd3945fe$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$31de9c62fd3945fe$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $16Dvi.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $31de9c62fd3945fe$var$getActivitiesQuery(product, $31de9c62fd3945fe$var$getMyActivitiesQuery(activityQueries.map((query)=>$31de9c62fd3945fe$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $16Dvi.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $31de9c62fd3945fe$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $31de9c62fd3945fe$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $31de9c62fd3945fe$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $7EIv8.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("arLWL", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $79b19e3d84d0097f$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $79b19e3d84d0097f$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $79b19e3d84d0097f$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $79b19e3d84d0097f$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $79b19e3d84d0097f$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $79b19e3d84d0097f$export$c939d6148e47244a);
function $79b19e3d84d0097f$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $79b19e3d84d0097f$var$rollUpActivityItems(all),
        viewed: $79b19e3d84d0097f$var$rollUpActivityItems(viewed),
        workedOn: $79b19e3d84d0097f$var$rollUpActivityItems(workedOn)
    };
}
function $79b19e3d84d0097f$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $79b19e3d84d0097f$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$79b19e3d84d0097f$var$fragmentName(key)} on ${$79b19e3d84d0097f$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $79b19e3d84d0097f$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $79b19e3d84d0097f$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $79b19e3d84d0097f$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $79b19e3d84d0097f$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $79b19e3d84d0097f$var$containerMapTypes = new Map([
    [
        $79b19e3d84d0097f$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $79b19e3d84d0097f$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $79b19e3d84d0097f$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $79b19e3d84d0097f$export$e8f56bed6776c7ea(filters) {
    var _filters$actors, _filters$containerIds, _filters$products, _filters$eventTypes, _filters$objectTypes, _filters$rootContaine;
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: (_filters$actors = filters.actors) === null || _filters$actors === void 0 ? void 0 : _filters$actors.length,
        containerIds: (_filters$containerIds = filters.containerIds) === null || _filters$containerIds === void 0 ? void 0 : _filters$containerIds.length,
        // comma separated lists
        products: (_filters$products = filters.products) === null || _filters$products === void 0 ? void 0 : _filters$products.join(','),
        eventTypes: (_filters$eventTypes = filters.eventTypes) === null || _filters$eventTypes === void 0 ? void 0 : _filters$eventTypes.join(','),
        objectTypes: (_filters$objectTypes = filters.objectTypes) === null || _filters$objectTypes === void 0 ? void 0 : _filters$objectTypes.join(','),
        rootContainerIds: (_filters$rootContaine = filters.rootContainerIds) === null || _filters$rootContaine === void 0 ? void 0 : _filters$rootContaine.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $79b19e3d84d0097f$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $79b19e3d84d0097f$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$79b19e3d84d0097f$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($79b19e3d84d0097f$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $79b19e3d84d0097f$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $79b19e3d84d0097f$export$c939d6148e47244a(response) {
    if (!(response !== null && response !== void 0 && response.data) || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$79b19e3d84d0097f$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $79b19e3d84d0097f$export$884573c560ed3600(response.data);
}
function $79b19e3d84d0097f$export$884573c560ed3600(queryData) {
    var _activityRoot$all, _activityRoot$all$edg, _activityRoot$workedO, _activityRoot$workedO2, _queryData$activity, _queryData$activity$m, _queryData$activity$m2, _queryData$activity$m3;
    return !queryData.activity || ((_activityRoot$all = $79b19e3d84d0097f$export$ea55e8e0446efa94(queryData.activity).all) === null || _activityRoot$all === void 0 ? void 0 : (_activityRoot$all$edg = _activityRoot$all.edges) === null || _activityRoot$all$edg === void 0 ? void 0 : _activityRoot$all$edg.length) === 0 && ((_activityRoot$workedO = $79b19e3d84d0097f$export$ea55e8e0446efa94(queryData.activity).workedOn) === null || _activityRoot$workedO === void 0 ? void 0 : (_activityRoot$workedO2 = _activityRoot$workedO.edges) === null || _activityRoot$workedO2 === void 0 ? void 0 : _activityRoot$workedO2.length) === 0 && ((_queryData$activity = queryData.activity) === null || _queryData$activity === void 0 ? void 0 : (_queryData$activity$m = _queryData$activity.myActivity) === null || _queryData$activity$m === void 0 ? void 0 : (_queryData$activity$m2 = _queryData$activity$m.viewed) === null || _queryData$activity$m2 === void 0 ? void 0 : (_queryData$activity$m3 = _queryData$activity$m2.edges) === null || _queryData$activity$m3 === void 0 ? void 0 : _queryData$activity$m3.length) === 0;
}

});



parcelRegister("BIZrR", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $07165ae9ce7b39ad$export$e955abb82869dc84);

var $eUqFw = parcelRequire("eUqFw");

var $cPQ3Q = parcelRequire("cPQ3Q");
var $bFzGY = parcelRequire("bFzGY");

var $tmKh8 = parcelRequire("tmKh8");

var $kUJhP = parcelRequire("kUJhP");

var $dvIfS = parcelRequire("dvIfS");

var $iUYbh = parcelRequire("iUYbh");
const $07165ae9ce7b39ad$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef } = (0, $tmKh8.useAnalyticsPropertiesContext)();
    const sendAnalyticsEvent = (0, $eUqFw.useCallback)((payload, options)=>{
        const extraTags = options !== null && options !== void 0 && options.removeDefaultTags ? [] : [
            'atlaskit',
            'aiMate'
        ];
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || []
        ]));
        const { conversationChannelId: conversationChannelId, experienceId: experienceId, product: product, agentId: agentId, fullScreen: fullScreen } = propertiesRef.current;
        const defaultAttributes = {
            [(0, $kUJhP.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $kUJhP.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $kUJhP.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $kUJhP.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $kUJhP.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen
        };
        if (payload instanceof (0, $cPQ3Q.default)) {
            const aiMateContextAttributes = (0, $iUYbh.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $dvIfS.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $iUYbh.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $dvIfS.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
};

});
parcelRegister("tmKh8", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $05845a4e47f30586$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $05845a4e47f30586$export$ab8aa3dfd687f012);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $05845a4e47f30586$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    propertiesRef: {
        current: {
            conversationChannelId: '',
            experienceId: '',
            product: '',
            agentId: null,
            fullScreen: false
        }
    },
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $05845a4e47f30586$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
    const propertiesRef = (0, $eUqFw.useRef)({
        conversationChannelId: '',
        experienceId: '',
        product: '',
        agentId: null,
        fullScreen: false
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $eUqFw.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            propertiesRef: propertiesRef,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05845a4e47f30586$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $05845a4e47f30586$export$a00cd3c213413389 = ({ source: source, children: children })=>{
    const data = (0, $eUqFw.useMemo)(()=>({
            source: source
        }), [
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05845a4e47f30586$export$1aefd27d2ed3c1c9, null, children));
};
const $05845a4e47f30586$export$ab8aa3dfd687f012 = ()=>{
    return (0, $eUqFw.useContext)($05845a4e47f30586$var$AnalyticsPropertiesContext);
};

});

parcelRegister("kUJhP", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $f39c2a8ee8be4b92$export$8cffc8b2c93affd4);
const $f39c2a8ee8be4b92$export$8cffc8b2c93affd4 = {
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    product: 'product',
    agentId: 'agentId',
    fullScreen: 'fullScreen'
};

});

parcelRegister("dvIfS", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $9d607fb9e6f1370c$export$85183a312807388d);
$parcel$export(module.exports, "InteractionSource", () => $9d607fb9e6f1370c$export$2f18b5d4816974c0);
$parcel$export(module.exports, "FollowUpSource", () => $9d607fb9e6f1370c$export$f1b72addbccfc188);

var $6PJBT = parcelRequire("6PJBT");
const $9d607fb9e6f1370c$export$85183a312807388d = (0, $6PJBT.FabricChannel).aiMate;
let $9d607fb9e6f1370c$export$2f18b5d4816974c0 = /*#__PURE__*/ function(InteractionSource) {
    InteractionSource["CHAT_INPUT"] = "chatInput";
    InteractionSource["FOLLOW_UPS"] = "followUps";
    InteractionSource["MOVED_OVER"] = "movedOver";
    InteractionSource["EMPTY_STATE_SUGGESTIONS"] = "emptyStateSuggestions";
    return InteractionSource;
}({});
let $9d607fb9e6f1370c$export$f1b72addbccfc188 = /*#__PURE__*/ function(FollowUpSource) {
    FollowUpSource["NONE"] = "none";
    FollowUpSource["SAIN"] = "sain";
    FollowUpSource["READING_AIDS"] = "reading-aids";
    FollowUpSource["PAGE_SUMMARY"] = "page-summary";
    FollowUpSource["AI_MATE"] = "ai-mate";
    return FollowUpSource;
}({});

});

parcelRegister("iUYbh", function(module, exports) {

$parcel$export(module.exports, "getAttributesFromContexts", () => $dc5c239eed5cadfb$export$d97c97ed77ff09e8);
const $dc5c239eed5cadfb$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return true;
};
const $dc5c239eed5cadfb$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let aiMateOnly = context.filter((x)=>$dc5c239eed5cadfb$var$isSourceAndAttributes(x) && x.source === 'AIMate');
    return aiMateOnly.reduce((acc, x)=>{
        var _x$attributes;
        return {
            ...acc,
            ...(_x$attributes = x.attributes) !== null && _x$attributes !== void 0 ? _x$attributes : {}
        };
    }, {});
};

});


parcelRegister("a0eNT", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $0be31bab44d4c374$export$c2095165ae2bdcda);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8fAH0 = parcelRequire("8fAH0");

var $01mPo = parcelRequire("01mPo");
function $0be31bab44d4c374$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $eUqFw.useRef)();
    const firedViewedUIEventId = (0, $eUqFw.useRef)();
    const mapToCcpProductKeys = (0, $eUqFw.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $eUqFw.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $eUqFw.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $eUqFw.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("8fAH0", function(module, exports) {

$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $b894dc23cc6a0ac0$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $b894dc23cc6a0ac0$export$54e3fc09a2a3347a);
const $b894dc23cc6a0ac0$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b894dc23cc6a0ac0$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b894dc23cc6a0ac0$export$6c053e1694ef181c = {
    prod: $b894dc23cc6a0ac0$export$31048cb2a0753b12,
    staging: $b894dc23cc6a0ac0$export$9d8f18312db80469
};
const $b894dc23cc6a0ac0$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("01mPo", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $2ccab29d76660949$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $2ccab29d76660949$export$285f3d0989f9023f);
const $2ccab29d76660949$export$c536a7e29a0739b8 = 'crossFlow';
var $2ccab29d76660949$export$285f3d0989f9023f;
(function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
})($2ccab29d76660949$export$285f3d0989f9023f || ($2ccab29d76660949$export$285f3d0989f9023f = {}));

});


parcelRegister("aqjZk", function(module, exports) {

var $7yTVG = parcelRequire("7yTVG");

var $6EV6g = parcelRequire("6EV6g");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $796bd651c63a4c51$var$shuffle(collection) {
    var func = $1c8hB(collection) ? $7yTVG : $6EV6g;
    return func(collection);
}
module.exports = $796bd651c63a4c51$var$shuffle;

});
parcelRegister("7yTVG", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3F3vs = parcelRequire("3F3vs");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $581717cde6f26598$var$arrayShuffle(array) {
    return $3F3vs($b69Sx(array));
}
module.exports = $581717cde6f26598$var$arrayShuffle;

});
parcelRegister("3F3vs", function(module, exports) {

var $9JT20 = parcelRequire("9JT20");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $2aa7ebbe760856ad$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $9JT20(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $2aa7ebbe760856ad$var$shuffleSelf;

});
parcelRegister("9JT20", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7173011882c80230$var$nativeFloor = Math.floor, $7173011882c80230$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $7173011882c80230$var$baseRandom(lower, upper) {
    return lower + $7173011882c80230$var$nativeFloor($7173011882c80230$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $7173011882c80230$var$baseRandom;

});



parcelRegister("6EV6g", function(module, exports) {

var $3F3vs = parcelRequire("3F3vs");

var $hvbu2 = parcelRequire("hvbu2");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $4d92c55b2944d5b8$var$baseShuffle(collection) {
    return $3F3vs($hvbu2(collection));
}
module.exports = $4d92c55b2944d5b8$var$baseShuffle;

});


parcelRegister("6TFMw", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $50584a104514324b$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $50584a104514324b$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $PdmhA = parcelRequire("PdmhA");
// WARNING: The following types are duplicated from '@atlaskit/atlassian-navigation' so that we can avoid having to include atlassian-navigation as a dependency just for these types
// The more correct solution would be to extract these types and have them in a separate package that we both import from, but this will do for now
/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $50584a104514324b$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
            borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $PdmhA.N100)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $50584a104514324b$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $50584a104514324b$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, $50584a104514324b$export$e6c62eb05a8288ed.default, searchCSS);
};
const $50584a104514324b$var$ctx = /*#__PURE__*/ (0, $eUqFw.createContext)($50584a104514324b$export$e6c62eb05a8288ed.default);
const $50584a104514324b$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $50584a104514324b$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50584a104514324b$var$ctx.Provider, {
        value: theme
    }, children);
};
const $50584a104514324b$export$93d4e7f90805808f = ()=>{
    return (0, $eUqFw.useContext)($50584a104514324b$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $50584a104514324b$export$f9bb738f552c610d = $50584a104514324b$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $50584a104514324b$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("5NPFi", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $43999af67c5463f8$export$82eafebb825fc23f);

var $eUqFw = parcelRequire("eUqFw");

var $dsroq = parcelRequire("dsroq");

var $PdmhA = parcelRequire("PdmhA");
const $43999af67c5463f8$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $PdmhA.N800})` })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        label: "search",
        primaryColor: isExpanded ? primaryColor : theme.default.color,
        size: size
    });

});

parcelRegister("307ln", function(module, exports) {

$parcel$export(module.exports, "MobileSearchIconWrapper", () => $22f71183dae0f1e0$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $22f71183dae0f1e0$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $22f71183dae0f1e0$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $22f71183dae0f1e0$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $22f71183dae0f1e0$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $22f71183dae0f1e0$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $22f71183dae0f1e0$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $22f71183dae0f1e0$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $22f71183dae0f1e0$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $22f71183dae0f1e0$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $22f71183dae0f1e0$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $22f71183dae0f1e0$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $22f71183dae0f1e0$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $22f71183dae0f1e0$export$3f33ed4b273b43d);

var $byn9U = parcelRequire("byn9U");

var $g3tFP = parcelRequire("g3tFP");

var $exJuA = parcelRequire("exJuA");

var $dw2fA = parcelRequire("dw2fA");

var $PdmhA = parcelRequire("PdmhA");
const $22f71183dae0f1e0$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $22f71183dae0f1e0$export$63e083aca343a6ae = (0, $exJuA.default).span`
	display: none;
	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: ${(props)=>props.isExpanded ? 'none' : 'block'};
	}
`;
const $22f71183dae0f1e0$export$9673cb6b61244e6e = (0, $exJuA.default)('span')`
	width: ${(0, $dw2fA.grid).multiple(2).px};
	height: ${(0, $dw2fA.grid).multiple(2).px};
	position: absolute;
	top: ${(0, $dw2fA.grid).px};
	left: ${(0, $dw2fA.grid).px};
	color: ${(props)=>props.isExpanded ? `var(--ds-text, ${0, $PdmhA.N900})` : props.default.color};

	:focus {
		box-shadow: 0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`};
		border-radius: 100%;
		outline: none;
	}

	// Override the out-of-the-box SearchIcon for vertical centering.
	& > span[role='img'] {
		line-height: 0;
	}

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: none;
	}

	button {
		height: auto;
		vertical-align: baseline;
	}
`;
const $22f71183dae0f1e0$export$1da38d078e896a10 = (0, $exJuA.default)('div')`
	position: absolute;
	display: flex;
	top: 0;
	right: 0;
	height: 100%;
	align-items: center;
	margin: auto 0;

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		right: 24px;
	}
`;
const $22f71183dae0f1e0$export$ff9b1a25d343474d = (0, $exJuA.default)('div')`
	width: ${(0, $dw2fA.grid).multiple(2).px};
	height: ${(0, $dw2fA.grid).multiple(2).px};
	padding: 5px ${"var(--ds-space-075, 6px)"};
	color: ${`var(--ds-text-subtlest, ${(0, $PdmhA.N70)})`};
	background-color: transparent;

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: none;
	}

	:hover {
		cursor: pointer;
		color: ${`var(--ds-icon, ${(0, $PdmhA.N500)})`};
	}

	& > span > svg {
		vertical-align: unset;
	}
`;
const $22f71183dae0f1e0$export$54c466678ae7c638 = (0, $exJuA.default)('div')`
	display: none;
	margin: 0 ${(0, $dw2fA.grid).px};
	height: ${(0, $dw2fA.grid).multiple(4).px};
	padding-bottom: ${(0, $dw2fA.grid).multiple(0.25).px};

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: block;
	}

	:hover {
		border-radius: 100%;
		background-color: ${(props)=>props.hover.backgroundColor};
		color: ${(props)=>props.hover.color};
	}
`;
const $22f71183dae0f1e0$export$c2b37b18a8b54130 = (0, $exJuA.default)('div')(// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
(0, $byn9U.css)`
		position: relative;
		max-width: 100%;
		@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
			width: 100%;
		}
	`, (props)=>{
    const styles = `
      width: ${props.isExpanded ? (0, $dw2fA.dialogWidth) : (0, $dw2fA.collapsedSearchInputWidth)};
    `;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return (0, $byn9U.css)`
				${styles}
				@media screen and (max-width: ${0, $dw2fA.dialogPageTakeoverWidth}px) {
					width: 100%;
					height: ${0, $dw2fA.atlassianNavigationHeight};
					background-color: ${props.default.backgroundColor};
					display: flex;
					align-items: center;
					max-width: initial;
				}
			`;
    return styles;
});
const $22f71183dae0f1e0$export$b6261a2c5ea449d = (0, $exJuA.default).input`
	height: ${(0, $dw2fA.inputFieldHeight).px};
	width: 100%;
	padding: 0px ${"var(--ds-space-150, 12px)"} 0px 30px;
	box-sizing: border-box;
	outline: none;
	border-radius: 5px;
	font-size: 14px;
	line-height: 20px;
	${(props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $22f71183dae0f1e0$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $dw2fA.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $dw2fA.grid).multiple(1.5).px} ${(0, $dw2fA.grid).multiple(0.25).px};
            margin: 0 ${(0, $dw2fA.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `}
`;
const $22f71183dae0f1e0$export$ca6fe3402791d08e = (0, $exJuA.default)((0, $g3tFP.default))({
    display: 'none'
});
const $22f71183dae0f1e0$export$6d53dccb772ed720 = (0, $exJuA.default)('input')`
	height: ${(0, $dw2fA.inputFieldHeight).px};
	width: 100%;
	padding: 0px ${"var(--ds-space-150, 12px)"} 0px 30px;
	box-sizing: border-box;
	outline: none;
	border-radius: 5px;
	font-size: 14px;
	line-height: 20px;
	border: ${()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $PdmhA.N100})`}`};
	background-color: ${"var(--ds-background-input, rgb(255, 255, 255))"};
	color: ${`var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`};

	:hover {
		background-color: ${"var(--ds-background-input-hovered, rgb(255, 255, 255))"};
	}

	:focus {
		color: ${`var(--ds-text, ${(0, $PdmhA.N900)})`};
		box-shadow: ${()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $PdmhA.N100})`}`};
	}

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: none;
	}
`;
const $22f71183dae0f1e0$export$c47d4a3e1f1297f1 = (0, $exJuA.default)('div')({
    position: 'relative',
    '@media screen and (min-width: 781px)': {
        minWidth: '200px'
    },
    height: '32px'
});
const $22f71183dae0f1e0$export$58ae19ee1fc7be8a = (0, $exJuA.default)('div')({
    position: 'relative'
});
const $22f71183dae0f1e0$export$b40f2abde293e8e4 = (0, $exJuA.default)('div')`
	position: relative;
	max-width: 100%;
	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		width: 100%;
	}
	width: ${(0, $dw2fA.collapsedSearchInputWidth)};
`;
const $22f71183dae0f1e0$export$eb4e9f55bbe045df = (0, $exJuA.default)('span')`
	width: ${(0, $dw2fA.grid).multiple(2).px};
	height: ${(0, $dw2fA.grid).multiple(2).px};
	position: absolute;
	top: ${(0, $dw2fA.grid).px};
	left: ${(0, $dw2fA.grid).px};
	color: rgb(107, 119, 140);

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: none;
	}
`;
const $22f71183dae0f1e0$export$3f33ed4b273b43d = (0, $exJuA.default)('span')`
	display: none;
	padding: ${(0, $dw2fA.grid).multiple(0.5).px};
	padding-right: ${"var(--ds-space-025, 2px)"};
	color: rgb(52, 69, 99);

	@media screen and (max-width: ${(0, $dw2fA.dialogPageTakeoverWidth)}px) {
		display: flex;
	}
`;

});
parcelRegister("dw2fA", function(module, exports) {

$parcel$export(module.exports, "zIndex", () => $9d70026501b94e7b$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $9d70026501b94e7b$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $9d70026501b94e7b$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $9d70026501b94e7b$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $9d70026501b94e7b$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $9d70026501b94e7b$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $9d70026501b94e7b$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $9d70026501b94e7b$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $9d70026501b94e7b$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $9d70026501b94e7b$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $9d70026501b94e7b$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $9d70026501b94e7b$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $9d70026501b94e7b$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $9d70026501b94e7b$export$b6b16ffe83ef4b56);

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
const $9d70026501b94e7b$var$GRID_UNIT = (0, $lcnyw.gridSize)();
const $9d70026501b94e7b$var$AkGrid = (num = 1)=>({
        px: `${num * $9d70026501b94e7b$var$GRID_UNIT}px`,
        unitless: num * $9d70026501b94e7b$var$GRID_UNIT,
        multiple: (multiplier)=>$9d70026501b94e7b$var$AkGrid(multiplier * num),
        half: ()=>$9d70026501b94e7b$var$AkGrid(0.5 * num),
        twice: ()=>$9d70026501b94e7b$var$AkGrid(2 * num)
    });
const $9d70026501b94e7b$export$56446adcecbeec34 = {
    searchDialog: (0, $lcnyw.layers).dialog()
};
const $9d70026501b94e7b$export$85fc379452d91af0 = $9d70026501b94e7b$var$AkGrid(1);
const $9d70026501b94e7b$export$b9930dabfa4a3a3 = '56px';
const $9d70026501b94e7b$export$f6af7620e8789c39 = '200px';
const $9d70026501b94e7b$export$64d8573e83b64ff8 = '150px';
const $9d70026501b94e7b$export$a3da89b899389ed8 = '780px';
const $9d70026501b94e7b$export$ce4512df260a325a = 780;
const $9d70026501b94e7b$export$a406031ed42c8e02 = '1130px';
const $9d70026501b94e7b$export$e00021bea368c518 = $9d70026501b94e7b$export$85fc379452d91af0.multiple(4);
const $9d70026501b94e7b$export$30310ee354b45eb0 = $9d70026501b94e7b$export$85fc379452d91af0.multiple(6);
const $9d70026501b94e7b$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $9d70026501b94e7b$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $9d70026501b94e7b$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N20)})`;
const $9d70026501b94e7b$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $PdmhA.P300)})`;
const $9d70026501b94e7b$export$b6b16ffe83ef4b56 = (0, $byn9U.css)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});

});


parcelRegister("9UxRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $73739b725d2d3fee$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6TFMw = parcelRequire("6TFMw");

var $307ln = parcelRequire("307ln");

var $8nmPf = parcelRequire("8nmPf");

var $5NPFi = parcelRequire("5NPFi");

var $2MkWI = parcelRequire("2MkWI");

var $4iA8B = parcelRequire("4iA8B");

var $8Xv32 = parcelRequire("8Xv32");
const $73739b725d2d3fee$var$MAX_INPUT_LENGTH = 500;
const $73739b725d2d3fee$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $6TFMw.useTheme)();
    const { forwardRef: forwardRef, features: features } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = (features === null || features === void 0 ? void 0 : features.interactiveSkeleton) || {};
    if (enabled || (0, $4iA8B.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xv32.SSRsearchInput), {
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nmPf.SearchAnchorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SearchInputContainer), (0, $kU09D.default)({}, theme, {
        isExpanded: false,
        role: "search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.MobileSearchIconWrapper), {
        isExpanded: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2MkWI.default), {
        label: "",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NPFi.SearchIcon), {
                theme: theme,
                isExpanded: false,
                size: "medium"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.DesktopSearchIconWrapper), (0, $kU09D.default)({}, theme, {
        isExpanded: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NPFi.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SearchInputField), (0, $kU09D.default)({
        "data-test-id": "search-dialog-search-skeleton",
        isExpanded: false,
        placeholder: placeholder,
        ref: forwardRef || undefined,
        disabled: true,
        value: "",
        maxLength: $73739b725d2d3fee$var$MAX_INPUT_LENGTH,
        onChange: ()=>{}
    }, theme))));
};
var $73739b725d2d3fee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73739b725d2d3fee$export$9b2f977cfc67f251, (0, $kU09D.default)({}, props, {
        forwardRef: ref
    })));

});
parcelRegister("8nmPf", function(module, exports) {

$parcel$export(module.exports, "AbsoluteContainer", () => $61922d69bb7b00f8$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $61922d69bb7b00f8$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $61922d69bb7b00f8$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $61922d69bb7b00f8$export$5566658d36f6ca7b);

var $byn9U = parcelRequire("byn9U");

var $exJuA = parcelRequire("exJuA");

var $dw2fA = parcelRequire("dw2fA");
const $61922d69bb7b00f8$export$36aa0f4a98890c96 = (0, $exJuA.default)('div')({}, (props)=>{
    if (props.isExpanded) return (0, $byn9U.css)({
        position: 'absolute',
        right: 0,
        zIndex: (0, $dw2fA.zIndex).searchDialog
    });
    return {};
});
const $61922d69bb7b00f8$export$f565ce1043dae7c9 = (0, $exJuA.default)('div')({
    position: 'relative'
}, (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $byn9U.css)`
				@media screen and (max-width: ${0, $dw2fA.dialogPageCentreWidth}) {
					position: fixed;
					z-index: ${(0, $dw2fA.zIndex).searchDialog};
					left: calc((100% - ${0, $dw2fA.dialogWidth}) / 2);
				}
				@media screen and (max-width: ${0, $dw2fA.dialogPageTakeoverWidth}px) {
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					display: flex;
					flex-direction: column;
					overflow: auto;
				}
			`;
    return {};
});
const $61922d69bb7b00f8$export$dfece74a62f1398d = (0, $exJuA.default).div`
	position: relative;
	/* Prevent the input from being 200px when the icon is at the maximum icon width */
	@media screen and (min-width: ${(0, $dw2fA.dialogPageTakeoverWidth) + 1}px) {
		min-width: 200px;
	}
	width: ${(0, $dw2fA.inputFieldHeight).px};
	height: ${(0, $dw2fA.inputFieldHeight).px};
`;
const $61922d69bb7b00f8$export$5566658d36f6ca7b = (0, $exJuA.default)($61922d69bb7b00f8$export$dfece74a62f1398d)`
	height: ${(props)=>props.isExpanded ? (0, $dw2fA.enlargedInputFieldHeight).px : (0, $dw2fA.inputFieldHeight).px};
`;

});

parcelRegister("4iA8B", function(module, exports) {

$parcel$export(module.exports, "getInputSkeletonQuery", () => $3214e015df2eecf4$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $3214e015df2eecf4$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $3214e015df2eecf4$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $3214e015df2eecf4$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $3214e015df2eecf4$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $3214e015df2eecf4$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $3214e015df2eecf4$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $3214e015df2eecf4$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $3214e015df2eecf4$export$c830bcf42e072a93);
const $3214e015df2eecf4$export$b8b6c2e7a0664212 = ()=>{
    var _window, _window$inputSkeleton;
    return ((_window = window) === null || _window === void 0 ? void 0 : (_window$inputSkeleton = _window.inputSkeletonState) === null || _window$inputSkeleton === void 0 ? void 0 : _window$inputSkeleton.query) || '';
};
const $3214e015df2eecf4$export$baa1c819dd4691f3 = (newQuery)=>{
    var _window2;
    if ((_window2 = window) !== null && _window2 !== void 0 && _window2.inputSkeletonState) window.inputSkeletonState.query = newQuery;
};
const $3214e015df2eecf4$export$38fcbc98be180790 = ()=>{
    var _window3, _window3$inputSkeleto;
    return ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$inputSkeleto = _window3.inputSkeletonState) === null || _window3$inputSkeleto === void 0 ? void 0 : _window3$inputSkeleto.isFocused) || false;
};
const $3214e015df2eecf4$export$d3c6894b4e9af000 = (newIsFocused)=>{
    var _window4;
    if ((_window4 = window) !== null && _window4 !== void 0 && _window4.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
};
const $3214e015df2eecf4$export$a0c71b3bd9ec143c = ()=>{
    var _window5, _window5$inputSkeleto, _window6, _window6$inputSkeleto, _window7, _window7$inputSkeleto;
    const selectionStart = ((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$inputSkeleto = _window5.inputSkeletonState) === null || _window5$inputSkeleto === void 0 ? void 0 : _window5$inputSkeleto.selectionStart) || 0;
    const selectionEnd = ((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$inputSkeleto = _window6.inputSkeletonState) === null || _window6$inputSkeleto === void 0 ? void 0 : _window6$inputSkeleto.selectionEnd) || 0;
    const selectionDirection = ((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$inputSkeleto = _window7.inputSkeletonState) === null || _window7$inputSkeleto === void 0 ? void 0 : _window7$inputSkeleto.selectionDirection) || 'none';
    return {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        selectionDirection: selectionDirection
    };
};
const $3214e015df2eecf4$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    var _window8;
    if ((_window8 = window) !== null && _window8 !== void 0 && _window8.inputSkeletonState) {
        window.inputSkeletonState.selectionStart = newSelectionStart;
        window.inputSkeletonState.selectionEnd = newSelectionEnd;
        window.inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $3214e015df2eecf4$export$c89dd2d5d4024c5e = ()=>{
    window.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $3214e015df2eecf4$export$166ce39761ad7743 = ()=>{
    if (window.inputSkeletonState) {
        window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
            const [target, event, handler] = ssrEventListener;
            target.removeEventListener(event, handler);
        });
        window.inputSkeletonState.listeners = [];
    }
};
const $3214e015df2eecf4$export$c830bcf42e072a93 = ()=>{
    if (window['inputSkeletonState']) {
        $3214e015df2eecf4$export$166ce39761ad7743();
        delete window['inputSkeletonState'];
    }
};

});

parcelRegister("8Xv32", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $307ln = parcelRequire("307ln");


var $5NPFi = parcelRequire("5NPFi");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme })=>{
    const scriptRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const current = scriptRef === null || scriptRef === void 0 ? void 0 : scriptRef.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRsearchInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "ssr-search-input-popout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRformContainer), {
        id: "ssr-form-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        method: "get",
        action: advancedSearchUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRsearchInputContainer), {
        id: "ssr-input-container",
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRmobileSearchIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NPFi.SearchIcon), {
        theme: theme,
        isExpanded: false,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRdesktopSearchIconWrapper), {
        id: "ssr-search-icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NPFi.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $307ln.SSRsearchInputField), {
        id: "ssr-search-input",
        name: "text",
        placeholder: placeholder,
        autoComplete: "off"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", (0, $kU09D.default)({
        "data-test-id": "ssr-scripts-init",
        ref: scriptRef,
        dangerouslySetInnerHTML: {
            __html: (0, $8fffee0bd212e63a$export$bc237d627614fc48)
        }
    }, customScriptDataAttributes))))));
};

});
/* eslint-disable */ // @ts-ignore
const $8fffee0bd212e63a$export$bc237d627614fc48 = `(function(document,window){var _a;var currentInput=document.getElementById("ssr-search-input");var container=document.getElementById("ssr-input-container");var topContainer=document.getElementById("ssr-search-input-popout-container");var iconWrapper=document.getElementById("ssr-search-icon-wrapper");var formContainer=document.getElementById("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute;right: 0px;z-index: 300;");formContainer===null||formContainer===void 0?void 0:formContainer.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");container===null||container===void 0?void 0:container.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute; right:0px; z-index:300;");container===null||container===void 0?void 0:container.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused&&currentInput){currentInput.value=window.inputSkeletonState.query;currentInput.placeholder=window.inputSkeletonState.placeholder;currentInput.focus();currentInput.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&currentInput&&!!queryValue){currentInput.value=queryValue}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute;right: 0px;z-index: 300;");formContainer===null||formContainer===void 0?void 0:formContainer.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");container===null||container===void 0?void 0:container.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}window.inputSkeletonState.selectionStart=currentInput.selectionStart||0;window.inputSkeletonState.selectionEnd=currentInput.selectionEnd||0;window.inputSkeletonState.selectionDirection=currentInput.selectionDirection||"none"}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;window.inputSkeletonState.placeholder=currentInput.placeholder}setExpandedStyles()}function blurClickHandler(e){if(currentInput&&e.target===currentInput&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=currentInput.selectionStart||0;window.inputSkeletonState.selectionEnd=currentInput.selectionEnd||0;window.inputSkeletonState.selectionDirection=currentInput.selectionDirection||"none";if(!(topContainer===null||topContainer===void 0?void 0:topContainer.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==currentInput){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){currentInput.value=sessionQuery}else{currentInput.value=""}topContainer===null||topContainer===void 0?void 0:topContainer.removeAttribute("style");container===null||container===void 0?void 0:container.removeAttribute("style");iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.removeAttribute("style");currentInput.removeAttribute("style");formContainer===null||formContainer===void 0?void 0:formContainer.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}addListener(currentInput,"input",changeHandler);addListener(currentInput,"select",changeHandler);addListener(currentInput,"keydown",changeHandler);addListener(currentInput,"focus",focusHandler);addListener(document,"click",blurClickHandler)})(document,window);`;



parcelRegister("72tMA", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $51ffd28b87385efa$export$b24dcbe1ec677a8);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $9rJV7 = parcelRequire("9rJV7");

var $3IgFF = parcelRequire("3IgFF");

var $5y8eZ = parcelRequire("5y8eZ");
const $51ffd28b87385efa$var$Store = (0, $a61MH.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: {
        setError: (error)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    error: error
                });
            },
        setLoading: (isLoading)=>({ setState: setState })=>{
                setState({
                    isLoading: isLoading
                });
            },
        setPermissions: (permissions)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    permissions: (0, $5y8eZ.transformPermissions)(permissions)
                });
            }
    },
    name: 'teams-permissions'
});
const $51ffd28b87385efa$var$useTeamsPermissionsStore = (0, $ggKAj.createHook)($51ffd28b87385efa$var$Store);
const $51ffd28b87385efa$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, initialState: initialState } = {
    enabled: false,
    initialState: {}
})=>{
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { setError: setError, setLoading: setLoading, setPermissions: setPermissions }] = $51ffd28b87385efa$var$useTeamsPermissionsStore();
    const [request, controller] = (0, $eUqFw.useMemo)(()=>(0, $5y8eZ.requestPermissions)({
            orgId: orgId,
            apiVersion: 'v4',
            siteId: cloudId !== null && cloudId !== void 0 ? cloudId : 'None'
        }), [
        orgId,
        cloudId
    ]);
    const [getPermissions, { loading: loading, error: error, data: data }] = (0, $3IgFF.useLazyService)(request, controller, {
        ErrorHandler: (0, $9rJV7.LegionError),
        initialState: initialState
    });
    const isLoadingElsewhere = state.isLoading && !loading;
    const hasLoadedAnywhere = state.error || state.hasLoaded;
    const willSendRequest = orgId && enabled && !hasLoadedAnywhere && !isLoadingElsewhere;
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (willSendRequest) {
                setLoading(true);
                await getPermissions();
            }
        };
        fetchData();
        return ()=>{
            setLoading(false);
        };
    }, [
        getPermissions,
        setLoading,
        willSendRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data !== null && data !== void 0 && data.permissions) setPermissions(data.permissions);
        if (error) setError(error);
    }, [
        data,
        error,
        setPermissions,
        setError
    ]);
    return {
        loading: loading,
        data: data,
        ...state
    };
};

});
parcelRegister("9rJV7", function(module, exports) {

$parcel$export(module.exports, "LegionError", () => $6e0a41770e6b117f$export$6f5d01e55f14843f);
class $6e0a41770e6b117f$export$6f5d01e55f14843f extends Error {
    constructor(data, ...params){
        super(...params);
        this.name = 'LegionError';
        this.message = data.error;
        this.status = data.status;
        this.path = data.path;
        this.timestamp = data.timestamp;
    }
}

});

parcelRegister("3IgFF", function(module, exports) {

$parcel$export(module.exports, "useLazyService", () => $2b4269ae8c2ceece$export$1a85343b4dbf3bf5);
$parcel$export(module.exports, "useService", () => $2b4269ae8c2ceece$export$6de4685a6c88b4e9);

var $eUqFw = parcelRequire("eUqFw");

var $8s693 = parcelRequire("8s693");
const $2b4269ae8c2ceece$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        error: undefined,
        data: undefined,
        ...options === null || options === void 0 ? void 0 : options.initialState
    });
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setState((s)=>({
                ...s,
                loading: true
            }));
        try {
            var _response$headers;
            const response = await request();
            const traceId = response === null || response === void 0 ? void 0 : (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('atl-traceid');
            let jsonResponse;
            let isResponseText = false;
            const resText = await (response === null || response === void 0 ? void 0 : response.text()) || '{}';
            try {
                jsonResponse = JSON.parse(resText);
            } catch  {
                isResponseText = true;
            }
            if (!(response !== null && response !== void 0 && response.ok) || isResponseText) {
                if (options !== null && options !== void 0 && options.ErrorHandler) throw new options.ErrorHandler({
                    ...jsonResponse,
                    traceId: traceId,
                    status: response === null || response === void 0 ? void 0 : response.status,
                    statusText: (response === null || response === void 0 ? void 0 : response.statusText) || resText
                });
                else throw new (0, $8s693.HttpError)(response === null || response === void 0 ? void 0 : response.status, (response === null || response === void 0 ? void 0 : response.statusText) || resText, traceId);
            }
            setState((s)=>({
                    ...s,
                    loading: false,
                    data: jsonResponse
                }));
            return response;
        } catch (error) {
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: error
                }));
        }
    }, [
        request,
        options === null || options === void 0 ? void 0 : options.ErrorHandler
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            controller.abort();
        };
    }, [
        controller
    ]);
    return [
        getData,
        state
    ];
};
const $2b4269ae8c2ceece$export$6de4685a6c88b4e9 = (...[request, controller, options])=>{
    const [getData, state] = $2b4269ae8c2ceece$export$1a85343b4dbf3bf5(request, controller, {
        ...options,
        initialState: {
            ...options === null || options === void 0 ? void 0 : options.initialState,
            loading: true
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return state;
};

});
parcelRegister("8s693", function(module, exports) {

$parcel$export(module.exports, "requestWithAbort", () => $6275b48469d07cf0$export$970d18814fa0cb04);
$parcel$export(module.exports, "HttpError", () => $6275b48469d07cf0$export$65bd6083489bd8bb);

var $k7xLD = parcelRequire("k7xLD");
const $6275b48469d07cf0$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            ...options
        });
const $6275b48469d07cf0$export$970d18814fa0cb04 = (url, options = {})=>{
    const controller = new (0, $k7xLD.AbortControllerFacade)();
    return [
        $6275b48469d07cf0$export$b5fe3f66a567bec0(url, {
            signal: controller.signal,
            ...options
        }),
        controller
    ];
};
class $6275b48469d07cf0$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}

});
parcelRegister("k7xLD", function(module, exports) {

$parcel$export(module.exports, "AbortControllerFacade", () => $ea5ea797bc07004e$export$f5cffffa581a7d2c);

var $5zQU9 = parcelRequire("5zQU9");
class $ea5ea797bc07004e$var$AbortSignalFacade {
    constructor(){
        (0, $5zQU9.default)(this, "aborted", false);
        (0, $5zQU9.default)(this, "reason", '');
        (0, $5zQU9.default)(this, "onabort", ()=>{});
        (0, $5zQU9.default)(this, "throwIfAborted", ()=>{});
        (0, $5zQU9.default)(this, "addEventListener", ()=>{});
        (0, $5zQU9.default)(this, "removeEventListener", ()=>{});
        (0, $5zQU9.default)(this, "dispatchEvent", ()=>false);
    }
}
class $ea5ea797bc07004e$export$f5cffffa581a7d2c {
    abort() {}
    constructor(){
        (0, $5zQU9.default)(this, "signal", new $ea5ea797bc07004e$var$AbortSignalFacade());
        if (typeof window === 'object' && window.AbortController) {
            const controller = new AbortController();
            this.abort = controller.abort.bind(controller);
            this.signal = controller.signal;
        }
    }
}

});



parcelRegister("5y8eZ", function(module, exports) {

$parcel$export(module.exports, "requestPermissions", () => $40a68526f56b22ee$export$8cec5d3683c6896e);
$parcel$export(module.exports, "transformPermissions", () => $40a68526f56b22ee$export$7fe0bfa353103198);

var $k7xLD = parcelRequire("k7xLD");

var $8s693 = parcelRequire("8s693");

var $cLcX0 = parcelRequire("cLcX0");
const $40a68526f56b22ee$export$510a9a6650a678de = ({ orgId: orgId, siteId: siteId, apiVersion: apiVersion })=>`/gateway/api/${apiVersion}/teams/permission/self/organization/${orgId}${apiVersion === 'v4' ? `?siteId=${siteId}` : ''}`;
const $40a68526f56b22ee$export$8cec5d3683c6896e = ({ orgId: orgId, ...props })=>orgId ? (0, $8s693.requestWithAbort)($40a68526f56b22ee$export$510a9a6650a678de({
        ...props,
        orgId: orgId
    }), {
        method: 'GET'
    }) : [
        ()=>Promise.resolve(),
        new (0, $k7xLD.AbortControllerFacade)()
    ];
const $40a68526f56b22ee$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case (0, $cLcX0.TeamsPermissionApi).canCreateTeams:
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case (0, $cLcX0.TeamsPermissionApi).canViewTeams:
                return {
                    ...acc,
                    canViewTeams: true
                };
            case (0, $cLcX0.TeamsPermissionApi).canAdminTeams:
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};

});
parcelRegister("cLcX0", function(module, exports) {

$parcel$export(module.exports, "TeamsPermissionApi", () => $94a3eb8d808fc4bc$export$d079b1c48d5fbf57);
let $94a3eb8d808fc4bc$export$d079b1c48d5fbf57 = /*#__PURE__*/ function(TeamsPermissionApi) {
    TeamsPermissionApi["canCreateTeams"] = "CAN_CREATE_TEAMS";
    TeamsPermissionApi["canViewTeams"] = "CAN_VIEW_TEAMS";
    TeamsPermissionApi["canAdminTeams"] = "CAN_ADMIN_TEAMS";
    return TeamsPermissionApi;
}({});

});



parcelRegister("idyMy", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $d4346be0706dfeaa$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $d4346be0706dfeaa$export$130340d16a670190);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $jbJtr = parcelRequire("jbJtr");

var $3YDeS = parcelRequire("3YDeS");

var $9ckYO = parcelRequire("9ckYO");
const $d4346be0706dfeaa$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $3YDeS.DEFAULT_CONTEXT));
const $d4346be0706dfeaa$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $9ckYO.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $jbJtr.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4346be0706dfeaa$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $3YDeS.DEFAULT_CONTEXT)
    }, children);
};
const $d4346be0706dfeaa$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aNvhX.FlightDeckProvider), (0, $kU09D.default)({
        product: product
    }, flightDeckProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4346be0706dfeaa$export$3bf19eb896b777b8, {
        locale: locale,
        product: product,
        teamPermissions: teamPermissions,
        teamPermissionCheckEnabled: teamPermissionCheckEnabled,
        orgId: orgId
    }, children));
};
const $d4346be0706dfeaa$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($d4346be0706dfeaa$export$8a37839ac1e08b25);

});
parcelRegister("aNvhX", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $7dc6c04379a09164$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $7dc6c04379a09164$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $7dc6c04379a09164$export$3b241cde208d2c5e);

var $eUqFw = parcelRequire("eUqFw");

var $5PgJs = parcelRequire("5PgJs");
const $7dc6c04379a09164$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    getArtifact: null
});
function $7dc6c04379a09164$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return new (0, $5PgJs.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dc6c04379a09164$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $7dc6c04379a09164$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($7dc6c04379a09164$export$ca1b33377afa620);
function $7dc6c04379a09164$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const { getArtifact: getArtifact } = $7dc6c04379a09164$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("jbJtr", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $df82518bfe3cd946$export$233293b7afb7b362);

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $7aWzm = parcelRequire("7aWzm");
const $df82518bfe3cd946$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    var _artifact$overrides;
    if (!(artifact !== null && artifact !== void 0 && (_artifact$overrides = artifact.overrides) !== null && _artifact$overrides !== void 0 && _artifact$overrides.length) || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        var _artifact$overrides$f;
        return {
            ...acc,
            ...artifact.overrides && ((_artifact$overrides$f = artifact.overrides.find((override)=>override.key === overrideKey)) === null || _artifact$overrides$f === void 0 ? void 0 : _artifact$overrides$f.item) || null
        };
    }, artifact);
};
const $df82518bfe3cd946$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $eUqFw.useMemo)(()=>({
            ...(0, $7aWzm.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $aNvhX.useFlightDeckArtifact)((0, $7aWzm.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
   * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
   * We can probably remove this memo once that functionality is available
   */ return (0, $eUqFw.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $df82518bfe3cd946$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("7aWzm", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $5396e6337509e2ba$export$c270c412a04ff3e6);

var $dfBCt = parcelRequire("dfBCt");
const $5396e6337509e2ba$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $5396e6337509e2ba$export$71f196808ce40e60 = 'prod';
const $5396e6337509e2ba$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $5396e6337509e2ba$export$e836203c1e95eac3 = 'commercial';
const $5396e6337509e2ba$export$c270c412a04ff3e6 = {
    name: $5396e6337509e2ba$export$953923d576277fd6,
    dimensions: {
        environmentType: $5396e6337509e2ba$export$71f196808ce40e60,
        perimeter: (0, $dfBCt.isFedRamp)() ? $5396e6337509e2ba$export$6392ca3738ed1e9 : $5396e6337509e2ba$export$e836203c1e95eac3
    }
};

});


parcelRegister("3YDeS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $2e5569b88e7b5ccc$export$9c542858adf7dcd0);
const $2e5569b88e7b5ccc$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("9ckYO", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $6b25823a0f54427a$export$66d7d96ce076bcd6);

var $72tMA = parcelRequire("72tMA");

var $3KWRH = parcelRequire("3KWRH");
const $6b25823a0f54427a$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $72tMA.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!(teamPermissions !== null && teamPermissions !== void 0 && teamPermissions.canCreateTeams) ? [
                (0, $3KWRH.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!(teamPermissions !== null && teamPermissions !== void 0 && teamPermissions.canViewTeams) ? [
                (0, $3KWRH.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("3KWRH", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $2bc3545a13034657$export$c6e6fe52d34907dc);
let $2bc3545a13034657$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("5ZVKY", function(module, exports) {

$parcel$export(module.exports, "ErrorWithContext", () => $45df73832c24b744$export$6e749dfbce027249);
class $45df73832c24b744$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = context;
    }
}

});

parcelRegister("d8riu", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $9901326496384064$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $9901326496384064$export$aecb6ab9d1724228);

var $idyMy = parcelRequire("idyMy");
var $8hTqU = parcelRequire("8hTqU");
const $9901326496384064$var$KEY = 'people-menu';
const $9901326496384064$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $idyMy.usePeopleAndTeamsConfigurationContext)();
    return configuration[$9901326496384064$var$KEY];
};
const $9901326496384064$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $8hTqU.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $9901326496384064$var$KEY);

});
parcelRegister("8hTqU", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $608ae91cf5e3d925$export$aead0eac38c797a5);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $idyMy = parcelRequire("idyMy");
function $608ae91cf5e3d925$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $608ae91cf5e3d925$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $idyMy.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$608ae91cf5e3d925$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
            remoteConfig: keyedConfig
        }, props));
    };

});


parcelRegister("43nnt", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $2f399387ef86931a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $2f399387ef86931a$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $2f399387ef86931a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $2f399387ef86931a$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $2f399387ef86931a$export$91c413c8a5c77e19);
const $2f399387ef86931a$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $2f399387ef86931a$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $2f399387ef86931a$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $2f399387ef86931a$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($2f399387ef86931a$var$ANALYTICS_CHANNEL);
        });
    };
const $2f399387ef86931a$export$a1fb57756f0de62b = $2f399387ef86931a$var$fireEvent('operational');
const $2f399387ef86931a$export$59608e0169622110 = $2f399387ef86931a$var$fireEvent('screen');
const $2f399387ef86931a$export$574d2f19a52d67ca = $2f399387ef86931a$var$fireEvent('track');
const $2f399387ef86931a$export$7eca133280843f9e = $2f399387ef86931a$var$fireEvent('ui');
const $2f399387ef86931a$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("4o61W", function(module, exports) {

$parcel$export(module.exports, "LazyIntlProvider", () => $331e14d37d10294b$export$b4f1ecc6daf5eb10);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");
const $331e14d37d10294b$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $331e14d37d10294b$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $331e14d37d10294b$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $331e14d37d10294b$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $331e14d37d10294b$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale } = (0, $5JgJ2.default)();
    const { messages: messages } = $331e14d37d10294b$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), (0, $kU09D.default)({}, rest, {
        messages: messages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }), children);
};

});

parcelRegister("hNYCh", function(module, exports) {

$parcel$export(module.exports, "constructProductOriginParams", () => $cf66086a14e9611b$export$d479c7e8f449d360);
$parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", () => $cf66086a14e9611b$export$873f5b458fb2c7bd);
$parcel$export(module.exports, "getPeopleProfilePage", () => $cf66086a14e9611b$export$8d1c08ae3a193cc5);
$parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", () => $cf66086a14e9611b$export$143be302a1686103);
$parcel$export(module.exports, "trimLastForwardSlash", () => $cf66086a14e9611b$export$41ba1f3da3359c4);
function $cf66086a14e9611b$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $cf66086a14e9611b$export$d479c7e8f449d360(originQuery) {
    var _originQuery$product;
    return $cf66086a14e9611b$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': ((_originQuery$product = originQuery.product) === null || _originQuery$product === void 0 ? void 0 : _originQuery$product.toUpperCase()) || ''
    });
}
function $cf66086a14e9611b$export$575daf737e125483(remoteConfigResources) {
    return (remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.baseUrl) || '';
}
function $cf66086a14e9611b$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$cf66086a14e9611b$export$575daf737e125483(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleDirectoryHome) || '').replace(':orgId', orgId !== null && orgId !== void 0 ? orgId : '')}${$cf66086a14e9611b$var$toStrParams(params)}`;
}
function $cf66086a14e9611b$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$cf66086a14e9611b$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleDirectoryHome) || ''}${$cf66086a14e9611b$var$toStrParams(params)}`;
}
function $cf66086a14e9611b$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$cf66086a14e9611b$export$575daf737e125483(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleProfile) || '').replace(':userId', userId)}${$cf66086a14e9611b$var$toStrParams(params)}`;
}
function $cf66086a14e9611b$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$cf66086a14e9611b$export$575daf737e125483(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.teamProfile) || '').replace(':teamId', teamId).replace(':orgId', orgId !== null && orgId !== void 0 ? orgId : '')}${$cf66086a14e9611b$var$toStrParams(params)}`;
}
function $cf66086a14e9611b$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$cf66086a14e9611b$export$575daf737e125483(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.teamProfile) || '').replace(':teamId', teamId)}${$cf66086a14e9611b$var$toStrParams(params)}`;
}
function $cf66086a14e9611b$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}

});

parcelRegister("ewm1U", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $a925247ddc173c7e$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $a925247ddc173c7e$export$c776284ef4b1209a);
const $a925247ddc173c7e$export$83179404a61b001a = 'FetchError';
function $a925247ddc173c7e$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $a925247ddc173c7e$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $a925247ddc173c7e$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        var _headers;
        if (response.ok) return response.json();
        const traceId = (response === null || response === void 0 ? void 0 : (_headers = response.headers) === null || _headers === void 0 ? void 0 : _headers.get('atl-traceid')) || undefined;
        throw $a925247ddc173c7e$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $a925247ddc173c7e$export$c776284ef4b1209a = (url, data, headers)=>$a925247ddc173c7e$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });

});

parcelRegister("kWzlf", function(module, exports) {

$parcel$export(module.exports, "searchTeamsOfUser", () => $f3f4a38ec07d4850$export$c52386bca71fd065);
$parcel$export(module.exports, "postCreateTeam", () => $f3f4a38ec07d4850$export$db3c0c162386baf4);

var $4ECFx = parcelRequire("4ECFx");

var $hNYCh = parcelRequire("hNYCh");

var $ulzhA = parcelRequire("ulzhA");

var $5ZVKY = parcelRequire("5ZVKY");

var $ewm1U = parcelRequire("ewm1U");
const $f3f4a38ec07d4850$var$LIMIT_RESULTS = 5;
const $f3f4a38ec07d4850$export$51eb1e4b266d279a = '/gateway/api';
const $f3f4a38ec07d4850$export$a6635dd972d6facf = `${$f3f4a38ec07d4850$export$51eb1e4b266d279a}/v3/teams`;
const $f3f4a38ec07d4850$export$8ebb304bc6fdbba2 = `${$f3f4a38ec07d4850$export$51eb1e4b266d279a}/v4/teams`;
const $f3f4a38ec07d4850$export$d6cee1ef1aa86c6d = `${$f3f4a38ec07d4850$export$a6635dd972d6facf}/of-user`;
const $f3f4a38ec07d4850$export$5c5040d455d75334 = `${$f3f4a38ec07d4850$export$8ebb304bc6fdbba2}/search`;
const $f3f4a38ec07d4850$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$f3f4a38ec07d4850$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId !== null && orgId !== void 0 ? orgId : ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$f3f4a38ec07d4850$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $f3f4a38ec07d4850$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$f3f4a38ec07d4850$export$5c5040d455d75334}${(0, $hNYCh.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $f3f4a38ec07d4850$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $ewm1U.fetchJson)($f3f4a38ec07d4850$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : // If `orgId` is not present, just make this request hang forever as though loading.
    new Promise(()=>{});
const $f3f4a38ec07d4850$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $5ZVKY.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $f3f4a38ec07d4850$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $f3f4a38ec07d4850$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $ewm1U.postJson)(url, postData);
};
const $f3f4a38ec07d4850$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    var _metaData$tenantUrl, _result$memberIds$len, _result$memberIds;
    (0, $4ECFx.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $4ECFx.teamsClient).setBaseUrl(`${(_metaData$tenantUrl = metaData.tenantUrl) !== null && _metaData$tenantUrl !== void 0 ? _metaData$tenantUrl : ''}${$f3f4a38ec07d4850$export$51eb1e4b266d279a}`);
    const result = await (0, $4ECFx.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings === (0, $ulzhA.TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $ulzhA.TeamState).ACTIVE : (0, $ulzhA.TeamState).PURGED,
        membershipSettings: result.membershipSettings === 'OPEN' ? (0, $ulzhA.TeamMembershipSettings).OPEN : (0, $ulzhA.TeamMembershipSettings).INVITE_ONLY,
        memberCount: (_result$memberIds$len = (_result$memberIds = result.memberIds) === null || _result$memberIds === void 0 ? void 0 : _result$memberIds.length) !== null && _result$memberIds$len !== void 0 ? _result$memberIds$len : 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $ulzhA.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $ulzhA.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        permission: result.permission === 'FULL_WRITE' ? (0, $ulzhA.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $ulzhA.TeamPermission).FULL_READ : (0, $ulzhA.TeamPermission).NONE
    };
};
const $f3f4a38ec07d4850$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$f3f4a38ec07d4850$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $hNYCh.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $f3f4a38ec07d4850$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $f3f4a38ec07d4850$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $ewm1U.postJson)(url, postData);
};

});
parcelRegister("4ECFx", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $3638e4b5855e0cde$export$5ed932c3646b89c6);

var $5zQU9 = parcelRequire("5zQU9");

var $2jxmo = parcelRequire("2jxmo");

var $hEG4C = parcelRequire("hEG4C");

var $8tuxY = parcelRequire("8tuxY");

var $2clzq = parcelRequire("2clzq");

var $aKZ7r = parcelRequire("aKZ7r");

var $dIk2P = parcelRequire("dIk2P");

var $4cnCs = parcelRequire("4cnCs");

var $2n7Y6 = parcelRequire("2n7Y6");

var $l3MHp = parcelRequire("l3MHp");

var $atACn = parcelRequire("atACn");
class $3638e4b5855e0cde$export$db59823f35bf78ce {
    constructor(/**
   * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
   */ context){
        (0, $5zQU9.default)(this, "_aggClient", (0, $hEG4C.aggClient));
        (0, $5zQU9.default)(this, "_atlasClient", (0, $8tuxY.atlasClient));
        (0, $5zQU9.default)(this, "_directoryClient", (0, $2clzq.directoryClient));
        (0, $5zQU9.default)(this, "_legionClient", (0, $dIk2P.defaultLegionClient));
        (0, $5zQU9.default)(this, "_mutabilityClient", (0, $4cnCs.default));
        (0, $5zQU9.default)(this, "_permsClient", (0, $2n7Y6.default));
        (0, $5zQU9.default)(this, "_publicApiClient", (0, $l3MHp.default));
        (0, $5zQU9.default)(this, "_invitationsClient", (0, $aKZ7r.default));
        (0, $5zQU9.default)(this, "_userPreferencesClient", (0, $atACn.default));
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $2jxmo.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
   * Sets the base URL to be used in the client requests
   * @param {string} baseUrl - The new base URL
   */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._atlasClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Sets context including CloudId & OrgId to be used for all requests
   */ setContext(context) {
        this._aggClient.setContext(context);
        this._atlasClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
    }
    /**
   * @private
   * @deprecated use setBaseUrl instead
   */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Fetches Browse user settings
   */ async querySettings(...args) {
        return this.measurePerformance('querySettings', ()=>this._directoryClient.querySettings(...args));
    }
    /**
   * Fetches feature flags from Directory
   * @deprecated As part of decommisioning pf-directoy
   */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
   * Fetches team health monitor details for a team from Atlas
   */ async queryTeamHealthMonitors(...args) {
        return this.measurePerformance('queryTeamHealthMonitors', ()=>this._atlasClient.queryTeamHealthMonitors(...args));
    }
    /**
   * Get user information of members of a team, paginated
   * @param {string} teamId
   * @returns {Promise}
   */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
   * Get user information of a member of a team
   * @param {string} userId
   * @returns {Promise<CloudUser>}
   */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
   *
   * @param teamId
   * @returns {Promise<TeamWithImageUrls>}
   */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
   * Search teams based on query
   */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
   * Update team details
   */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
   * @private
   * @deprecated use addUsersToTeam instead
   */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
   * Get the current user's team membership
   */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
   * Get a teams "Links"
   */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
   * Create a team link
   */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
   * Update a team link
   */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
   * Delete a team link
   */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
   * Reorder a team link
   */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
   * @deprecated Invitation status no longer exists
   * Accept a team invitation
   */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
   * @deprecated Invitation status no longer exists
   * Decline a team invitation
   */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
   * Add current user to a team
   */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
   * Cancel a join request to a private team
   */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
   * Accept a join request to a private team
   */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
   * Decline a join request to a private team
   */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
   * @deprecated use removeTeamMemberships instead
   */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
   * Delete a team
   */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
   * Create a team
   */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
   *
   * @param teamId
   * @returns {Promise<SoftDeletedTeam>}
   */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
   * Get user profile with mutability constraints
   */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
   * Is the current user a site admin
   */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
   * Add users to a team
   */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
   * Remove users from a team
   */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
   * Restore a deleted team
   */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
   * Get token to upload media for a team
   */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
   * Get token to read media for a user
   */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
   * Get token to upload media for a user
   */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
   * Update header image for a user
   */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
}
const $3638e4b5855e0cde$export$5ed932c3646b89c6 = new $3638e4b5855e0cde$export$db59823f35bf78ce();

});
parcelRegister("2jxmo", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $1af73bc341cbebc7$export$879344107b04120c);

var $12kyE = parcelRequire("12kyE");

var $jOJCx = parcelRequire("jOJCx");
const $1af73bc341cbebc7$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamHealthMonitors',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam'
];
const $1af73bc341cbebc7$export$879344107b04120c = new Map([
    ...$1af73bc341cbebc7$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $jOJCx.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $12kyE.ExperienceTypes).Operation,
                performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("jOJCx", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $e6d6131fe77ab9d5$export$9a18529d1e90e81a);

var $kDfSL = parcelRequire("kDfSL");

var $64RAW = parcelRequire("64RAW");

var $en1kV = parcelRequire("en1kV");
class $e6d6131fe77ab9d5$export$9a18529d1e90e81a extends (0, $kDfSL.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $en1kV.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $64RAW.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $64RAW.isErrorStatusCode)((0, $64RAW.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $en1kV.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $64RAW.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $en1kV.createErrorMetadata)(error),
                    packageVersion: "2.24.0",
                    packageName: "@atlassian/teams-client"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "2.24.0",
                packageName: "@atlassian/teams-client"
            }
        });
    }
}

});
parcelRegister("64RAW", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $0124556df82503ae$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $0124556df82503ae$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $0124556df82503ae$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $0124556df82503ae$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $0124556df82503ae$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $0124556df82503ae$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $0124556df82503ae$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $0124556df82503ae$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $0124556df82503ae$export$476aa014e2fd89d5);

var $5zQU9 = parcelRequire("5zQU9");
var $0124556df82503ae$var$_class;
let $0124556df82503ae$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
let $0124556df82503ae$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $0124556df82503ae$export$cde1786a482f9a1c(error) {
    return $0124556df82503ae$export$9677d7c364ada66c($0124556df82503ae$export$f66f92b8741acd5b.UNAUTHORIZED, error) || $0124556df82503ae$export$9677d7c364ada66c($0124556df82503ae$export$f66f92b8741acd5b.FORBIDDEN, error);
}
function $0124556df82503ae$export$9677d7c364ada66c(statusCode, error) {
    var _error$message;
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}
function $0124556df82503ae$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
let $0124556df82503ae$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $0124556df82503ae$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $0124556df82503ae$export$c73ca302efeda3b4 extends $0124556df82503ae$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $0124556df82503ae$export$c73ca302efeda3b4.prototype);
    }
}
class $0124556df82503ae$export$d87f401f8106d7a2 extends $0124556df82503ae$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $0124556df82503ae$export$d87f401f8106d7a2.prototype);
    }
}
class $0124556df82503ae$export$65bd6083489bd8bb extends $0124556df82503ae$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $0124556df82503ae$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $0124556df82503ae$export$826a3d65b8435adf extends $0124556df82503ae$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $0124556df82503ae$export$826a3d65b8435adf.prototype);
    }
}
class $0124556df82503ae$export$92d6ed0888e7cb7f extends $0124556df82503ae$var$CommonError {
    // tslint:disable-line no-any
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $0124556df82503ae$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$0124556df82503ae$var$_class = $0124556df82503ae$export$92d6ed0888e7cb7f;
(0, $5zQU9.default)($0124556df82503ae$export$92d6ed0888e7cb7f, "from", (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $0124556df82503ae$var$_class(errorData);
});
function $0124556df82503ae$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("en1kV", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $a764400fb643b18e$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $a764400fb643b18e$export$a8da197a8bcc7e95);

var $64RAW = parcelRequire("64RAW");
const $a764400fb643b18e$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $64RAW.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $64RAW.HttpError) ? error.status : undefined
        }
    });
const $a764400fb643b18e$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $a764400fb643b18e$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error === null || error === void 0 ? void 0 : error.constructor.name;
    if (!errorName) return false;
    return $a764400fb643b18e$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("hEG4C", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $cda6cf03b79e1a73$export$464c991dbf0b2393);

var $ghqky = parcelRequire("ghqky");

var $1gWjz = parcelRequire("1gWjz");

var $kGrnS = parcelRequire("kGrnS");

var $8gATS = parcelRequire("8gATS");

var $brcsi = parcelRequire("brcsi");
class $cda6cf03b79e1a73$export$b44e5dafe13af7b3 extends (0, $kGrnS.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $brcsi.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>{
                var _node$member$extended, _node$member$extended2;
                return {
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $ghqky.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $ghqky.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: (_node$member$extended = (_node$member$extended2 = node.member.extendedProfile) === null || _node$member$extended2 === void 0 ? void 0 : _node$member$extended2.jobTitle) !== null && _node$member$extended !== void 0 ? _node$member$extended : undefined
                    }
                };
            }),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
}
const $cda6cf03b79e1a73$export$464c991dbf0b2393 = new $cda6cf03b79e1a73$export$b44e5dafe13af7b3((0, $1gWjz.DEFAULT_CONFIG).stargateRoot, {
    logException: $8gATS.logException
});

});
parcelRegister("ghqky", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $bda2a88b77834632$export$1d0eef1d33b05366);

const $bda2a88b77834632$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $d88aa0927ed9c9ef$export$470b0d72e4fdc43a));
const $bda2a88b77834632$export$1d0eef1d33b05366 = (ari)=>{
    if ($bda2a88b77834632$export$caac29844ad91f64(ari)) return ari.replace((0, $d88aa0927ed9c9ef$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $bda2a88b77834632$export$fca6a88adb58674a = (userId)=>{
    return $bda2a88b77834632$export$caac29844ad91f64(userId) ? userId : `${0, $d88aa0927ed9c9ef$export$470b0d72e4fdc43a}${userId}`;
};
const $bda2a88b77834632$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $d88aa0927ed9c9ef$export$cfedc369802e0c68));
const $bda2a88b77834632$export$e78216c959b9f3af = (ari)=>{
    if ($bda2a88b77834632$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $d88aa0927ed9c9ef$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $bda2a88b77834632$export$2bcc6e4924859c6f = (teamId)=>{
    return $bda2a88b77834632$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $d88aa0927ed9c9ef$export$cfedc369802e0c68}${teamId}`;
};

});
const $d88aa0927ed9c9ef$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d88aa0927ed9c9ef$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("1gWjz", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $0ed48523d73dd56e$export$c2f8e0cc249a8d8f);
const $0ed48523d73dd56e$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations'
};

});

parcelRegister("kGrnS", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $f0ecf8ce11ff5e68$export$42f6d6baced34b2d);

var $64RAW = parcelRequire("64RAW");

var $3JjfI = parcelRequire("3JjfI");

var $ic74T = parcelRequire("ic74T");
class $f0ecf8ce11ff5e68$export$42f6d6baced34b2d extends (0, $3JjfI.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $ic74T.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $64RAW.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $64RAW.DefaultError)({});
        }
    }
}

});
parcelRegister("3JjfI", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $2b74823271a1b73d$export$4f22f74eddb7716a);

var $5zQU9 = parcelRequire("5zQU9");

var $8gATS = parcelRequire("8gATS");
class $2b74823271a1b73d$export$4f22f74eddb7716a {
    constructor(config){
        (0, $5zQU9.default)(this, "logException", (ex, name, context)=>{
            (0, $8gATS.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        });
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
}

});
parcelRegister("8gATS", function(module, exports) {

$parcel$export(module.exports, "logException", () => $604c70ff271383d5$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $604c70ff271383d5$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $604c70ff271383d5$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $604c70ff271383d5$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $604c70ff271383d5$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $604c70ff271383d5$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $604c70ff271383d5$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $604c70ff271383d5$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript
// eslint-disable-next-line import/no-extraneous-dependencies

var $5uW8f = parcelRequire("5uW8f");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $604c70ff271383d5$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $604c70ff271383d5$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $5uW8f.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            var _context$packageName, _context$packageVersi;
            $604c70ff271383d5$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', (_context$packageName = context.packageName) !== null && _context$packageName !== void 0 ? _context$packageName : 'unknown');
            scope.setTag('packageVersion', (_context$packageVersi = context.packageVersion) !== null && _context$packageVersi !== void 0 ? _context$packageVersi : 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $604c70ff271383d5$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $5uW8f.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        var _context$packageName2, _context$packageVersi2;
        $604c70ff271383d5$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', (_context$packageName2 = context.packageName) !== null && _context$packageName2 !== void 0 ? _context$packageName2 : 'unknown');
        scope.setTag('packageVersion', (_context$packageVersi2 = context.packageVersion) !== null && _context$packageVersi2 !== void 0 ? _context$packageVersi2 : 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $604c70ff271383d5$export$ece28f5cfa04608(message, context = {}) {
    $604c70ff271383d5$var$logMessage('error', message, context).catch(()=>{});
}
function $604c70ff271383d5$export$386587bcf05ee8ea(message, context = {}) {
    $604c70ff271383d5$var$logMessage('info', message, context).catch(()=>{});
}
const $604c70ff271383d5$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $604c70ff271383d5$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $604c70ff271383d5$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $604c70ff271383d5$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $604c70ff271383d5$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $604c70ff271383d5$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $604c70ff271383d5$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $604c70ff271383d5$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $604c70ff271383d5$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$604c70ff271383d5$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $604c70ff271383d5$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $5uW8f.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("5uW8f", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $400cd8e4ce4f2977$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $400cd8e4ce4f2977$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $400cd8e4ce4f2977$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $400cd8e4ce4f2977$export$d8bd0edf6c978788);

var $finb5 = parcelRequire("finb5");

var $bOYrL = parcelRequire("bOYrL");
let $400cd8e4ce4f2977$export$ac71c212168fcd2b;
const $400cd8e4ce4f2977$export$7d446c6f4e54de82 = (client)=>{
    $400cd8e4ce4f2977$export$ac71c212168fcd2b = client;
};
const $400cd8e4ce4f2977$export$f553e8b08ef59d31 = async ()=>{
    if (!$400cd8e4ce4f2977$export$ac71c212168fcd2b) await $400cd8e4ce4f2977$export$d8bd0edf6c978788({});
    return $400cd8e4ce4f2977$export$ac71c212168fcd2b;
};
async function $400cd8e4ce4f2977$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    var _window$__buildInfo;
    const sentryClient = await $400cd8e4ce4f2977$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $bOYrL.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || ((_window$__buildInfo = window.__buildInfo) === null || _window$__buildInfo === void 0 ? void 0 : _window$__buildInfo.FRONTEND_VERSION) || 'unknown',
                product: $400cd8e4ce4f2977$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $finb5.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $400cd8e4ce4f2977$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("b6qtF"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $400cd8e4ce4f2977$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("finb5", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $b22a841bfbdaf787$export$6faa4a850bc4d0ce);

var $dfBCt = parcelRequire("dfBCt");
const $b22a841bfbdaf787$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $b22a841bfbdaf787$export$68c35ed3898e185a = '5988845';
const $b22a841bfbdaf787$var$SENTRY_COMMERCIAL_DSN = `https://${$b22a841bfbdaf787$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$b22a841bfbdaf787$export$68c35ed3898e185a}`;
const $b22a841bfbdaf787$var$SENTRY_FEDRAMP_DSN = `https://${$b22a841bfbdaf787$export$9cf97fd92bea5d81}@sentry.atlassian-us-gov-mod.com/${$b22a841bfbdaf787$export$68c35ed3898e185a}`;
const $b22a841bfbdaf787$export$6faa4a850bc4d0ce = (0, $dfBCt.isFedRamp)() ? $b22a841bfbdaf787$var$SENTRY_FEDRAMP_DSN : $b22a841bfbdaf787$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("bOYrL", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $89b340b32b8dca63$export$357606956af25316);

var $8RmPJ = parcelRequire("8RmPJ");

var $5uW8f = parcelRequire("5uW8f");
const $89b340b32b8dca63$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $89b340b32b8dca63$export$357606956af25316(client, options) {
    if (0, $5uW8f.sentryClient) return;
    if (!client) return;
    (0, $5uW8f.setSentryClient)(client);
    const sentryConfig = (0, $8RmPJ.getSentryConfig)(options);
    (0, $5uW8f.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $89b340b32b8dca63$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("8RmPJ", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $6734fc330263e950$export$5580e6304e95c792);

var $finb5 = parcelRequire("finb5");
const $6734fc330263e950$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.'
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $finb5.SENTRY_DSN),
    attachStacktrace: true
};
function $6734fc330263e950$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$6734fc330263e950$var$DEFAULT_SENTRY_CONFIG,
        // __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"@atlassian/teams-client"}@${"2.24.0"}` || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("b6qtF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hJuQR');
        const value = parcelRequire('5ZfYW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hJuQR").then(()=>parcelRequire('5ZfYW'));
}

});




parcelRegister("ic74T", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $d3eed68284447b34$export$7feffc86760ee7ce);

var $64RAW = parcelRequire("64RAW");

var $fRKnP = parcelRequire("fRKnP");

var $dj1F1 = parcelRequire("dj1F1");
async function $d3eed68284447b34$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $64RAW.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $64RAW.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $d3eed68284447b34$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $fRKnP.withExponentialBackoff)($d3eed68284447b34$export$93d33e3b46bf00e7, {
        initial: (0, $fRKnP.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $fRKnP.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $fRKnP.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $fRKnP.isFetchResponse)(data) && (0, $fRKnP.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result === null || result === void 0 ? void 0 : result.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $dj1F1.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $64RAW.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId !== null && traceId !== void 0 ? traceId : undefined
        });
    }
    return result;
}

});
parcelRegister("fRKnP", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $b8cfc90965ff0bcd$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $b8cfc90965ff0bcd$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $b8cfc90965ff0bcd$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $b8cfc90965ff0bcd$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $b8cfc90965ff0bcd$export$b4c0bf5325504bf3);
const $b8cfc90965ff0bcd$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $b8cfc90965ff0bcd$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $b8cfc90965ff0bcd$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
// tslint:disable-next-line no-any
const $b8cfc90965ff0bcd$var$defaultRetryIfCallback = (a)=>!a;
const $b8cfc90965ff0bcd$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $b8cfc90965ff0bcd$var$defaultRetryIfCallback
};
function $b8cfc90965ff0bcd$export$20eaa22f2295996f(toTry, hofOptions = $b8cfc90965ff0bcd$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
   * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
   * The functioned-to-be-retried is called on each recursion.
   */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $b8cfc90965ff0bcd$export$b4c0bf5325504bf3 = $b8cfc90965ff0bcd$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $b8cfc90965ff0bcd$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $b8cfc90965ff0bcd$export$8f4286bf21155381.JITTER,
    max: $b8cfc90965ff0bcd$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$b8cfc90965ff0bcd$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("dj1F1", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $9afe5679a2fd31e5$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $9afe5679a2fd31e5$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $9afe5679a2fd31e5$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $9afe5679a2fd31e5$export$8c005e458e12d501.handlers = handlers;
    }
};
function $9afe5679a2fd31e5$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $9afe5679a2fd31e5$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("brcsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $853be0b7969fcbea$export$2e2bcd8739ae039);
var $853be0b7969fcbea$export$2e2bcd8739ae039 = `query TeamMembership($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;

});


parcelRegister("8tuxY", function(module, exports) {

$parcel$export(module.exports, "atlasClient", () => $62b8ba2984067406$export$f355c2c282c063e9);

var $04x4D = parcelRequire("04x4D");

var $1gWjz = parcelRequire("1gWjz");

var $kGrnS = parcelRequire("kGrnS");

var $8gATS = parcelRequire("8gATS");
const $62b8ba2984067406$var$buildTeamHealthQuery = (teamId, cloudId)=>({
        query: `query TeamHealthMonitors($teamId: String!, $cloudId: String) {
    TeamHealthMonitors: teamHealthMonitorsByTeamId(teamId: $teamId, sort: CREATION_DATE_DESC, first: 5) {
      edges {
        node {
          creationDate
          isComplete(cloudId: $cloudId)
          uuid
          teamHealthMonitorResults(cloudId: $cloudId) {
            rating
          }
        }
      }
    }
  }`,
        variables: {
            teamId: teamId,
            cloudId: cloudId
        }
    });
const $62b8ba2984067406$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $62b8ba2984067406$export$a43522412b2aa24c extends (0, $kGrnS.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/watermelon/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/watermelon/graphql`);
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Gets team health monitor data
   * @param {string} teamId
   * @returns {Promise}
   * @private
   */ queryTeamHealthMonitors(teamId) {
        const teamHealthQuery = $62b8ba2984067406$var$buildTeamHealthQuery(teamId, this.getContext().cloudId);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                var _data$TeamHealthMonit, _data$TeamHealthMonit2;
                const data = await this.makeGraphQLRequest(teamHealthQuery, {
                    operationName: 'TeamHealthMonitors'
                });
                return (_data$TeamHealthMonit = (_data$TeamHealthMonit2 = data.TeamHealthMonitors.edges) === null || _data$TeamHealthMonit2 === void 0 ? void 0 : _data$TeamHealthMonit2.map((edge)=>{
                    var _node$teamHealthMonit, _node$teamHealthMonit2, _node$teamHealthMonit3, _node$teamHealthMonit4, _node$teamHealthMonit5, _node$teamHealthMonit6;
                    const node = edge === null || edge === void 0 ? void 0 : edge.node;
                    if (!node || !node.uuid || !node.creationDate) return null;
                    return {
                        date: node.creationDate,
                        uuid: node.uuid,
                        greenCount: (_node$teamHealthMonit = (_node$teamHealthMonit2 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit2 === void 0 ? void 0 : _node$teamHealthMonit2.filter((result)=>result.rating === 'GREEN').length) !== null && _node$teamHealthMonit !== void 0 ? _node$teamHealthMonit : 0,
                        yellowCount: (_node$teamHealthMonit3 = (_node$teamHealthMonit4 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit4 === void 0 ? void 0 : _node$teamHealthMonit4.filter((result)=>result.rating === 'YELLOW').length) !== null && _node$teamHealthMonit3 !== void 0 ? _node$teamHealthMonit3 : 0,
                        redCount: (_node$teamHealthMonit5 = (_node$teamHealthMonit6 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit6 === void 0 ? void 0 : _node$teamHealthMonit6.filter((result)=>result.rating === 'RED').length) !== null && _node$teamHealthMonit5 !== void 0 ? _node$teamHealthMonit5 : 0
                    };
                }).filter((0, $04x4D.filterNull))) !== null && _data$TeamHealthMonit !== void 0 ? _data$TeamHealthMonit : [];
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $62b8ba2984067406$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $62b8ba2984067406$export$f355c2c282c063e9 = new $62b8ba2984067406$export$a43522412b2aa24c((0, $1gWjz.DEFAULT_CONFIG).stargateRoot, {
    logException: $8gATS.logException
});

});
parcelRegister("04x4D", function(module, exports) {

$parcel$export(module.exports, "filterNull", () => $00da0795ddf602a1$export$f340908427d1f469);
function $00da0795ddf602a1$export$f340908427d1f469(x) {
    return !!x;
}

});


parcelRegister("2clzq", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $199d6f2b994a79da$export$ead519165de472de);

var $1gWjz = parcelRequire("1gWjz");

var $kGrnS = parcelRequire("kGrnS");

var $8gATS = parcelRequire("8gATS");
const $199d6f2b994a79da$export$28456d095a642fd = 'internal.browse-users-allowed';
const $199d6f2b994a79da$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
/**
 * @type CloudUser
 * @property {string} avatarUrl
 * @property {string} id
 * @property {string} fullName
 * @property {string} title
 */ const $199d6f2b994a79da$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $199d6f2b994a79da$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $199d6f2b994a79da$export$c8a50bf6c196fc10 extends (0, $kGrnS.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async querySettings(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, // only Embeddable Directory care about value of product.
    product) {
        const settingsQuery = {
            query: `query Settings($cloudId: String!, $product: Product) {
        Settings: PeopleDirectorySettings(cloudId: $cloudId, product: $product) {
          isEnabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                product: product
            }
        };
        const response = await this.makeGraphQLRequest(settingsQuery, {
            operationName: 'Settings'
        });
        const searchEnabled = response.Settings && response.Settings.isEnabled;
        return {
            [$199d6f2b994a79da$export$28456d095a642fd]: searchEnabled
        };
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $199d6f2b994a79da$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $199d6f2b994a79da$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $199d6f2b994a79da$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $199d6f2b994a79da$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $199d6f2b994a79da$export$ead519165de472de = new $199d6f2b994a79da$export$c8a50bf6c196fc10((0, $1gWjz.DEFAULT_CONFIG).stargateRoot, {
    logException: $8gATS.logException
});

});

parcelRegister("aKZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4d9c3d77399aa2$export$2e2bcd8739ae039);

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");

var $8gATS = parcelRequire("8gATS");

var $eUjeh = parcelRequire("eUjeh");
const $7d4d9c3d77399aa2$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $7d4d9c3d77399aa2$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $7d4d9c3d77399aa2$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $7d4d9c3d77399aa2$export$3209eb31343f39d extends (0, $8WDE7.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $7d4d9c3d77399aa2$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $7d4d9c3d77399aa2$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$7d4d9c3d77399aa2$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $7d4d9c3d77399aa2$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $eUjeh.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($7d4d9c3d77399aa2$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$7d4d9c3d77399aa2$export$2e2bcd8739ae039 = new $7d4d9c3d77399aa2$export$3209eb31343f39d((0, $1gWjz.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $8gATS.logException
});

});
parcelRegister("8WDE7", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $68327e67776ed83b$export$ea8b5b3aea9558ce);

var $5zQU9 = parcelRequire("5zQU9");

var $6l6Xk = parcelRequire("6l6Xk");

var $64RAW = parcelRequire("64RAW");

var $fRKnP = parcelRequire("fRKnP");

var $dj1F1 = parcelRequire("dj1F1");

var $3JjfI = parcelRequire("3JjfI");

var $4Zian = parcelRequire("4Zian");

var $gxHEt = parcelRequire("gxHEt");

var $6MjiS = parcelRequire("6MjiS");

var $8f1JF = parcelRequire("8f1JF");
const $68327e67776ed83b$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $68327e67776ed83b$var$incrementRedirectCount;
let $68327e67776ed83b$var$clearRedirectCount;
$68327e67776ed83b$export$7a0fc52d8c359feb();
function $68327e67776ed83b$export$7a0fc52d8c359feb() {
    $68327e67776ed83b$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $4Zian.setCookie)((0, $4Zian.REDIRECT_COUNT), (0, $4Zian.getCookieAsInteger)((0, $4Zian.REDIRECT_COUNT)) + 1));
    $68327e67776ed83b$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $4Zian.clearCookie)((0, $4Zian.REDIRECT_COUNT)));
}
class $68327e67776ed83b$export$ea8b5b3aea9558ce extends (0, $3JjfI.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config);
        /**
     * This function is necessary for if `statusCodeHandler` prescribes a login
     * redirect upon a 401 response.
     * While the default redirect behaviour may be overriden, this function has
     * been kept separate to ensure it cannot be overriden, lest a host
     * application supply embeddable-directory with a custom handler that suffers
     * the infinite redirect bug.
     */ (0, $5zQU9.default)(this, "preventInfiniteRedirectLoop", (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $68327e67776ed83b$var$incrementRedirectCount();
            } else $68327e67776ed83b$var$clearRedirectCount();
        });
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$68327e67776ed83b$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $fRKnP.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $dj1F1.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $64RAW.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $gxHEt.parseErrorMessage)(response);
                const httpError = new (0, $64RAW.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId !== null && traceId !== void 0 ? traceId : undefined
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $8f1JF.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $6MjiS.parseResponse)(response);
    }
}

});
parcelRegister("4Zian", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $3a1af36087805922$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $3a1af36087805922$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $3a1af36087805922$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $3a1af36087805922$export$ad3506281d5a5e5d);
const $3a1af36087805922$export$f6101897f0230549 = 'redirectCount';
const $3a1af36087805922$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $3a1af36087805922$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $3a1af36087805922$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $3a1af36087805922$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("gxHEt", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $c0b196c3f3cd0371$export$91c32f1b22d29b2d);
async function $c0b196c3f3cd0371$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("6MjiS", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $4ef633084be4b717$export$ba14d9a5a581e827);
function $4ef633084be4b717$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("8f1JF", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $6001121b57783403$export$6bd073e2c6dda996);
const $6001121b57783403$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $6001121b57783403$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($6001121b57783403$var$UUID_REGEX, '<UUID>');
};

});


parcelRegister("eUjeh", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $ada53635dfa3d75c$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $ada53635dfa3d75c$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $ada53635dfa3d75c$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $ada53635dfa3d75c$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($ada53635dfa3d75c$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($ada53635dfa3d75c$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($ada53635dfa3d75c$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($ada53635dfa3d75c$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $ada53635dfa3d75c$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $ada53635dfa3d75c$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $ada53635dfa3d75c$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($ada53635dfa3d75c$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($ada53635dfa3d75c$var$toRecommendation)
        }
    };
};

});


parcelRegister("dIk2P", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $9fbeeedf54c6c208$export$95c697fe95d86a77);

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");
/**
 * @type AllTeamsQuery
 * Query type for the getAllTeams API
 * @property {string} orgId - Organization ID
 * @property {string} cursor - Cursor to fetch the next page of results
 * @property {number} limit - Number of teams to fetch
 * @property {string} searchQuery - Search query to filter teams
 * @property {string[]} memberAccountIds - List of member account IDs to filter teams
 * @property {boolean} useDefaultSort - Whether to use the default sort order
 */ /**
 * @type AllTeamsResponse
 * Response type for the getAllTeams API
 * @property {TeamWithMemberships[]} teams - List of teams
 * @property {string} cursor - Cursor to fetch the next page of results
 * @property {Error} error - Error object if the API call fails
 */ /**
 * @type AllTeamsPayload
 * Payload type for the getAllTeams API
 * @property {TeamWithMemberships[]} entities - List of teams
 * @property {string} cursor - Cursor to fetch the next page of results
 */ const $9fbeeedf54c6c208$var$v3UrlPath = `/v3/teams`;
const $9fbeeedf54c6c208$var$v4UrlPath = `/v4/teams`;
class $9fbeeedf54c6c208$export$68a6a391e3cf23be extends (0, $8WDE7.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                }
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
   * @private
   * @deprecated use publicApiClient.addUsersToTeam instead
   */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$9fbeeedf54c6c208$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$9fbeeedf54c6c208$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$9fbeeedf54c6c208$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
   * @private
   * @deprecated use publicApiClient.removeTeamMemberships instead
   */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$9fbeeedf54c6c208$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
   * @private
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$9fbeeedf54c6c208$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$9fbeeedf54c6c208$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>{
            var _response$baseUrl;
            return {
                ...response,
                baseUrl: (_response$baseUrl = response.baseUrl) !== null && _response$baseUrl !== void 0 && _response$baseUrl.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            };
        });
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$9fbeeedf54c6c208$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        var _teamResponse$members, _teamResponse$members2;
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: ((_teamResponse$members = teamResponse.membership) === null || _teamResponse$members === void 0 ? void 0 : (_teamResponse$members2 = _teamResponse$members.members) === null || _teamResponse$members2 === void 0 ? void 0 : _teamResponse$members2.map((m)=>m.membershipId.memberId)) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            // Team Search API does not return members
            members: [],
            // Team Search API does not return members
            membership: {
                members: [],
                errors: []
            }
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $9fbeeedf54c6c208$export$95c697fe95d86a77 = new $9fbeeedf54c6c208$export$68a6a391e3cf23be((0, $1gWjz.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("4cnCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ea9ab0ee7776dd$export$2e2bcd8739ae039);

var $64RAW = parcelRequire("64RAW");

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");
const $30ea9ab0ee7776dd$var$defaultConfig = {
    serviceUrl: `${(0, $1gWjz.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $30ea9ab0ee7776dd$var$NOT_EDITABLE = 'not_editable';
const $30ea9ab0ee7776dd$var$NOT_EDITABLE_FIELD = 'field';
const $30ea9ab0ee7776dd$var$NOT_EDITABLE_REASON = 'reason';
class $30ea9ab0ee7776dd$export$1f387592ab3ca6d0 extends (0, $8WDE7.RestClient) {
    constructor(config = {}){
        super({
            ...$30ea9ab0ee7776dd$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $30ea9ab0ee7776dd$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $30ea9ab0ee7776dd$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$30ea9ab0ee7776dd$var$NOT_EDITABLE] != null) for (const value of json[$30ea9ab0ee7776dd$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$30ea9ab0ee7776dd$var$NOT_EDITABLE_FIELD],
        reason: $30ea9ab0ee7776dd$var$determineReason(value[$30ea9ab0ee7776dd$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $30ea9ab0ee7776dd$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $64RAW.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$30ea9ab0ee7776dd$export$2e2bcd8739ae039 = new $30ea9ab0ee7776dd$export$1f387592ab3ca6d0();

});

parcelRegister("2n7Y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba3e91c51b155ca$export$2e2bcd8739ae039);

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");
class $1ba3e91c51b155ca$export$23820d8d740dd467 extends (0, $8WDE7.RestClient) {
    getIsSiteAdmin(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$1ba3e91c51b155ca$export$2e2bcd8739ae039 = new $1ba3e91c51b155ca$export$23820d8d740dd467({
    serviceUrl: (0, $1gWjz.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("l3MHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54fa76d5a2ca752$export$2e2bcd8739ae039);

var $64RAW = parcelRequire("64RAW");

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");
/**
 * @deprecated migrate to generated types
 */ /**
 * @deprecated migrate to generated types
 */ /**
 * @deprecated migrate to generated types
 */ const $f54fa76d5a2ca752$var$V1_URL = '/teams/v1';
const $f54fa76d5a2ca752$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $f54fa76d5a2ca752$export$38575d07403d67c extends (0, $8WDE7.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$f54fa76d5a2ca752$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $64RAW.HttpError) && $f54fa76d5a2ca752$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $64RAW.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$f54fa76d5a2ca752$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$f54fa76d5a2ca752$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$f54fa76d5a2ca752$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$f54fa76d5a2ca752$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$f54fa76d5a2ca752$export$2e2bcd8739ae039 = new $f54fa76d5a2ca752$export$38575d07403d67c((0, $1gWjz.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("atACn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a09045e3a7bf7ce$export$2e2bcd8739ae039);

var $1gWjz = parcelRequire("1gWjz");

var $8WDE7 = parcelRequire("8WDE7");
const $7a09045e3a7bf7ce$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $7a09045e3a7bf7ce$export$3c27e20d1b94924 extends (0, $8WDE7.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($7a09045e3a7bf7ce$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $7a09045e3a7bf7ce$export$2e2bcd8739ae039 = new $7a09045e3a7bf7ce$export$3c27e20d1b94924({
    serviceUrl: (0, $1gWjz.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("ulzhA", function(module, exports) {

$parcel$export(module.exports, "TeamState", () => $05b3886d64800766$export$c5c56131401e0716);
$parcel$export(module.exports, "TeamMembershipSettings", () => $05b3886d64800766$export$93b1c6cf9d16dce6);
$parcel$export(module.exports, "TeamDiscoverability", () => $05b3886d64800766$export$c698762b98da6685);
$parcel$export(module.exports, "TeamRestriction", () => $05b3886d64800766$export$e94592bde85a4d74);
$parcel$export(module.exports, "TeamPermission", () => $05b3886d64800766$export$4db108522156032a);
// raw data is returned from Legion API
let $05b3886d64800766$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
let $05b3886d64800766$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    return TeamMembershipSettings;
}({});
let $05b3886d64800766$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
let $05b3886d64800766$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
let $05b3886d64800766$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({}); // Note: Should never see this, as UI should get a 404 instead. Included for completeness.
 // a data returned by creating a new team endpoint
 // a data returned by inviting team member

});


parcelRegister("3uF31", function(module, exports) {

$parcel$export(module.exports, "trimTeamAriInObject", () => $28b403a5f5410eeb$export$c75c12ecb0b3724e);
$parcel$export(module.exports, "transformTeams", () => $28b403a5f5410eeb$export$fd398a52d6f57b46);
function $28b403a5f5410eeb$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $28b403a5f5410eeb$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($28b403a5f5410eeb$export$c75c12ecb0b3724e);
};

});

parcelRegister("5PxOI", function(module, exports) {

$parcel$export(module.exports, "useService", () => $43ebf283b4992b48$export$6de4685a6c88b4e9);

var $eUqFw = parcelRequire("eUqFw");
const $43ebf283b4992b48$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $eUqFw.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $eUqFw.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});

parcelRegister("blZ8J", function(module, exports) {

$parcel$export(module.exports, "useSubscribeAll", () => $844114f3654a6c22$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $844114f3654a6c22$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $844114f3654a6c22$export$60959659b2c22881);

var $eUqFw = parcelRequire("eUqFw");
const $844114f3654a6c22$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        var _subscribedEvents$top;
        const events = (_subscribedEvents$top = subscribedEvents[topic]) !== null && _subscribedEvents$top !== void 0 ? _subscribedEvents$top : [];
        const subId = events.length.toString();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish
    };
};
const $844114f3654a6c22$var$pubSub = $844114f3654a6c22$var$createPubSub();
const $844114f3654a6c22$var$usePubSub = ()=>{
    return $844114f3654a6c22$var$pubSub;
};
const $844114f3654a6c22$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $844114f3654a6c22$var$usePubSub();
    const callbackRef = (0, $eUqFw.useRef)(callback);
    callbackRef.current = callback;
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $844114f3654a6c22$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $844114f3654a6c22$var$usePubSub();
    const callbackRef = (0, $eUqFw.useRef)(callback);
    callbackRef.current = callback;
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $844114f3654a6c22$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $844114f3654a6c22$var$usePubSub();
    const publishFn = (0, $eUqFw.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $844114f3654a6c22$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent })=>{
    $844114f3654a6c22$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    return null;
};

});

parcelRegister("3ULZw", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $2d9bd420367c2b33$export$38f9b635c1c454e7);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $2d9bd420367c2b33$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fill: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));
const $2d9bd420367c2b33$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), (0, $kU09D.default)({}, props, {
        glyph: $2d9bd420367c2b33$var$CustomGlyph,
        label: ""
    }));

});

parcelRegister("7aUAL", function(module, exports) {

$parcel$export(module.exports, "Flex", () => $1804dc13c9bcfc5f$export$f51f4c4ede09e011);

var $joBf7 = parcelRequire("joBf7");

var $lcnyw = parcelRequire("lcnyw");
const $1804dc13c9bcfc5f$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e18obzhx0"
})("display:flex;flex:", ({ flex: flex })=>flex, ";flex-basis:", ({ flexBasis: flexBasis })=>flexBasis, ";flex-direction:", ({ flexDirection: flexDirection })=>flexDirection, ";flex-flow:", ({ flexFlow: flexFlow })=>flexFlow, ";flex-grow:", ({ flexGrow: flexGrow })=>flexGrow, ";flex-shrink:", ({ flexShrink: flexShrink })=>flexShrink, ";flex-wrap:", ({ flexWrap: flexWrap })=>flexWrap, ";align-content:", ({ alignContent: alignContent })=>alignContent, ";align-items:", ({ alignItems: alignItems })=>alignItems, ";align-self:", ({ alignSelf: alignSelf })=>alignSelf, ";justify-content:", ({ justifyContent: justifyContent })=>justifyContent, ";order:", ({ order: order })=>order, ";place-items:", ({ placeItems: placeItems })=>placeItems, ";place-self:", ({ placeSelf: placeSelf })=>placeSelf, ";place-content:", ({ placeContent: placeContent })=>placeContent, ";row-gap:", ({ rowGap: rowGap })=>typeof rowGap === 'number' ? `${rowGap * (0, $lcnyw.gridSize)()}px` : rowGap, ";column-gap:", ({ columnGap: columnGap })=>typeof columnGap === 'number' ? `${columnGap * (0, $lcnyw.gridSize)()}px` : columnGap, ";");

});

parcelRegister("foi9F", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantIconButton", () => $b3472e19fd553a6c$export$929ad068726028cf);

var $bYKiA = parcelRequire("bYKiA");



const $b3472e19fd553a6c$export$929ad068726028cf = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("l1t1S")).then((module)=>module.ConversationAssistantIconButton),
    loading: ()=>null
});

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $3dd2aa1a057580d8$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $3dd2aa1a057580d8$export$64aee74ba59709e5 = 439; // px
const $3dd2aa1a057580d8$export$1c07393c5bb1bc27 = 439; // px
const $3dd2aa1a057580d8$export$aa3478deee7adbeb = 350; // px
const $3dd2aa1a057580d8$export$21e515a86cd1733b = 'Chat';

parcelRegister("l1t1S", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f1nWp');
        const value = parcelRequire('kdHFz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f1nWp").then(()=>parcelRequire('kdHFz'));
}

});


parcelRegister("b9pGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e4756f840596a1$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

var $81e4756f840596a1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2AzcD")),
    loading: ()=>null
});

});
parcelRegister("2AzcD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('c1oF4')
        ]);
        const value = parcelRequire('7FUhi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("c1oF4")
    ]).then(()=>parcelRequire('7FUhi'));
}

});


parcelRegister("bXfYq", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $8b41986b7baf876e$export$53bf948a400e8426);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $8b41986b7baf876e$var$store = (0, $a61MH.createStore)({
    initialState: {
        editorContext: undefined
    },
    actions: {
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            }
    }
});
const $8b41986b7baf876e$export$53bf948a400e8426 = (0, $ggKAj.createActionsHook)($8b41986b7baf876e$var$store);

});

parcelRegister("hIc01", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $ce4fda9001dfd476$export$c7990a6594835e51);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $ho1Ek = parcelRequire("ho1Ek");

var $7SiNx = parcelRequire("7SiNx");
var $l30er = parcelRequire("l30er");

const $ce4fda9001dfd476$var$rootStyles = (0, $l30er.xcss)({
    right: 'space.0',
    display: 'flex',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} - ${(0, $ho1Ek.BANNER_HEIGHT)})`
});
const $ce4fda9001dfd476$var$handleStyles = (0, $l30er.xcss)({
    cursor: 'ew-resize',
    userSelect: 'none',
    position: 'absolute',
    top: 'space.200',
    bottom: 'space.0',
    left: 'space.0',
    width: '24px',
    borderTopLeftRadius: 'border.radius.200',
    transition: 'border 0.2s ease-in-out',
    borderLeft: '2px solid transparent',
    ':hover': {
        borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
    }
});
const $ce4fda9001dfd476$var$handleSpacerStyles = (0, $l30er.xcss)({
    width: '24px',
    position: 'absolute',
    display: 'block',
    left: '-24px',
    top: 'space.0',
    bottom: 'space.0'
});
const $ce4fda9001dfd476$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $3dd2aa1a057580d8$export$64aee74ba59709e5), minWidth: minWidth = (0, $3dd2aa1a057580d8$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw', expanded: expanded = false })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(initialWidth);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isDraggingRef = (0, $eUqFw.useRef)(false);
    const initialMousePositionRef = (0, $eUqFw.useRef)(0);
    const prevDistanceMovedRef = (0, $eUqFw.useRef)(0);
    const rafRef = (0, $eUqFw.useRef)(null);
    const getWrapperWidth = ()=>{
        var _wrapperRef$current, _wrapperRef$current$g;
        return ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : (_wrapperRef$current$g = _wrapperRef$current.getBoundingClientRect()) === null || _wrapperRef$current$g === void 0 ? void 0 : _wrapperRef$current$g.width) || 0;
    };
    const handleMouseMove = (0, $eUqFw.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $eUqFw.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) {
            var _wrapperRef$current2;
            onResizeComplete(((_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.getBoundingClientRect().width) || width);
        }
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const mouseMoveHandler = (0, $74BVL.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $74BVL.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SiNx.default), {
        xcss: $ce4fda9001dfd476$var$rootStyles,
        ref: wrapperRef,
        role: "presentation",
        testId: "panel-resize-wrapper",
        style: {
            width: expanded ? '100%' : width,
            maxWidth: expanded ? '100%' : maxWidth,
            minWidth: expanded ? '100%' : minWidth
        }
    }, !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SiNx.default), {
        testId: "panel-resize-handle",
        onMouseDown: handleMouseDown,
        xcss: $ce4fda9001dfd476$var$handleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SiNx.default), {
        xcss: $ce4fda9001dfd476$var$handleSpacerStyles
    })), children);
};

});

parcelRegister("l3nfS", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => (parcelRequire("fMnuI")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("fMnuI")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("fMnuI")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("6McIL")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("R3yQe")).createRecommendationContextExtensions);

var $fMnuI = parcelRequire("fMnuI");

var $1C8Mr = parcelRequire("1C8Mr");

var $99V7q = parcelRequire("99V7q");

var $6rN8D = parcelRequire("6rN8D");

var $6McIL = parcelRequire("6McIL");

var $R3yQe = parcelRequire("R3yQe");

var $jwM9a = parcelRequire("jwM9a");

});
parcelRegister("fMnuI", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => $6675c3eddcc769ef$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $6675c3eddcc769ef$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $6675c3eddcc769ef$export$d1609d6291f3d60d);
const $6675c3eddcc769ef$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $6675c3eddcc769ef$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $6675c3eddcc769ef$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $6675c3eddcc769ef$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("1C8Mr", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $0c47cde06babf078$export$196a138f6d49c2bb = [
    'edition'
];
const $0c47cde06babf078$export$28c762e8047316d8 = (0, $jwM9a.createProductExtensions)($0c47cde06babf078$export$196a138f6d49c2bb);

});
parcelRegister("jwM9a", function(module, exports) {

$parcel$export(module.exports, "createProductExtensions", () => $521c483279788870$export$42e62ee12e8ced48);
parcelRequire("8a0ZO");
var $kxJAm = parcelRequire("kxJAm");
const $521c483279788870$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $521c483279788870$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $521c483279788870$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $kxJAm.CrossFlowExtensions)(filteredOptions);
    };
const $521c483279788870$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $kxJAm.CrossFlowExtensions)(combinedOptions);
};

});


parcelRegister("99V7q", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $11b100e259e3e828$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $11b100e259e3e828$export$386012fe624cad4 = (0, $jwM9a.createProductExtensions)($11b100e259e3e828$export$390f3b1f433f2095);

});

parcelRegister("6rN8D", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $87312b9f08e3bc2d$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $87312b9f08e3bc2d$export$a60e4abab2cc3b2b = (0, $jwM9a.createProductExtensions)($87312b9f08e3bc2d$export$c41268b4369999ed);

});

parcelRegister("6McIL", function(module, exports) {

$parcel$export(module.exports, "createProvisioningPageExtensions", () => $16d391dc83d3e7c4$export$f05508383d0ca130);

var $jwM9a = parcelRequire("jwM9a");
const $16d391dc83d3e7c4$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $16d391dc83d3e7c4$export$f05508383d0ca130 = (options)=>(0, $jwM9a.createProductExtensions)($16d391dc83d3e7c4$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("R3yQe", function(module, exports) {

$parcel$export(module.exports, "createRecommendationContextExtensions", () => $4f0f7ee27b3a43d5$export$d1baeed0bd0517aa);

var $jwM9a = parcelRequire("jwM9a");
const $4f0f7ee27b3a43d5$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $4f0f7ee27b3a43d5$export$d1baeed0bd0517aa = (options)=>(0, $jwM9a.createProductExtensions)($4f0f7ee27b3a43d5$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("WYb5n", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $0b1418f3e2dcbe79$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $0b1418f3e2dcbe79$export$496e4f58036bb94d);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

const $0b1418f3e2dcbe79$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("lEe3j")));

const $0b1418f3e2dcbe79$var$AKModalTransition = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3jScb")).then((module)=>({
            default: module.ModalTransition
        })));
const $0b1418f3e2dcbe79$export$be58429061ae5194 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $0b1418f3e2dcbe79$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $eUqFw.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $eUqFw.useCallback)(()=>{
        var _invitePeopleState$on;
        if (!invitePeopleState.isOpen) return;
        (_invitePeopleState$on = invitePeopleState.onClose) === null || _invitePeopleState$on === void 0 || _invitePeopleState$on.call(invitePeopleState);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $eUqFw.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1418f3e2dcbe79$export$be58429061ae5194.Provider, {
        value: context
    }, children, invitePeopleState.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1418f3e2dcbe79$var$AKModalTransition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1418f3e2dcbe79$var$AKInvitePeopleModal, (0, $kU09D.default)({
        onCloseHandler: closeModal,
        experimental_onReopenHandler: reopenModal
    }, invitePeopleState.props)))));
};

});
parcelRegister("lEe3j", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dOlzb')
        ]);
        const value = parcelRequire('i19xm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dOlzb")
    ]).then(()=>parcelRequire('i19xm'));
}

});

parcelRegister("3jScb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jf59F');
        const value = parcelRequire('dzmUA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jf59F").then(()=>parcelRequire('dzmUA'));
}

});


parcelRegister("fQNrS", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $b8a211d102cdeb2b$export$b9ec44715ae5ad99);

var $eUqFw = parcelRequire("eUqFw");

var $WYb5n = parcelRequire("WYb5n");
const $b8a211d102cdeb2b$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $eUqFw.useContext)((0, $WYb5n.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("1OCZ5", function(module, exports) {

$parcel$export(module.exports, "ChatOpenerSubscriber", () => $1528b370723d616e$export$6fa95a645837361b);

var $BIZrR = parcelRequire("BIZrR");

var $blZ8J = parcelRequire("blZ8J");
const $1528b370723d616e$var$ignoredEvents = new Set([
    'editor-context-payload'
]);
const $1528b370723d616e$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $BIZrR.useAnalytics)();
    (0, $blZ8J.useSubscribeAll)(({ type: type, source: source })=>{
        const isEventShouldNotTriggerOpeningChat = $1528b370723d616e$var$ignoredEvents.has(type);
        sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !isEventShouldNotTriggerOpeningChat
            }
        });
        if (isEventShouldNotTriggerOpeningChat) return;
        onTriggerOpeningChat();
    });
    return null;
};

});

parcelRegister("4x8TP", function(module, exports) {

$parcel$export(module.exports, "ChatContextSubscriber", () => $34d125c2a9a1f054$export$29ff0802eb3bb217);

var $eUqFw = parcelRequire("eUqFw");

var $blZ8J = parcelRequire("blZ8J");

var $bXfYq = parcelRequire("bXfYq");
const $34d125c2a9a1f054$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext } = (0, $bXfYq.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $blZ8J.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                if (payload.type === 'editor-context-payload') setEditorContext(payload.data);
            } catch (error) {}
        }
    });
};

});

parcelRegister("hZTR9", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantButton", () => $d1a3760e8b9a8696$export$7c328c0993982813);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9s1gS = parcelRequire("9s1gS");

var $3ULZw = parcelRequire("3ULZw");

var $iwEjM = parcelRequire("iwEjM");
const $d1a3760e8b9a8696$export$7c328c0993982813 = ({ testId: testId, isActive: isActive, onClick: onClick, tooltipContent: tooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9s1gS.PrimaryButton), {
        style: {
            paddingInline: '8px'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ULZw.ChatPillIcon), null),
        testId: testId,
        isSelected: isActive,
        onClick: onClick,
        tooltip: tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : formatMessage((0, $iwEjM.messages).buttonLabel)
    }, formatMessage((0, $iwEjM.messages).buttonLabel));
};

});
parcelRegister("9s1gS", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $6e17b701e834933f$export$ac16a6a04d9b7c84);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XKQK = parcelRequire("4XKQK");

var $8cU5f = parcelRequire("8cU5f");

var $2P4Yq = parcelRequire("2P4Yq");

var $elB0M = parcelRequire("elB0M");
const $6e17b701e834933f$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $6e17b701e834933f$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $6e17b701e834933f$var$buttonBaseStyles = (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
const $6e17b701e834933f$var$buttonHighlightedStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$6e17b701e834933f$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$6e17b701e834933f$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $6e17b701e834933f$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
    const theme = (0, $2P4Yq.useTheme)();
    const button = (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$6e17b701e834933f$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
            [$6e17b701e834933f$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
        },
        css: [
            $6e17b701e834933f$var$buttonBaseStyles,
            isHighlighted && $6e17b701e834933f$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, (0, $byn9U.jsx)((0, $4XKQK.default), (0, $kU09D.default)({
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        theme: (0, $elB0M.getPrimaryButtonTheme)(theme)
    }, buttonProps), children));
    if (tooltip) return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $6e17b701e834933f$export$2e2bcd8739ae039 = $6e17b701e834933f$export$ac16a6a04d9b7c84;

});
parcelRegister("2P4Yq", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $20e433d568537a6d$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $b11DU = parcelRequire("b11DU");
const $20e433d568537a6d$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)((0, $b11DU.ThemeContext));

});
parcelRegister("b11DU", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $80510fe9b7f45ccd$export$2c657da244d00bd6);

var $eUqFw = parcelRequire("eUqFw");

var $4gWNx = parcelRequire("4gWNx");
const $80510fe9b7f45ccd$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $4gWNx.defaultTheme));
const $80510fe9b7f45ccd$export$d8964aec282183a3 = $80510fe9b7f45ccd$export$2c657da244d00bd6.Provider;

});
parcelRegister("4gWNx", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $31c644177e838e0f$export$164de7ab8df77ef0);

var $PdmhA = parcelRequire("PdmhA");

var $gKXUJ = parcelRequire("gKXUJ");

var $gun9Y = parcelRequire("gun9Y");
const $31c644177e838e0f$export$eeee8619e1b91cb0 = (0, $gun9Y.generateTheme)({
    name: (0, $gKXUJ.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $PdmhA.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $PdmhA.B400)
});
const $31c644177e838e0f$export$164de7ab8df77ef0 = $31c644177e838e0f$export$eeee8619e1b91cb0;

});
parcelRegister("gKXUJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $c32f6ae1db996d88$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $c32f6ae1db996d88$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $e0dEZ = parcelRequire("e0dEZ");
const $c32f6ae1db996d88$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B400), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $PdmhA.B400)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B400), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $PdmhA.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $PdmhA.B400)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N700)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.N200), 0.3)})`}`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: '#357DE8' // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $e0dEZ.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N0)})`,
                color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
                borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N0)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
            opacity: 1
        }
    }
};
const $c32f6ae1db996d88$export$2491e13b198e597d = 'atlassian';
var $c32f6ae1db996d88$export$2e2bcd8739ae039 = $c32f6ae1db996d88$var$defaultTheme;

});
parcelRegister("e0dEZ", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $a31ba9673f7b1144$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $a31ba9673f7b1144$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $a31ba9673f7b1144$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $a31ba9673f7b1144$export$77a1051494882576);

var $taXj4 = parcelRequire("taXj4");
const $a31ba9673f7b1144$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $taXj4.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $a31ba9673f7b1144$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $a31ba9673f7b1144$var$hex = '[a-z0-9]';
const $a31ba9673f7b1144$var$shortHandHexColorPattern = new RegExp(`#(${$a31ba9673f7b1144$var$hex})(${$a31ba9673f7b1144$var$hex})(${$a31ba9673f7b1144$var$hex})`, 'i');
const $a31ba9673f7b1144$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $a31ba9673f7b1144$var$isShortHexColor = (color)=>color && color.length === 4;
const $a31ba9673f7b1144$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$a31ba9673f7b1144$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $a31ba9673f7b1144$var$completeTriplet = (colors)=>`#${$a31ba9673f7b1144$var$repeat(colors[1], 6)}`;
const $a31ba9673f7b1144$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $a31ba9673f7b1144$export$db8d2130677f868c = (color)=>{
    if ($a31ba9673f7b1144$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($a31ba9673f7b1144$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($a31ba9673f7b1144$var$isTriplet(colors)) return $a31ba9673f7b1144$var$completeTriplet(colors);
            else return $a31ba9673f7b1144$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $a31ba9673f7b1144$export$10a10e7cd1193377 = (color)=>{
    const converted = $a31ba9673f7b1144$export$db8d2130677f868c(color);
    return (0, $taXj4.default).contrastRatio(converted).hex;
};
const $a31ba9673f7b1144$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$a31ba9673f7b1144$export$7229be6d7219ee6a((0, $taXj4.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("gun9Y", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $c01169badf40e79e$export$2e4ecffaca289a18);

var $gKXUJ = parcelRequire("gKXUJ");

var $e0dEZ = parcelRequire("e0dEZ");
const $c01169badf40e79e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
const $c01169badf40e79e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $c01169badf40e79e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $e0dEZ.hexToRGBA)(backgroundColor, 0.65) : (0, $e0dEZ.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $e0dEZ.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $e0dEZ.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $e0dEZ.hexToRGBA)(backgroundColor, 0.8) : (0, $e0dEZ.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $e0dEZ.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $e0dEZ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $e0dEZ.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $e0dEZ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $e0dEZ.getBoxShadow)('transparent')
        }
    };
};
const $c01169badf40e79e$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $e0dEZ.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $c01169badf40e79e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $e0dEZ.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $gKXUJ.DEFAULT_THEME_NAME)) return 0, $gKXUJ.default;
    return {
        mode: {
            create: $c01169badf40e79e$var$generateButtonCSSStates($c01169badf40e79e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $c01169badf40e79e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $c01169badf40e79e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $e0dEZ.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $e0dEZ.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $e0dEZ.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $e0dEZ.getBoxShadow)((0, $e0dEZ.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $e0dEZ.getContrastColor)(0.1, $c01169badf40e79e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $c01169badf40e79e$export$2e2bcd8739ae039 = $c01169badf40e79e$export$2e4ecffaca289a18;

});




parcelRegister("elB0M", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $a71fbc93802c7bf5$export$14dd6915caf431fe);
const $a71fbc93802c7bf5$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("iwEjM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d7ca7d76d447d340$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d7ca7d76d447d340$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        id: 'conversation-assistant-button.label',
        defaultMessage: 'Chat',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("5z7sX", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d60340fd49444c$export$2e2bcd8739ae039);
// export main component

var $4pM8a = parcelRequire("4pM8a");
var $40d60340fd49444c$export$2e2bcd8739ae039 // types
 = (0, $4pM8a.default);

});
parcelRegister("4pM8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $336ed4fa05f1211a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $cTgSO = parcelRequire("cTgSO");

var $3MV1G = parcelRequire("3MV1G");

var $4b6QJ = parcelRequire("4b6QJ");

var $ihFT6 = parcelRequire("ihFT6");

var $c9l6O = parcelRequire("c9l6O");

var $fLSKh = parcelRequire("fLSKh");

var $2uJvj = parcelRequire("2uJvj");

var $5kDaL = parcelRequire("5kDaL");

var $bbcrb = parcelRequire("bbcrb");

var $9cQai = parcelRequire("9cQai");

var $ee64e = parcelRequire("ee64e");

var $kgV5T = parcelRequire("kgV5T");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $336ed4fa05f1211a$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $336ed4fa05f1211a$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $fLSKh.clearMeasure)('hoverAndClick');
    }, 5 * $336ed4fa05f1211a$var$SECOND);
};
const $336ed4fa05f1211a$var$SECOND = 1000;
function $336ed4fa05f1211a$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $c9l6O.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $eUqFw.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $c9l6O.VOID_FUNC), renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent = false } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const closeMenu = (0, $eUqFw.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $eUqFw.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $fLSKh.startMeasure)('clickAndShow');
        (0, $fLSKh.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $2uJvj.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $eUqFw.useCallback)(()=>{
        (0, $5kDaL.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $fLSKh.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $336ed4fa05f1211a$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbcrb.PeopleMenuContentInternal), null), []);
    if (isSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ee64e.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        offset: isVisible ? undefined : $336ed4fa05f1211a$var$OFFSET_FOR_MORE_BUTTON_VIEW,
        content: PopupContent,
        isOpen: isPeopleMenuOpen,
        placement: isVisible ? 'bottom-start' : 'right-start',
        onClose: closeMenu,
        shouldRenderToParent: shouldRenderToParent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ee64e.default), (0, $kU09D.default)({
                isVisible: isVisible,
                isHighlighted: isHighlighted,
                customChevronIcon: customChevronIcon,
                triggerProps: triggerProps
            }, buttonProps))
    }), enablePreFetchingByHovering && canPrefetch && (0, $ihFT6.isCachedDataClear)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgV5T.UsersTeamsPreFetch), {
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        product: product,
        tenantUrl: tenantUrl,
        renotifyExperiment: renotifyExperimentProps
    }));
}
const $336ed4fa05f1211a$var$PeopleMenuInternalWithAnalytics = (0, $2jDha.default)()($336ed4fa05f1211a$export$b26ac1e1a63fbe24);
function $336ed4fa05f1211a$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cQai.default), providerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($336ed4fa05f1211a$var$PeopleMenuInternalWithAnalytics, {
        customChevronIcon: customChevronIcon,
        isHighlighted: isHighlighted,
        onClick: onClick,
        enablePreFetchingByHovering: enablePreFetchingByHovering,
        peopleText: peopleText
    }));
}

});
parcelRegister("4b6QJ", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $30ad80a99d381767$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $30ad80a99d381767$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $30ad80a99d381767$export$c8d82c28669da5dc);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kwce8 = parcelRequire("kwce8");
parcelRequire("2uJvj");
var $aeeLZ = parcelRequire("aeeLZ");

var $1F44O = parcelRequire("1F44O");

var $2VQNe = parcelRequire("2VQNe");

const $30ad80a99d381767$var$AKModalTransition = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("3jScb")).then((module)=>({
            default: module.ModalTransition
        })));

const $30ad80a99d381767$var$TeamCreateDialog = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("h9ydR")).then((module)=>({
            default: module.TeamCreateDialog
        })));
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $30ad80a99d381767$var$resetBoxModel = (0, $kwce8.css)`
	width: ${"var(--ds-space-0, 0px)"} !important;
	height: ${"var(--ds-space-0, 0px)"} !important;
	margin: ${"var(--ds-space-0, 0px)"} !important;
	padding: ${"var(--ds-space-0, 0px)"} !important;
`;
// this wrapper is for preventing changing layout of around elements
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30ad80a99d381767$var$DialogWrapper = (0, $kwce8.default).div`
	${$30ad80a99d381767$var$resetBoxModel};

	&:before,
	&:after {
		${$30ad80a99d381767$var$resetBoxModel};
		content: '' !important;
		box-shadow: none !important;
		border-radius: ${"var(--ds-space-0, 0px)"} !important;
	}
`;
const $30ad80a99d381767$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $aeeLZ.AnalyticsSource).PEOPLE_MENU
};
const $30ad80a99d381767$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    renotifyExperimentProps: {
        isLoading: false,
        isEnrolled: false,
        isJswTargeted: false,
        onFetchedPendingUsers: ()=>false
    },
    showRenotifyMessage: false,
    shouldRenderToParent: false,
    isSectionList: false
});
function $30ad80a99d381767$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false, cloudId: cloudId, renotifyExperimentProps: renotifyExperimentProps } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $eUqFw.useState)(false);
    const [renotifyDismissed, setRenotifyDismissed] = (0, $eUqFw.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(undefined);
    const [showRenotifyModal, setShowRenotifyModal] = (0, $eUqFw.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const pendingUsersResponse = (0, $2VQNe.usePendingUsers)({
        cloudId: cloudId,
        startFetching: isOpen,
        renotifyExperiment: renotifyExperimentProps,
        product: props === null || props === void 0 ? void 0 : props.product
    });
    const renotifyEligible = pendingUsersResponse.status === (0, $2VQNe.RenotifyStatus).ELIGIBLE;
    const pendingUsers = renotifyEligible ? pendingUsersResponse.pendingUsers : undefined;
    const showRenotifyMessage = renotifyEligible && !renotifyDismissed;
    const togglePeopleMenu = (0, $eUqFw.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $eUqFw.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const toggleRenotifyModal = (0, $eUqFw.useCallback)(()=>{
        setShowRenotifyModal((prevState)=>{
            return !prevState;
        });
    }, []);
    const values = (0, $eUqFw.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog,
            toggleRenotifyModal: toggleRenotifyModal,
            pendingUsers: pendingUsers,
            renotifyEligible: renotifyEligible,
            showRenotifyMessage: showRenotifyMessage,
            setRenotifyDismissed: setRenotifyDismissed,
            isSpotlightActive: isSpotlightActive,
            setIsSpotlightActive: setIsSpotlightActive
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog,
        toggleRenotifyModal,
        pendingUsers,
        renotifyEligible,
        showRenotifyMessage,
        setRenotifyDismissed,
        isSpotlightActive,
        setIsSpotlightActive
    ]);
    const closeTeamCreateDialog = (0, $eUqFw.useCallback)(()=>{
        var _values$teamCreateDia;
        toggleOpenTeamCreateDialog(false);
        if (typeof ((_values$teamCreateDia = values.teamCreateDialogProps) === null || _values$teamCreateDia === void 0 ? void 0 : _values$teamCreateDia.onClose) === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$export$c92ff8b73313c89.Provider, {
        value: values
    }, children, !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$var$DialogWrapper, {
        "data-testid": `${otherProps.testId}-team-create-dialog-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$var$AKModalTransition, null, isOpenTeamCreateDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$var$TeamCreateDialog, (0, $kU09D.default)({
        cloudId: values.cloudId,
        orgId: values.orgId,
        product: values.product,
        principalId: values.userId,
        addFlag: values.addFlag,
        pushRoute: values.pushRoute,
        extraAnalyticsAttrs: $30ad80a99d381767$var$analyticsAttrsTeamCreateDialog
    }, values.teamCreateDialogProps, {
        onClose: closeTeamCreateDialog
    }))))), !isSSR && showRenotifyModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$var$DialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30ad80a99d381767$var$AKModalTransition, null, showRenotifyModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1F44O.RenotifyModal), null)))));
}
const $30ad80a99d381767$export$c8d82c28669da5dc = ()=>(0, $eUqFw.useContext)($30ad80a99d381767$export$c92ff8b73313c89);

});
parcelRegister("2uJvj", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $1d11ae47f98d6e0b$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $1d11ae47f98d6e0b$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $1d11ae47f98d6e0b$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $1d11ae47f98d6e0b$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $1d11ae47f98d6e0b$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $1d11ae47f98d6e0b$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $1d11ae47f98d6e0b$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $1d11ae47f98d6e0b$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $1d11ae47f98d6e0b$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $1d11ae47f98d6e0b$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $1d11ae47f98d6e0b$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $1d11ae47f98d6e0b$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $1d11ae47f98d6e0b$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $1d11ae47f98d6e0b$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageNotNow", () => $1d11ae47f98d6e0b$export$a5bdd25287196af4);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageRemindTeam", () => $1d11ae47f98d6e0b$export$881b6b12fd147cc);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageViewed", () => $1d11ae47f98d6e0b$export$451dcd11e28959);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalViewed", () => $1d11ae47f98d6e0b$export$fdfb31060bc22a02);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCopyLink", () => $1d11ae47f98d6e0b$export$5deab56d147776ca);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCancelButton", () => $1d11ae47f98d6e0b$export$a4a63a010743799d);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalSendReminderButton", () => $1d11ae47f98d6e0b$export$faf6c5030f38bba5);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded", () => $1d11ae47f98d6e0b$export$736bb3246fa74c1f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersFailed", () => $1d11ae47f98d6e0b$export$794d511945a81231);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesSucceeded", () => $1d11ae47f98d6e0b$export$866a7379b396a7e3);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesFailed", () => $1d11ae47f98d6e0b$export$498c81c82596e8ea);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyNotEligible", () => $1d11ae47f98d6e0b$export$644347da17a1bc39);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightViewed", () => $1d11ae47f98d6e0b$export$68b8d9efc6f7f58f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightCancelButton", () => $1d11ae47f98d6e0b$export$f900d0881e38df06);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightConfirmButton", () => $1d11ae47f98d6e0b$export$acbad06cf5c53b17);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("aeeLZ")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("aeeLZ")).AnalyticsAction);
$parcel$export(module.exports, "AnalyticsSource", () => (parcelRequire("aeeLZ")).AnalyticsSource);

var $43nnt = parcelRequire("43nnt");

var $aeeLZ = parcelRequire("aeeLZ");

var $8P1hz = parcelRequire("8P1hz");
const $1d11ae47f98d6e0b$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED
    });
};
const $1d11ae47f98d6e0b$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $1d11ae47f98d6e0b$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $1d11ae47f98d6e0b$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $1d11ae47f98d6e0b$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $1d11ae47f98d6e0b$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $1d11ae47f98d6e0b$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $43nnt.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $1d11ae47f98d6e0b$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $aeeLZ.AnalyticsAction).RENDERED
    });
};
const $1d11ae47f98d6e0b$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $aeeLZ.AnalyticsAction).TRIGGERED
    });
};
const $1d11ae47f98d6e0b$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $aeeLZ.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $1d11ae47f98d6e0b$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $43nnt.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $aeeLZ.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $1d11ae47f98d6e0b$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $43nnt.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $1d11ae47f98d6e0b$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $43nnt.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $aeeLZ.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $1d11ae47f98d6e0b$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $aeeLZ.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};
const $1d11ae47f98d6e0b$export$a5bdd25287196af4 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $1d11ae47f98d6e0b$export$881b6b12fd147cc = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'remindTeamMembersButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $1d11ae47f98d6e0b$export$451dcd11e28959 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $aeeLZ.AnalyticsAction).VIEWED,
        name: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $1d11ae47f98d6e0b$export$fdfb31060bc22a02 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $aeeLZ.AnalyticsAction).VIEWED,
        name: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $1d11ae47f98d6e0b$export$5deab56d147776ca = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'copyInviteLinkButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$a4a63a010743799d = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $1d11ae47f98d6e0b$export$faf6c5030f38bba5 = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'sendReminderButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$736bb3246fa74c1f = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $aeeLZ.AnalyticsAction).SUCCEEDED,
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$794d511945a81231 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $aeeLZ.AnalyticsAction).FAILED,
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $1d11ae47f98d6e0b$export$866a7379b396a7e3 = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $aeeLZ.AnalyticsAction).SUCCEEDED,
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$498c81c82596e8ea = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $aeeLZ.AnalyticsAction).FAILED,
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$644347da17a1bc39 = (createAnalyticsEvent, attributes)=>{
    (0, $43nnt.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).RENOTIFY_EXPERIMENT,
        action: (0, $aeeLZ.AnalyticsAction).INELIGIBLE,
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_MESSAGE,
        attributes: attributes
    });
};
const $1d11ae47f98d6e0b$export$68b8d9efc6f7f58f = (createAnalyticsEvent)=>{
    (0, $43nnt.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $aeeLZ.AnalyticsAction).VIEWED,
        name: (0, $aeeLZ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $1d11ae47f98d6e0b$export$f900d0881e38df06 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightDismissButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $1d11ae47f98d6e0b$export$acbad06cf5c53b17 = (createAnalyticsEvent)=>{
    (0, $43nnt.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).BUTTON,
        action: (0, $aeeLZ.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightConfirmButton',
        source: (0, $aeeLZ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};

});
parcelRegister("aeeLZ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $7726abd02ec04823$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $7726abd02ec04823$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $7726abd02ec04823$export$6890652a1aff7d1c);
let $7726abd02ec04823$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["FETCH_INACTIVE_USERS_DATA"] = "fetchInactiveUsersData";
    AnalyticsActionSubject["SEND_REINVITES"] = "sendReinvites";
    AnalyticsActionSubject["RENOTIFY_EXPERIMENT"] = "renotifyExperiment";
    return AnalyticsActionSubject;
}({});
let $7726abd02ec04823$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
    return AnalyticsAction;
}({});
let $7726abd02ec04823$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsSource["RENOTIFY_MESSAGE"] = "renotifyMessage";
    AnalyticsSource["RENOTIFY_MODAL"] = "renotifyModal";
    AnalyticsSource["RENOTIFY_SPOTLIGHT"] = "renotifySpotlight";
    return AnalyticsSource;
}({});

});

parcelRegister("8P1hz", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $66c414cf23d21afd$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $66c414cf23d21afd$export$e648838c8bbef986);

var $43nnt = parcelRequire("43nnt");
parcelRequire("2uJvj");
var $aeeLZ = parcelRequire("aeeLZ");
const $66c414cf23d21afd$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $aeeLZ.AnalyticsAction).SUCCEEDED : (0, $aeeLZ.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: (error === null || error === void 0 ? void 0 : error.message) || JSON.stringify(error)
        }
    });
};
const $66c414cf23d21afd$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $43nnt.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $aeeLZ.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $aeeLZ.AnalyticsAction).SUCCEEDED : (0, $aeeLZ.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: (error === null || error === void 0 ? void 0 : error.message) || JSON.stringify(error)
        }
    });
};

});


parcelRegister("1F44O", function(module, exports) {

$parcel$export(module.exports, "RenotifyModal", () => $135cc85556c41df6$export$c68d29a05874a11b);

var $7rh0R = parcelRequire("7rh0R");

const $135cc85556c41df6$export$c68d29a05874a11b = (0, $7rh0R.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("23lsy")));

});
parcelRegister("23lsy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dMTnM');
        const value = parcelRequire('kBBI6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dMTnM").then(()=>parcelRequire('kBBI6'));
}

});


parcelRegister("2VQNe", function(module, exports) {

$parcel$export(module.exports, "RenotifyStatus", () => $2229db4295e7a8f0$export$e1b7db4c83021afe);
$parcel$export(module.exports, "usePendingUsers", () => $2229db4295e7a8f0$export$8d720c7cdd23491d);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $2uJvj = parcelRequire("2uJvj");

var $gSkgO = parcelRequire("gSkgO");
const $2229db4295e7a8f0$export$50fd3325777ce4bc = new Map();
const $2229db4295e7a8f0$export$7149af0c7f6b6e85 = 'pendingUsers';
const $2229db4295e7a8f0$export$c9c3fbf7cb17786e = 'renotifyEligibility';
let $2229db4295e7a8f0$export$e1b7db4c83021afe = /*#__PURE__*/ function(RenotifyStatus) {
    RenotifyStatus["IS_LOADING"] = "isLoading";
    RenotifyStatus["ELIGIBLE"] = "eligible";
    RenotifyStatus["INELIGIBLE"] = "ineligible";
    RenotifyStatus["ERROR"] = "error";
    return RenotifyStatus;
}({});
const $2229db4295e7a8f0$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS = 600000; // 10 minutes
function $2229db4295e7a8f0$export$8d720c7cdd23491d({ cloudId: cloudId, startFetching: startFetching, renotifyExperiment: renotifyExperiment, product: product, requestCacheTimeout: requestCacheTimeout }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [pendingUsers, setPendingUsers] = (0, $eUqFw.useState)($2229db4295e7a8f0$export$50fd3325777ce4bc.get($2229db4295e7a8f0$export$7149af0c7f6b6e85));
    const [renotifyEligible, setRenotifyEligibility] = (0, $eUqFw.useState)($2229db4295e7a8f0$export$50fd3325777ce4bc.get($2229db4295e7a8f0$export$c9c3fbf7cb17786e));
    const { loading: pendingUsersLoading, error: pendingUsersError, data: pendingUsersData, fetchData: fetchPendingUsers } = (0, $gSkgO.usePendingUsersService)(cloudId, requestCacheTimeout === undefined ? $2229db4295e7a8f0$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS : requestCacheTimeout, product);
    (0, $eUqFw.useEffect)(()=>{
        if (renotifyEligible !== undefined || renotifyExperiment !== null && renotifyExperiment !== void 0 && renotifyExperiment.isLoading || !startFetching) return;
        if (renotifyExperiment !== null && renotifyExperiment !== void 0 && renotifyExperiment.isEnrolled || renotifyExperiment !== null && renotifyExperiment !== void 0 && renotifyExperiment.isJswTargeted) fetchPendingUsers();
        else {
            $2229db4295e7a8f0$export$50fd3325777ce4bc.set($2229db4295e7a8f0$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        renotifyEligible,
        fetchPendingUsers,
        renotifyExperiment === null || renotifyExperiment === void 0 ? void 0 : renotifyExperiment.isLoading,
        renotifyExperiment === null || renotifyExperiment === void 0 ? void 0 : renotifyExperiment.isEnrolled,
        renotifyExperiment === null || renotifyExperiment === void 0 ? void 0 : renotifyExperiment.isJswTargeted,
        startFetching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (pendingUsersError) {
            (0, $2uJvj.triggerAnalyticsForRenotifyFetchInactiveUsersFailed)(createAnalyticsEvent);
            $2229db4295e7a8f0$export$50fd3325777ce4bc.set($2229db4295e7a8f0$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
            return;
        }
        if (pendingUsersData === undefined || pendingUsersLoading) return;
        $2229db4295e7a8f0$export$50fd3325777ce4bc.set($2229db4295e7a8f0$export$7149af0c7f6b6e85, pendingUsersData);
        setPendingUsers(pendingUsersData);
        if (pendingUsersData !== null && pendingUsersData !== void 0 && pendingUsersData.length) {
            var _renotifyExperiment$o;
            (0, $2uJvj.triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded)(createAnalyticsEvent, {
                numberOfInviteeEmails: pendingUsersData === null || pendingUsersData === void 0 ? void 0 : pendingUsersData.length
            });
            $2229db4295e7a8f0$export$50fd3325777ce4bc.set($2229db4295e7a8f0$export$c9c3fbf7cb17786e, true);
            // fire jsw renotify exposure but not impact confluence side
            if (renotifyExperiment !== null && renotifyExperiment !== void 0 && renotifyExperiment.isEnrolled || (renotifyExperiment === null || renotifyExperiment === void 0 ? void 0 : (_renotifyExperiment$o = renotifyExperiment.onFetchedPendingUsers) === null || _renotifyExperiment$o === void 0 ? void 0 : _renotifyExperiment$o.call(renotifyExperiment)) === true) setRenotifyEligibility(true);
        } else {
            (0, $2uJvj.triggerAnalyticsForRenotifyNotEligible)(createAnalyticsEvent, {
                reason: 'No pending users'
            });
            $2229db4295e7a8f0$export$50fd3325777ce4bc.set($2229db4295e7a8f0$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        createAnalyticsEvent,
        pendingUsersData,
        pendingUsersError,
        pendingUsersLoading,
        renotifyExperiment
    ]);
    if (pendingUsersLoading || renotifyExperiment !== null && renotifyExperiment !== void 0 && renotifyExperiment.isLoading) return {
        status: $2229db4295e7a8f0$export$e1b7db4c83021afe.IS_LOADING,
        isLoading: true
    };
    if (pendingUsersError) return {
        status: $2229db4295e7a8f0$export$e1b7db4c83021afe.ERROR,
        pendingUsersError: pendingUsersError !== null && pendingUsersError !== void 0 ? pendingUsersError : new Error('Invalid pending user response'),
        isLoading: false
    };
    if (renotifyEligible === false || !pendingUsers) return {
        status: $2229db4295e7a8f0$export$e1b7db4c83021afe.INELIGIBLE,
        isLoading: false
    };
    return {
        status: $2229db4295e7a8f0$export$e1b7db4c83021afe.ELIGIBLE,
        isLoading: false,
        pendingUsers: pendingUsers
    };
}

});
parcelRegister("gSkgO", function(module, exports) {

$parcel$export(module.exports, "usePendingUsersService", () => $c49169bd27d55054$export$4e16c66a0a5052e1);

var $eUqFw = parcelRequire("eUqFw");

var $e2QQJ = parcelRequire("e2QQJ");

var $5PxOI = parcelRequire("5PxOI");

var $4Dvo9 = parcelRequire("4Dvo9");

var $4b6QJ = parcelRequire("4b6QJ");
const $c49169bd27d55054$var$mapFetchInactiveUserFnByTimeout = new Map();
function $c49169bd27d55054$var$getFetchInactiveUsersCachedFn(timeout = (0, $e2QQJ.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $c49169bd27d55054$var$mapFetchInactiveUserFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $e2QQJ.withCached)((0, $4Dvo9.fetchInactiveUsers), timeout);
    $c49169bd27d55054$var$mapFetchInactiveUserFnByTimeout.set(timeout, fn);
    return fn;
}
function $c49169bd27d55054$export$4e16c66a0a5052e1(cloudId, cacheTimeout, product) {
    const { product: contextProduct } = (0, $4b6QJ.usePeopleMenuContext)();
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $c49169bd27d55054$var$getFetchInactiveUsersCachedFn(cacheTimeout);
            return fn(cloudId, product !== null && product !== void 0 ? product : contextProduct);
        }
        return (0, $4Dvo9.fetchInactiveUsers)(cloudId, product !== null && product !== void 0 ? product : contextProduct);
    }, [
        cacheTimeout,
        cloudId,
        product,
        contextProduct
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $5PxOI.useService)(request);
    return {
        loading: loading,
        error: error,
        data: data === null || data === void 0 ? void 0 : data.users,
        fetchData: fetchData
    };
}

});
parcelRegister("e2QQJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $a39a3f63071ff345$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $a39a3f63071ff345$export$7f51828d6b6af163);
const $a39a3f63071ff345$var$ONE_SECOND = 1000;
const $a39a3f63071ff345$export$d8b1aa62ff4847fc = 5 * $a39a3f63071ff345$var$ONE_SECOND;
const $a39a3f63071ff345$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $a39a3f63071ff345$export$7f51828d6b6af163 = (fn, timeout = $a39a3f63071ff345$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($a39a3f63071ff345$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("4Dvo9", function(module, exports) {

$parcel$export(module.exports, "fetchInactiveUsers", () => $3603271126bef1d7$export$b6000772b84436c7);
$parcel$export(module.exports, "sendReinvites", () => $3603271126bef1d7$export$df764bf7318de5);

var $d8HAl = parcelRequire("d8HAl");
const $3603271126bef1d7$var$EXPERIMENT_API_BASE = '/gateway/api/growth/';
const $3603271126bef1d7$var$getExperimentAPICommonPath = (product)=>`${$3603271126bef1d7$var$EXPERIMENT_API_BASE}${product === 'confluence' ? 'notify-if-invitee-never-logged-in-confluence' : 'notify-if-invitee-never-logged-in'}`;
const $3603271126bef1d7$var$getInactiveUsersUrl = (cloudId, product)=>`${$3603271126bef1d7$var$getExperimentAPICommonPath(product)}/get-inactive-users?cloudId=${cloudId}`;
const $3603271126bef1d7$export$b6000772b84436c7 = (cloudId, product)=>(0, $d8HAl.fetchJson)($3603271126bef1d7$var$getInactiveUsersUrl(cloudId, product));
const $3603271126bef1d7$var$getReinviteUrl = (product)=>`${$3603271126bef1d7$var$getExperimentAPICommonPath(product)}/reinvite`;
const $3603271126bef1d7$export$df764bf7318de5 = (cloudId, reInvites, product)=>{
    return (0, $d8HAl.postJson)($3603271126bef1d7$var$getReinviteUrl(product), {
        owner: `ari:cloud:platform::site/${cloudId}`,
        reInvites: reInvites.map(({ userId: userId, continueUrl: continueUrl })=>({
                inviteeId: `ari:cloud:identity::user/${userId}`,
                continueUrl: continueUrl
            }))
    });
};

});
parcelRegister("d8HAl", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $990dd4d047fe8684$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $990dd4d047fe8684$export$c776284ef4b1209a);
const $990dd4d047fe8684$export$83179404a61b001a = 'FetchError';
function $990dd4d047fe8684$export$847691ec04985fa0(error, status) {
    return {
        name: $990dd4d047fe8684$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status
    };
}
const $990dd4d047fe8684$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw $990dd4d047fe8684$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status);
    });
const $990dd4d047fe8684$export$c776284ef4b1209a = (url, data)=>$990dd4d047fe8684$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});




parcelRegister("h9ydR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('91aMR')
        ]);
        const value = parcelRequire('9ARRL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("91aMR")
    ]).then(()=>parcelRequire('9ARRL'));
}

});


parcelRegister("ihFT6", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $d4fa4e8a21636494$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $d4fa4e8a21636494$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zFY6 = parcelRequire("1zFY6");
var $3PSDu = parcelRequire("3PSDu");
const $d4fa4e8a21636494$export$50fd3325777ce4bc = new Map();
const $d4fa4e8a21636494$export$cd84c175965a58da = 'collaborators';
const $d4fa4e8a21636494$export$b5c382592ac689a7 = 'teams';
const $d4fa4e8a21636494$var$ONE_SEC = 1000;
const $d4fa4e8a21636494$var$ONE_MINUTE = $d4fa4e8a21636494$var$ONE_SEC * 60;
const $d4fa4e8a21636494$var$REQUEST_CACHE_TIMEOUT_TEAMS = $d4fa4e8a21636494$var$ONE_MINUTE;
const $d4fa4e8a21636494$var$REQUEST_CACHE_TIMEOUT_USERS = $d4fa4e8a21636494$var$ONE_MINUTE * 5;
function $d4fa4e8a21636494$export$cee8b843259f0f74() {
    return $d4fa4e8a21636494$export$50fd3325777ce4bc.size === 0;
}
function $d4fa4e8a21636494$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $eUqFw.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $eUqFw.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $1zFY6.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $d4fa4e8a21636494$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $3PSDu.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $d4fa4e8a21636494$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $eUqFw.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $d4fa4e8a21636494$export$50fd3325777ce4bc.set($d4fa4e8a21636494$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $eUqFw.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $d4fa4e8a21636494$export$50fd3325777ce4bc.set($d4fa4e8a21636494$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $d4fa4e8a21636494$export$50fd3325777ce4bc.get($d4fa4e8a21636494$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $d4fa4e8a21636494$export$50fd3325777ce4bc.get($d4fa4e8a21636494$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("1zFY6", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $12599d66727c981b$export$979a4f9449b8be53);

var $eUqFw = parcelRequire("eUqFw");

var $8Grwo = parcelRequire("8Grwo");

var $fuDbF = parcelRequire("fuDbF");

var $e2QQJ = parcelRequire("e2QQJ");

var $5PxOI = parcelRequire("5PxOI");
const $12599d66727c981b$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $12599d66727c981b$var$getFetchCollaboratorsCachedFn(timeout = (0, $e2QQJ.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $12599d66727c981b$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $e2QQJ.withCached)((0, $8Grwo.fetchCollaborators), timeout);
    $12599d66727c981b$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $12599d66727c981b$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $12599d66727c981b$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $8Grwo.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $5PxOI.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $eUqFw.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $eUqFw.useMemo)(()=>(0, $fuDbF.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("8Grwo", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $6527982a735b3537$export$cadad85c3acf2ad8);

var $ewm1U = parcelRequire("ewm1U");
const $6527982a735b3537$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $6527982a735b3537$var$LIMIT_RESULTS = 5;
const $6527982a735b3537$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $ewm1U.postJson)(`${tenantUrl}${$6527982a735b3537$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $6527982a735b3537$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});

parcelRegister("fuDbF", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $b4780e1af0a3ce0a$export$1eb7590d078520b8);

var $cb9ao = parcelRequire("cb9ao");
const $b4780e1af0a3ce0a$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $cb9ao.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $b4780e1af0a3ce0a$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($b4780e1af0a3ce0a$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("cb9ao", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $8ddd9f674f731bc3$export$49be827a0aef75dd);
let $8ddd9f674f731bc3$export$49be827a0aef75dd = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}({});
let $8ddd9f674f731bc3$export$fba7c3adda5094d9 = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}({});

});



parcelRegister("3PSDu", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $2cb0841912fb15a3$export$668750a034956301);

var $eUqFw = parcelRequire("eUqFw");

var $kWzlf = parcelRequire("kWzlf");

var $3uF31 = parcelRequire("3uF31");

var $e2QQJ = parcelRequire("e2QQJ");

var $5PxOI = parcelRequire("5PxOI");
const $2cb0841912fb15a3$var$mapFetchMyTeamsFnByTimeout = new Map();
function $2cb0841912fb15a3$var$getFetchMyTeamsCachedFn(timeout = (0, $e2QQJ.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $2cb0841912fb15a3$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $e2QQJ.withCached)((0, $kWzlf.searchTeamsOfUser), timeout);
    $2cb0841912fb15a3$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $2cb0841912fb15a3$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $2cb0841912fb15a3$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $kWzlf.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $5PxOI.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $eUqFw.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $eUqFw.useMemo)(()=>(0, $3uF31.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});


parcelRegister("c9l6O", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $8d86b319c4ada34a$export$7e6ba5d480e9bd2f);
const $8d86b319c4ada34a$export$53bb833296af4a30 = 5;
const $8d86b319c4ada34a$export$88d6945644578407 = 3;
const $8d86b319c4ada34a$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("fLSKh", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $b7b5b6152292bf9d$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $b7b5b6152292bf9d$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $b7b5b6152292bf9d$export$6f766653554dac02);
const $b7b5b6152292bf9d$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $b7b5b6152292bf9d$var$hasPerformanceAPIAvailable = $b7b5b6152292bf9d$var$isPerformanceAPIAvailable();
const $b7b5b6152292bf9d$var$measureMap = new Map();
function $b7b5b6152292bf9d$export$b62aa2130c86b59b(measureName) {
    if (!$b7b5b6152292bf9d$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $b7b5b6152292bf9d$var$measureMap.set(measureName, performance.now());
}
function $b7b5b6152292bf9d$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$b7b5b6152292bf9d$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$b7b5b6152292bf9d$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $b7b5b6152292bf9d$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $b7b5b6152292bf9d$export$6f766653554dac02(measureName);
    }
}
function $b7b5b6152292bf9d$export$6f766653554dac02(measureName) {
    if (!$b7b5b6152292bf9d$var$hasPerformanceAPIAvailable) return;
    $b7b5b6152292bf9d$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("5kDaL", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $3e1d34dca0859089$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $3e1d34dca0859089$export$48b47052ec2aea7f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8PFhw = parcelRequire("8PFhw");

var $4b6QJ = parcelRequire("4b6QJ");

var $ihFT6 = parcelRequire("ihFT6");

var $iEV5l = parcelRequire("iEV5l");

var $8pUzG = parcelRequire("8pUzG");

const $3e1d34dca0859089$export$479f0f2f71193efe = (0, $7rh0R.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("h1I8F")));
const $3e1d34dca0859089$export$b0396be60c0e9152 = 480;
const $3e1d34dca0859089$export$3f133812f81dfa49 = 320;
const $3e1d34dca0859089$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $3e1d34dca0859089$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    // kick off some requests sooner
    (0, $ihFT6.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $3e1d34dca0859089$export$b0396be60c0e9152,
        maxHeight: $3e1d34dca0859089$export$94aaf6acd960c412,
        minWidth: $3e1d34dca0859089$export$3f133812f81dfa49
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iEV5l.MenuGroupPeople), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pUzG.MenuGroupTeams), {
        isLoading: true
    }));
}

});
parcelRegister("iEV5l", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $d9583e5d4c7aa93a$export$c521b8e86241ef89);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jDha = parcelRequire("2jDha");

var $bo4OB = parcelRequire("bo4OB");

var $d8riu = parcelRequire("d8riu");

var $hNYCh = parcelRequire("hNYCh");

var $4b6QJ = parcelRequire("4b6QJ");

var $c9l6O = parcelRequire("c9l6O");

var $9ovdk = parcelRequire("9ovdk");
parcelRequire("2uJvj");
var $aeeLZ = parcelRequire("aeeLZ");
var $2uJvj = parcelRequire("2uJvj");

var $dborh = parcelRequire("dborh");

var $a1RKc = parcelRequire("a1RKc");

var $57wPB = parcelRequire("57wPB");
const $d9583e5d4c7aa93a$export$2e63129145f0c868 = (props)=>{
    var _remoteConfig$section;
    const intl = (0, $5JgJ2.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $c9l6O.VOID_FUNC), pushRoute: pushRoute = (0, $c9l6O.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $c9l6O.VOID_FUNC) } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    const handleClickOnPeople = (0, $eUqFw.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $9ovdk.isModifiedEvent)(event);
            (0, $2uJvj.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $hNYCh.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1RKc.MenuGroupSection), {
        title: (_remoteConfig$section = remoteConfig.sections.collaborators.label) !== null && _remoteConfig$section !== void 0 ? _remoteConfig$section : intl.formatMessage((0, $dborh.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems
    }, users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
            key: user.id,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $57wPB.ImgIcon), {
                src: user.avatarUrl,
                alt: ""
            }),
            testId: `${testId}-people-item`,
            href: (0, $hNYCh.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU),
            onClick: handleClickOnPeople(user.id)
        }, user.fullName)));
};
const $d9583e5d4c7aa93a$export$c521b8e86241ef89 = (0, $2jDha.default)()((0, $d8riu.withMandatoryPeopleMenuConfiguration)($d9583e5d4c7aa93a$export$2e63129145f0c868));

});
parcelRegister("9ovdk", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $6d6e916ad521ab03$export$642c6f14f6d4bbd5);
const $6d6e916ad521ab03$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("dborh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $998f4280b4bc78bd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $998f4280b4bc78bd$var$PREFIX = 'ptc.pm';
const $998f4280b4bc78bd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    yourCollab: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.collaborators.title`,
        defaultMessage: 'Your Collaborators',
        description: 'A title of Your-Collaborators section in People Menu dropdown'
    },
    yourTeams: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.your-teams.title`,
        defaultMessage: 'Your Teams',
        description: 'A title of a Your-Teams section in People Menu dropdown'
    },
    viewYourProfile: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.view-your-profile`,
        defaultMessage: 'View your profile',
        description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
    },
    errorHeading: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
    },
    errorText: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the People Menu.'
    },
    errorImageAltText: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the People Menu'
    },
    people: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.people`,
        defaultMessage: 'People',
        description: 'A default title of primary People menu'
    },
    teams: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.teams`,
        defaultMessage: 'Teams',
        description: 'A new default title of primary People menu'
    },
    numMembers: {
        id: `${$998f4280b4bc78bd$var$PREFIX}.num-members`,
        defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
        description: 'Subtext of the number of members belonging to a team'
    }
});

});

parcelRegister("a1RKc", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $74d3afd514e2151b$export$33b4adfb29dd0d95);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");
var $lV9rH = parcelRequire("lV9rH");

var $4b6QJ = parcelRequire("4b6QJ");

var $jYiHp = parcelRequire("jYiHp");
const $74d3afd514e2151b$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        testId: `${sectionType}-skeleton-heading`
    }), Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYiHp.default), {
            key: `${sectionType}-${index}`
        }))) : children);
};

});
parcelRegister("jYiHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a2202cf37935ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $PdmhA = parcelRequire("PdmhA");

var $57wPB = parcelRequire("57wPB");
const $e8a2202cf37935ff$var$cssFn = ()=>{
    return {
        '&::before': {
            backgroundColor: `var(--ds-skeleton, ${0, $PdmhA.N20A})`,
            borderRadius: '100%',
            flexShrink: 0,
            content: '""',
            marginLeft: 0,
            marginRight: "var(--ds-space-150, 12px)",
            width: (0, $57wPB.ICON_SIZE),
            height: (0, $57wPB.ICON_SIZE)
        }
    };
};
function $e8a2202cf37935ff$export$2e2bcd8739ae039() {
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasAvatar: true,
        cssFn: $e8a2202cf37935ff$var$cssFn,
        testId: "people-menu-skeleton-item"
    }));
}

});
parcelRegister("57wPB", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE", () => $3ba712c8d1664491$export$91a15f1424900d33);
$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $3ba712c8d1664491$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $3ba712c8d1664491$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $3ba712c8d1664491$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $3ba712c8d1664491$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $3ba712c8d1664491$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $3ba712c8d1664491$export$5884f4bd467a603a);

var $eUqFw = parcelRequire("eUqFw");

var $5ZVKY = parcelRequire("5ZVKY");

var $4donp = parcelRequire("4donp");
const $3ba712c8d1664491$export$91a15f1424900d33 = 32;
const $3ba712c8d1664491$export$b0396be60c0e9152 = 480;
const $3ba712c8d1664491$export$3f133812f81dfa49 = 320;
const $3ba712c8d1664491$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $3ba712c8d1664491$export$804b6389edcac2c2({ src: src, alt: alt }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src || '',
        alt: alt,
        height: $3ba712c8d1664491$export$91a15f1424900d33,
        width: $3ba712c8d1664491$export$91a15f1424900d33,
        style: {
            borderRadius: $3ba712c8d1664491$export$91a15f1424900d33 / 2
        }
    });
}
function $3ba712c8d1664491$export$6b52db8960fbef38() {
    (0, $eUqFw.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $3ba712c8d1664491$export$5884f4bd467a603a = (error)=>{
    (0, $4donp.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $5ZVKY.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error === null || error === void 0 ? void 0 : error.message
        }
    });
};

});
parcelRegister("4donp", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $311b490345009634$export$a0db9187c809008d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $kCXD5 = parcelRequire("kCXD5");
class $311b490345009634$var$UFOExperienceWithPackageContext extends (0, $kDfSL.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $kCXD5.packageContext)
            }
        });
    }
    async failure(config) {
        var _config$metadata;
        return super.failure({
            force: config === null || config === void 0 ? void 0 : config.force,
            metadata: {
                ...(_config$metadata = config === null || config === void 0 ? void 0 : config.metadata) !== null && _config$metadata !== void 0 ? _config$metadata : {},
                ...(0, $kCXD5.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $kCXD5.packageContext)
            }
        });
    }
}
const $311b490345009634$export$a0db9187c809008d = new $311b490345009634$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("kCXD5", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $f0459c717b9815b4$export$beac86d91b8e8b21);
const $f0459c717b9815b4$export$beac86d91b8e8b21 = {
    packageName: "@atlassian/people-menu",
    packageVersion: "57.2.3"
};

});






parcelRegister("8pUzG", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $620c8b0eee76716b$export$c3915c5ac3f99d49);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jDha = parcelRequire("2jDha");

var $bo4OB = parcelRequire("bo4OB");

var $d8riu = parcelRequire("d8riu");

var $hNYCh = parcelRequire("hNYCh");

var $4b6QJ = parcelRequire("4b6QJ");

var $c9l6O = parcelRequire("c9l6O");

var $9ovdk = parcelRequire("9ovdk");
parcelRequire("2uJvj");
var $aeeLZ = parcelRequire("aeeLZ");
var $2uJvj = parcelRequire("2uJvj");

var $dborh = parcelRequire("dborh");

var $a1RKc = parcelRequire("a1RKc");

var $57wPB = parcelRequire("57wPB");
const $620c8b0eee76716b$export$86c994b04df922e = (props)=>{
    var _remoteConfig$section;
    const intl = (0, $5JgJ2.default)();
    const { orgId: orgId } = (0, $4b6QJ.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $c9l6O.VOID_FUNC), pushRoute: pushRoute = (0, $c9l6O.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $c9l6O.VOID_FUNC) } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    const handleClickOnTeam = (0, $eUqFw.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $9ovdk.isModifiedEvent)(event);
            (0, $2uJvj.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $hNYCh.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $aeeLZ.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1RKc.MenuGroupSection), {
        title: (_remoteConfig$section = remoteConfig.sections.teams.label) !== null && _remoteConfig$section !== void 0 ? _remoteConfig$section : intl.formatMessage((0, $dborh.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems
    }, teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>{
        var _team$memberCount;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
            key: team.id,
            href: (0, $hNYCh.getTeamProfilePageLinkWithOrgId)({
                remoteConfigResources: remoteConfig.resources,
                teamId: team.id,
                orgId: orgId
            }),
            onClick: handleClickOnTeam(team.id),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $57wPB.ImgIcon), {
                src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                alt: team.displayName
            }),
            description: intl.formatMessage((0, $dborh.messages).numMembers, {
                memberCount: (_team$memberCount = team.memberCount) !== null && _team$memberCount !== void 0 ? _team$memberCount : 1
            }),
            testId: `${testId}-team-item`
        }, team.displayName);
    }));
};
const $620c8b0eee76716b$export$c3915c5ac3f99d49 = (0, $2jDha.default)()((0, $d8riu.withMandatoryPeopleMenuConfiguration)($620c8b0eee76716b$export$86c994b04df922e));

});

parcelRegister("h1I8F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1ld0H');
        const value = parcelRequire('69peh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1ld0H").then(()=>parcelRequire('69peh'));
}

});


parcelRegister("bbcrb", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $823a5e9dc5d023b3$export$78306a734b6419e6);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4b6QJ = parcelRequire("4b6QJ");

var $SGoBy = parcelRequire("SGoBy");

var $c9l6O = parcelRequire("c9l6O");

var $5kDaL = parcelRequire("5kDaL");

var $9cQai = parcelRequire("9cQai");
const $823a5e9dc5d023b3$var$stopPropagation = (e)=>e.stopPropagation();
const $823a5e9dc5d023b3$export$78306a734b6419e6 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $eUqFw.useContext)((0, $4b6QJ.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $SGoBy.default)(isBrowseUsersEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onClick: $823a5e9dc5d023b3$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kDaL.MenuContentFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kDaL.MenuContent), {
        isLoadingPermission: isLoadingPermission,
        hasPermission: hasPermission
    })));
});
const $823a5e9dc5d023b3$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9cQai.default), (0, $kU09D.default)({
        isOpen: true,
        onOpen: (0, $c9l6O.VOID_FUNC),
        onClose: (0, $c9l6O.VOID_FUNC)
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($823a5e9dc5d023b3$export$78306a734b6419e6, null));
};
var $823a5e9dc5d023b3$export$2e2bcd8739ae039 = $823a5e9dc5d023b3$var$PeopleMenuContent;

});
parcelRegister("SGoBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a45ee317eadbf54$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0a45ee317eadbf54$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $eUqFw.useState)(noQuery);
    const [loading, setLoading] = (0, $eUqFw.useState)(!noQuery);
    (0, $eUqFw.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("9cQai", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3db2f4874d95cf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $4o61W = parcelRequire("4o61W");

var $hNYCh = parcelRequire("hNYCh");

var $4b6QJ = parcelRequire("4b6QJ");

var $kCXD5 = parcelRequire("kCXD5");
parcelRequire("2uJvj");
var $aeeLZ = parcelRequire("aeeLZ");

var $bXShH = parcelRequire("bXShH");
const $6b3db2f4874d95cf$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $6b3db2f4874d95cf$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$6b3db2f4874d95cf$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $aeeLZ.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $aeeLZ.AnalyticsSource).PEOPLE_MENU,
        ...(0, $kCXD5.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $hNYCh.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        renotifyExperimentProps: renotifyExperimentProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4b6QJ.PeopleMenuContextProvider), commonPropsInContext, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4o61W.LazyIntlProvider), {
        fetchLanguageFile: (0, $bXShH.fetchLanguageFile)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: analyticsContextData
    }, children)));
};
var $6b3db2f4874d95cf$export$2e2bcd8739ae039 = $6b3db2f4874d95cf$var$PeopleMenuProviders;

});
parcelRegister("bXShH", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $8b5f502b04f032db$export$c08b58fa4727b0d2);

var $jNmy9 = parcelRequire("jNmy9");
function $8b5f502b04f032db$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $jNmy9.cs();
        case 'da-DK':
        case 'da':
            return $jNmy9.da();
        case 'de-DE':
        case 'de':
            return $jNmy9.de();
        case 'es-ES':
        case 'es':
            return $jNmy9.es();
        case 'et-EE':
        case 'et':
            return $jNmy9.et();
        case 'fi-FI':
        case 'fi':
            return $jNmy9.fi();
        case 'fr-FR':
        case 'fr':
            return $jNmy9.fr();
        case 'hu-HU':
        case 'hu':
            return $jNmy9.hu();
        case 'is-IS':
        case 'is':
            return $jNmy9.is();
        case 'it-IT':
        case 'it':
            return $jNmy9.it();
        case 'ja-JP':
        case 'ja':
            return $jNmy9.ja();
        case 'ko-KR':
        case 'ko':
            return $jNmy9.ko();
        case 'nb-NB':
        case 'nb':
            return $jNmy9.nb();
        case 'nl-NL':
        case 'nl':
            return $jNmy9.nl();
        case 'pl-PL':
        case 'pl':
            return $jNmy9.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $jNmy9.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $jNmy9.ptbr();
        case 'ro-RO':
        case 'ro':
            return $jNmy9.ro();
        case 'ru-RU':
        case 'ru':
            return $jNmy9.ru();
        case 'sk-SK':
        case 'sk':
            return $jNmy9.sk();
        case 'sv-SE':
        case 'sv':
            return $jNmy9.sv();
        case 'tr-TR':
        case 'tr':
            return $jNmy9.tr();
        case 'th-TH':
        case 'th':
            return $jNmy9.th();
        case 'uk-UK':
        case 'uk':
            return $jNmy9.uk();
        case 'vi-VI':
        case 'vi':
            return $jNmy9.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $jNmy9.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $jNmy9.zh();
    }
    return $jNmy9.fallback();
}

});
parcelRegister("jNmy9", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $e69415da8cc791c6$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $e69415da8cc791c6$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $e69415da8cc791c6$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $e69415da8cc791c6$export$2fa162a495d26869);
$parcel$export(module.exports, "es", () => $e69415da8cc791c6$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $e69415da8cc791c6$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $e69415da8cc791c6$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $e69415da8cc791c6$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $e69415da8cc791c6$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $e69415da8cc791c6$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $e69415da8cc791c6$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $e69415da8cc791c6$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $e69415da8cc791c6$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $e69415da8cc791c6$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $e69415da8cc791c6$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $e69415da8cc791c6$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $e69415da8cc791c6$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $e69415da8cc791c6$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $e69415da8cc791c6$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $e69415da8cc791c6$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $e69415da8cc791c6$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $e69415da8cc791c6$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $e69415da8cc791c6$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $e69415da8cc791c6$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $e69415da8cc791c6$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $e69415da8cc791c6$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $e69415da8cc791c6$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $e69415da8cc791c6$export$41779e6acd26e15f);
/* istanbul ignore file */ const $e69415da8cc791c6$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $e69415da8cc791c6$export$bde1ed0f60b38f2f = ()=>(parcelRequire("gCJBk"));

const $e69415da8cc791c6$export$8c8450b83b664ba4 = ()=>(parcelRequire("hMX0F"));

const $e69415da8cc791c6$export$2fa162a495d26869 = ()=>(parcelRequire("aS9T1"));

const $e69415da8cc791c6$export$ca5e4045a55e76d2 = ()=>(parcelRequire("3ga39"));

const $e69415da8cc791c6$export$457177dcde8472be = ()=>(parcelRequire("8nnj3"));

const $e69415da8cc791c6$export$ed5179c818622fb = ()=>(parcelRequire("7evuC"));

const $e69415da8cc791c6$export$acb2a88f7d552ebf = ()=>(parcelRequire("gd9ca"));

const $e69415da8cc791c6$export$9901d21957972d53 = ()=>(parcelRequire("h8Qqw"));

const $e69415da8cc791c6$export$226b3eccf92c9ed9 = ()=>(parcelRequire("56bsz"));

const $e69415da8cc791c6$export$3486a10f30cf1ee4 = ()=>(parcelRequire("goTqw"));

const $e69415da8cc791c6$export$8c6f505e9474ce90 = ()=>(parcelRequire("iaCxd"));

const $e69415da8cc791c6$export$798cf677954c9533 = ()=>(parcelRequire("bwfZY"));

const $e69415da8cc791c6$export$38ef0e3f791a121e = ()=>(parcelRequire("a12ny"));

const $e69415da8cc791c6$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("5NVzH"));

const $e69415da8cc791c6$export$6ea5311eda92944f = ()=>(parcelRequire("jEWtm"));

const $e69415da8cc791c6$export$84175d5f1cb4e39d = ()=>(parcelRequire("byTpM"));

const $e69415da8cc791c6$export$82924b14976e7373 = ()=>(parcelRequire("8CVur"));

const $e69415da8cc791c6$export$ea30ec7f37fb148d = ()=>(parcelRequire("bk0mB"));

const $e69415da8cc791c6$export$cf48009033a0126b = ()=>(parcelRequire("3Jw70"));

const $e69415da8cc791c6$export$d608fa5b5bfd2021 = ()=>(parcelRequire("grxo0"));

const $e69415da8cc791c6$export$65540e5f7f6e7dce = ()=>(parcelRequire("7zPXx"));

const $e69415da8cc791c6$export$72451b88a72ad9c2 = ()=>(parcelRequire("2nvcH"));

const $e69415da8cc791c6$export$d657bc098992a431 = ()=>(parcelRequire("ebJIf"));

const $e69415da8cc791c6$export$312745a8a3013c00 = ()=>(parcelRequire("b7ZC9"));

const $e69415da8cc791c6$export$e3786bf10a8abdf2 = ()=>(parcelRequire("7KilY"));

const $e69415da8cc791c6$export$b65a7f08f2280505 = ()=>(parcelRequire("kNZfK"));

const $e69415da8cc791c6$export$41779e6acd26e15f = ()=>(parcelRequire("VEHQ4"));

});
parcelRegister("gCJBk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fXuTV');
        const value = parcelRequire('47meK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fXuTV").then(()=>parcelRequire('47meK'));
}

});

parcelRegister("hMX0F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2ivQ0');
        const value = parcelRequire('d2V58');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2ivQ0").then(()=>parcelRequire('d2V58'));
}

});

parcelRegister("aS9T1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('19qx2');
        const value = parcelRequire('b4XVL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("19qx2").then(()=>parcelRequire('b4XVL'));
}

});

parcelRegister("3ga39", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5AL0X');
        const value = parcelRequire('jZvXS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5AL0X").then(()=>parcelRequire('jZvXS'));
}

});

parcelRegister("8nnj3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('zcpwV');
        const value = parcelRequire('YJ8Ko');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("zcpwV").then(()=>parcelRequire('YJ8Ko'));
}

});

parcelRegister("7evuC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gHqQ9');
        const value = parcelRequire('efiNQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gHqQ9").then(()=>parcelRequire('efiNQ'));
}

});

parcelRegister("gd9ca", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6EvcX');
        const value = parcelRequire('kO8gw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6EvcX").then(()=>parcelRequire('kO8gw'));
}

});

parcelRegister("h8Qqw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gHSJK');
        const value = parcelRequire('cOo43');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gHSJK").then(()=>parcelRequire('cOo43'));
}

});

parcelRegister("56bsz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2xsYn');
        const value = parcelRequire('aKWDe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2xsYn").then(()=>parcelRequire('aKWDe'));
}

});

parcelRegister("goTqw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9nbye');
        const value = parcelRequire('asEdu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9nbye").then(()=>parcelRequire('asEdu'));
}

});

parcelRegister("iaCxd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hgXCS');
        const value = parcelRequire('95Psw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hgXCS").then(()=>parcelRequire('95Psw'));
}

});

parcelRegister("bwfZY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5AxcR');
        const value = parcelRequire('9yl8o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5AxcR").then(()=>parcelRequire('9yl8o'));
}

});

parcelRegister("a12ny", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k4LWA');
        const value = parcelRequire('kKnMC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k4LWA").then(()=>parcelRequire('kKnMC'));
}

});

parcelRegister("5NVzH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('55tmR');
        const value = parcelRequire('hxGE0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("55tmR").then(()=>parcelRequire('hxGE0'));
}

});

parcelRegister("jEWtm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3TT5L');
        const value = parcelRequire('icsR5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3TT5L").then(()=>parcelRequire('icsR5'));
}

});

parcelRegister("byTpM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i6CWM');
        const value = parcelRequire('5LFMs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i6CWM").then(()=>parcelRequire('5LFMs'));
}

});

parcelRegister("8CVur", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('euaZ0');
        const value = parcelRequire('bZg1e');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("euaZ0").then(()=>parcelRequire('bZg1e'));
}

});

parcelRegister("bk0mB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8osYk');
        const value = parcelRequire('l9ae7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8osYk").then(()=>parcelRequire('l9ae7'));
}

});

parcelRegister("3Jw70", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7oyXL');
        const value = parcelRequire('28O4I');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7oyXL").then(()=>parcelRequire('28O4I'));
}

});

parcelRegister("grxo0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8wHuS');
        const value = parcelRequire('5ZtHB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8wHuS").then(()=>parcelRequire('5ZtHB'));
}

});

parcelRegister("7zPXx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aBz6I');
        const value = parcelRequire('2o0SJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aBz6I").then(()=>parcelRequire('2o0SJ'));
}

});

parcelRegister("2nvcH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7KDHm');
        const value = parcelRequire('aL1GW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7KDHm").then(()=>parcelRequire('aL1GW'));
}

});

parcelRegister("ebJIf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gnwcL');
        const value = parcelRequire('dC2Qw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gnwcL").then(()=>parcelRequire('dC2Qw'));
}

});

parcelRegister("b7ZC9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4vCZN');
        const value = parcelRequire('iOt35');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4vCZN").then(()=>parcelRequire('iOt35'));
}

});

parcelRegister("7KilY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9zoew');
        const value = parcelRequire('d7tMk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9zoew").then(()=>parcelRequire('d7tMk'));
}

});

parcelRegister("kNZfK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7FFLm');
        const value = parcelRequire('hYVOd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7FFLm").then(()=>parcelRequire('hYVOd'));
}

});

parcelRegister("VEHQ4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('etRoJ');
        const value = parcelRequire('5753S');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("etRoJ").then(()=>parcelRequire('5753S'));
}

});





parcelRegister("ee64e", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $a5b7144f6ae23b6b$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $a5b7144f6ae23b6b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7rh0R = parcelRequire("7rh0R");

var $hTs14 = parcelRequire("hTs14");

var $dtaN9 = parcelRequire("dtaN9");

var $bULPy = parcelRequire("bULPy");

var $7aUAL = parcelRequire("7aUAL");

var $d8riu = parcelRequire("d8riu");

var $4b6QJ = parcelRequire("4b6QJ");

var $dborh = parcelRequire("dborh");

var $byrJl = parcelRequire("byrJl");

var $1OV4Q = parcelRequire("1OV4Q");
function $a5b7144f6ae23b6b$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $d8riu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = (remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.navLabel) || peopleText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`
    }, navLabel ? navLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dborh.messages).teams));
}
function $a5b7144f6ae23b6b$var$PeopleMenuTrigger(props) {
    const { isSpotlightActive: isSpotlightActive, renotifyExperimentProps: renotifyExperimentProps } = (0, $4b6QJ.usePeopleMenuContext)();
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $eUqFw.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $d8riu.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = (remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.navLabel) || peopleText;
    const chevron = customChevronIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: "dropdown-chevron"
    });
    const renderPrimaryDropDownButton = (0, $eUqFw.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), (0, $kU09D.default)({
            isHighlighted: isHighlighted
        }, buttonProps, triggerProps), navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dborh.messages).teams));
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) {
        if (renotifyExperimentProps !== null && renotifyExperimentProps !== void 0 && renotifyExperimentProps.isEnrolled && isSpotlightActive !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
            fallback: renderPrimaryDropDownButton()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7aUAL.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byrJl.RenotifySpotlight), {
            "data-testid": "renotify-spotlight-trigger",
            setIsOpen: onClick,
            renderFallback: renderPrimaryDropDownButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1OV4Q.default), {
            testId: "renotify-menu-trigger-button",
            triggerProps: triggerProps
        }, navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dborh.messages).teams)))));
        return renderPrimaryDropDownButton();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), (0, $kU09D.default)({
        iconAfter: chevron
    }, triggerProps, buttonProps), navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dborh.messages).teams));
}
var $a5b7144f6ae23b6b$export$2e2bcd8739ae039 = $a5b7144f6ae23b6b$var$PeopleMenuTrigger;

});
parcelRegister("byrJl", function(module, exports) {

$parcel$export(module.exports, "RenotifySpotlight", () => $8698616165c58a3f$export$c598a42b0405f75);

var $7rh0R = parcelRequire("7rh0R");

const $8698616165c58a3f$export$c598a42b0405f75 = (0, $7rh0R.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("lQ2OZ")));

});
parcelRegister("lQ2OZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('CZpQn');
        const value = parcelRequire('hDVup');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("CZpQn").then(()=>parcelRequire('hDVup'));
}

});


parcelRegister("1OV4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1536bc475b2480ac$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $573eM = parcelRequire("573eM");

var $86Ndv = parcelRequire("86Ndv");

var $9ceZm = parcelRequire("9ceZm");
const $1536bc475b2480ac$var$buttonStyles = (0, $byn9U.css)({
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
function $1536bc475b2480ac$var$RenotifyMenuButton(props) {
    const { testId: testId, triggerProps: triggerProps, children: children } = props;
    // The cloned spotlight button requires the className prop to be set
    // for the padding style to be applied properly
    return (0, $byn9U.jsx)((0, $573eM.default), (0, $kU09D.default)({
        "data-testid": testId,
        className: "renotify-menu-button",
        css: $1536bc475b2480ac$var$buttonStyles,
        iconAfter: (0, $byn9U.jsx)((0, $9ceZm.RenotifySpotlightTriggerChevron), null, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "dropdown-chevron"
        }))
    }, triggerProps), children);
}
var $1536bc475b2480ac$export$2e2bcd8739ae039 = $1536bc475b2480ac$var$RenotifyMenuButton;

});
parcelRegister("9ceZm", function(module, exports) {

$parcel$export(module.exports, "RenotifyMessageContainer", () => $6b20dc7ee6788091$export$82eb61f2818fcdcb);
$parcel$export(module.exports, "RenotifyModalWidthFull", () => $6b20dc7ee6788091$export$1b5dc0ba5fe67cdb);
$parcel$export(module.exports, "RenotifyModalUsersContainerOld", () => $6b20dc7ee6788091$export$3c85d9063ef37ec2);
$parcel$export(module.exports, "RenotifyModalUsersContainerNew", () => $6b20dc7ee6788091$export$95332295e58cacdf);
$parcel$export(module.exports, "RenotifySpotlightTriggerChevron", () => $6b20dc7ee6788091$export$bdd40b9dcae00142);
$parcel$export(module.exports, "RenotifySpotlightContent", () => $6b20dc7ee6788091$export$75293539a002acf6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");

var $8BKky = parcelRequire("8BKky");

var $PdmhA = parcelRequire("PdmhA");
const $6b20dc7ee6788091$export$82eb61f2818fcdcb = (0, $exJuA.default)((0, $8BKky.default))({
    maxWidth: '300px',
    padding: "var(--ds-space-200, 16px)",
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${(0, $PdmhA.Y100)})`,
    '&::before': {
        height: "var(--ds-space-0, 0px)"
    },
    '&::after': {
        height: "var(--ds-space-0, 0px)"
    }
});
const $6b20dc7ee6788091$export$1b5dc0ba5fe67cdb = (0, $exJuA.default).div({
    width: '100%'
});
const $6b20dc7ee6788091$export$3c85d9063ef37ec2 = (0, $exJuA.default).div({
    height: '200px',
    maxHeight: '200px',
    overflowY: 'auto',
    marginTop: "var(--ds-space-200, 16px)",
    padding: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-100, 8px)",
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-information, ${(0, $PdmhA.N20)})`}`
});
const $6b20dc7ee6788091$export$95332295e58cacdf = (0, $exJuA.default).div({
    height: 'fit-content',
    maxHeight: '174px',
    overflowY: 'auto',
    marginTop: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-100, 8px)"
});
const $6b20dc7ee6788091$export$bdd40b9dcae00142 = (0, $exJuA.default).span({
    marginLeft: "var(--ds-space-negative-100, -8px)",
    marginRight: "var(--ds-space-negative-100, -8px)",
    opacity: 0.5
});
const $6b20dc7ee6788091$export$75293539a002acf6 = (0, $exJuA.default).div({
    marginTop: "var(--ds-space-050, 4px)",
    marginBottom: "var(--ds-space-100, 8px)"
});

});



parcelRegister("kgV5T", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $ec2196f5472952dd$export$ffb64487c0de3976);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $2VQNe = parcelRequire("2VQNe");

var $ihFT6 = parcelRequire("ihFT6");

var $fLSKh = parcelRequire("fLSKh");

var $2uJvj = parcelRequire("2uJvj");
function $ec2196f5472952dd$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent, renotifyExperiment: renotifyExperiment }) {
    (0, $eUqFw.useEffect)(()=>{
        (0, $2uJvj.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $fLSKh.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $ihFT6.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    /*
   * This hook checks the renotify experiments eligibility passed from Jira
   * and will only take action if enrolled. It makes a single call to
   * Experiment-API which proxies a call to Hydra and Identity Gatekeeper
   * to return users who have been invited to Jira but not accepted.
   */ (0, $2VQNe.usePendingUsers)({
        cloudId: cloudId,
        startFetching: true,
        renotifyExperiment: renotifyExperiment
    });
    // stop to measure fetching data time when isLoading is finished.
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoading) (0, $fLSKh.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $2uJvj.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $ec2196f5472952dd$export$ffb64487c0de3976 = (0, $2jDha.default)()($ec2196f5472952dd$export$50ca75733630fce1);

});



parcelRegister("5xNTL", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $4096bd9f3f70d7db$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $9UxRe = parcelRequire("9UxRe");
var $6TFMw = parcelRequire("6TFMw");

var $eUqFw = parcelRequire("eUqFw");
const $4096bd9f3f70d7db$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6TFMw.ThemeProvider), {
        partialSearchCSS: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UxRe.default), rest));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9UxRe.default), rest);
};

});

parcelRegister("6YYy9", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $5157509c2085d4ec$export$6620595b7f837f8f);

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $epLgd = parcelRequire("epLgd");

var $jbNLw = parcelRequire("jbNLw");
const $5157509c2085d4ec$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $aNvhX.useFlightDeckContext)();
    return (0, $eUqFw.useMemo)(()=>(0, $jbNLw.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $epLgd.FD_CLIENT_FETCH_PROPS).name, (0, $epLgd.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';

const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

const $3e55effaa3b38112$export$a59f8d67326bd1cb = "4.17.2";

const $28470208e5f4eca0$export$42f4885608027d0c = 'non_boolean';

const $0a67c8cf323404fc$export$b98e411ae80c806f = '/';

const $920d8b588bd9151b$export$881d135f98d8d7d0 = 100;
const $920d8b588bd9151b$export$9ab5bdcb8a1d6c34 = false;
const $920d8b588bd9151b$export$12c1dc38ea1692da = 0;

const $12cf9be4d8e6252f$export$cf090d5281b5ae06 = 10000;
const $12cf9be4d8e6252f$export$8575e30be0feb909 = 30000;

const $7a66036879e6348d$export$3288b14b6745c572 = 204;
const $7a66036879e6348d$export$c09e7ea0fc79f34f = 409;
const $7a66036879e6348d$export$974c37534b0191b1 = 503;

const $b91e065bcd1bc966$export$d4c5499dc806c969 = ', Loading';

const $a3c11500ccd013c5$export$d4c5499dc806c969 = ', Loading';


$parcel$global.rlb("bCeK4")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.3636b2c2.js.map
